"use client";
import "@repo/edtech-ui-kit/styles";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { PrinterIcon, ArrowDownAndBracketTrailingIcon, ArrowLeftCircleIcon } from "@repo/edtech-assets";
import { useFullscreen, BASE_URL, WEBCOM_ASSETS_BASE, IS_WEBCOM, useThemeSwitcher, EdtechProvider } from "@repo/edtech-shared";
import { Loader, FullscreenButton, Button, ButtonVariant } from "@repo/edtech-ui-kit";
import { useRef, useState, useEffect, useCallback } from "react";
function _mergeNamespaces(P, p) {
  for (var t = 0; t < p.length; t++) {
    const a = p[t];
    if (typeof a != "string" && !Array.isArray(a)) {
      for (const f in a)
        if (f !== "default" && !(f in P)) {
          const S = Object.getOwnPropertyDescriptor(a, f);
          S && Object.defineProperty(P, f, S.get ? S : {
            enumerable: !0,
            get: () => a[f]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(P, Symbol.toStringTag, { value: "Module" }));
}
function r(P) {
  var p, t, a = "";
  if (typeof P == "string" || typeof P == "number") a += P;
  else if (typeof P == "object") if (Array.isArray(P)) {
    var f = P.length;
    for (p = 0; p < f; p++) P[p] && (t = r(P[p])) && (a && (a += " "), a += t);
  } else for (t in P) P[t] && (a && (a += " "), a += t);
  return a;
}
function clsx() {
  for (var P, p, t = 0, a = "", f = arguments.length; t < f; t++) (P = arguments[t]) && (p = r(P)) && (a && (a += " "), a += p);
  return a;
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getAugmentedNamespace(P) {
  if (Object.prototype.hasOwnProperty.call(P, "__esModule")) return P;
  var p = P.default;
  if (typeof p == "function") {
    var t = function a() {
      var f = !1;
      try {
        f = this instanceof a;
      } catch {
      }
      return f ? Reflect.construct(p, arguments, this.constructor) : p.apply(this, arguments);
    };
    t.prototype = p.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(P).forEach(function(a) {
    var f = Object.getOwnPropertyDescriptor(P, a);
    Object.defineProperty(t, a, f.get ? f : {
      enumerable: !0,
      get: function() {
        return P[a];
      }
    });
  }), t;
}
function commonjsRequire(P) {
  throw new Error('Could not dynamically require "' + P + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$6 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var path2dPolyfill_esm = {}, hasRequiredPath2dPolyfill_esm;
function requirePath2dPolyfill_esm() {
  if (hasRequiredPath2dPolyfill_esm) return path2dPolyfill_esm;
  hasRequiredPath2dPolyfill_esm = 1;
  function P(e, l, u) {
    for (var c = 0, y = l.length, C; c < y; c++)
      (C || !(c in l)) && (C || (C = Array.prototype.slice.call(l, 0, c)), C[c] = l[c]);
    return e.concat(C || Array.prototype.slice.call(l));
  }
  var p = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
  }, t = /([astvzqmhlc])([^astvzqmhlc]*)/gi, a = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
  function f(e) {
    var l = e.match(a);
    return l ? l.map(Number) : [];
  }
  function S(e) {
    var l = [], u = String(e).trim();
    return u[0] !== "M" && u[0] !== "m" || u.replace(t, function(c, y, C) {
      var R = f(C), s = y.toLowerCase(), m = y;
      if (s === "m" && R.length > 2 && (l.push(P([m], R.splice(0, 2))), s = "l", m = m === "m" ? "l" : "L"), R.length < p[s])
        return "";
      for (l.push(P([m], R.splice(0, p[s]))); R.length >= p[s] && R.length && p[s]; )
        l.push(P([m], R.splice(0, p[s])));
      return "";
    }), l;
  }
  function E(e, l) {
    var u = e.x * Math.cos(l) - e.y * Math.sin(l), c = e.y * Math.cos(l) + e.x * Math.sin(l);
    e.x = u, e.y = c;
  }
  function v(e, l, u) {
    e.x += l, e.y += u;
  }
  function T(e, l) {
    e.x *= l, e.y *= l;
  }
  var i = (
    /** @class */
    (function() {
      function e(l) {
        var u;
        this.commands = [], l && l instanceof e ? (u = this.commands).push.apply(u, l.commands) : l && (this.commands = S(l));
      }
      return e.prototype.addPath = function(l) {
        var u;
        l && l instanceof e && (u = this.commands).push.apply(u, l.commands);
      }, e.prototype.moveTo = function(l, u) {
        this.commands.push(["M", l, u]);
      }, e.prototype.lineTo = function(l, u) {
        this.commands.push(["L", l, u]);
      }, e.prototype.arc = function(l, u, c, y, C, R) {
        this.commands.push(["AC", l, u, c, y, C, !!R]);
      }, e.prototype.arcTo = function(l, u, c, y, C) {
        this.commands.push(["AT", l, u, c, y, C]);
      }, e.prototype.ellipse = function(l, u, c, y, C, R, s, m) {
        this.commands.push(["E", l, u, c, y, C, R, s, !!m]);
      }, e.prototype.closePath = function() {
        this.commands.push(["Z"]);
      }, e.prototype.bezierCurveTo = function(l, u, c, y, C, R) {
        this.commands.push(["C", l, u, c, y, C, R]);
      }, e.prototype.quadraticCurveTo = function(l, u, c, y) {
        this.commands.push(["Q", l, u, c, y]);
      }, e.prototype.rect = function(l, u, c, y) {
        this.commands.push(["R", l, u, c, y]);
      }, e.prototype.roundRect = function(l, u, c, y, C) {
        typeof C > "u" ? this.commands.push(["RR", l, u, c, y, 0]) : this.commands.push(["RR", l, u, c, y, C]);
      }, e;
    })()
  );
  function n(e, l) {
    var u = 0, c = 0, y, C, R, s, m, F, B, k, V, z, K, J, $, j, G, M, x, A, g, I, U, _ = null, H = null, N = null, b = null, w = null, O = null;
    e.beginPath();
    for (var D = 0; D < l.length; ++D) {
      A = l[D][0], A !== "S" && A !== "s" && A !== "C" && A !== "c" && (_ = null, H = null), A !== "T" && A !== "t" && A !== "Q" && A !== "q" && (N = null, b = null);
      var L = void 0;
      switch (A) {
        case "m":
        case "M":
          L = l[D], A === "m" ? (u += L[1], c += L[2]) : (u = L[1], c = L[2]), (A === "M" || !w) && (w = { x: u, y: c }), e.moveTo(u, c);
          break;
        case "l":
          L = l[D], u += L[1], c += L[2], e.lineTo(u, c);
          break;
        case "L":
          L = l[D], u = L[1], c = L[2], e.lineTo(u, c);
          break;
        case "H":
          L = l[D], u = L[1], e.lineTo(u, c);
          break;
        case "h":
          L = l[D], u += L[1], e.lineTo(u, c);
          break;
        case "V":
          L = l[D], c = L[1], e.lineTo(u, c);
          break;
        case "v":
          L = l[D], c += L[1], e.lineTo(u, c);
          break;
        case "a":
        case "A":
          if (L = l[D], O === null)
            throw new Error("This should never happen");
          A === "a" ? (u += L[6], c += L[7]) : (u = L[6], c = L[7]), j = L[1], G = L[2], B = L[3] * Math.PI / 180, R = !!L[4], s = !!L[5], m = { x: u, y: c }, F = {
            x: (O.x - m.x) / 2,
            y: (O.y - m.y) / 2
          }, E(F, -B), k = F.x * F.x / (j * j) + F.y * F.y / (G * G), k > 1 && (k = Math.sqrt(k), j *= k, G *= k), g = {
            x: j * F.y / G,
            y: -(G * F.x) / j
          }, V = j * j * G * G, z = j * j * F.y * F.y + G * G * F.x * F.x, s !== R ? T(g, Math.sqrt((V - z) / z) || 0) : T(g, -Math.sqrt((V - z) / z) || 0), C = Math.atan2((F.y - g.y) / G, (F.x - g.x) / j), y = Math.atan2(-(F.y + g.y) / G, -(F.x + g.x) / j), E(g, B), v(g, (m.x + O.x) / 2, (m.y + O.y) / 2), e.save(), e.translate(g.x, g.y), e.rotate(B), e.scale(j, G), e.arc(0, 0, 1, C, y, !s), e.restore();
          break;
        case "C":
          L = l[D], _ = L[3], H = L[4], u = L[5], c = L[6], e.bezierCurveTo(L[1], L[2], _, H, u, c);
          break;
        case "c":
          L = l[D], e.bezierCurveTo(L[1] + u, L[2] + c, L[3] + u, L[4] + c, L[5] + u, L[6] + c), _ = L[3] + u, H = L[4] + c, u += L[5], c += L[6];
          break;
        case "S":
          L = l[D], (_ === null || H === null) && (_ = u, H = c), e.bezierCurveTo(2 * u - _, 2 * c - H, L[1], L[2], L[3], L[4]), _ = L[1], H = L[2], u = L[3], c = L[4];
          break;
        case "s":
          L = l[D], (_ === null || H === null) && (_ = u, H = c), e.bezierCurveTo(2 * u - _, 2 * c - H, L[1] + u, L[2] + c, L[3] + u, L[4] + c), _ = L[1] + u, H = L[2] + c, u += L[3], c += L[4];
          break;
        case "Q":
          L = l[D], N = L[1], b = L[2], u = L[3], c = L[4], e.quadraticCurveTo(N, b, u, c);
          break;
        case "q":
          L = l[D], N = L[1] + u, b = L[2] + c, u += L[3], c += L[4], e.quadraticCurveTo(N, b, u, c);
          break;
        case "T":
          L = l[D], (N === null || b === null) && (N = u, b = c), N = 2 * u - N, b = 2 * c - b, u = L[1], c = L[2], e.quadraticCurveTo(N, b, u, c);
          break;
        case "t":
          L = l[D], (N === null || b === null) && (N = u, b = c), N = 2 * u - N, b = 2 * c - b, u += L[1], c += L[2], e.quadraticCurveTo(N, b, u, c);
          break;
        case "z":
        case "Z":
          w && (u = w.x, c = w.y), w = null, e.closePath();
          break;
        case "AC":
          L = l[D], u = L[1], c = L[2], $ = L[3], C = L[4], y = L[5], I = L[6], e.arc(u, c, $, C, y, I);
          break;
        case "AT":
          L = l[D], K = L[1], J = L[2], u = L[3], c = L[4], $ = L[5], e.arcTo(K, J, u, c, $);
          break;
        case "E":
          L = l[D], u = L[1], c = L[2], j = L[3], G = L[4], B = L[5], C = L[6], y = L[7], I = L[8], e.save(), e.translate(u, c), e.rotate(B), e.scale(j, G), e.arc(0, 0, 1, C, y, I), e.restore();
          break;
        case "R":
          L = l[D], u = L[1], c = L[2], M = L[3], x = L[4], w = { x: u, y: c }, e.rect(u, c, M, x);
          break;
        case "RR":
          L = l[D], u = L[1], c = L[2], M = L[3], x = L[4], U = L[5], w = { x: u, y: c }, e.roundRect(u, c, M, x, U);
          break;
      }
      O ? (O.x = u, O.y = c) : O = { x: u, y: c };
    }
  }
  function o(e) {
    if (!(!e || !e.CanvasRenderingContext2D || e.Path2D)) {
      var l = e.CanvasRenderingContext2D, u = l.prototype.fill, c = l.prototype.stroke, y = l.prototype.isPointInPath;
      l.prototype.fill = function() {
        for (var R = [], s = 0; s < arguments.length; s++)
          R[s] = arguments[s];
        if (R[0] instanceof i) {
          var m = R[0], F = R[1] || "nonzero";
          n(this, m.commands), u.apply(this, [F]);
        } else {
          var F = R[0] || "nonzero";
          return u.apply(this, [F]);
        }
      }, l.prototype.stroke = function(R) {
        R && n(this, R.commands), c.apply(this);
      }, l.prototype.isPointInPath = function() {
        for (var R = [], s = 0; s < arguments.length; s++)
          R[s] = arguments[s];
        if (R[0] instanceof i) {
          var m = R[0], F = R[1], B = R[2], k = R[3] || "nonzero";
          return n(this, m.commands), y.apply(this, [F, B, k]);
        } else
          return y.apply(this, R);
      }, e.Path2D = i;
    }
  }
  function d(e, l, u, c, y) {
    var C = this;
    if (y === void 0 && (y = 0), typeof y == "number" && (y = [y]), Array.isArray(y)) {
      if (y.length === 0 || y.length > 4)
        throw new RangeError("Failed to execute 'roundRect' on '".concat(this.constructor.name, "': ").concat(y.length, " radii provided. Between one and four radii are necessary."));
      y.forEach(function(k) {
        if (k < 0)
          throw new RangeError("Failed to execute 'roundRect' on '".concat(C.constructor.name, "': Radius value ").concat(k, " is negative."));
      });
    } else
      return;
    if (y.length === 1 && y[0] === 0)
      return this.rect(e, l, u, c);
    var R = Math.min(u, c) / 2, s, m, F, B = s = m = F = Math.min(R, y[0]);
    y.length === 2 && (s = F = Math.min(R, y[1])), y.length === 3 && (s = F = Math.min(R, y[1]), m = Math.min(R, y[2])), y.length === 4 && (s = Math.min(R, y[1]), m = Math.min(R, y[2]), F = Math.min(R, y[3])), this.moveTo(e, l + c - F), this.arcTo(e, l, e + B, l, B), this.arcTo(e + u, l, e + u, l + s, s), this.arcTo(e + u, l + c, e + u - m, l + c, m), this.arcTo(e, l + c, e, l + c - F, F), this.moveTo(e, l);
  }
  function h(e) {
    if (!(!e || !e.CanvasRenderingContext2D)) {
      var l = e.CanvasRenderingContext2D, u = e.Path2D;
      l && !l.prototype.roundRect && (l.prototype.roundRect = d), u && !u.prototype.roundRect && (u.prototype.roundRect = d);
    }
  }
  return o(window), h(window), path2dPolyfill_esm;
}
var hasRequiredPdf;
function requirePdf() {
  return hasRequiredPdf || (hasRequiredPdf = 1, (function(module, exports) {
    (function(p, t) {
      module.exports = p.pdfjsLib = t();
    })(globalThis, () => (
      /******/
      (() => {
        var __webpack_modules__ = [
          ,
          /* 1 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.VerbosityLevel = p.Util = p.UnknownErrorException = p.UnexpectedResponseException = p.TextRenderingMode = p.RenderingIntentFlag = p.PromiseCapability = p.PermissionFlag = p.PasswordResponses = p.PasswordException = p.PageActionEventType = p.OPS = p.MissingPDFException = p.MAX_IMAGE_SIZE_TO_CACHE = p.LINE_FACTOR = p.LINE_DESCENT_FACTOR = p.InvalidPDFException = p.ImageKind = p.IDENTITY_MATRIX = p.FormatError = p.FeatureTest = p.FONT_IDENTITY_MATRIX = p.DocumentActionEventType = p.CMapCompressionType = p.BaseException = p.BASELINE_FACTOR = p.AnnotationType = p.AnnotationReplyType = p.AnnotationPrefix = p.AnnotationMode = p.AnnotationFlag = p.AnnotationFieldFlag = p.AnnotationEditorType = p.AnnotationEditorPrefix = p.AnnotationEditorParamsType = p.AnnotationBorderStyleType = p.AnnotationActionEventType = p.AbortException = void 0, p.assert = g, p.bytesToString = X, p.createValidAbsoluteUrl = U, p.getModificationDate = _t, p.getUuid = Ut, p.getVerbosityLevel = G, p.info = M, p.isArrayBuffer = xt, p.isArrayEqual = wt, p.isNodeJS = void 0, p.normalizeUnicode = Nt, p.objectFromMap = Y, p.objectSize = nt, p.setVerbosityLevel = j, p.shadow = _, p.string32 = ct, p.stringToBytes = q, p.stringToPDFString = pt, p.stringToUTF8String = vt, p.unreachable = A, p.utf8StringToString = yt, p.warn = x, t(2), t(84), t(86), t(87), t(89), t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123);
            const a = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
            p.isNodeJS = a;
            const f = [1, 0, 0, 1, 0, 0];
            p.IDENTITY_MATRIX = f;
            const S = [1e-3, 0, 0, 1e-3, 0, 0];
            p.FONT_IDENTITY_MATRIX = S;
            const E = 1e7;
            p.MAX_IMAGE_SIZE_TO_CACHE = E;
            const v = 1.35;
            p.LINE_FACTOR = v;
            const T = 0.35;
            p.LINE_DESCENT_FACTOR = T;
            const i = T / v;
            p.BASELINE_FACTOR = i;
            const n = {
              ANY: 1,
              DISPLAY: 2,
              PRINT: 4,
              SAVE: 8,
              ANNOTATIONS_FORMS: 16,
              ANNOTATIONS_STORAGE: 32,
              ANNOTATIONS_DISABLE: 64,
              OPLIST: 256
            };
            p.RenderingIntentFlag = n;
            const o = {
              DISABLE: 0,
              ENABLE: 1,
              ENABLE_FORMS: 2,
              ENABLE_STORAGE: 3
            };
            p.AnnotationMode = o;
            const d = "pdfjs_internal_editor_";
            p.AnnotationEditorPrefix = d;
            const h = {
              DISABLE: -1,
              NONE: 0,
              FREETEXT: 3,
              STAMP: 13,
              INK: 15
            };
            p.AnnotationEditorType = h;
            const e = {
              RESIZE: 1,
              CREATE: 2,
              FREETEXT_SIZE: 11,
              FREETEXT_COLOR: 12,
              FREETEXT_OPACITY: 13,
              INK_COLOR: 21,
              INK_THICKNESS: 22,
              INK_OPACITY: 23
            };
            p.AnnotationEditorParamsType = e;
            const l = {
              PRINT: 4,
              MODIFY_CONTENTS: 8,
              COPY: 16,
              MODIFY_ANNOTATIONS: 32,
              FILL_INTERACTIVE_FORMS: 256,
              COPY_FOR_ACCESSIBILITY: 512,
              ASSEMBLE: 1024,
              PRINT_HIGH_QUALITY: 2048
            };
            p.PermissionFlag = l;
            const u = {
              FILL: 0,
              STROKE: 1,
              FILL_STROKE: 2,
              INVISIBLE: 3,
              FILL_ADD_TO_PATH: 4,
              STROKE_ADD_TO_PATH: 5,
              FILL_STROKE_ADD_TO_PATH: 6,
              ADD_TO_PATH: 7,
              FILL_STROKE_MASK: 3,
              ADD_TO_PATH_FLAG: 4
            };
            p.TextRenderingMode = u;
            const c = {
              GRAYSCALE_1BPP: 1,
              RGB_24BPP: 2,
              RGBA_32BPP: 3
            };
            p.ImageKind = c;
            const y = {
              TEXT: 1,
              LINK: 2,
              FREETEXT: 3,
              LINE: 4,
              SQUARE: 5,
              CIRCLE: 6,
              POLYGON: 7,
              POLYLINE: 8,
              HIGHLIGHT: 9,
              UNDERLINE: 10,
              SQUIGGLY: 11,
              STRIKEOUT: 12,
              STAMP: 13,
              CARET: 14,
              INK: 15,
              POPUP: 16,
              FILEATTACHMENT: 17,
              SOUND: 18,
              MOVIE: 19,
              WIDGET: 20,
              SCREEN: 21,
              PRINTERMARK: 22,
              TRAPNET: 23,
              WATERMARK: 24,
              THREED: 25,
              REDACT: 26
            };
            p.AnnotationType = y;
            const C = {
              GROUP: "Group",
              REPLY: "R"
            };
            p.AnnotationReplyType = C;
            const R = {
              INVISIBLE: 1,
              HIDDEN: 2,
              PRINT: 4,
              NOZOOM: 8,
              NOROTATE: 16,
              NOVIEW: 32,
              READONLY: 64,
              LOCKED: 128,
              TOGGLENOVIEW: 256,
              LOCKEDCONTENTS: 512
            };
            p.AnnotationFlag = R;
            const s = {
              READONLY: 1,
              REQUIRED: 2,
              NOEXPORT: 4,
              MULTILINE: 4096,
              PASSWORD: 8192,
              NOTOGGLETOOFF: 16384,
              RADIO: 32768,
              PUSHBUTTON: 65536,
              COMBO: 131072,
              EDIT: 262144,
              SORT: 524288,
              FILESELECT: 1048576,
              MULTISELECT: 2097152,
              DONOTSPELLCHECK: 4194304,
              DONOTSCROLL: 8388608,
              COMB: 16777216,
              RICHTEXT: 33554432,
              RADIOSINUNISON: 33554432,
              COMMITONSELCHANGE: 67108864
            };
            p.AnnotationFieldFlag = s;
            const m = {
              SOLID: 1,
              DASHED: 2,
              BEVELED: 3,
              INSET: 4,
              UNDERLINE: 5
            };
            p.AnnotationBorderStyleType = m;
            const F = {
              E: "Mouse Enter",
              X: "Mouse Exit",
              D: "Mouse Down",
              U: "Mouse Up",
              Fo: "Focus",
              Bl: "Blur",
              PO: "PageOpen",
              PC: "PageClose",
              PV: "PageVisible",
              PI: "PageInvisible",
              K: "Keystroke",
              F: "Format",
              V: "Validate",
              C: "Calculate"
            };
            p.AnnotationActionEventType = F;
            const B = {
              WC: "WillClose",
              WS: "WillSave",
              DS: "DidSave",
              WP: "WillPrint",
              DP: "DidPrint"
            };
            p.DocumentActionEventType = B;
            const k = {
              O: "PageOpen",
              C: "PageClose"
            };
            p.PageActionEventType = k;
            const V = {
              ERRORS: 0,
              WARNINGS: 1,
              INFOS: 5
            };
            p.VerbosityLevel = V;
            const z = {
              NONE: 0,
              BINARY: 1
            };
            p.CMapCompressionType = z;
            const K = {
              dependency: 1,
              setLineWidth: 2,
              setLineCap: 3,
              setLineJoin: 4,
              setMiterLimit: 5,
              setDash: 6,
              setRenderingIntent: 7,
              setFlatness: 8,
              setGState: 9,
              save: 10,
              restore: 11,
              transform: 12,
              moveTo: 13,
              lineTo: 14,
              curveTo: 15,
              curveTo2: 16,
              curveTo3: 17,
              closePath: 18,
              rectangle: 19,
              stroke: 20,
              closeStroke: 21,
              fill: 22,
              eoFill: 23,
              fillStroke: 24,
              eoFillStroke: 25,
              closeFillStroke: 26,
              closeEOFillStroke: 27,
              endPath: 28,
              clip: 29,
              eoClip: 30,
              beginText: 31,
              endText: 32,
              setCharSpacing: 33,
              setWordSpacing: 34,
              setHScale: 35,
              setLeading: 36,
              setFont: 37,
              setTextRenderingMode: 38,
              setTextRise: 39,
              moveText: 40,
              setLeadingMoveText: 41,
              setTextMatrix: 42,
              nextLine: 43,
              showText: 44,
              showSpacedText: 45,
              nextLineShowText: 46,
              nextLineSetSpacingShowText: 47,
              setCharWidth: 48,
              setCharWidthAndBounds: 49,
              setStrokeColorSpace: 50,
              setFillColorSpace: 51,
              setStrokeColor: 52,
              setStrokeColorN: 53,
              setFillColor: 54,
              setFillColorN: 55,
              setStrokeGray: 56,
              setFillGray: 57,
              setStrokeRGBColor: 58,
              setFillRGBColor: 59,
              setStrokeCMYKColor: 60,
              setFillCMYKColor: 61,
              shadingFill: 62,
              beginInlineImage: 63,
              beginImageData: 64,
              endInlineImage: 65,
              paintXObject: 66,
              markPoint: 67,
              markPointProps: 68,
              beginMarkedContent: 69,
              beginMarkedContentProps: 70,
              endMarkedContent: 71,
              beginCompat: 72,
              endCompat: 73,
              paintFormXObjectBegin: 74,
              paintFormXObjectEnd: 75,
              beginGroup: 76,
              endGroup: 77,
              beginAnnotation: 80,
              endAnnotation: 81,
              paintImageMaskXObject: 83,
              paintImageMaskXObjectGroup: 84,
              paintImageXObject: 85,
              paintInlineImageXObject: 86,
              paintInlineImageXObjectGroup: 87,
              paintImageXObjectRepeat: 88,
              paintImageMaskXObjectRepeat: 89,
              paintSolidColorImageMask: 90,
              constructPath: 91
            };
            p.OPS = K;
            const J = {
              NEED_PASSWORD: 1,
              INCORRECT_PASSWORD: 2
            };
            p.PasswordResponses = J;
            let $ = V.WARNINGS;
            function j(ot) {
              Number.isInteger(ot) && ($ = ot);
            }
            function G() {
              return $;
            }
            function M(ot) {
              $ >= V.INFOS && console.log(`Info: ${ot}`);
            }
            function x(ot) {
              $ >= V.WARNINGS && console.log(`Warning: ${ot}`);
            }
            function A(ot) {
              throw new Error(ot);
            }
            function g(ot, it) {
              ot || A(it);
            }
            function I(ot) {
              switch (ot?.protocol) {
                case "http:":
                case "https:":
                case "ftp:":
                case "mailto:":
                case "tel:":
                  return !0;
                default:
                  return !1;
              }
            }
            function U(ot) {
              let it = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, tt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
              if (!ot)
                return null;
              try {
                if (tt && typeof ot == "string" && (tt.addDefaultProtocol && ot.startsWith("www.") && ot.match(/\./g)?.length >= 2 && (ot = `http://${ot}`), tt.tryConvertEncoding))
                  try {
                    ot = vt(ot);
                  } catch {
                  }
                const ut = it ? new URL(ot, it) : new URL(ot);
                if (I(ut))
                  return ut;
              } catch {
              }
              return null;
            }
            function _(ot, it, tt) {
              let ut = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
              return Object.defineProperty(ot, it, {
                value: tt,
                enumerable: !ut,
                configurable: !0,
                writable: !1
              }), tt;
            }
            const H = (function() {
              function it(tt, ut) {
                this.constructor === it && A("Cannot initialize BaseException."), this.message = tt, this.name = ut;
              }
              return it.prototype = new Error(), it.constructor = it, it;
            })();
            p.BaseException = H;
            class N extends H {
              constructor(it, tt) {
                super(it, "PasswordException"), this.code = tt;
              }
            }
            p.PasswordException = N;
            class b extends H {
              constructor(it, tt) {
                super(it, "UnknownErrorException"), this.details = tt;
              }
            }
            p.UnknownErrorException = b;
            class w extends H {
              constructor(it) {
                super(it, "InvalidPDFException");
              }
            }
            p.InvalidPDFException = w;
            class O extends H {
              constructor(it) {
                super(it, "MissingPDFException");
              }
            }
            p.MissingPDFException = O;
            class D extends H {
              constructor(it, tt) {
                super(it, "UnexpectedResponseException"), this.status = tt;
              }
            }
            p.UnexpectedResponseException = D;
            class L extends H {
              constructor(it) {
                super(it, "FormatError");
              }
            }
            p.FormatError = L;
            class W extends H {
              constructor(it) {
                super(it, "AbortException");
              }
            }
            p.AbortException = W;
            function X(ot) {
              (typeof ot != "object" || ot?.length === void 0) && A("Invalid argument for bytesToString");
              const it = ot.length, tt = 8192;
              if (it < tt)
                return String.fromCharCode.apply(null, ot);
              const ut = [];
              for (let Et = 0; Et < it; Et += tt) {
                const kt = Math.min(Et + tt, it), rt = ot.subarray(Et, kt);
                ut.push(String.fromCharCode.apply(null, rt));
              }
              return ut.join("");
            }
            function q(ot) {
              typeof ot != "string" && A("Invalid argument for stringToBytes");
              const it = ot.length, tt = new Uint8Array(it);
              for (let ut = 0; ut < it; ++ut)
                tt[ut] = ot.charCodeAt(ut) & 255;
              return tt;
            }
            function ct(ot) {
              return String.fromCharCode(ot >> 24 & 255, ot >> 16 & 255, ot >> 8 & 255, ot & 255);
            }
            function nt(ot) {
              return Object.keys(ot).length;
            }
            function Y(ot) {
              const it = /* @__PURE__ */ Object.create(null);
              for (const [tt, ut] of ot)
                it[tt] = ut;
              return it;
            }
            function Q() {
              const ot = new Uint8Array(4);
              return ot[0] = 1, new Uint32Array(ot.buffer, 0, 1)[0] === 1;
            }
            function et() {
              try {
                return new Function(""), !0;
              } catch {
                return !1;
              }
            }
            class Z {
              static get isLittleEndian() {
                return _(this, "isLittleEndian", Q());
              }
              static get isEvalSupported() {
                return _(this, "isEvalSupported", et());
              }
              static get isOffscreenCanvasSupported() {
                return _(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
              }
              static get platform() {
                return typeof navigator > "u" ? _(this, "platform", {
                  isWin: !1,
                  isMac: !1
                }) : _(this, "platform", {
                  isWin: navigator.platform.includes("Win"),
                  isMac: navigator.platform.includes("Mac")
                });
              }
              static get isCSSRoundSupported() {
                return _(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
              }
            }
            p.FeatureTest = Z;
            const at = [...Array(256).keys()].map((ot) => ot.toString(16).padStart(2, "0"));
            class lt {
              static makeHexColor(it, tt, ut) {
                return `#${at[it]}${at[tt]}${at[ut]}`;
              }
              static scaleMinMax(it, tt) {
                let ut;
                it[0] ? (it[0] < 0 && (ut = tt[0], tt[0] = tt[1], tt[1] = ut), tt[0] *= it[0], tt[1] *= it[0], it[3] < 0 && (ut = tt[2], tt[2] = tt[3], tt[3] = ut), tt[2] *= it[3], tt[3] *= it[3]) : (ut = tt[0], tt[0] = tt[2], tt[2] = ut, ut = tt[1], tt[1] = tt[3], tt[3] = ut, it[1] < 0 && (ut = tt[2], tt[2] = tt[3], tt[3] = ut), tt[2] *= it[1], tt[3] *= it[1], it[2] < 0 && (ut = tt[0], tt[0] = tt[1], tt[1] = ut), tt[0] *= it[2], tt[1] *= it[2]), tt[0] += it[4], tt[1] += it[4], tt[2] += it[5], tt[3] += it[5];
              }
              static transform(it, tt) {
                return [it[0] * tt[0] + it[2] * tt[1], it[1] * tt[0] + it[3] * tt[1], it[0] * tt[2] + it[2] * tt[3], it[1] * tt[2] + it[3] * tt[3], it[0] * tt[4] + it[2] * tt[5] + it[4], it[1] * tt[4] + it[3] * tt[5] + it[5]];
              }
              static applyTransform(it, tt) {
                const ut = it[0] * tt[0] + it[1] * tt[2] + tt[4], Et = it[0] * tt[1] + it[1] * tt[3] + tt[5];
                return [ut, Et];
              }
              static applyInverseTransform(it, tt) {
                const ut = tt[0] * tt[3] - tt[1] * tt[2], Et = (it[0] * tt[3] - it[1] * tt[2] + tt[2] * tt[5] - tt[4] * tt[3]) / ut, kt = (-it[0] * tt[1] + it[1] * tt[0] + tt[4] * tt[1] - tt[5] * tt[0]) / ut;
                return [Et, kt];
              }
              static getAxialAlignedBoundingBox(it, tt) {
                const ut = this.applyTransform(it, tt), Et = this.applyTransform(it.slice(2, 4), tt), kt = this.applyTransform([it[0], it[3]], tt), rt = this.applyTransform([it[2], it[1]], tt);
                return [Math.min(ut[0], Et[0], kt[0], rt[0]), Math.min(ut[1], Et[1], kt[1], rt[1]), Math.max(ut[0], Et[0], kt[0], rt[0]), Math.max(ut[1], Et[1], kt[1], rt[1])];
              }
              static inverseTransform(it) {
                const tt = it[0] * it[3] - it[1] * it[2];
                return [it[3] / tt, -it[1] / tt, -it[2] / tt, it[0] / tt, (it[2] * it[5] - it[4] * it[3]) / tt, (it[4] * it[1] - it[5] * it[0]) / tt];
              }
              static singularValueDecompose2dScale(it) {
                const tt = [it[0], it[2], it[1], it[3]], ut = it[0] * tt[0] + it[1] * tt[2], Et = it[0] * tt[1] + it[1] * tt[3], kt = it[2] * tt[0] + it[3] * tt[2], rt = it[2] * tt[1] + it[3] * tt[3], dt = (ut + rt) / 2, bt = Math.sqrt((ut + rt) ** 2 - 4 * (ut * rt - kt * Et)) / 2, gt = dt + bt || 1, mt = dt - bt || 1;
                return [Math.sqrt(gt), Math.sqrt(mt)];
              }
              static normalizeRect(it) {
                const tt = it.slice(0);
                return it[0] > it[2] && (tt[0] = it[2], tt[2] = it[0]), it[1] > it[3] && (tt[1] = it[3], tt[3] = it[1]), tt;
              }
              static intersect(it, tt) {
                const ut = Math.max(Math.min(it[0], it[2]), Math.min(tt[0], tt[2])), Et = Math.min(Math.max(it[0], it[2]), Math.max(tt[0], tt[2]));
                if (ut > Et)
                  return null;
                const kt = Math.max(Math.min(it[1], it[3]), Math.min(tt[1], tt[3])), rt = Math.min(Math.max(it[1], it[3]), Math.max(tt[1], tt[3]));
                return kt > rt ? null : [ut, kt, Et, rt];
              }
              static bezierBoundingBox(it, tt, ut, Et, kt, rt, dt, bt) {
                const gt = [], mt = [[], []];
                let At, ht, Tt, St, Pt, It, Ft, Lt;
                for (let Ht = 0; Ht < 2; ++Ht) {
                  if (Ht === 0 ? (ht = 6 * it - 12 * ut + 6 * kt, At = -3 * it + 9 * ut - 9 * kt + 3 * dt, Tt = 3 * ut - 3 * it) : (ht = 6 * tt - 12 * Et + 6 * rt, At = -3 * tt + 9 * Et - 9 * rt + 3 * bt, Tt = 3 * Et - 3 * tt), Math.abs(At) < 1e-12) {
                    if (Math.abs(ht) < 1e-12)
                      continue;
                    St = -Tt / ht, 0 < St && St < 1 && gt.push(St);
                    continue;
                  }
                  Ft = ht * ht - 4 * Tt * At, Lt = Math.sqrt(Ft), !(Ft < 0) && (Pt = (-ht + Lt) / (2 * At), 0 < Pt && Pt < 1 && gt.push(Pt), It = (-ht - Lt) / (2 * At), 0 < It && It < 1 && gt.push(It));
                }
                let Bt = gt.length, Dt;
                const Vt = Bt;
                for (; Bt--; )
                  St = gt[Bt], Dt = 1 - St, mt[0][Bt] = Dt * Dt * Dt * it + 3 * Dt * Dt * St * ut + 3 * Dt * St * St * kt + St * St * St * dt, mt[1][Bt] = Dt * Dt * Dt * tt + 3 * Dt * Dt * St * Et + 3 * Dt * St * St * rt + St * St * St * bt;
                return mt[0][Vt] = it, mt[1][Vt] = tt, mt[0][Vt + 1] = dt, mt[1][Vt + 1] = bt, mt[0].length = mt[1].length = Vt + 2, [Math.min(...mt[0]), Math.min(...mt[1]), Math.max(...mt[0]), Math.max(...mt[1])];
              }
            }
            p.Util = lt;
            const ft = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
            function pt(ot) {
              if (ot[0] >= "ï") {
                let tt;
                if (ot[0] === "þ" && ot[1] === "ÿ" ? tt = "utf-16be" : ot[0] === "ÿ" && ot[1] === "þ" ? tt = "utf-16le" : ot[0] === "ï" && ot[1] === "»" && ot[2] === "¿" && (tt = "utf-8"), tt)
                  try {
                    const ut = new TextDecoder(tt, {
                      fatal: !0
                    }), Et = q(ot);
                    return ut.decode(Et);
                  } catch (ut) {
                    x(`stringToPDFString: "${ut}".`);
                  }
              }
              const it = [];
              for (let tt = 0, ut = ot.length; tt < ut; tt++) {
                const Et = ft[ot.charCodeAt(tt)];
                it.push(Et ? String.fromCharCode(Et) : ot.charAt(tt));
              }
              return it.join("");
            }
            function vt(ot) {
              return decodeURIComponent(escape(ot));
            }
            function yt(ot) {
              return unescape(encodeURIComponent(ot));
            }
            function xt(ot) {
              return typeof ot == "object" && ot?.byteLength !== void 0;
            }
            function wt(ot, it) {
              if (ot.length !== it.length)
                return !1;
              for (let tt = 0, ut = ot.length; tt < ut; tt++)
                if (ot[tt] !== it[tt])
                  return !1;
              return !0;
            }
            function _t() {
              let ot = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Date();
              return [ot.getUTCFullYear().toString(), (ot.getUTCMonth() + 1).toString().padStart(2, "0"), ot.getUTCDate().toString().padStart(2, "0"), ot.getUTCHours().toString().padStart(2, "0"), ot.getUTCMinutes().toString().padStart(2, "0"), ot.getUTCSeconds().toString().padStart(2, "0")].join("");
            }
            class Ct {
              #t = !1;
              constructor() {
                this.promise = new Promise((it, tt) => {
                  this.resolve = (ut) => {
                    this.#t = !0, it(ut);
                  }, this.reject = (ut) => {
                    this.#t = !0, tt(ut);
                  };
                });
              }
              get settled() {
                return this.#t;
              }
            }
            p.PromiseCapability = Ct;
            let Mt = null, Rt = null;
            function Nt(ot) {
              return Mt || (Mt = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, Rt = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), ot.replaceAll(Mt, (it, tt, ut) => tt ? tt.normalize("NFKC") : Rt.get(ut));
            }
            function Ut() {
              if (typeof crypto < "u" && typeof crypto?.randomUUID == "function")
                return crypto.randomUUID();
              const ot = new Uint8Array(32);
              if (typeof crypto < "u" && typeof crypto?.getRandomValues == "function")
                crypto.getRandomValues(ot);
              else
                for (let it = 0; it < 32; it++)
                  ot[it] = Math.floor(Math.random() * 255);
              return X(ot);
            }
            const Ot = "pdfjs_internal_id_";
            p.AnnotationPrefix = Ot;
          }),
          /* 2 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(4), S = t(69), E = t(70), v = "WebAssembly", T = f[v], i = Error("e", { cause: 7 }).cause !== 7, n = function(d, h) {
              var e = {};
              e[d] = E(d, h, i), a({
                global: !0,
                constructor: !0,
                arity: 1,
                forced: i
              }, e);
            }, o = function(d, h) {
              if (T && T[d]) {
                var e = {};
                e[d] = E(v + "." + d, h, i), a({
                  target: v,
                  stat: !0,
                  constructor: !0,
                  arity: 1,
                  forced: i
                }, e);
              }
            };
            n("Error", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), n("EvalError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), n("RangeError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), n("ReferenceError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), n("SyntaxError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), n("TypeError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), n("URIError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), o("CompileError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), o("LinkError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            }), o("RuntimeError", function(d) {
              return function(e) {
                return S(d, this, arguments);
              };
            });
          }),
          /* 3 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(5).f, S = t(44), E = t(48), v = t(38), T = t(56), i = t(68);
            P.exports = function(n, o) {
              var d = n.target, h = n.global, e = n.stat, l, u, c, y, C, R;
              if (h ? u = a : e ? u = a[d] || v(d, {}) : u = (a[d] || {}).prototype, u)
                for (c in o) {
                  if (C = o[c], n.dontCallGetSet ? (R = f(u, c), y = R && R.value) : y = u[c], l = i(h ? c : d + (e ? "." : "#") + c, n.forced), !l && y !== void 0) {
                    if (typeof C == typeof y)
                      continue;
                    T(C, y);
                  }
                  (n.sham || y && y.sham) && S(C, "sham", !0), E(u, c, C, n);
                }
            };
          }),
          /* 4 */
          /***/
          (function(P) {
            var p = function(t) {
              return t && t.Math === Math && t;
            };
            P.exports = p(typeof globalThis == "object" && globalThis) || p(typeof window == "object" && window) || p(typeof self == "object" && self) || p(typeof commonjsGlobal == "object" && commonjsGlobal) || /* @__PURE__ */ (function() {
              return this;
            })() || this || Function("return this")();
          }),
          /* 5 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(8), S = t(10), E = t(11), v = t(12), T = t(18), i = t(39), n = t(42), o = Object.getOwnPropertyDescriptor;
            p.f = a ? o : function(h, e) {
              if (h = v(h), e = T(e), n)
                try {
                  return o(h, e);
                } catch {
                }
              if (i(h, e))
                return E(!f(S.f, h, e), h[e]);
            };
          }),
          /* 6 */
          /***/
          ((P, p, t) => {
            var a = t(7);
            P.exports = !a(function() {
              return Object.defineProperty({}, 1, {
                get: function() {
                  return 7;
                }
              })[1] !== 7;
            });
          }),
          /* 7 */
          /***/
          ((P) => {
            P.exports = function(p) {
              try {
                return !!p();
              } catch {
                return !0;
              }
            };
          }),
          /* 8 */
          /***/
          ((P, p, t) => {
            var a = t(9), f = Function.prototype.call;
            P.exports = a ? f.bind(f) : function() {
              return f.apply(f, arguments);
            };
          }),
          /* 9 */
          /***/
          ((P, p, t) => {
            var a = t(7);
            P.exports = !a(function() {
              var f = (function() {
              }).bind();
              return typeof f != "function" || f.hasOwnProperty("prototype");
            });
          }),
          /* 10 */
          /***/
          ((P, p) => {
            var t = {}.propertyIsEnumerable, a = Object.getOwnPropertyDescriptor, f = a && !t.call({ 1: 2 }, 1);
            p.f = f ? function(E) {
              var v = a(this, E);
              return !!v && v.enumerable;
            } : t;
          }),
          /* 11 */
          /***/
          ((P) => {
            P.exports = function(p, t) {
              return {
                enumerable: !(p & 1),
                configurable: !(p & 2),
                writable: !(p & 4),
                value: t
              };
            };
          }),
          /* 12 */
          /***/
          ((P, p, t) => {
            var a = t(13), f = t(16);
            P.exports = function(S) {
              return a(f(S));
            };
          }),
          /* 13 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(7), S = t(15), E = Object, v = a("".split);
            P.exports = f(function() {
              return !E("z").propertyIsEnumerable(0);
            }) ? function(T) {
              return S(T) === "String" ? v(T, "") : E(T);
            } : E;
          }),
          /* 14 */
          /***/
          ((P, p, t) => {
            var a = t(9), f = Function.prototype, S = f.call, E = a && f.bind.bind(S, S);
            P.exports = a ? E : function(v) {
              return function() {
                return S.apply(v, arguments);
              };
            };
          }),
          /* 15 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = a({}.toString), S = a("".slice);
            P.exports = function(E) {
              return S(f(E), 8, -1);
            };
          }),
          /* 16 */
          /***/
          ((P, p, t) => {
            var a = t(17), f = TypeError;
            P.exports = function(S) {
              if (a(S))
                throw f("Can't call method on " + S);
              return S;
            };
          }),
          /* 17 */
          /***/
          ((P) => {
            P.exports = function(p) {
              return p == null;
            };
          }),
          /* 18 */
          /***/
          ((P, p, t) => {
            var a = t(19), f = t(23);
            P.exports = function(S) {
              var E = a(S, "string");
              return f(E) ? E : E + "";
            };
          }),
          /* 19 */
          /***/
          ((P, p, t) => {
            var a = t(8), f = t(20), S = t(23), E = t(30), v = t(33), T = t(34), i = TypeError, n = T("toPrimitive");
            P.exports = function(o, d) {
              if (!f(o) || S(o))
                return o;
              var h = E(o, n), e;
              if (h) {
                if (d === void 0 && (d = "default"), e = a(h, o, d), !f(e) || S(e))
                  return e;
                throw i("Can't convert object to primitive value");
              }
              return d === void 0 && (d = "number"), v(o, d);
            };
          }),
          /* 20 */
          /***/
          ((P, p, t) => {
            var a = t(21), f = t(22), S = f.all;
            P.exports = f.IS_HTMLDDA ? function(E) {
              return typeof E == "object" ? E !== null : a(E) || E === S;
            } : function(E) {
              return typeof E == "object" ? E !== null : a(E);
            };
          }),
          /* 21 */
          /***/
          ((P, p, t) => {
            var a = t(22), f = a.all;
            P.exports = a.IS_HTMLDDA ? function(S) {
              return typeof S == "function" || S === f;
            } : function(S) {
              return typeof S == "function";
            };
          }),
          /* 22 */
          /***/
          ((P) => {
            var p = typeof document == "object" && document.all, t = typeof p > "u" && p !== void 0;
            P.exports = {
              all: p,
              IS_HTMLDDA: t
            };
          }),
          /* 23 */
          /***/
          ((P, p, t) => {
            var a = t(24), f = t(21), S = t(25), E = t(26), v = Object;
            P.exports = E ? function(T) {
              return typeof T == "symbol";
            } : function(T) {
              var i = a("Symbol");
              return f(i) && S(i.prototype, v(T));
            };
          }),
          /* 24 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(21), S = function(E) {
              return f(E) ? E : void 0;
            };
            P.exports = function(E, v) {
              return arguments.length < 2 ? S(a[E]) : a[E] && a[E][v];
            };
          }),
          /* 25 */
          /***/
          ((P, p, t) => {
            var a = t(14);
            P.exports = a({}.isPrototypeOf);
          }),
          /* 26 */
          /***/
          ((P, p, t) => {
            var a = t(27);
            P.exports = a && !Symbol.sham && typeof Symbol.iterator == "symbol";
          }),
          /* 27 */
          /***/
          ((P, p, t) => {
            var a = t(28), f = t(7), S = t(4), E = S.String;
            P.exports = !!Object.getOwnPropertySymbols && !f(function() {
              var v = /* @__PURE__ */ Symbol("symbol detection");
              return !E(v) || !(Object(v) instanceof Symbol) || !Symbol.sham && a && a < 41;
            });
          }),
          /* 28 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(29), S = a.process, E = a.Deno, v = S && S.versions || E && E.version, T = v && v.v8, i, n;
            T && (i = T.split("."), n = i[0] > 0 && i[0] < 4 ? 1 : +(i[0] + i[1])), !n && f && (i = f.match(/Edge\/(\d+)/), (!i || i[1] >= 74) && (i = f.match(/Chrome\/(\d+)/), i && (n = +i[1]))), P.exports = n;
          }),
          /* 29 */
          /***/
          ((P) => {
            P.exports = typeof navigator < "u" && String(navigator.userAgent) || "";
          }),
          /* 30 */
          /***/
          ((P, p, t) => {
            var a = t(31), f = t(17);
            P.exports = function(S, E) {
              var v = S[E];
              return f(v) ? void 0 : a(v);
            };
          }),
          /* 31 */
          /***/
          ((P, p, t) => {
            var a = t(21), f = t(32), S = TypeError;
            P.exports = function(E) {
              if (a(E))
                return E;
              throw S(f(E) + " is not a function");
            };
          }),
          /* 32 */
          /***/
          ((P) => {
            var p = String;
            P.exports = function(t) {
              try {
                return p(t);
              } catch {
                return "Object";
              }
            };
          }),
          /* 33 */
          /***/
          ((P, p, t) => {
            var a = t(8), f = t(21), S = t(20), E = TypeError;
            P.exports = function(v, T) {
              var i, n;
              if (T === "string" && f(i = v.toString) && !S(n = a(i, v)) || f(i = v.valueOf) && !S(n = a(i, v)) || T !== "string" && f(i = v.toString) && !S(n = a(i, v)))
                return n;
              throw E("Can't convert object to primitive value");
            };
          }),
          /* 34 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(35), S = t(39), E = t(41), v = t(27), T = t(26), i = a.Symbol, n = f("wks"), o = T ? i.for || i : i && i.withoutSetter || E;
            P.exports = function(d) {
              return S(n, d) || (n[d] = v && S(i, d) ? i[d] : o("Symbol." + d)), n[d];
            };
          }),
          /* 35 */
          /***/
          ((P, p, t) => {
            var a = t(36), f = t(37);
            (P.exports = function(S, E) {
              return f[S] || (f[S] = E !== void 0 ? E : {});
            })("versions", []).push({
              version: "3.32.2",
              mode: a ? "pure" : "global",
              copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
              license: "https://github.com/zloirock/core-js/blob/v3.32.2/LICENSE",
              source: "https://github.com/zloirock/core-js"
            });
          }),
          /* 36 */
          /***/
          ((P) => {
            P.exports = !1;
          }),
          /* 37 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(38), S = "__core-js_shared__", E = a[S] || f(S, {});
            P.exports = E;
          }),
          /* 38 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = Object.defineProperty;
            P.exports = function(S, E) {
              try {
                f(a, S, {
                  value: E,
                  configurable: !0,
                  writable: !0
                });
              } catch {
                a[S] = E;
              }
              return E;
            };
          }),
          /* 39 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(40), S = a({}.hasOwnProperty);
            P.exports = Object.hasOwn || function(v, T) {
              return S(f(v), T);
            };
          }),
          /* 40 */
          /***/
          ((P, p, t) => {
            var a = t(16), f = Object;
            P.exports = function(S) {
              return f(a(S));
            };
          }),
          /* 41 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = 0, S = Math.random(), E = a(1 .toString);
            P.exports = function(v) {
              return "Symbol(" + (v === void 0 ? "" : v) + ")_" + E(++f + S, 36);
            };
          }),
          /* 42 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(7), S = t(43);
            P.exports = !a && !f(function() {
              return Object.defineProperty(S("div"), "a", {
                get: function() {
                  return 7;
                }
              }).a !== 7;
            });
          }),
          /* 43 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(20), S = a.document, E = f(S) && f(S.createElement);
            P.exports = function(v) {
              return E ? S.createElement(v) : {};
            };
          }),
          /* 44 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(45), S = t(11);
            P.exports = a ? function(E, v, T) {
              return f.f(E, v, S(1, T));
            } : function(E, v, T) {
              return E[v] = T, E;
            };
          }),
          /* 45 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(42), S = t(46), E = t(47), v = t(18), T = TypeError, i = Object.defineProperty, n = Object.getOwnPropertyDescriptor, o = "enumerable", d = "configurable", h = "writable";
            p.f = a ? S ? function(l, u, c) {
              if (E(l), u = v(u), E(c), typeof l == "function" && u === "prototype" && "value" in c && h in c && !c[h]) {
                var y = n(l, u);
                y && y[h] && (l[u] = c.value, c = {
                  configurable: d in c ? c[d] : y[d],
                  enumerable: o in c ? c[o] : y[o],
                  writable: !1
                });
              }
              return i(l, u, c);
            } : i : function(l, u, c) {
              if (E(l), u = v(u), E(c), f)
                try {
                  return i(l, u, c);
                } catch {
                }
              if ("get" in c || "set" in c)
                throw T("Accessors not supported");
              return "value" in c && (l[u] = c.value), l;
            };
          }),
          /* 46 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(7);
            P.exports = a && f(function() {
              return Object.defineProperty(function() {
              }, "prototype", {
                value: 42,
                writable: !1
              }).prototype !== 42;
            });
          }),
          /* 47 */
          /***/
          ((P, p, t) => {
            var a = t(20), f = String, S = TypeError;
            P.exports = function(E) {
              if (a(E))
                return E;
              throw S(f(E) + " is not an object");
            };
          }),
          /* 48 */
          /***/
          ((P, p, t) => {
            var a = t(21), f = t(45), S = t(49), E = t(38);
            P.exports = function(v, T, i, n) {
              n || (n = {});
              var o = n.enumerable, d = n.name !== void 0 ? n.name : T;
              if (a(i) && S(i, d, n), n.global)
                o ? v[T] = i : E(T, i);
              else {
                try {
                  n.unsafe ? v[T] && (o = !0) : delete v[T];
                } catch {
                }
                o ? v[T] = i : f.f(v, T, {
                  value: i,
                  enumerable: !1,
                  configurable: !n.nonConfigurable,
                  writable: !n.nonWritable
                });
              }
              return v;
            };
          }),
          /* 49 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(7), S = t(21), E = t(39), v = t(6), T = t(50).CONFIGURABLE, i = t(51), n = t(52), o = n.enforce, d = n.get, h = String, e = Object.defineProperty, l = a("".slice), u = a("".replace), c = a([].join), y = v && !f(function() {
              return e(function() {
              }, "length", { value: 8 }).length !== 8;
            }), C = String(String).split("String"), R = P.exports = function(s, m, F) {
              l(h(m), 0, 7) === "Symbol(" && (m = "[" + u(h(m), /^Symbol\(([^)]*)\)/, "$1") + "]"), F && F.getter && (m = "get " + m), F && F.setter && (m = "set " + m), (!E(s, "name") || T && s.name !== m) && (v ? e(s, "name", {
                value: m,
                configurable: !0
              }) : s.name = m), y && F && E(F, "arity") && s.length !== F.arity && e(s, "length", { value: F.arity });
              try {
                F && E(F, "constructor") && F.constructor ? v && e(s, "prototype", { writable: !1 }) : s.prototype && (s.prototype = void 0);
              } catch {
              }
              var B = o(s);
              return E(B, "source") || (B.source = c(C, typeof m == "string" ? m : "")), s;
            };
            Function.prototype.toString = R(function() {
              return S(this) && d(this).source || i(this);
            }, "toString");
          }),
          /* 50 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(39), S = Function.prototype, E = a && Object.getOwnPropertyDescriptor, v = f(S, "name"), T = v && (function() {
            }).name === "something", i = v && (!a || a && E(S, "name").configurable);
            P.exports = {
              EXISTS: v,
              PROPER: T,
              CONFIGURABLE: i
            };
          }),
          /* 51 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(21), S = t(37), E = a(Function.toString);
            f(S.inspectSource) || (S.inspectSource = function(v) {
              return E(v);
            }), P.exports = S.inspectSource;
          }),
          /* 52 */
          /***/
          ((P, p, t) => {
            var a = t(53), f = t(4), S = t(20), E = t(44), v = t(39), T = t(37), i = t(54), n = t(55), o = "Object already initialized", d = f.TypeError, h = f.WeakMap, e, l, u, c = function(s) {
              return u(s) ? l(s) : e(s, {});
            }, y = function(s) {
              return function(m) {
                var F;
                if (!S(m) || (F = l(m)).type !== s)
                  throw d("Incompatible receiver, " + s + " required");
                return F;
              };
            };
            if (a || T.state) {
              var C = T.state || (T.state = new h());
              C.get = C.get, C.has = C.has, C.set = C.set, e = function(s, m) {
                if (C.has(s))
                  throw d(o);
                return m.facade = s, C.set(s, m), m;
              }, l = function(s) {
                return C.get(s) || {};
              }, u = function(s) {
                return C.has(s);
              };
            } else {
              var R = i("state");
              n[R] = !0, e = function(s, m) {
                if (v(s, R))
                  throw d(o);
                return m.facade = s, E(s, R, m), m;
              }, l = function(s) {
                return v(s, R) ? s[R] : {};
              }, u = function(s) {
                return v(s, R);
              };
            }
            P.exports = {
              set: e,
              get: l,
              has: u,
              enforce: c,
              getterFor: y
            };
          }),
          /* 53 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(21), S = a.WeakMap;
            P.exports = f(S) && /native code/.test(String(S));
          }),
          /* 54 */
          /***/
          ((P, p, t) => {
            var a = t(35), f = t(41), S = a("keys");
            P.exports = function(E) {
              return S[E] || (S[E] = f(E));
            };
          }),
          /* 55 */
          /***/
          ((P) => {
            P.exports = {};
          }),
          /* 56 */
          /***/
          ((P, p, t) => {
            var a = t(39), f = t(57), S = t(5), E = t(45);
            P.exports = function(v, T, i) {
              for (var n = f(T), o = E.f, d = S.f, h = 0; h < n.length; h++) {
                var e = n[h];
                !a(v, e) && !(i && a(i, e)) && o(v, e, d(T, e));
              }
            };
          }),
          /* 57 */
          /***/
          ((P, p, t) => {
            var a = t(24), f = t(14), S = t(58), E = t(67), v = t(47), T = f([].concat);
            P.exports = a("Reflect", "ownKeys") || function(n) {
              var o = S.f(v(n)), d = E.f;
              return d ? T(o, d(n)) : o;
            };
          }),
          /* 58 */
          /***/
          ((P, p, t) => {
            var a = t(59), f = t(66), S = f.concat("length", "prototype");
            p.f = Object.getOwnPropertyNames || function(v) {
              return a(v, S);
            };
          }),
          /* 59 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(39), S = t(12), E = t(60).indexOf, v = t(55), T = a([].push);
            P.exports = function(i, n) {
              var o = S(i), d = 0, h = [], e;
              for (e in o)
                !f(v, e) && f(o, e) && T(h, e);
              for (; n.length > d; )
                f(o, e = n[d++]) && (~E(h, e) || T(h, e));
              return h;
            };
          }),
          /* 60 */
          /***/
          ((P, p, t) => {
            var a = t(12), f = t(61), S = t(64), E = function(v) {
              return function(T, i, n) {
                var o = a(T), d = S(o), h = f(n, d), e;
                if (v && i !== i) {
                  for (; d > h; )
                    if (e = o[h++], e !== e)
                      return !0;
                } else
                  for (; d > h; h++)
                    if ((v || h in o) && o[h] === i)
                      return v || h || 0;
                return !v && -1;
              };
            };
            P.exports = {
              includes: E(!0),
              indexOf: E(!1)
            };
          }),
          /* 61 */
          /***/
          ((P, p, t) => {
            var a = t(62), f = Math.max, S = Math.min;
            P.exports = function(E, v) {
              var T = a(E);
              return T < 0 ? f(T + v, 0) : S(T, v);
            };
          }),
          /* 62 */
          /***/
          ((P, p, t) => {
            var a = t(63);
            P.exports = function(f) {
              var S = +f;
              return S !== S || S === 0 ? 0 : a(S);
            };
          }),
          /* 63 */
          /***/
          ((P) => {
            var p = Math.ceil, t = Math.floor;
            P.exports = Math.trunc || function(f) {
              var S = +f;
              return (S > 0 ? t : p)(S);
            };
          }),
          /* 64 */
          /***/
          ((P, p, t) => {
            var a = t(65);
            P.exports = function(f) {
              return a(f.length);
            };
          }),
          /* 65 */
          /***/
          ((P, p, t) => {
            var a = t(62), f = Math.min;
            P.exports = function(S) {
              return S > 0 ? f(a(S), 9007199254740991) : 0;
            };
          }),
          /* 66 */
          /***/
          ((P) => {
            P.exports = [
              "constructor",
              "hasOwnProperty",
              "isPrototypeOf",
              "propertyIsEnumerable",
              "toLocaleString",
              "toString",
              "valueOf"
            ];
          }),
          /* 67 */
          /***/
          ((P, p) => {
            p.f = Object.getOwnPropertySymbols;
          }),
          /* 68 */
          /***/
          ((P, p, t) => {
            var a = t(7), f = t(21), S = /#|\.prototype\./, E = function(o, d) {
              var h = T[v(o)];
              return h === n ? !0 : h === i ? !1 : f(d) ? a(d) : !!d;
            }, v = E.normalize = function(o) {
              return String(o).replace(S, ".").toLowerCase();
            }, T = E.data = {}, i = E.NATIVE = "N", n = E.POLYFILL = "P";
            P.exports = E;
          }),
          /* 69 */
          /***/
          ((P, p, t) => {
            var a = t(9), f = Function.prototype, S = f.apply, E = f.call;
            P.exports = typeof Reflect == "object" && Reflect.apply || (a ? E.bind(S) : function() {
              return E.apply(S, arguments);
            });
          }),
          /* 70 */
          /***/
          ((P, p, t) => {
            var a = t(24), f = t(39), S = t(44), E = t(25), v = t(71), T = t(56), i = t(74), n = t(75), o = t(76), d = t(80), h = t(81), e = t(6), l = t(36);
            P.exports = function(u, c, y, C) {
              var R = "stackTraceLimit", s = C ? 2 : 1, m = u.split("."), F = m[m.length - 1], B = a.apply(null, m);
              if (B) {
                var k = B.prototype;
                if (!l && f(k, "cause") && delete k.cause, !y)
                  return B;
                var V = a("Error"), z = c(function(K, J) {
                  var $ = o(C ? J : K, void 0), j = C ? new B(K) : new B();
                  return $ !== void 0 && S(j, "message", $), h(j, z, j.stack, 2), this && E(k, this) && n(j, this, z), arguments.length > s && d(j, arguments[s]), j;
                });
                if (z.prototype = k, F !== "Error" ? v ? v(z, V) : T(z, V, { name: !0 }) : e && R in B && (i(z, B, R), i(z, B, "prepareStackTrace")), T(z, B), !l)
                  try {
                    k.name !== F && S(k, "name", F), k.constructor = z;
                  } catch {
                  }
                return z;
              }
            };
          }),
          /* 71 */
          /***/
          ((P, p, t) => {
            var a = t(72), f = t(47), S = t(73);
            P.exports = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
              var E = !1, v = {}, T;
              try {
                T = a(Object.prototype, "__proto__", "set"), T(v, []), E = v instanceof Array;
              } catch {
              }
              return function(n, o) {
                return f(n), S(o), E ? T(n, o) : n.__proto__ = o, n;
              };
            })() : void 0);
          }),
          /* 72 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(31);
            P.exports = function(S, E, v) {
              try {
                return a(f(Object.getOwnPropertyDescriptor(S, E)[v]));
              } catch {
              }
            };
          }),
          /* 73 */
          /***/
          ((P, p, t) => {
            var a = t(21), f = String, S = TypeError;
            P.exports = function(E) {
              if (typeof E == "object" || a(E))
                return E;
              throw S("Can't set " + f(E) + " as a prototype");
            };
          }),
          /* 74 */
          /***/
          ((P, p, t) => {
            var a = t(45).f;
            P.exports = function(f, S, E) {
              E in f || a(f, E, {
                configurable: !0,
                get: function() {
                  return S[E];
                },
                set: function(v) {
                  S[E] = v;
                }
              });
            };
          }),
          /* 75 */
          /***/
          ((P, p, t) => {
            var a = t(21), f = t(20), S = t(71);
            P.exports = function(E, v, T) {
              var i, n;
              return S && a(i = v.constructor) && i !== T && f(n = i.prototype) && n !== T.prototype && S(E, n), E;
            };
          }),
          /* 76 */
          /***/
          ((P, p, t) => {
            var a = t(77);
            P.exports = function(f, S) {
              return f === void 0 ? arguments.length < 2 ? "" : S : a(f);
            };
          }),
          /* 77 */
          /***/
          ((P, p, t) => {
            var a = t(78), f = String;
            P.exports = function(S) {
              if (a(S) === "Symbol")
                throw TypeError("Cannot convert a Symbol value to a string");
              return f(S);
            };
          }),
          /* 78 */
          /***/
          ((P, p, t) => {
            var a = t(79), f = t(21), S = t(15), E = t(34), v = E("toStringTag"), T = Object, i = S(/* @__PURE__ */ (function() {
              return arguments;
            })()) === "Arguments", n = function(o, d) {
              try {
                return o[d];
              } catch {
              }
            };
            P.exports = a ? S : function(o) {
              var d, h, e;
              return o === void 0 ? "Undefined" : o === null ? "Null" : typeof (h = n(d = T(o), v)) == "string" ? h : i ? S(d) : (e = S(d)) === "Object" && f(d.callee) ? "Arguments" : e;
            };
          }),
          /* 79 */
          /***/
          ((P, p, t) => {
            var a = t(34), f = a("toStringTag"), S = {};
            S[f] = "z", P.exports = String(S) === "[object z]";
          }),
          /* 80 */
          /***/
          ((P, p, t) => {
            var a = t(20), f = t(44);
            P.exports = function(S, E) {
              a(E) && "cause" in E && f(S, "cause", E.cause);
            };
          }),
          /* 81 */
          /***/
          ((P, p, t) => {
            var a = t(44), f = t(82), S = t(83), E = Error.captureStackTrace;
            P.exports = function(v, T, i, n) {
              S && (E ? E(v, T) : a(v, "stack", f(i, n)));
            };
          }),
          /* 82 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = Error, S = a("".replace), E = (function(i) {
              return String(f(i).stack);
            })("zxcasd"), v = /\n\s*at [^:]*:[^\n]*/, T = v.test(E);
            P.exports = function(i, n) {
              if (T && typeof i == "string" && !f.prepareStackTrace)
                for (; n--; )
                  i = S(i, v, "");
              return i;
            };
          }),
          /* 83 */
          /***/
          ((P, p, t) => {
            var a = t(7), f = t(11);
            P.exports = !a(function() {
              var S = Error("a");
              return "stack" in S ? (Object.defineProperty(S, "stack", f(1, 7)), S.stack !== 7) : !0;
            });
          }),
          /* 84 */
          /***/
          ((P, p, t) => {
            var a = t(48), f = t(14), S = t(77), E = t(85), v = URLSearchParams, T = v.prototype, i = f(T.append), n = f(T.delete), o = f(T.forEach), d = f([].push), h = new v("a=1&a=2&b=3");
            h.delete("a", 1), h.delete("b", void 0), h + "" != "a=2" && a(T, "delete", function(e) {
              var l = arguments.length, u = l < 2 ? void 0 : arguments[1];
              if (l && u === void 0)
                return n(this, e);
              var c = [];
              o(this, function(k, V) {
                d(c, {
                  key: V,
                  value: k
                });
              }), E(l, 1);
              for (var y = S(e), C = S(u), R = 0, s = 0, m = !1, F = c.length, B; R < F; )
                B = c[R++], m || B.key === y ? (m = !0, n(this, B.key)) : s++;
              for (; s < F; )
                B = c[s++], B.key === y && B.value === C || i(this, B.key, B.value);
            }, {
              enumerable: !0,
              unsafe: !0
            });
          }),
          /* 85 */
          /***/
          ((P) => {
            var p = TypeError;
            P.exports = function(t, a) {
              if (t < a)
                throw p("Not enough arguments");
              return t;
            };
          }),
          /* 86 */
          /***/
          ((P, p, t) => {
            var a = t(48), f = t(14), S = t(77), E = t(85), v = URLSearchParams, T = v.prototype, i = f(T.getAll), n = f(T.has), o = new v("a=1");
            (o.has("a", 2) || !o.has("a", void 0)) && a(T, "has", function(h) {
              var e = arguments.length, l = e < 2 ? void 0 : arguments[1];
              if (e && l === void 0)
                return n(this, h);
              var u = i(this, h);
              E(e, 1);
              for (var c = S(l), y = 0; y < u.length; )
                if (u[y++] === c)
                  return !0;
              return !1;
            }, {
              enumerable: !0,
              unsafe: !0
            });
          }),
          /* 87 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(14), S = t(88), E = URLSearchParams.prototype, v = f(E.forEach);
            a && !("size" in E) && S(E, "size", {
              get: function() {
                var i = 0;
                return v(this, function() {
                  i++;
                }), i;
              },
              configurable: !0,
              enumerable: !0
            });
          }),
          /* 88 */
          /***/
          ((P, p, t) => {
            var a = t(49), f = t(45);
            P.exports = function(S, E, v) {
              return v.get && a(v.get, E, { getter: !0 }), v.set && a(v.set, E, { setter: !0 }), f.f(S, E, v);
            };
          }),
          /* 89 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(40), S = t(64), E = t(90), v = t(92), T = t(7), i = T(function() {
              return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
            }), n = function() {
              try {
                Object.defineProperty([], "length", { writable: !1 }).push();
              } catch (d) {
                return d instanceof TypeError;
              }
            }, o = i || !n();
            a({
              target: "Array",
              proto: !0,
              arity: 1,
              forced: o
            }, {
              push: function(h) {
                var e = f(this), l = S(e), u = arguments.length;
                v(l + u);
                for (var c = 0; c < u; c++)
                  e[l] = arguments[c], l++;
                return E(e, l), l;
              }
            });
          }),
          /* 90 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(91), S = TypeError, E = Object.getOwnPropertyDescriptor, v = a && !(function() {
              if (this !== void 0)
                return !0;
              try {
                Object.defineProperty([], "length", { writable: !1 }).length = 1;
              } catch (T) {
                return T instanceof TypeError;
              }
            })();
            P.exports = v ? function(T, i) {
              if (f(T) && !E(T, "length").writable)
                throw S("Cannot set read only .length");
              return T.length = i;
            } : function(T, i) {
              return T.length = i;
            };
          }),
          /* 91 */
          /***/
          ((P, p, t) => {
            var a = t(15);
            P.exports = Array.isArray || function(S) {
              return a(S) === "Array";
            };
          }),
          /* 92 */
          /***/
          ((P) => {
            var p = TypeError, t = 9007199254740991;
            P.exports = function(a) {
              if (a > t)
                throw p("Maximum allowed index exceeded");
              return a;
            };
          }),
          /* 93 */
          /***/
          ((P, p, t) => {
            var a = t(94), f = t(98).findLast, S = a.aTypedArray, E = a.exportTypedArrayMethod;
            E("findLast", function(T) {
              return f(S(this), T, arguments.length > 1 ? arguments[1] : void 0);
            });
          }),
          /* 94 */
          /***/
          ((P, p, t) => {
            var a = t(95), f = t(6), S = t(4), E = t(21), v = t(20), T = t(39), i = t(78), n = t(32), o = t(44), d = t(48), h = t(88), e = t(25), l = t(96), u = t(71), c = t(34), y = t(41), C = t(52), R = C.enforce, s = C.get, m = S.Int8Array, F = m && m.prototype, B = S.Uint8ClampedArray, k = B && B.prototype, V = m && l(m), z = F && l(F), K = Object.prototype, J = S.TypeError, $ = c("toStringTag"), j = y("TYPED_ARRAY_TAG"), G = "TypedArrayConstructor", M = a && !!u && i(S.opera) !== "Opera", x = !1, A, g, I, U = {
              Int8Array: 1,
              Uint8Array: 1,
              Uint8ClampedArray: 1,
              Int16Array: 2,
              Uint16Array: 2,
              Int32Array: 4,
              Uint32Array: 4,
              Float32Array: 4,
              Float64Array: 8
            }, _ = {
              BigInt64Array: 8,
              BigUint64Array: 8
            }, H = function(X) {
              if (!v(X))
                return !1;
              var q = i(X);
              return q === "DataView" || T(U, q) || T(_, q);
            }, N = function(W) {
              var X = l(W);
              if (v(X)) {
                var q = s(X);
                return q && T(q, G) ? q[G] : N(X);
              }
            }, b = function(W) {
              if (!v(W))
                return !1;
              var X = i(W);
              return T(U, X) || T(_, X);
            }, w = function(W) {
              if (b(W))
                return W;
              throw J("Target is not a typed array");
            }, O = function(W) {
              if (E(W) && (!u || e(V, W)))
                return W;
              throw J(n(W) + " is not a typed array constructor");
            }, D = function(W, X, q, ct) {
              if (f) {
                if (q)
                  for (var nt in U) {
                    var Y = S[nt];
                    if (Y && T(Y.prototype, W))
                      try {
                        delete Y.prototype[W];
                      } catch {
                        try {
                          Y.prototype[W] = X;
                        } catch {
                        }
                      }
                  }
                (!z[W] || q) && d(z, W, q ? X : M && F[W] || X, ct);
              }
            }, L = function(W, X, q) {
              var ct, nt;
              if (f) {
                if (u) {
                  if (q) {
                    for (ct in U)
                      if (nt = S[ct], nt && T(nt, W))
                        try {
                          delete nt[W];
                        } catch {
                        }
                  }
                  if (!V[W] || q)
                    try {
                      return d(V, W, q ? X : M && V[W] || X);
                    } catch {
                    }
                  else
                    return;
                }
                for (ct in U)
                  nt = S[ct], nt && (!nt[W] || q) && d(nt, W, X);
              }
            };
            for (A in U)
              g = S[A], I = g && g.prototype, I ? R(I)[G] = g : M = !1;
            for (A in _)
              g = S[A], I = g && g.prototype, I && (R(I)[G] = g);
            if ((!M || !E(V) || V === Function.prototype) && (V = function() {
              throw J("Incorrect invocation");
            }, M))
              for (A in U)
                S[A] && u(S[A], V);
            if ((!M || !z || z === K) && (z = V.prototype, M))
              for (A in U)
                S[A] && u(S[A].prototype, z);
            if (M && l(k) !== z && u(k, z), f && !T(z, $)) {
              x = !0, h(z, $, {
                configurable: !0,
                get: function() {
                  return v(this) ? this[j] : void 0;
                }
              });
              for (A in U)
                S[A] && o(S[A], j, A);
            }
            P.exports = {
              NATIVE_ARRAY_BUFFER_VIEWS: M,
              TYPED_ARRAY_TAG: x && j,
              aTypedArray: w,
              aTypedArrayConstructor: O,
              exportTypedArrayMethod: D,
              exportTypedArrayStaticMethod: L,
              getTypedArrayConstructor: N,
              isView: H,
              isTypedArray: b,
              TypedArray: V,
              TypedArrayPrototype: z
            };
          }),
          /* 95 */
          /***/
          ((P) => {
            P.exports = typeof ArrayBuffer < "u" && typeof DataView < "u";
          }),
          /* 96 */
          /***/
          ((P, p, t) => {
            var a = t(39), f = t(21), S = t(40), E = t(54), v = t(97), T = E("IE_PROTO"), i = Object, n = i.prototype;
            P.exports = v ? i.getPrototypeOf : function(o) {
              var d = S(o);
              if (a(d, T))
                return d[T];
              var h = d.constructor;
              return f(h) && d instanceof h ? h.prototype : d instanceof i ? n : null;
            };
          }),
          /* 97 */
          /***/
          ((P, p, t) => {
            var a = t(7);
            P.exports = !a(function() {
              function f() {
              }
              return f.prototype.constructor = null, Object.getPrototypeOf(new f()) !== f.prototype;
            });
          }),
          /* 98 */
          /***/
          ((P, p, t) => {
            var a = t(99), f = t(13), S = t(40), E = t(64), v = function(T) {
              var i = T === 1;
              return function(n, o, d) {
                for (var h = S(n), e = f(h), l = a(o, d), u = E(e), c, y; u-- > 0; )
                  if (c = e[u], y = l(c, u, h), y)
                    switch (T) {
                      case 0:
                        return c;
                      case 1:
                        return u;
                    }
                return i ? -1 : void 0;
              };
            };
            P.exports = {
              findLast: v(0),
              findLastIndex: v(1)
            };
          }),
          /* 99 */
          /***/
          ((P, p, t) => {
            var a = t(100), f = t(31), S = t(9), E = a(a.bind);
            P.exports = function(v, T) {
              return f(v), T === void 0 ? v : S ? E(v, T) : function() {
                return v.apply(T, arguments);
              };
            };
          }),
          /* 100 */
          /***/
          ((P, p, t) => {
            var a = t(15), f = t(14);
            P.exports = function(S) {
              if (a(S) === "Function")
                return f(S);
            };
          }),
          /* 101 */
          /***/
          ((P, p, t) => {
            var a = t(94), f = t(98).findLastIndex, S = a.aTypedArray, E = a.exportTypedArrayMethod;
            E("findLastIndex", function(T) {
              return f(S(this), T, arguments.length > 1 ? arguments[1] : void 0);
            });
          }),
          /* 102 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(8), S = t(94), E = t(64), v = t(103), T = t(40), i = t(7), n = a.RangeError, o = a.Int8Array, d = o && o.prototype, h = d && d.set, e = S.aTypedArray, l = S.exportTypedArrayMethod, u = !i(function() {
              var y = new Uint8ClampedArray(2);
              return f(h, y, {
                length: 1,
                0: 3
              }, 1), y[1] !== 3;
            }), c = u && S.NATIVE_ARRAY_BUFFER_VIEWS && i(function() {
              var y = new o(2);
              return y.set(1), y.set("2", 1), y[0] !== 0 || y[1] !== 2;
            });
            l("set", function(C) {
              e(this);
              var R = v(arguments.length > 1 ? arguments[1] : void 0, 1), s = T(C);
              if (u)
                return f(h, this, s, R);
              var m = this.length, F = E(s), B = 0;
              if (F + R > m)
                throw n("Wrong length");
              for (; B < F; )
                this[R + B] = s[B++];
            }, !u || c);
          }),
          /* 103 */
          /***/
          ((P, p, t) => {
            var a = t(104), f = RangeError;
            P.exports = function(S, E) {
              var v = a(S);
              if (v % E)
                throw f("Wrong offset");
              return v;
            };
          }),
          /* 104 */
          /***/
          ((P, p, t) => {
            var a = t(62), f = RangeError;
            P.exports = function(S) {
              var E = a(S);
              if (E < 0)
                throw f("The argument can't be less than 0");
              return E;
            };
          }),
          /* 105 */
          /***/
          ((P, p, t) => {
            var a = t(106), f = t(94), S = f.aTypedArray, E = f.exportTypedArrayMethod, v = f.getTypedArrayConstructor;
            E("toReversed", function() {
              return a(S(this), v(this));
            });
          }),
          /* 106 */
          /***/
          ((P, p, t) => {
            var a = t(64);
            P.exports = function(f, S) {
              for (var E = a(f), v = new S(E), T = 0; T < E; T++)
                v[T] = f[E - T - 1];
              return v;
            };
          }),
          /* 107 */
          /***/
          ((P, p, t) => {
            var a = t(94), f = t(14), S = t(31), E = t(108), v = a.aTypedArray, T = a.getTypedArrayConstructor, i = a.exportTypedArrayMethod, n = f(a.TypedArrayPrototype.sort);
            i("toSorted", function(d) {
              d !== void 0 && S(d);
              var h = v(this), e = E(T(h), h);
              return n(e, d);
            });
          }),
          /* 108 */
          /***/
          ((P, p, t) => {
            var a = t(64);
            P.exports = function(f, S) {
              for (var E = 0, v = a(S), T = new f(v); v > E; )
                T[E] = S[E++];
              return T;
            };
          }),
          /* 109 */
          /***/
          ((P, p, t) => {
            var a = t(110), f = t(94), S = t(111), E = t(62), v = t(112), T = f.aTypedArray, i = f.getTypedArrayConstructor, n = f.exportTypedArrayMethod, o = !!(function() {
              try {
                new Int8Array(1).with(2, {
                  valueOf: function() {
                    throw 8;
                  }
                });
              } catch (d) {
                return d === 8;
              }
            })();
            n("with", function(d, h) {
              var e = T(this), l = E(d), u = S(e) ? v(h) : +h;
              return a(e, i(e), l, u);
            }, !o);
          }),
          /* 110 */
          /***/
          ((P, p, t) => {
            var a = t(64), f = t(62), S = RangeError;
            P.exports = function(E, v, T, i) {
              var n = a(E), o = f(T), d = o < 0 ? n + o : o;
              if (d >= n || d < 0)
                throw S("Incorrect index");
              for (var h = new v(n), e = 0; e < n; e++)
                h[e] = e === d ? i : E[e];
              return h;
            };
          }),
          /* 111 */
          /***/
          ((P, p, t) => {
            var a = t(78);
            P.exports = function(f) {
              var S = a(f);
              return S === "BigInt64Array" || S === "BigUint64Array";
            };
          }),
          /* 112 */
          /***/
          ((P, p, t) => {
            var a = t(19), f = TypeError;
            P.exports = function(S) {
              var E = a(S, "number");
              if (typeof E == "number")
                throw f("Can't convert number to bigint");
              return BigInt(E);
            };
          }),
          /* 113 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(88), S = t(114), E = ArrayBuffer.prototype;
            a && !("detached" in E) && f(E, "detached", {
              configurable: !0,
              get: function() {
                return S(this);
              }
            });
          }),
          /* 114 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(115), S = a(ArrayBuffer.prototype.slice);
            P.exports = function(E) {
              if (f(E) !== 0)
                return !1;
              try {
                return S(E, 0, 0), !1;
              } catch {
                return !0;
              }
            };
          }),
          /* 115 */
          /***/
          ((P, p, t) => {
            var a = t(72), f = t(15), S = TypeError;
            P.exports = a(ArrayBuffer.prototype, "byteLength", "get") || function(E) {
              if (f(E) !== "ArrayBuffer")
                throw S("ArrayBuffer expected");
              return E.byteLength;
            };
          }),
          /* 116 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(117);
            f && a({
              target: "ArrayBuffer",
              proto: !0
            }, {
              transfer: function() {
                return f(this, arguments.length ? arguments[0] : void 0, !0);
              }
            });
          }),
          /* 117 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(14), S = t(72), E = t(118), v = t(114), T = t(115), i = t(119), n = a.TypeError, o = a.structuredClone, d = a.ArrayBuffer, h = a.DataView, e = Math.min, l = d.prototype, u = h.prototype, c = f(l.slice), y = S(l, "resizable", "get"), C = S(l, "maxByteLength", "get"), R = f(u.getInt8), s = f(u.setInt8);
            P.exports = i && function(m, F, B) {
              var k = T(m), V = F === void 0 ? k : E(F), z = !y || !y(m);
              if (v(m))
                throw n("ArrayBuffer is detached");
              var K = o(m, { transfer: [m] });
              if (k === V && (B || z))
                return K;
              if (k >= V && (!B || z))
                return c(K, 0, V);
              for (var J = B && !z && C ? { maxByteLength: C(K) } : void 0, $ = new d(V, J), j = new h(K), G = new h($), M = e(V, k), x = 0; x < M; x++)
                s(G, x, R(j, x));
              return $;
            };
          }),
          /* 118 */
          /***/
          ((P, p, t) => {
            var a = t(62), f = t(65), S = RangeError;
            P.exports = function(E) {
              if (E === void 0)
                return 0;
              var v = a(E), T = f(v);
              if (v !== T)
                throw S("Wrong length or index");
              return T;
            };
          }),
          /* 119 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(7), S = t(28), E = t(120), v = t(121), T = t(122), i = a.structuredClone;
            P.exports = !!i && !f(function() {
              if (v && S > 92 || T && S > 94 || E && S > 97)
                return !1;
              var n = new ArrayBuffer(8), o = i(n, { transfer: [n] });
              return n.byteLength !== 0 || o.byteLength !== 8;
            });
          }),
          /* 120 */
          /***/
          ((P, p, t) => {
            var a = t(121), f = t(122);
            P.exports = !a && !f && typeof window == "object" && typeof document == "object";
          }),
          /* 121 */
          /***/
          ((P) => {
            P.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";
          }),
          /* 122 */
          /***/
          ((P, p, t) => {
            var a = t(4), f = t(15);
            P.exports = f(a.process) === "process";
          }),
          /* 123 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(117);
            f && a({
              target: "ArrayBuffer",
              proto: !0
            }, {
              transferToFixedLength: function() {
                return f(this, arguments.length ? arguments[0] : void 0, !1);
              }
            });
          }),
          /* 124 */
          /***/
          ((__unused_webpack_module, exports, __w_pdfjs_require__) => {
            Object.defineProperty(exports, "__esModule", {
              value: !0
            }), exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0, Object.defineProperty(exports, "SVGGraphics", {
              enumerable: !0,
              get: function() {
                return _displaySvg.SVGGraphics;
              }
            }), exports.build = void 0, exports.getDocument = getDocument, exports.version = void 0, __w_pdfjs_require__(84), __w_pdfjs_require__(86), __w_pdfjs_require__(87), __w_pdfjs_require__(2), __w_pdfjs_require__(93), __w_pdfjs_require__(101), __w_pdfjs_require__(102), __w_pdfjs_require__(105), __w_pdfjs_require__(107), __w_pdfjs_require__(109), __w_pdfjs_require__(113), __w_pdfjs_require__(116), __w_pdfjs_require__(123), __w_pdfjs_require__(89), __w_pdfjs_require__(125), __w_pdfjs_require__(136), __w_pdfjs_require__(138), __w_pdfjs_require__(141), __w_pdfjs_require__(143), __w_pdfjs_require__(145), __w_pdfjs_require__(147), __w_pdfjs_require__(149), __w_pdfjs_require__(152);
            var _util = __w_pdfjs_require__(1), _annotation_storage = __w_pdfjs_require__(163), _display_utils = __w_pdfjs_require__(168), _font_loader = __w_pdfjs_require__(171), _displayNode_utils = __w_pdfjs_require__(172), _canvas = __w_pdfjs_require__(173), _worker_options = __w_pdfjs_require__(176), _message_handler = __w_pdfjs_require__(177), _metadata = __w_pdfjs_require__(178), _optional_content_config = __w_pdfjs_require__(179), _transport_stream = __w_pdfjs_require__(180), _displayFetch_stream = __w_pdfjs_require__(181), _displayNetwork = __w_pdfjs_require__(184), _displayNode_stream = __w_pdfjs_require__(185), _displaySvg = __w_pdfjs_require__(186), _xfa_text = __w_pdfjs_require__(194);
            const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100, DELAYED_CLEANUP_TIMEOUT = 5e3, DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
            exports.DefaultCanvasFactory = DefaultCanvasFactory;
            const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
            exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
            const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
            exports.DefaultFilterFactory = DefaultFilterFactory;
            const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
            exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
            function getDocument(P) {
              if (typeof P == "string" || P instanceof URL ? P = {
                url: P
              } : (0, _util.isArrayBuffer)(P) && (P = {
                data: P
              }), typeof P != "object")
                throw new Error("Invalid parameter in getDocument, need parameter object.");
              if (!P.url && !P.data && !P.range)
                throw new Error("Invalid parameter object: need either .data, .range or .url");
              const p = new PDFDocumentLoadingTask(), {
                docId: t
              } = p, a = P.url ? getUrlProp(P.url) : null, f = P.data ? getDataProp(P.data) : null, S = P.httpHeaders || null, E = P.withCredentials === !0, v = P.password ?? null, T = P.range instanceof PDFDataRangeTransport ? P.range : null, i = Number.isInteger(P.rangeChunkSize) && P.rangeChunkSize > 0 ? P.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
              let n = P.worker instanceof PDFWorker ? P.worker : null;
              const o = P.verbosity, d = typeof P.docBaseUrl == "string" && !(0, _display_utils.isDataScheme)(P.docBaseUrl) ? P.docBaseUrl : null, h = typeof P.cMapUrl == "string" ? P.cMapUrl : null, e = P.cMapPacked !== !1, l = P.CMapReaderFactory || DefaultCMapReaderFactory, u = typeof P.standardFontDataUrl == "string" ? P.standardFontDataUrl : null, c = P.StandardFontDataFactory || DefaultStandardFontDataFactory, y = P.stopAtErrors !== !0, C = Number.isInteger(P.maxImageSize) && P.maxImageSize > -1 ? P.maxImageSize : -1, R = P.isEvalSupported !== !1, s = typeof P.isOffscreenCanvasSupported == "boolean" ? P.isOffscreenCanvasSupported : !_util.isNodeJS, m = Number.isInteger(P.canvasMaxAreaInBytes) ? P.canvasMaxAreaInBytes : -1, F = typeof P.disableFontFace == "boolean" ? P.disableFontFace : _util.isNodeJS, B = P.fontExtraProperties === !0, k = P.enableXfa === !0, V = P.ownerDocument || globalThis.document, z = P.disableRange === !0, K = P.disableStream === !0, J = P.disableAutoFetch === !0, $ = P.pdfBug === !0, j = T ? T.length : P.length ?? NaN, G = typeof P.useSystemFonts == "boolean" ? P.useSystemFonts : !_util.isNodeJS && !F, M = typeof P.useWorkerFetch == "boolean" ? P.useWorkerFetch : l === _display_utils.DOMCMapReaderFactory && c === _display_utils.DOMStandardFontDataFactory && h && u && (0, _display_utils.isValidFetchUrl)(h, document.baseURI) && (0, _display_utils.isValidFetchUrl)(u, document.baseURI), x = P.canvasFactory || new DefaultCanvasFactory({
                ownerDocument: V
              }), A = P.filterFactory || new DefaultFilterFactory({
                docId: t,
                ownerDocument: V
              }), g = null;
              (0, _util.setVerbosityLevel)(o);
              const I = {
                canvasFactory: x,
                filterFactory: A
              };
              if (M || (I.cMapReaderFactory = new l({
                baseUrl: h,
                isCompressed: e
              }), I.standardFontDataFactory = new c({
                baseUrl: u
              })), !n) {
                const H = {
                  verbosity: o,
                  port: _worker_options.GlobalWorkerOptions.workerPort
                };
                n = H.port ? PDFWorker.fromPort(H) : new PDFWorker(H), p._worker = n;
              }
              const U = {
                docId: t,
                apiVersion: "3.11.174",
                data: f,
                password: v,
                disableAutoFetch: J,
                rangeChunkSize: i,
                length: j,
                docBaseUrl: d,
                enableXfa: k,
                evaluatorOptions: {
                  maxImageSize: C,
                  disableFontFace: F,
                  ignoreErrors: y,
                  isEvalSupported: R,
                  isOffscreenCanvasSupported: s,
                  canvasMaxAreaInBytes: m,
                  fontExtraProperties: B,
                  useSystemFonts: G,
                  cMapUrl: M ? h : null,
                  standardFontDataUrl: M ? u : null
                }
              }, _ = {
                ignoreErrors: y,
                isEvalSupported: R,
                disableFontFace: F,
                fontExtraProperties: B,
                enableXfa: k,
                ownerDocument: V,
                disableAutoFetch: J,
                pdfBug: $,
                styleElement: g
              };
              return n.promise.then(function() {
                if (p.destroyed)
                  throw new Error("Loading aborted");
                const H = _fetchDocument(n, U), N = new Promise(function(b) {
                  let w;
                  T ? w = new _transport_stream.PDFDataTransportStream({
                    length: j,
                    initialData: T.initialData,
                    progressiveDone: T.progressiveDone,
                    contentDispositionFilename: T.contentDispositionFilename,
                    disableRange: z,
                    disableStream: K
                  }, T) : f || (w = ((D) => _util.isNodeJS ? new _displayNode_stream.PDFNodeStream(D) : (0, _display_utils.isValidFetchUrl)(D.url) ? new _displayFetch_stream.PDFFetchStream(D) : new _displayNetwork.PDFNetworkStream(D))({
                    url: a,
                    length: j,
                    httpHeaders: S,
                    withCredentials: E,
                    rangeChunkSize: i,
                    disableRange: z,
                    disableStream: K
                  })), b(w);
                });
                return Promise.all([H, N]).then(function(b) {
                  let [w, O] = b;
                  if (p.destroyed)
                    throw new Error("Loading aborted");
                  const D = new _message_handler.MessageHandler(t, w, n.port), L = new WorkerTransport(D, p, O, _, I);
                  p._transport = L, D.send("Ready", null);
                });
              }).catch(p._capability.reject), p;
            }
            async function _fetchDocument(P, p) {
              if (P.destroyed)
                throw new Error("Worker was destroyed");
              const t = await P.messageHandler.sendWithPromise("GetDocRequest", p, p.data ? [p.data.buffer] : null);
              if (P.destroyed)
                throw new Error("Worker was destroyed");
              return t;
            }
            function getUrlProp(P) {
              if (P instanceof URL)
                return P.href;
              try {
                return new URL(P, window.location).href;
              } catch {
                if (_util.isNodeJS && typeof P == "string")
                  return P;
              }
              throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
            }
            function getDataProp(P) {
              if (_util.isNodeJS && typeof Buffer < "u" && P instanceof Buffer)
                throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
              if (P instanceof Uint8Array && P.byteLength === P.buffer.byteLength)
                return P;
              if (typeof P == "string")
                return (0, _util.stringToBytes)(P);
              if (typeof P == "object" && !isNaN(P?.length) || (0, _util.isArrayBuffer)(P))
                return new Uint8Array(P);
              throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
            }
            class PDFDocumentLoadingTask {
              static #t = 0;
              constructor() {
                this._capability = new _util.PromiseCapability(), this._transport = null, this._worker = null, this.docId = `d${PDFDocumentLoadingTask.#t++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null;
              }
              get promise() {
                return this._capability.promise;
              }
              async destroy() {
                this.destroyed = !0;
                try {
                  this._worker?.port && (this._worker._pendingDestroy = !0), await this._transport?.destroy();
                } catch (p) {
                  throw this._worker?.port && delete this._worker._pendingDestroy, p;
                }
                this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
              }
            }
            exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
            class PDFDataRangeTransport {
              constructor(p, t) {
                let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                this.length = p, this.initialData = t, this.progressiveDone = a, this.contentDispositionFilename = f, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = new _util.PromiseCapability();
              }
              addRangeListener(p) {
                this._rangeListeners.push(p);
              }
              addProgressListener(p) {
                this._progressListeners.push(p);
              }
              addProgressiveReadListener(p) {
                this._progressiveReadListeners.push(p);
              }
              addProgressiveDoneListener(p) {
                this._progressiveDoneListeners.push(p);
              }
              onDataRange(p, t) {
                for (const a of this._rangeListeners)
                  a(p, t);
              }
              onDataProgress(p, t) {
                this._readyCapability.promise.then(() => {
                  for (const a of this._progressListeners)
                    a(p, t);
                });
              }
              onDataProgressiveRead(p) {
                this._readyCapability.promise.then(() => {
                  for (const t of this._progressiveReadListeners)
                    t(p);
                });
              }
              onDataProgressiveDone() {
                this._readyCapability.promise.then(() => {
                  for (const p of this._progressiveDoneListeners)
                    p();
                });
              }
              transportReady() {
                this._readyCapability.resolve();
              }
              requestDataRange(p, t) {
                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
              }
              abort() {
              }
            }
            exports.PDFDataRangeTransport = PDFDataRangeTransport;
            class PDFDocumentProxy {
              constructor(p, t) {
                this._pdfInfo = p, this._transport = t, Object.defineProperty(this, "getJavaScript", {
                  value: () => ((0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead."), this.getJSActions().then((a) => {
                    if (!a)
                      return a;
                    const f = [];
                    for (const S in a)
                      f.push(...a[S]);
                    return f;
                  }))
                });
              }
              get annotationStorage() {
                return this._transport.annotationStorage;
              }
              get filterFactory() {
                return this._transport.filterFactory;
              }
              get numPages() {
                return this._pdfInfo.numPages;
              }
              get fingerprints() {
                return this._pdfInfo.fingerprints;
              }
              get isPureXfa() {
                return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
              }
              get allXfaHtml() {
                return this._transport._htmlForXfa;
              }
              getPage(p) {
                return this._transport.getPage(p);
              }
              getPageIndex(p) {
                return this._transport.getPageIndex(p);
              }
              getDestinations() {
                return this._transport.getDestinations();
              }
              getDestination(p) {
                return this._transport.getDestination(p);
              }
              getPageLabels() {
                return this._transport.getPageLabels();
              }
              getPageLayout() {
                return this._transport.getPageLayout();
              }
              getPageMode() {
                return this._transport.getPageMode();
              }
              getViewerPreferences() {
                return this._transport.getViewerPreferences();
              }
              getOpenAction() {
                return this._transport.getOpenAction();
              }
              getAttachments() {
                return this._transport.getAttachments();
              }
              getJSActions() {
                return this._transport.getDocJSActions();
              }
              getOutline() {
                return this._transport.getOutline();
              }
              getOptionalContentConfig() {
                return this._transport.getOptionalContentConfig();
              }
              getPermissions() {
                return this._transport.getPermissions();
              }
              getMetadata() {
                return this._transport.getMetadata();
              }
              getMarkInfo() {
                return this._transport.getMarkInfo();
              }
              getData() {
                return this._transport.getData();
              }
              saveDocument() {
                return this._transport.saveDocument();
              }
              getDownloadInfo() {
                return this._transport.downloadInfoCapability.promise;
              }
              cleanup() {
                let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                return this._transport.startCleanup(p || this.isPureXfa);
              }
              destroy() {
                return this.loadingTask.destroy();
              }
              get loadingParams() {
                return this._transport.loadingParams;
              }
              get loadingTask() {
                return this._transport.loadingTask;
              }
              getFieldObjects() {
                return this._transport.getFieldObjects();
              }
              hasJSActions() {
                return this._transport.hasJSActions();
              }
              getCalculationOrderIds() {
                return this._transport.getCalculationOrderIds();
              }
            }
            exports.PDFDocumentProxy = PDFDocumentProxy;
            class PDFPageProxy {
              #t = null;
              #e = !1;
              constructor(p, t, a) {
                let f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                this._pageIndex = p, this._pageInfo = t, this._transport = a, this._stats = f ? new _display_utils.StatTimer() : null, this._pdfBug = f, this.commonObjs = a.commonObjs, this.objs = new PDFObjects(), this._maybeCleanupAfterRender = !1, this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1;
              }
              get pageNumber() {
                return this._pageIndex + 1;
              }
              get rotate() {
                return this._pageInfo.rotate;
              }
              get ref() {
                return this._pageInfo.ref;
              }
              get userUnit() {
                return this._pageInfo.userUnit;
              }
              get view() {
                return this._pageInfo.view;
              }
              getViewport() {
                let {
                  scale: p,
                  rotation: t = this.rotate,
                  offsetX: a = 0,
                  offsetY: f = 0,
                  dontFlip: S = !1
                } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return new _display_utils.PageViewport({
                  viewBox: this.view,
                  scale: p,
                  rotation: t,
                  offsetX: a,
                  offsetY: f,
                  dontFlip: S
                });
              }
              getAnnotations() {
                let {
                  intent: p = "display"
                } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                const t = this._transport.getRenderingIntent(p);
                return this._transport.getAnnotations(this._pageIndex, t.renderingIntent);
              }
              getJSActions() {
                return this._transport.getPageJSActions(this._pageIndex);
              }
              get filterFactory() {
                return this._transport.filterFactory;
              }
              get isPureXfa() {
                return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
              }
              async getXfa() {
                return this._transport._htmlForXfa?.children[this._pageIndex] || null;
              }
              render(p) {
                let {
                  canvasContext: t,
                  viewport: a,
                  intent: f = "display",
                  annotationMode: S = _util.AnnotationMode.ENABLE,
                  transform: E = null,
                  background: v = null,
                  optionalContentConfigPromise: T = null,
                  annotationCanvasMap: i = null,
                  pageColors: n = null,
                  printAnnotationStorage: o = null
                } = p;
                this._stats?.time("Overall");
                const d = this._transport.getRenderingIntent(f, S, o);
                this.#e = !1, this.#i(), T || (T = this._transport.getOptionalContentConfig());
                let h = this._intentStates.get(d.cacheKey);
                h || (h = /* @__PURE__ */ Object.create(null), this._intentStates.set(d.cacheKey, h)), h.streamReaderCancelTimeout && (clearTimeout(h.streamReaderCancelTimeout), h.streamReaderCancelTimeout = null);
                const e = !!(d.renderingIntent & _util.RenderingIntentFlag.PRINT);
                h.displayReadyCapability || (h.displayReadyCapability = new _util.PromiseCapability(), h.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats?.time("Page Request"), this._pumpOperatorList(d));
                const l = (y) => {
                  h.renderTasks.delete(u), (this._maybeCleanupAfterRender || e) && (this.#e = !0), this.#n(!e), y ? (u.capability.reject(y), this._abortOperatorList({
                    intentState: h,
                    reason: y instanceof Error ? y : new Error(y)
                  })) : u.capability.resolve(), this._stats?.timeEnd("Rendering"), this._stats?.timeEnd("Overall");
                }, u = new InternalRenderTask({
                  callback: l,
                  params: {
                    canvasContext: t,
                    viewport: a,
                    transform: E,
                    background: v
                  },
                  objs: this.objs,
                  commonObjs: this.commonObjs,
                  annotationCanvasMap: i,
                  operatorList: h.operatorList,
                  pageIndex: this._pageIndex,
                  canvasFactory: this._transport.canvasFactory,
                  filterFactory: this._transport.filterFactory,
                  useRequestAnimationFrame: !e,
                  pdfBug: this._pdfBug,
                  pageColors: n
                });
                (h.renderTasks ||= /* @__PURE__ */ new Set()).add(u);
                const c = u.task;
                return Promise.all([h.displayReadyCapability.promise, T]).then((y) => {
                  let [C, R] = y;
                  if (this.destroyed) {
                    l();
                    return;
                  }
                  this._stats?.time("Rendering"), u.initializeGraphics({
                    transparency: C,
                    optionalContentConfig: R
                  }), u.operatorListChanged();
                }).catch(l), c;
              }
              getOperatorList() {
                let {
                  intent: p = "display",
                  annotationMode: t = _util.AnnotationMode.ENABLE,
                  printAnnotationStorage: a = null
                } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                function f() {
                  E.operatorList.lastChunk && (E.opListReadCapability.resolve(E.operatorList), E.renderTasks.delete(v));
                }
                const S = this._transport.getRenderingIntent(p, t, a, !0);
                let E = this._intentStates.get(S.cacheKey);
                E || (E = /* @__PURE__ */ Object.create(null), this._intentStates.set(S.cacheKey, E));
                let v;
                return E.opListReadCapability || (v = /* @__PURE__ */ Object.create(null), v.operatorListChanged = f, E.opListReadCapability = new _util.PromiseCapability(), (E.renderTasks ||= /* @__PURE__ */ new Set()).add(v), E.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats?.time("Page Request"), this._pumpOperatorList(S)), E.opListReadCapability.promise;
              }
              streamTextContent() {
                let {
                  includeMarkedContent: p = !1,
                  disableNormalization: t = !1
                } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                  pageIndex: this._pageIndex,
                  includeMarkedContent: p === !0,
                  disableNormalization: t === !0
                }, {
                  highWaterMark: 100,
                  size(f) {
                    return f.items.length;
                  }
                });
              }
              getTextContent() {
                let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (this._transport._htmlForXfa)
                  return this.getXfa().then((a) => _xfa_text.XfaText.textContent(a));
                const t = this.streamTextContent(p);
                return new Promise(function(a, f) {
                  function S() {
                    E.read().then(function(T) {
                      let {
                        value: i,
                        done: n
                      } = T;
                      if (n) {
                        a(v);
                        return;
                      }
                      Object.assign(v.styles, i.styles), v.items.push(...i.items), S();
                    }, f);
                  }
                  const E = t.getReader(), v = {
                    items: [],
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  S();
                });
              }
              getStructTree() {
                return this._transport.getStructTree(this._pageIndex);
              }
              _destroy() {
                this.destroyed = !0;
                const p = [];
                for (const t of this._intentStates.values())
                  if (this._abortOperatorList({
                    intentState: t,
                    reason: new Error("Page was destroyed."),
                    force: !0
                  }), !t.opListReadCapability)
                    for (const a of t.renderTasks)
                      p.push(a.completed), a.cancel();
                return this.objs.clear(), this.#e = !1, this.#i(), Promise.all(p);
              }
              cleanup() {
                let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                this.#e = !0;
                const t = this.#n(!1);
                return p && t && (this._stats &&= new _display_utils.StatTimer()), t;
              }
              #n() {
                let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                if (this.#i(), !this.#e || this.destroyed)
                  return !1;
                if (p)
                  return this.#t = setTimeout(() => {
                    this.#t = null, this.#n(!1);
                  }, DELAYED_CLEANUP_TIMEOUT), !1;
                for (const {
                  renderTasks: t,
                  operatorList: a
                } of this._intentStates.values())
                  if (t.size > 0 || !a.lastChunk)
                    return !1;
                return this._intentStates.clear(), this.objs.clear(), this.#e = !1, !0;
              }
              #i() {
                this.#t && (clearTimeout(this.#t), this.#t = null);
              }
              _startRenderPage(p, t) {
                const a = this._intentStates.get(t);
                a && (this._stats?.timeEnd("Page Request"), a.displayReadyCapability?.resolve(p));
              }
              _renderPageChunk(p, t) {
                for (let a = 0, f = p.length; a < f; a++)
                  t.operatorList.fnArray.push(p.fnArray[a]), t.operatorList.argsArray.push(p.argsArray[a]);
                t.operatorList.lastChunk = p.lastChunk, t.operatorList.separateAnnots = p.separateAnnots;
                for (const a of t.renderTasks)
                  a.operatorListChanged();
                p.lastChunk && this.#n(!0);
              }
              _pumpOperatorList(p) {
                let {
                  renderingIntent: t,
                  cacheKey: a,
                  annotationStorageSerializable: f
                } = p;
                const {
                  map: S,
                  transfers: E
                } = f, T = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                  pageIndex: this._pageIndex,
                  intent: t,
                  cacheKey: a,
                  annotationStorage: S
                }, E).getReader(), i = this._intentStates.get(a);
                i.streamReader = T;
                const n = () => {
                  T.read().then((o) => {
                    let {
                      value: d,
                      done: h
                    } = o;
                    if (h) {
                      i.streamReader = null;
                      return;
                    }
                    this._transport.destroyed || (this._renderPageChunk(d, i), n());
                  }, (o) => {
                    if (i.streamReader = null, !this._transport.destroyed) {
                      if (i.operatorList) {
                        i.operatorList.lastChunk = !0;
                        for (const d of i.renderTasks)
                          d.operatorListChanged();
                        this.#n(!0);
                      }
                      if (i.displayReadyCapability)
                        i.displayReadyCapability.reject(o);
                      else if (i.opListReadCapability)
                        i.opListReadCapability.reject(o);
                      else
                        throw o;
                    }
                  });
                };
                n();
              }
              _abortOperatorList(p) {
                let {
                  intentState: t,
                  reason: a,
                  force: f = !1
                } = p;
                if (t.streamReader) {
                  if (t.streamReaderCancelTimeout && (clearTimeout(t.streamReaderCancelTimeout), t.streamReaderCancelTimeout = null), !f) {
                    if (t.renderTasks.size > 0)
                      return;
                    if (a instanceof _display_utils.RenderingCancelledException) {
                      let S = RENDERING_CANCELLED_TIMEOUT;
                      a.extraDelay > 0 && a.extraDelay < 1e3 && (S += a.extraDelay), t.streamReaderCancelTimeout = setTimeout(() => {
                        t.streamReaderCancelTimeout = null, this._abortOperatorList({
                          intentState: t,
                          reason: a,
                          force: !0
                        });
                      }, S);
                      return;
                    }
                  }
                  if (t.streamReader.cancel(new _util.AbortException(a.message)).catch(() => {
                  }), t.streamReader = null, !this._transport.destroyed) {
                    for (const [S, E] of this._intentStates)
                      if (E === t) {
                        this._intentStates.delete(S);
                        break;
                      }
                    this.cleanup();
                  }
                }
              }
              get stats() {
                return this._stats;
              }
            }
            exports.PDFPageProxy = PDFPageProxy;
            class LoopbackPort {
              #t = /* @__PURE__ */ new Set();
              #e = Promise.resolve();
              postMessage(p, t) {
                const a = {
                  data: structuredClone(p, null)
                };
                this.#e.then(() => {
                  for (const f of this.#t)
                    f.call(this, a);
                });
              }
              addEventListener(p, t) {
                this.#t.add(t);
              }
              removeEventListener(p, t) {
                this.#t.delete(t);
              }
              terminate() {
                this.#t.clear();
              }
            }
            exports.LoopbackPort = LoopbackPort;
            const PDFWorkerUtil = {
              isWorkerDisabled: !1,
              fallbackWorkerSrc: null,
              fakeWorkerId: 0
            };
            exports.PDFWorkerUtil = PDFWorkerUtil;
            {
              if (_util.isNodeJS && typeof commonjsRequire == "function")
                PDFWorkerUtil.isWorkerDisabled = !0, PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
              else if (typeof document == "object") {
                const P = document?.currentScript?.src;
                P && (PDFWorkerUtil.fallbackWorkerSrc = P.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
              }
              PDFWorkerUtil.isSameOrigin = function(P, p) {
                let t;
                try {
                  if (t = new URL(P), !t.origin || t.origin === "null")
                    return !1;
                } catch {
                  return !1;
                }
                const a = new URL(p, t);
                return t.origin === a.origin;
              }, PDFWorkerUtil.createCDNWrapper = function(P) {
                const p = `importScripts("${P}");`;
                return URL.createObjectURL(new Blob([p]));
              };
            }
            class PDFWorker {
              static #workerPorts;
              constructor() {
                let {
                  name: P = null,
                  port: p = null,
                  verbosity: t = (0, _util.getVerbosityLevel)()
                } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (this.name = P, this.destroyed = !1, this.verbosity = t, this._readyCapability = new _util.PromiseCapability(), this._port = null, this._webWorker = null, this._messageHandler = null, p) {
                  if (PDFWorker.#workerPorts?.has(p))
                    throw new Error("Cannot use more than one PDFWorker per port.");
                  (PDFWorker.#workerPorts ||= /* @__PURE__ */ new WeakMap()).set(p, this), this._initializeFromPort(p);
                  return;
                }
                this._initialize();
              }
              get promise() {
                return this._readyCapability.promise;
              }
              get port() {
                return this._port;
              }
              get messageHandler() {
                return this._messageHandler;
              }
              _initializeFromPort(P) {
                this._port = P, this._messageHandler = new _message_handler.MessageHandler("main", "worker", P), this._messageHandler.on("ready", function() {
                }), this._readyCapability.resolve(), this._messageHandler.send("configure", {
                  verbosity: this.verbosity
                });
              }
              _initialize() {
                if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                  let {
                    workerSrc: P
                  } = PDFWorker;
                  try {
                    PDFWorkerUtil.isSameOrigin(window.location.href, P) || (P = PDFWorkerUtil.createCDNWrapper(new URL(P, window.location).href));
                    const p = new Worker(P), t = new _message_handler.MessageHandler("main", "worker", p), a = () => {
                      p.removeEventListener("error", f), t.destroy(), p.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                    }, f = () => {
                      this._webWorker || a();
                    };
                    p.addEventListener("error", f), t.on("test", (E) => {
                      if (p.removeEventListener("error", f), this.destroyed) {
                        a();
                        return;
                      }
                      E ? (this._messageHandler = t, this._port = p, this._webWorker = p, this._readyCapability.resolve(), t.send("configure", {
                        verbosity: this.verbosity
                      })) : (this._setupFakeWorker(), t.destroy(), p.terminate());
                    }), t.on("ready", (E) => {
                      if (p.removeEventListener("error", f), this.destroyed) {
                        a();
                        return;
                      }
                      try {
                        S();
                      } catch {
                        this._setupFakeWorker();
                      }
                    });
                    const S = () => {
                      const E = new Uint8Array();
                      t.send("test", E, [E.buffer]);
                    };
                    S();
                    return;
                  } catch {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
              _setupFakeWorker() {
                PDFWorkerUtil.isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), PDFWorker._setupFakeWorkerGlobal.then((P) => {
                  if (this.destroyed) {
                    this._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  const p = new LoopbackPort();
                  this._port = p;
                  const t = `fake${PDFWorkerUtil.fakeWorkerId++}`, a = new _message_handler.MessageHandler(t + "_worker", t, p);
                  P.setup(a, p);
                  const f = new _message_handler.MessageHandler(t, t + "_worker", p);
                  this._messageHandler = f, this._readyCapability.resolve(), f.send("configure", {
                    verbosity: this.verbosity
                  });
                }).catch((P) => {
                  this._readyCapability.reject(new Error(`Setting up fake worker failed: "${P.message}".`));
                });
              }
              destroy() {
                this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), PDFWorker.#workerPorts?.delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
              }
              static fromPort(P) {
                if (!P?.port)
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                const p = this.#workerPorts?.get(P.port);
                if (p) {
                  if (p._pendingDestroy)
                    throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                  return p;
                }
                return new PDFWorker(P);
              }
              static get workerSrc() {
                if (_worker_options.GlobalWorkerOptions.workerSrc)
                  return _worker_options.GlobalWorkerOptions.workerSrc;
                if (PDFWorkerUtil.fallbackWorkerSrc !== null)
                  return _util.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), PDFWorkerUtil.fallbackWorkerSrc;
                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
              }
              static get _mainThreadWorkerMessageHandler() {
                try {
                  return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                } catch {
                  return null;
                }
              }
              static get _setupFakeWorkerGlobal() {
                const loader = async () => {
                  const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                  if (mainWorkerMessageHandler)
                    return mainWorkerMessageHandler;
                  if (_util.isNodeJS && typeof commonjsRequire == "function") {
                    const worker = eval("require")(this.workerSrc);
                    return worker.WorkerMessageHandler;
                  }
                  return await (0, _display_utils.loadScript)(this.workerSrc), window.pdfjsWorker.WorkerMessageHandler;
                };
                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
              }
            }
            exports.PDFWorker = PDFWorker;
            class WorkerTransport {
              #t = /* @__PURE__ */ new Map();
              #e = /* @__PURE__ */ new Map();
              #n = /* @__PURE__ */ new Map();
              #i = null;
              constructor(p, t, a, f, S) {
                this.messageHandler = p, this.loadingTask = t, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                  ownerDocument: f.ownerDocument,
                  styleElement: f.styleElement
                }), this._params = f, this.canvasFactory = S.canvasFactory, this.filterFactory = S.filterFactory, this.cMapReaderFactory = S.cMapReaderFactory, this.standardFontDataFactory = S.standardFontDataFactory, this.destroyed = !1, this.destroyCapability = null, this._networkStream = a, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = new _util.PromiseCapability(), this.setupMessageHandler();
              }
              #o(p) {
                let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                const a = this.#t.get(p);
                if (a)
                  return a;
                const f = this.messageHandler.sendWithPromise(p, t);
                return this.#t.set(p, f), f;
              }
              get annotationStorage() {
                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
              }
              getRenderingIntent(p) {
                let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _util.AnnotationMode.ENABLE, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, S = _util.RenderingIntentFlag.DISPLAY, E = _annotation_storage.SerializableEmpty;
                switch (p) {
                  case "any":
                    S = _util.RenderingIntentFlag.ANY;
                    break;
                  case "display":
                    break;
                  case "print":
                    S = _util.RenderingIntentFlag.PRINT;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid intent: ${p}`);
                }
                switch (t) {
                  case _util.AnnotationMode.DISABLE:
                    S += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                    break;
                  case _util.AnnotationMode.ENABLE:
                    break;
                  case _util.AnnotationMode.ENABLE_FORMS:
                    S += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                    break;
                  case _util.AnnotationMode.ENABLE_STORAGE:
                    S += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE, E = (S & _util.RenderingIntentFlag.PRINT && a instanceof _annotation_storage.PrintAnnotationStorage ? a : this.annotationStorage).serializable;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${t}`);
                }
                return f && (S += _util.RenderingIntentFlag.OPLIST), {
                  renderingIntent: S,
                  cacheKey: `${S}_${E.hash}`,
                  annotationStorageSerializable: E
                };
              }
              destroy() {
                if (this.destroyCapability)
                  return this.destroyCapability.promise;
                this.destroyed = !0, this.destroyCapability = new _util.PromiseCapability(), this.#i?.reject(new Error("Worker was destroyed during onPassword callback"));
                const p = [];
                for (const a of this.#e.values())
                  p.push(a._destroy());
                this.#e.clear(), this.#n.clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
                const t = this.messageHandler.sendWithPromise("Terminate", null);
                return p.push(t), Promise.all(p).then(() => {
                  this.commonObjs.clear(), this.fontLoader.clear(), this.#t.clear(), this.filterFactory.destroy(), this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
                }, this.destroyCapability.reject), this.destroyCapability.promise;
              }
              setupMessageHandler() {
                const {
                  messageHandler: p,
                  loadingTask: t
                } = this;
                p.on("GetReader", (a, f) => {
                  (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (S) => {
                    this._lastProgress = {
                      loaded: S.loaded,
                      total: S.total
                    };
                  }, f.onPull = () => {
                    this._fullReader.read().then(function(S) {
                      let {
                        value: E,
                        done: v
                      } = S;
                      if (v) {
                        f.close();
                        return;
                      }
                      (0, _util.assert)(E instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer."), f.enqueue(new Uint8Array(E), 1, [E]);
                    }).catch((S) => {
                      f.error(S);
                    });
                  }, f.onCancel = (S) => {
                    this._fullReader.cancel(S), f.ready.catch((E) => {
                      if (!this.destroyed)
                        throw E;
                    });
                  };
                }), p.on("ReaderHeadersReady", (a) => {
                  const f = new _util.PromiseCapability(), S = this._fullReader;
                  return S.headersReady.then(() => {
                    (!S.isStreamingSupported || !S.isRangeSupported) && (this._lastProgress && t.onProgress?.(this._lastProgress), S.onProgress = (E) => {
                      t.onProgress?.({
                        loaded: E.loaded,
                        total: E.total
                      });
                    }), f.resolve({
                      isStreamingSupported: S.isStreamingSupported,
                      isRangeSupported: S.isRangeSupported,
                      contentLength: S.contentLength
                    });
                  }, f.reject), f.promise;
                }), p.on("GetRangeReader", (a, f) => {
                  (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                  const S = this._networkStream.getRangeReader(a.begin, a.end);
                  if (!S) {
                    f.close();
                    return;
                  }
                  f.onPull = () => {
                    S.read().then(function(E) {
                      let {
                        value: v,
                        done: T
                      } = E;
                      if (T) {
                        f.close();
                        return;
                      }
                      (0, _util.assert)(v instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer."), f.enqueue(new Uint8Array(v), 1, [v]);
                    }).catch((E) => {
                      f.error(E);
                    });
                  }, f.onCancel = (E) => {
                    S.cancel(E), f.ready.catch((v) => {
                      if (!this.destroyed)
                        throw v;
                    });
                  };
                }), p.on("GetDoc", (a) => {
                  let {
                    pdfInfo: f
                  } = a;
                  this._numPages = f.numPages, this._htmlForXfa = f.htmlForXfa, delete f.htmlForXfa, t._capability.resolve(new PDFDocumentProxy(f, this));
                }), p.on("DocException", function(a) {
                  let f;
                  switch (a.name) {
                    case "PasswordException":
                      f = new _util.PasswordException(a.message, a.code);
                      break;
                    case "InvalidPDFException":
                      f = new _util.InvalidPDFException(a.message);
                      break;
                    case "MissingPDFException":
                      f = new _util.MissingPDFException(a.message);
                      break;
                    case "UnexpectedResponseException":
                      f = new _util.UnexpectedResponseException(a.message, a.status);
                      break;
                    case "UnknownErrorException":
                      f = new _util.UnknownErrorException(a.message, a.details);
                      break;
                    default:
                      (0, _util.unreachable)("DocException - expected a valid Error.");
                  }
                  t._capability.reject(f);
                }), p.on("PasswordRequest", (a) => {
                  if (this.#i = new _util.PromiseCapability(), t.onPassword) {
                    const f = (S) => {
                      S instanceof Error ? this.#i.reject(S) : this.#i.resolve({
                        password: S
                      });
                    };
                    try {
                      t.onPassword(f, a.code);
                    } catch (S) {
                      this.#i.reject(S);
                    }
                  } else
                    this.#i.reject(new _util.PasswordException(a.message, a.code));
                  return this.#i.promise;
                }), p.on("DataLoaded", (a) => {
                  t.onProgress?.({
                    loaded: a.length,
                    total: a.length
                  }), this.downloadInfoCapability.resolve(a);
                }), p.on("StartRenderPage", (a) => {
                  if (this.destroyed)
                    return;
                  this.#e.get(a.pageIndex)._startRenderPage(a.transparency, a.cacheKey);
                }), p.on("commonobj", (a) => {
                  let [f, S, E] = a;
                  if (!this.destroyed && !this.commonObjs.has(f))
                    switch (S) {
                      case "Font":
                        const v = this._params;
                        if ("error" in E) {
                          const n = E.error;
                          (0, _util.warn)(`Error during font loading: ${n}`), this.commonObjs.resolve(f, n);
                          break;
                        }
                        const T = v.pdfBug && globalThis.FontInspector?.enabled ? (n, o) => globalThis.FontInspector.fontAdded(n, o) : null, i = new _font_loader.FontFaceObject(E, {
                          isEvalSupported: v.isEvalSupported,
                          disableFontFace: v.disableFontFace,
                          ignoreErrors: v.ignoreErrors,
                          inspectFont: T
                        });
                        this.fontLoader.bind(i).catch((n) => p.sendWithPromise("FontFallback", {
                          id: f
                        })).finally(() => {
                          !v.fontExtraProperties && i.data && (i.data = null), this.commonObjs.resolve(f, i);
                        });
                        break;
                      case "FontPath":
                      case "Image":
                      case "Pattern":
                        this.commonObjs.resolve(f, E);
                        break;
                      default:
                        throw new Error(`Got unknown common object type ${S}`);
                    }
                }), p.on("obj", (a) => {
                  let [f, S, E, v] = a;
                  if (this.destroyed)
                    return;
                  const T = this.#e.get(S);
                  if (!T.objs.has(f))
                    switch (E) {
                      case "Image":
                        if (T.objs.resolve(f, v), v) {
                          let i;
                          if (v.bitmap) {
                            const {
                              width: n,
                              height: o
                            } = v;
                            i = n * o * 4;
                          } else
                            i = v.data?.length || 0;
                          i > _util.MAX_IMAGE_SIZE_TO_CACHE && (T._maybeCleanupAfterRender = !0);
                        }
                        break;
                      case "Pattern":
                        T.objs.resolve(f, v);
                        break;
                      default:
                        throw new Error(`Got unknown object type ${E}`);
                    }
                }), p.on("DocProgress", (a) => {
                  this.destroyed || t.onProgress?.({
                    loaded: a.loaded,
                    total: a.total
                  });
                }), p.on("FetchBuiltInCMap", (a) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.cMapReaderFactory ? this.cMapReaderFactory.fetch(a) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), p.on("FetchStandardFontData", (a) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.standardFontDataFactory ? this.standardFontDataFactory.fetch(a) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
              }
              getData() {
                return this.messageHandler.sendWithPromise("GetData", null);
              }
              saveDocument() {
                this.annotationStorage.size <= 0 && (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                const {
                  map: p,
                  transfers: t
                } = this.annotationStorage.serializable;
                return this.messageHandler.sendWithPromise("SaveDocument", {
                  isPureXfa: !!this._htmlForXfa,
                  numPages: this._numPages,
                  annotationStorage: p,
                  filename: this._fullReader?.filename ?? null
                }, t).finally(() => {
                  this.annotationStorage.resetModified();
                });
              }
              getPage(p) {
                if (!Number.isInteger(p) || p <= 0 || p > this._numPages)
                  return Promise.reject(new Error("Invalid page request."));
                const t = p - 1, a = this.#n.get(t);
                if (a)
                  return a;
                const f = this.messageHandler.sendWithPromise("GetPage", {
                  pageIndex: t
                }).then((S) => {
                  if (this.destroyed)
                    throw new Error("Transport destroyed");
                  const E = new PDFPageProxy(t, S, this, this._params.pdfBug);
                  return this.#e.set(t, E), E;
                });
                return this.#n.set(t, f), f;
              }
              getPageIndex(p) {
                return typeof p != "object" || p === null || !Number.isInteger(p.num) || p.num < 0 || !Number.isInteger(p.gen) || p.gen < 0 ? Promise.reject(new Error("Invalid pageIndex request.")) : this.messageHandler.sendWithPromise("GetPageIndex", {
                  num: p.num,
                  gen: p.gen
                });
              }
              getAnnotations(p, t) {
                return this.messageHandler.sendWithPromise("GetAnnotations", {
                  pageIndex: p,
                  intent: t
                });
              }
              getFieldObjects() {
                return this.#o("GetFieldObjects");
              }
              hasJSActions() {
                return this.#o("HasJSActions");
              }
              getCalculationOrderIds() {
                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
              }
              getDestinations() {
                return this.messageHandler.sendWithPromise("GetDestinations", null);
              }
              getDestination(p) {
                return typeof p != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                  id: p
                });
              }
              getPageLabels() {
                return this.messageHandler.sendWithPromise("GetPageLabels", null);
              }
              getPageLayout() {
                return this.messageHandler.sendWithPromise("GetPageLayout", null);
              }
              getPageMode() {
                return this.messageHandler.sendWithPromise("GetPageMode", null);
              }
              getViewerPreferences() {
                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
              }
              getOpenAction() {
                return this.messageHandler.sendWithPromise("GetOpenAction", null);
              }
              getAttachments() {
                return this.messageHandler.sendWithPromise("GetAttachments", null);
              }
              getDocJSActions() {
                return this.#o("GetDocJSActions");
              }
              getPageJSActions(p) {
                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                  pageIndex: p
                });
              }
              getStructTree(p) {
                return this.messageHandler.sendWithPromise("GetStructTree", {
                  pageIndex: p
                });
              }
              getOutline() {
                return this.messageHandler.sendWithPromise("GetOutline", null);
              }
              getOptionalContentConfig() {
                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((p) => new _optional_content_config.OptionalContentConfig(p));
              }
              getPermissions() {
                return this.messageHandler.sendWithPromise("GetPermissions", null);
              }
              getMetadata() {
                const p = "GetMetadata", t = this.#t.get(p);
                if (t)
                  return t;
                const a = this.messageHandler.sendWithPromise(p, null).then((f) => ({
                  info: f[0],
                  metadata: f[1] ? new _metadata.Metadata(f[1]) : null,
                  contentDispositionFilename: this._fullReader?.filename ?? null,
                  contentLength: this._fullReader?.contentLength ?? null
                }));
                return this.#t.set(p, a), a;
              }
              getMarkInfo() {
                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
              }
              async startCleanup() {
                let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                if (!this.destroyed) {
                  await this.messageHandler.sendWithPromise("Cleanup", null);
                  for (const t of this.#e.values())
                    if (!t.cleanup())
                      throw new Error(`startCleanup: Page ${t.pageNumber} is currently rendering.`);
                  this.commonObjs.clear(), p || this.fontLoader.clear(), this.#t.clear(), this.filterFactory.destroy(!0);
                }
              }
              get loadingParams() {
                const {
                  disableAutoFetch: p,
                  enableXfa: t
                } = this._params;
                return (0, _util.shadow)(this, "loadingParams", {
                  disableAutoFetch: p,
                  enableXfa: t
                });
              }
            }
            class PDFObjects {
              #t = /* @__PURE__ */ Object.create(null);
              #e(p) {
                return this.#t[p] ||= {
                  capability: new _util.PromiseCapability(),
                  data: null
                };
              }
              get(p) {
                let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (t) {
                  const f = this.#e(p);
                  return f.capability.promise.then(() => t(f.data)), null;
                }
                const a = this.#t[p];
                if (!a?.capability.settled)
                  throw new Error(`Requesting object that isn't resolved yet ${p}.`);
                return a.data;
              }
              has(p) {
                return this.#t[p]?.capability.settled || !1;
              }
              resolve(p) {
                let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                const a = this.#e(p);
                a.data = t, a.capability.resolve();
              }
              clear() {
                for (const p in this.#t) {
                  const {
                    data: t
                  } = this.#t[p];
                  t?.bitmap?.close();
                }
                this.#t = /* @__PURE__ */ Object.create(null);
              }
            }
            class RenderTask {
              #t = null;
              constructor(p) {
                this.#t = p, this.onContinue = null;
              }
              get promise() {
                return this.#t.capability.promise;
              }
              cancel() {
                let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                this.#t.cancel(null, p);
              }
              get separateAnnots() {
                const {
                  separateAnnots: p
                } = this.#t.operatorList;
                if (!p)
                  return !1;
                const {
                  annotationCanvasMap: t
                } = this.#t;
                return p.form || p.canvas && t?.size > 0;
              }
            }
            exports.RenderTask = RenderTask;
            class InternalRenderTask {
              static #t = /* @__PURE__ */ new WeakSet();
              constructor(p) {
                let {
                  callback: t,
                  params: a,
                  objs: f,
                  commonObjs: S,
                  annotationCanvasMap: E,
                  operatorList: v,
                  pageIndex: T,
                  canvasFactory: i,
                  filterFactory: n,
                  useRequestAnimationFrame: o = !1,
                  pdfBug: d = !1,
                  pageColors: h = null
                } = p;
                this.callback = t, this.params = a, this.objs = f, this.commonObjs = S, this.annotationCanvasMap = E, this.operatorListIdx = null, this.operatorList = v, this._pageIndex = T, this.canvasFactory = i, this.filterFactory = n, this._pdfBug = d, this.pageColors = h, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = o === !0 && typeof window < "u", this.cancelled = !1, this.capability = new _util.PromiseCapability(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = a.canvasContext.canvas;
              }
              get completed() {
                return this.capability.promise.catch(function() {
                });
              }
              initializeGraphics(p) {
                let {
                  transparency: t = !1,
                  optionalContentConfig: a
                } = p;
                if (this.cancelled)
                  return;
                if (this._canvas) {
                  if (InternalRenderTask.#t.has(this._canvas))
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  InternalRenderTask.#t.add(this._canvas);
                }
                this._pdfBug && globalThis.StepperManager?.enabled && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
                const {
                  canvasContext: f,
                  viewport: S,
                  transform: E,
                  background: v
                } = this.params;
                this.gfx = new _canvas.CanvasGraphics(f, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                  optionalContentConfig: a
                }, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
                  transform: E,
                  viewport: S,
                  transparency: t,
                  background: v
                }), this.operatorListIdx = 0, this.graphicsReady = !0, this.graphicsReadyCallback?.();
              }
              cancel() {
                let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.running = !1, this.cancelled = !0, this.gfx?.endDrawing(), InternalRenderTask.#t.delete(this._canvas), this.callback(p || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, t));
              }
              operatorListChanged() {
                if (!this.graphicsReady) {
                  this.graphicsReadyCallback ||= this._continueBound;
                  return;
                }
                this.stepper?.updateOperatorList(this.operatorList), !this.running && this._continue();
              }
              _continue() {
                this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
              }
              _scheduleNext() {
                this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                  this._nextBound().catch(this._cancelBound);
                }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
              }
              async _next() {
                this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), InternalRenderTask.#t.delete(this._canvas), this.callback())));
              }
            }
            const version = "3.11.174";
            exports.version = version;
            const build = "ce8716743";
            exports.build = build;
          }),
          /* 125 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(126), S = t(135);
            a({
              target: "Set",
              proto: !0,
              real: !0,
              forced: !S("difference")
            }, { difference: f });
          }),
          /* 126 */
          /***/
          ((P, p, t) => {
            var a = t(127), f = t(128), S = t(129), E = t(132), v = t(133), T = t(130), i = t(131), n = f.has, o = f.remove;
            P.exports = function(h) {
              var e = a(this), l = v(h), u = S(e);
              return E(e) <= l.size ? T(e, function(c) {
                l.includes(c) && o(u, c);
              }) : i(l.getIterator(), function(c) {
                n(e, c) && o(u, c);
              }), u;
            };
          }),
          /* 127 */
          /***/
          ((P, p, t) => {
            var a = t(128).has;
            P.exports = function(f) {
              return a(f), f;
            };
          }),
          /* 128 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = Set.prototype;
            P.exports = {
              Set,
              add: a(f.add),
              has: a(f.has),
              remove: a(f.delete),
              proto: f
            };
          }),
          /* 129 */
          /***/
          ((P, p, t) => {
            var a = t(128), f = t(130), S = a.Set, E = a.add;
            P.exports = function(v) {
              var T = new S();
              return f(v, function(i) {
                E(T, i);
              }), T;
            };
          }),
          /* 130 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(131), S = t(128), E = S.Set, v = S.proto, T = a(v.forEach), i = a(v.keys), n = i(new E()).next;
            P.exports = function(o, d, h) {
              return h ? f({
                iterator: i(o),
                next: n
              }, d) : T(o, d);
            };
          }),
          /* 131 */
          /***/
          ((P, p, t) => {
            var a = t(8);
            P.exports = function(f, S, E) {
              for (var v = E ? f : f.iterator, T = f.next, i, n; !(i = a(T, v)).done; )
                if (n = S(i.value), n !== void 0)
                  return n;
            };
          }),
          /* 132 */
          /***/
          ((P, p, t) => {
            var a = t(72), f = t(128);
            P.exports = a(f.proto, "size", "get") || function(S) {
              return S.size;
            };
          }),
          /* 133 */
          /***/
          ((P, p, t) => {
            var a = t(31), f = t(47), S = t(8), E = t(62), v = t(134), T = "Invalid size", i = RangeError, n = TypeError, o = Math.max, d = function(h, e, l, u) {
              this.set = h, this.size = e, this.has = l, this.keys = u;
            };
            d.prototype = {
              getIterator: function() {
                return v(f(S(this.keys, this.set)));
              },
              includes: function(h) {
                return S(this.has, this.set, h);
              }
            }, P.exports = function(h) {
              f(h);
              var e = +h.size;
              if (e !== e)
                throw n(T);
              var l = E(e);
              if (l < 0)
                throw i(T);
              return new d(h, o(l, 0), a(h.has), a(h.keys));
            };
          }),
          /* 134 */
          /***/
          ((P) => {
            P.exports = function(p) {
              return {
                iterator: p,
                next: p.next,
                done: !1
              };
            };
          }),
          /* 135 */
          /***/
          ((P, p, t) => {
            var a = t(24), f = function(S) {
              return {
                size: S,
                has: function() {
                  return !1;
                },
                keys: function() {
                  return {
                    next: function() {
                      return { done: !0 };
                    }
                  };
                }
              };
            };
            P.exports = function(S) {
              var E = a("Set");
              try {
                new E()[S](f(0));
                try {
                  return new E()[S](f(-1)), !1;
                } catch {
                  return !0;
                }
              } catch {
                return !1;
              }
            };
          }),
          /* 136 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(7), S = t(137), E = t(135), v = !E("intersection") || f(function() {
              return Array.from((/* @__PURE__ */ new Set([
                1,
                2,
                3
              ])).intersection(/* @__PURE__ */ new Set([
                3,
                2
              ]))) !== "3,2";
            });
            a({
              target: "Set",
              proto: !0,
              real: !0,
              forced: v
            }, { intersection: S });
          }),
          /* 137 */
          /***/
          ((P, p, t) => {
            var a = t(127), f = t(128), S = t(132), E = t(133), v = t(130), T = t(131), i = f.Set, n = f.add, o = f.has;
            P.exports = function(h) {
              var e = a(this), l = E(h), u = new i();
              return S(e) > l.size ? T(l.getIterator(), function(c) {
                o(e, c) && n(u, c);
              }) : v(e, function(c) {
                l.includes(c) && n(u, c);
              }), u;
            };
          }),
          /* 138 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(139), S = t(135);
            a({
              target: "Set",
              proto: !0,
              real: !0,
              forced: !S("isDisjointFrom")
            }, { isDisjointFrom: f });
          }),
          /* 139 */
          /***/
          ((P, p, t) => {
            var a = t(127), f = t(128).has, S = t(132), E = t(133), v = t(130), T = t(131), i = t(140);
            P.exports = function(o) {
              var d = a(this), h = E(o);
              if (S(d) <= h.size)
                return v(d, function(l) {
                  if (h.includes(l))
                    return !1;
                }, !0) !== !1;
              var e = h.getIterator();
              return T(e, function(l) {
                if (f(d, l))
                  return i(e, "normal", !1);
              }) !== !1;
            };
          }),
          /* 140 */
          /***/
          ((P, p, t) => {
            var a = t(8), f = t(47), S = t(30);
            P.exports = function(E, v, T) {
              var i, n;
              f(E);
              try {
                if (i = S(E, "return"), !i) {
                  if (v === "throw")
                    throw T;
                  return T;
                }
                i = a(i, E);
              } catch (o) {
                n = !0, i = o;
              }
              if (v === "throw")
                throw T;
              if (n)
                throw i;
              return f(i), T;
            };
          }),
          /* 141 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(142), S = t(135);
            a({
              target: "Set",
              proto: !0,
              real: !0,
              forced: !S("isSubsetOf")
            }, { isSubsetOf: f });
          }),
          /* 142 */
          /***/
          ((P, p, t) => {
            var a = t(127), f = t(132), S = t(130), E = t(133);
            P.exports = function(T) {
              var i = a(this), n = E(T);
              return f(i) > n.size ? !1 : S(i, function(o) {
                if (!n.includes(o))
                  return !1;
              }, !0) !== !1;
            };
          }),
          /* 143 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(144), S = t(135);
            a({
              target: "Set",
              proto: !0,
              real: !0,
              forced: !S("isSupersetOf")
            }, { isSupersetOf: f });
          }),
          /* 144 */
          /***/
          ((P, p, t) => {
            var a = t(127), f = t(128).has, S = t(132), E = t(133), v = t(131), T = t(140);
            P.exports = function(n) {
              var o = a(this), d = E(n);
              if (S(o) < d.size)
                return !1;
              var h = d.getIterator();
              return v(h, function(e) {
                if (!f(o, e))
                  return T(h, "normal", !1);
              }) !== !1;
            };
          }),
          /* 145 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(146), S = t(135);
            a({
              target: "Set",
              proto: !0,
              real: !0,
              forced: !S("symmetricDifference")
            }, { symmetricDifference: f });
          }),
          /* 146 */
          /***/
          ((P, p, t) => {
            var a = t(127), f = t(128), S = t(129), E = t(133), v = t(131), T = f.add, i = f.has, n = f.remove;
            P.exports = function(d) {
              var h = a(this), e = E(d).getIterator(), l = S(h);
              return v(e, function(u) {
                i(h, u) ? n(l, u) : T(l, u);
              }), l;
            };
          }),
          /* 147 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(148), S = t(135);
            a({
              target: "Set",
              proto: !0,
              real: !0,
              forced: !S("union")
            }, { union: f });
          }),
          /* 148 */
          /***/
          ((P, p, t) => {
            var a = t(127), f = t(128).add, S = t(129), E = t(133), v = t(131);
            P.exports = function(i) {
              var n = a(this), o = E(i).getIterator(), d = S(n);
              return v(o, function(h) {
                f(d, h);
              }), d;
            };
          }),
          /* 149 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(4), S = t(24), E = t(11), v = t(45).f, T = t(39), i = t(150), n = t(75), o = t(76), d = t(151), h = t(82), e = t(6), l = t(36), u = "DOMException", c = S("Error"), y = S(u), C = function() {
              i(this, R);
              var G = arguments.length, M = o(G < 1 ? void 0 : arguments[0]), x = o(G < 2 ? void 0 : arguments[1], "Error"), A = new y(M, x), g = c(M);
              return g.name = u, v(A, "stack", E(1, h(g.stack, 1))), n(A, this, C), A;
            }, R = C.prototype = y.prototype, s = "stack" in c(u), m = "stack" in new y(1, 2), F = y && e && Object.getOwnPropertyDescriptor(f, u), B = !!F && !(F.writable && F.configurable), k = s && !B && !m;
            a({
              global: !0,
              constructor: !0,
              forced: l || k
            }, { DOMException: k ? C : y });
            var V = S(u), z = V.prototype;
            if (z.constructor !== V) {
              l || v(z, "constructor", E(1, V));
              for (var K in d)
                if (T(d, K)) {
                  var J = d[K], $ = J.s;
                  T(V, $) || v(V, $, E(6, J.c));
                }
            }
          }),
          /* 150 */
          /***/
          ((P, p, t) => {
            var a = t(25), f = TypeError;
            P.exports = function(S, E) {
              if (a(E, S))
                return S;
              throw f("Incorrect invocation");
            };
          }),
          /* 151 */
          /***/
          ((P) => {
            P.exports = {
              IndexSizeError: {
                s: "INDEX_SIZE_ERR",
                c: 1,
                m: 1
              },
              DOMStringSizeError: {
                s: "DOMSTRING_SIZE_ERR",
                c: 2,
                m: 0
              },
              HierarchyRequestError: {
                s: "HIERARCHY_REQUEST_ERR",
                c: 3,
                m: 1
              },
              WrongDocumentError: {
                s: "WRONG_DOCUMENT_ERR",
                c: 4,
                m: 1
              },
              InvalidCharacterError: {
                s: "INVALID_CHARACTER_ERR",
                c: 5,
                m: 1
              },
              NoDataAllowedError: {
                s: "NO_DATA_ALLOWED_ERR",
                c: 6,
                m: 0
              },
              NoModificationAllowedError: {
                s: "NO_MODIFICATION_ALLOWED_ERR",
                c: 7,
                m: 1
              },
              NotFoundError: {
                s: "NOT_FOUND_ERR",
                c: 8,
                m: 1
              },
              NotSupportedError: {
                s: "NOT_SUPPORTED_ERR",
                c: 9,
                m: 1
              },
              InUseAttributeError: {
                s: "INUSE_ATTRIBUTE_ERR",
                c: 10,
                m: 1
              },
              InvalidStateError: {
                s: "INVALID_STATE_ERR",
                c: 11,
                m: 1
              },
              SyntaxError: {
                s: "SYNTAX_ERR",
                c: 12,
                m: 1
              },
              InvalidModificationError: {
                s: "INVALID_MODIFICATION_ERR",
                c: 13,
                m: 1
              },
              NamespaceError: {
                s: "NAMESPACE_ERR",
                c: 14,
                m: 1
              },
              InvalidAccessError: {
                s: "INVALID_ACCESS_ERR",
                c: 15,
                m: 1
              },
              ValidationError: {
                s: "VALIDATION_ERR",
                c: 16,
                m: 0
              },
              TypeMismatchError: {
                s: "TYPE_MISMATCH_ERR",
                c: 17,
                m: 1
              },
              SecurityError: {
                s: "SECURITY_ERR",
                c: 18,
                m: 1
              },
              NetworkError: {
                s: "NETWORK_ERR",
                c: 19,
                m: 1
              },
              AbortError: {
                s: "ABORT_ERR",
                c: 20,
                m: 1
              },
              URLMismatchError: {
                s: "URL_MISMATCH_ERR",
                c: 21,
                m: 1
              },
              QuotaExceededError: {
                s: "QUOTA_EXCEEDED_ERR",
                c: 22,
                m: 1
              },
              TimeoutError: {
                s: "TIMEOUT_ERR",
                c: 23,
                m: 1
              },
              InvalidNodeTypeError: {
                s: "INVALID_NODE_TYPE_ERR",
                c: 24,
                m: 1
              },
              DataCloneError: {
                s: "DATA_CLONE_ERR",
                c: 25,
                m: 1
              }
            };
          }),
          /* 152 */
          /***/
          ((P, p, t) => {
            var a = t(36), f = t(3), S = t(4), E = t(24), v = t(14), T = t(7), i = t(41), n = t(21), o = t(153), d = t(17), h = t(20), e = t(23), l = t(154), u = t(47), c = t(78), y = t(39), C = t(159), R = t(44), s = t(64), m = t(85), F = t(160), B = t(162), k = t(128), V = t(83), z = t(119), K = S.Object, J = S.Array, $ = S.Date, j = S.Error, G = S.EvalError, M = S.RangeError, x = S.ReferenceError, A = S.SyntaxError, g = S.TypeError, I = S.URIError, U = S.PerformanceMark, _ = S.WebAssembly, H = _ && _.CompileError || j, N = _ && _.LinkError || j, b = _ && _.RuntimeError || j, w = E("DOMException"), O = B.Map, D = B.has, L = B.get, W = B.set, X = k.Set, q = k.add, ct = E("Object", "keys"), nt = v([].push), Y = v((!0).valueOf), Q = v(1 .valueOf), et = v("".valueOf), Z = v($.prototype.getTime), at = i("structuredClone"), lt = "DataCloneError", ft = "Transferring", pt = function(rt) {
              return !T(function() {
                var dt = new S.Set([7]), bt = rt(dt), gt = rt(K(7));
                return bt === dt || !bt.has(7) || typeof gt != "object" || +gt != 7;
              }) && rt;
            }, vt = function(rt, dt) {
              return !T(function() {
                var bt = new dt(), gt = rt({
                  a: bt,
                  b: bt
                });
                return !(gt && gt.a === gt.b && gt.a instanceof dt && gt.a.stack === bt.stack);
              });
            }, yt = function(rt) {
              return !T(function() {
                var dt = rt(new S.AggregateError([1], at, { cause: 3 }));
                return dt.name !== "AggregateError" || dt.errors[0] !== 1 || dt.message !== at || dt.cause !== 3;
              });
            }, xt = S.structuredClone, wt = a || !vt(xt, j) || !vt(xt, w) || !yt(xt), _t = !xt && pt(function(rt) {
              return new U(at, { detail: rt }).detail;
            }), Ct = pt(xt) || _t, Mt = function(rt) {
              throw new w("Uncloneable type: " + rt, lt);
            }, Rt = function(rt, dt) {
              throw new w((dt || "Cloning") + " of " + rt + " cannot be properly polyfilled in this engine", lt);
            }, Nt = function(rt, dt) {
              return Ct || Rt(dt), Ct(rt);
            }, Ut = function() {
              var rt;
              try {
                rt = new S.DataTransfer();
              } catch {
                try {
                  rt = new S.ClipboardEvent("").clipboardData;
                } catch {
                }
              }
              return rt && rt.items && rt.files ? rt : null;
            }, Ot = function(rt, dt, bt) {
              if (D(dt, rt))
                return L(dt, rt);
              var gt = bt || c(rt), mt, At, ht, Tt, St, Pt;
              if (gt === "SharedArrayBuffer")
                Ct ? mt = Ct(rt) : mt = rt;
              else {
                var It = S.DataView;
                !It && typeof rt.slice != "function" && Rt("ArrayBuffer");
                try {
                  if (typeof rt.slice == "function" && !rt.resizable)
                    mt = rt.slice(0);
                  else
                    for (At = rt.byteLength, ht = ("maxByteLength" in rt) ? { maxByteLength: rt.maxByteLength } : void 0, mt = new ArrayBuffer(At, ht), Tt = new It(rt), St = new It(mt), Pt = 0; Pt < At; Pt++)
                      St.setUint8(Pt, Tt.getUint8(Pt));
                } catch {
                  throw new w("ArrayBuffer is detached", lt);
                }
              }
              return W(dt, rt, mt), mt;
            }, ot = function(rt, dt, bt, gt, mt) {
              var At = S[dt];
              return h(At) || Rt(dt), new At(Ot(rt.buffer, mt), bt, gt);
            }, it = function(rt, dt, bt) {
              this.object = rt, this.type = dt, this.metadata = bt;
            }, tt = function(rt, dt, bt) {
              if (e(rt) && Mt("Symbol"), !h(rt))
                return rt;
              if (dt) {
                if (D(dt, rt))
                  return L(dt, rt);
              } else
                dt = new O();
              var gt = c(rt), mt, At, ht, Tt, St, Pt, It, Ft;
              switch (gt) {
                case "Array":
                  ht = J(s(rt));
                  break;
                case "Object":
                  ht = {};
                  break;
                case "Map":
                  ht = new O();
                  break;
                case "Set":
                  ht = new X();
                  break;
                case "RegExp":
                  ht = new RegExp(rt.source, F(rt));
                  break;
                case "Error":
                  switch (At = rt.name, At) {
                    case "AggregateError":
                      ht = E("AggregateError")([]);
                      break;
                    case "EvalError":
                      ht = G();
                      break;
                    case "RangeError":
                      ht = M();
                      break;
                    case "ReferenceError":
                      ht = x();
                      break;
                    case "SyntaxError":
                      ht = A();
                      break;
                    case "TypeError":
                      ht = g();
                      break;
                    case "URIError":
                      ht = I();
                      break;
                    case "CompileError":
                      ht = H();
                      break;
                    case "LinkError":
                      ht = N();
                      break;
                    case "RuntimeError":
                      ht = b();
                      break;
                    default:
                      ht = j();
                  }
                  break;
                case "DOMException":
                  ht = new w(rt.message, rt.name);
                  break;
                case "ArrayBuffer":
                case "SharedArrayBuffer":
                  ht = bt ? new it(rt, gt) : Ot(rt, dt, gt);
                  break;
                case "DataView":
                case "Int8Array":
                case "Uint8Array":
                case "Uint8ClampedArray":
                case "Int16Array":
                case "Uint16Array":
                case "Int32Array":
                case "Uint32Array":
                case "Float16Array":
                case "Float32Array":
                case "Float64Array":
                case "BigInt64Array":
                case "BigUint64Array":
                  Pt = gt === "DataView" ? rt.byteLength : rt.length, ht = bt ? new it(rt, gt, {
                    offset: rt.byteOffset,
                    length: Pt
                  }) : ot(rt, gt, rt.byteOffset, Pt, dt);
                  break;
                case "DOMQuad":
                  try {
                    ht = new DOMQuad(tt(rt.p1, dt, bt), tt(rt.p2, dt, bt), tt(rt.p3, dt, bt), tt(rt.p4, dt, bt));
                  } catch {
                    ht = Nt(rt, gt);
                  }
                  break;
                case "File":
                  if (Ct)
                    try {
                      ht = Ct(rt), c(ht) !== gt && (ht = void 0);
                    } catch {
                    }
                  if (!ht)
                    try {
                      ht = new File([rt], rt.name, rt);
                    } catch {
                    }
                  ht || Rt(gt);
                  break;
                case "FileList":
                  if (Tt = Ut(), Tt) {
                    for (St = 0, Pt = s(rt); St < Pt; St++)
                      Tt.items.add(tt(rt[St], dt, bt));
                    ht = Tt.files;
                  } else
                    ht = Nt(rt, gt);
                  break;
                case "ImageData":
                  try {
                    ht = new ImageData(tt(rt.data, dt, bt), rt.width, rt.height, { colorSpace: rt.colorSpace });
                  } catch {
                    ht = Nt(rt, gt);
                  }
                  break;
                default:
                  if (Ct)
                    ht = Ct(rt);
                  else
                    switch (gt) {
                      case "BigInt":
                        ht = K(rt.valueOf());
                        break;
                      case "Boolean":
                        ht = K(Y(rt));
                        break;
                      case "Number":
                        ht = K(Q(rt));
                        break;
                      case "String":
                        ht = K(et(rt));
                        break;
                      case "Date":
                        ht = new $(Z(rt));
                        break;
                      case "Blob":
                        try {
                          ht = rt.slice(0, rt.size, rt.type);
                        } catch {
                          Rt(gt);
                        }
                        break;
                      case "DOMPoint":
                      case "DOMPointReadOnly":
                        mt = S[gt];
                        try {
                          ht = mt.fromPoint ? mt.fromPoint(rt) : new mt(rt.x, rt.y, rt.z, rt.w);
                        } catch {
                          Rt(gt);
                        }
                        break;
                      case "DOMRect":
                      case "DOMRectReadOnly":
                        mt = S[gt];
                        try {
                          ht = mt.fromRect ? mt.fromRect(rt) : new mt(rt.x, rt.y, rt.width, rt.height);
                        } catch {
                          Rt(gt);
                        }
                        break;
                      case "DOMMatrix":
                      case "DOMMatrixReadOnly":
                        mt = S[gt];
                        try {
                          ht = mt.fromMatrix ? mt.fromMatrix(rt) : new mt(rt);
                        } catch {
                          Rt(gt);
                        }
                        break;
                      case "AudioData":
                      case "VideoFrame":
                        n(rt.clone) || Rt(gt);
                        try {
                          ht = rt.clone();
                        } catch {
                          Mt(gt);
                        }
                        break;
                      case "CropTarget":
                      case "CryptoKey":
                      case "FileSystemDirectoryHandle":
                      case "FileSystemFileHandle":
                      case "FileSystemHandle":
                      case "GPUCompilationInfo":
                      case "GPUCompilationMessage":
                      case "ImageBitmap":
                      case "RTCCertificate":
                      case "WebAssembly.Module":
                        Rt(gt);
                      default:
                        Mt(gt);
                    }
              }
              switch (W(dt, rt, ht), gt) {
                case "Array":
                case "Object":
                  for (It = ct(rt), St = 0, Pt = s(It); St < Pt; St++)
                    Ft = It[St], C(ht, Ft, tt(rt[Ft], dt, bt));
                  break;
                case "Map":
                  rt.forEach(function(Lt, Bt) {
                    W(ht, tt(Bt, dt, bt), tt(Lt, dt, bt));
                  });
                  break;
                case "Set":
                  rt.forEach(function(Lt) {
                    q(ht, tt(Lt, dt, bt));
                  });
                  break;
                case "Error":
                  R(ht, "message", tt(rt.message, dt, bt)), y(rt, "cause") && R(ht, "cause", tt(rt.cause, dt, bt)), At === "AggregateError" && (ht.errors = tt(rt.errors, dt, bt));
                case "DOMException":
                  V && R(ht, "stack", tt(rt.stack, dt, bt));
              }
              return ht;
            }, ut = function(rt, dt) {
              if (!h(rt))
                return rt;
              if (D(dt, rt))
                return L(dt, rt);
              var bt, gt, mt, At, ht, Tt, St, Pt;
              if (rt instanceof it)
                switch (bt = rt.type, gt = rt.object, bt) {
                  case "ArrayBuffer":
                  case "SharedArrayBuffer":
                    Pt = Ot(gt, dt, bt);
                    break;
                  case "DataView":
                  case "Int8Array":
                  case "Uint8Array":
                  case "Uint8ClampedArray":
                  case "Int16Array":
                  case "Uint16Array":
                  case "Int32Array":
                  case "Uint32Array":
                  case "Float16Array":
                  case "Float32Array":
                  case "Float64Array":
                  case "BigInt64Array":
                  case "BigUint64Array":
                    mt = rt.metadata, Pt = ot(gt, bt, mt.offset, mt.length, dt);
                }
              else
                switch (c(rt)) {
                  case "Array":
                  case "Object":
                    for (Tt = ct(rt), At = 0, ht = s(Tt); At < ht; At++)
                      St = Tt[At], rt[St] = ut(rt[St], dt);
                    break;
                  case "Map":
                    Pt = new O(), rt.forEach(function(It, Ft) {
                      W(Pt, ut(Ft, dt), ut(It, dt));
                    });
                    break;
                  case "Set":
                    Pt = new X(), rt.forEach(function(It) {
                      q(Pt, ut(It, dt));
                    });
                    break;
                  case "Error":
                    rt.message = ut(rt.message, dt), y(rt, "cause") && (rt.cause = ut(rt.cause, dt)), rt.name === "AggregateError" && (rt.errors = ut(rt.errors, dt));
                  case "DOMException":
                    V && (rt.stack = ut(rt.stack, dt));
                }
              return W(dt, rt, Pt || rt), Pt || rt;
            }, Et = function(rt, dt) {
              if (!h(rt))
                throw g("Transfer option cannot be converted to a sequence");
              var bt = [];
              l(rt, function(Lt) {
                nt(bt, u(Lt));
              });
              for (var gt = 0, mt = s(bt), At = [], ht, Tt, St, Pt, It, Ft; gt < mt; ) {
                if (ht = bt[gt++], Tt = c(ht), Tt === "ArrayBuffer") {
                  nt(At, ht);
                  continue;
                }
                if (D(dt, ht))
                  throw new w("Duplicate transferable", lt);
                if (z)
                  Pt = xt(ht, { transfer: [ht] });
                else
                  switch (Tt) {
                    case "ImageBitmap":
                      St = S.OffscreenCanvas, o(St) || Rt(Tt, ft);
                      try {
                        It = new St(ht.width, ht.height), Ft = It.getContext("bitmaprenderer"), Ft.transferFromImageBitmap(ht), Pt = It.transferToImageBitmap();
                      } catch {
                      }
                      break;
                    case "AudioData":
                    case "VideoFrame":
                      (!n(ht.clone) || !n(ht.close)) && Rt(Tt, ft);
                      try {
                        Pt = ht.clone(), ht.close();
                      } catch {
                      }
                      break;
                    case "MediaSourceHandle":
                    case "MessagePort":
                    case "OffscreenCanvas":
                    case "ReadableStream":
                    case "TransformStream":
                    case "WritableStream":
                      Rt(Tt, ft);
                  }
                if (Pt === void 0)
                  throw new w("This object cannot be transferred: " + Tt, lt);
                W(dt, ht, Pt);
              }
              return At;
            }, kt = function(rt, dt) {
              for (var bt = 0, gt = s(rt), mt, At; bt < gt; ) {
                if (mt = rt[bt++], D(dt, mt))
                  throw new w("Duplicate transferable", lt);
                z ? At = xt(mt, { transfer: [mt] }) : (n(mt.transfer) || Rt("ArrayBuffer", ft), At = mt.transfer()), W(dt, mt, At);
              }
            };
            f({
              global: !0,
              enumerable: !0,
              sham: !z,
              forced: wt
            }, {
              structuredClone: function(dt) {
                var bt = m(arguments.length, 1) > 1 && !d(arguments[1]) ? u(arguments[1]) : void 0, gt = bt ? bt.transfer : void 0, mt = !1, At, ht;
                gt !== void 0 && (At = new O(), ht = Et(gt, At), mt = !!s(ht));
                var Tt = tt(dt, At, mt);
                return mt && (At = new O(), kt(gt, At), Tt = ut(Tt, At)), Tt;
              }
            });
          }),
          /* 153 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(7), S = t(21), E = t(78), v = t(24), T = t(51), i = function() {
            }, n = [], o = v("Reflect", "construct"), d = /^\s*(?:class|function)\b/, h = a(d.exec), e = !d.exec(i), l = function(y) {
              if (!S(y))
                return !1;
              try {
                return o(i, n, y), !0;
              } catch {
                return !1;
              }
            }, u = function(y) {
              if (!S(y))
                return !1;
              switch (E(y)) {
                case "AsyncFunction":
                case "GeneratorFunction":
                case "AsyncGeneratorFunction":
                  return !1;
              }
              try {
                return e || !!h(d, T(y));
              } catch {
                return !0;
              }
            };
            u.sham = !0, P.exports = !o || f(function() {
              var c;
              return l(l.call) || !l(Object) || !l(function() {
                c = !0;
              }) || c;
            }) ? u : l;
          }),
          /* 154 */
          /***/
          ((P, p, t) => {
            var a = t(99), f = t(8), S = t(47), E = t(32), v = t(155), T = t(64), i = t(25), n = t(157), o = t(158), d = t(140), h = TypeError, e = function(u, c) {
              this.stopped = u, this.result = c;
            }, l = e.prototype;
            P.exports = function(u, c, y) {
              var C = y && y.that, R = !!(y && y.AS_ENTRIES), s = !!(y && y.IS_RECORD), m = !!(y && y.IS_ITERATOR), F = !!(y && y.INTERRUPTED), B = a(c, C), k, V, z, K, J, $, j, G = function(x) {
                return k && d(k, "normal", x), new e(!0, x);
              }, M = function(x) {
                return R ? (S(x), F ? B(x[0], x[1], G) : B(x[0], x[1])) : F ? B(x, G) : B(x);
              };
              if (s)
                k = u.iterator;
              else if (m)
                k = u;
              else {
                if (V = o(u), !V)
                  throw h(E(u) + " is not iterable");
                if (v(V)) {
                  for (z = 0, K = T(u); K > z; z++)
                    if (J = M(u[z]), J && i(l, J))
                      return J;
                  return new e(!1);
                }
                k = n(u, V);
              }
              for ($ = s ? u.next : k.next; !(j = f($, k)).done; ) {
                try {
                  J = M(j.value);
                } catch (x) {
                  d(k, "throw", x);
                }
                if (typeof J == "object" && J && i(l, J))
                  return J;
              }
              return new e(!1);
            };
          }),
          /* 155 */
          /***/
          ((P, p, t) => {
            var a = t(34), f = t(156), S = a("iterator"), E = Array.prototype;
            P.exports = function(v) {
              return v !== void 0 && (f.Array === v || E[S] === v);
            };
          }),
          /* 156 */
          /***/
          ((P) => {
            P.exports = {};
          }),
          /* 157 */
          /***/
          ((P, p, t) => {
            var a = t(8), f = t(31), S = t(47), E = t(32), v = t(158), T = TypeError;
            P.exports = function(i, n) {
              var o = arguments.length < 2 ? v(i) : n;
              if (f(o))
                return S(a(o, i));
              throw T(E(i) + " is not iterable");
            };
          }),
          /* 158 */
          /***/
          ((P, p, t) => {
            var a = t(78), f = t(30), S = t(17), E = t(156), v = t(34), T = v("iterator");
            P.exports = function(i) {
              if (!S(i))
                return f(i, T) || f(i, "@@iterator") || E[a(i)];
            };
          }),
          /* 159 */
          /***/
          ((P, p, t) => {
            var a = t(18), f = t(45), S = t(11);
            P.exports = function(E, v, T) {
              var i = a(v);
              i in E ? f.f(E, i, S(0, T)) : E[i] = T;
            };
          }),
          /* 160 */
          /***/
          ((P, p, t) => {
            var a = t(8), f = t(39), S = t(25), E = t(161), v = RegExp.prototype;
            P.exports = function(T) {
              var i = T.flags;
              return i === void 0 && !("flags" in v) && !f(T, "flags") && S(v, T) ? a(E, T) : i;
            };
          }),
          /* 161 */
          /***/
          ((P, p, t) => {
            var a = t(47);
            P.exports = function() {
              var f = a(this), S = "";
              return f.hasIndices && (S += "d"), f.global && (S += "g"), f.ignoreCase && (S += "i"), f.multiline && (S += "m"), f.dotAll && (S += "s"), f.unicode && (S += "u"), f.unicodeSets && (S += "v"), f.sticky && (S += "y"), S;
            };
          }),
          /* 162 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = Map.prototype;
            P.exports = {
              Map,
              set: a(f.set),
              get: a(f.get),
              has: a(f.has),
              remove: a(f.delete),
              proto: f
            };
          }),
          /* 163 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.SerializableEmpty = p.PrintAnnotationStorage = p.AnnotationStorage = void 0, t(89), t(149), t(152);
            var a = t(1), f = t(164), S = t(170);
            const E = Object.freeze({
              map: null,
              hash: "",
              transfers: void 0
            });
            p.SerializableEmpty = E;
            class v {
              #t = !1;
              #e = /* @__PURE__ */ new Map();
              constructor() {
                this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
              }
              getValue(n, o) {
                const d = this.#e.get(n);
                return d === void 0 ? o : Object.assign(o, d);
              }
              getRawValue(n) {
                return this.#e.get(n);
              }
              remove(n) {
                if (this.#e.delete(n), this.#e.size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
                  for (const o of this.#e.values())
                    if (o instanceof f.AnnotationEditor)
                      return;
                  this.onAnnotationEditor(null);
                }
              }
              setValue(n, o) {
                const d = this.#e.get(n);
                let h = !1;
                if (d !== void 0)
                  for (const [e, l] of Object.entries(o))
                    d[e] !== l && (h = !0, d[e] = l);
                else
                  h = !0, this.#e.set(n, o);
                h && this.#n(), o instanceof f.AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(o.constructor._type);
              }
              has(n) {
                return this.#e.has(n);
              }
              getAll() {
                return this.#e.size > 0 ? (0, a.objectFromMap)(this.#e) : null;
              }
              setAll(n) {
                for (const [o, d] of Object.entries(n))
                  this.setValue(o, d);
              }
              get size() {
                return this.#e.size;
              }
              #n() {
                this.#t || (this.#t = !0, typeof this.onSetModified == "function" && this.onSetModified());
              }
              resetModified() {
                this.#t && (this.#t = !1, typeof this.onResetModified == "function" && this.onResetModified());
              }
              get print() {
                return new T(this);
              }
              get serializable() {
                if (this.#e.size === 0)
                  return E;
                const n = /* @__PURE__ */ new Map(), o = new S.MurmurHash3_64(), d = [], h = /* @__PURE__ */ Object.create(null);
                let e = !1;
                for (const [l, u] of this.#e) {
                  const c = u instanceof f.AnnotationEditor ? u.serialize(!1, h) : u;
                  c && (n.set(l, c), o.update(`${l}:${JSON.stringify(c)}`), e ||= !!c.bitmap);
                }
                if (e)
                  for (const l of n.values())
                    l.bitmap && d.push(l.bitmap);
                return n.size > 0 ? {
                  map: n,
                  hash: o.hexdigest(),
                  transfers: d
                } : E;
              }
            }
            p.AnnotationStorage = v;
            class T extends v {
              #t;
              constructor(n) {
                super();
                const {
                  map: o,
                  hash: d,
                  transfers: h
                } = n.serializable, e = structuredClone(o, null);
                this.#t = {
                  map: e,
                  hash: d,
                  transfers: h
                };
              }
              get print() {
                (0, a.unreachable)("Should not call PrintAnnotationStorage.print");
              }
              get serializable() {
                return this.#t;
              }
            }
            p.PrintAnnotationStorage = T;
          }),
          /* 164 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.AnnotationEditor = void 0, t(89), t(2);
            var a = t(165), f = t(1), S = t(168);
            class E {
              #t = "";
              #e = !1;
              #n = null;
              #i = null;
              #o = null;
              #s = !1;
              #a = null;
              #l = this.focusin.bind(this);
              #c = this.focusout.bind(this);
              #r = !1;
              #h = !1;
              #u = !1;
              _initialOptions = /* @__PURE__ */ Object.create(null);
              _uiManager = null;
              _focusEventsAllowed = !0;
              _l10nPromise = null;
              #f = !1;
              #p = E._zIndex++;
              static _borderLineWidth = -1;
              static _colorManager = new a.ColorManager();
              static _zIndex = 1;
              static SMALL_EDITOR_SIZE = 0;
              constructor(i) {
                this.constructor === E && (0, f.unreachable)("Cannot initialize AnnotationEditor."), this.parent = i.parent, this.id = i.id, this.width = this.height = null, this.pageIndex = i.parent.pageIndex, this.name = i.name, this.div = null, this._uiManager = i.uiManager, this.annotationElementId = null, this._willKeepAspectRatio = !1, this._initialOptions.isCentered = i.isCentered, this._structTreeParentId = null;
                const {
                  rotation: n,
                  rawDims: {
                    pageWidth: o,
                    pageHeight: d,
                    pageX: h,
                    pageY: e
                  }
                } = this.parent.viewport;
                this.rotation = n, this.pageRotation = (360 + n - this._uiManager.viewParameters.rotation) % 360, this.pageDimensions = [o, d], this.pageTranslation = [h, e];
                const [l, u] = this.parentDimensions;
                this.x = i.x / l, this.y = i.y / u, this.isAttachedToDOM = !1, this.deleted = !1;
              }
              get editorType() {
                return Object.getPrototypeOf(this).constructor._type;
              }
              static get _defaultLineColor() {
                return (0, f.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
              }
              static deleteAnnotationElement(i) {
                const n = new v({
                  id: i.parent.getNextId(),
                  parent: i.parent,
                  uiManager: i._uiManager
                });
                n.annotationElementId = i.annotationElementId, n.deleted = !0, n._uiManager.addToAnnotationStorage(n);
              }
              static initialize(i) {
                let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (E._l10nPromise ||= new Map(["editor_alt_text_button_label", "editor_alt_text_edit_button_label", "editor_alt_text_decorative_tooltip"].map((d) => [d, i.get(d)])), n?.strings)
                  for (const d of n.strings)
                    E._l10nPromise.set(d, i.get(d));
                if (E._borderLineWidth !== -1)
                  return;
                const o = getComputedStyle(document.documentElement);
                E._borderLineWidth = parseFloat(o.getPropertyValue("--outline-width")) || 0;
              }
              static updateDefaultParams(i, n) {
              }
              static get defaultPropertiesToUpdate() {
                return [];
              }
              static isHandlingMimeForPasting(i) {
                return !1;
              }
              static paste(i, n) {
                (0, f.unreachable)("Not implemented");
              }
              get propertiesToUpdate() {
                return [];
              }
              get _isDraggable() {
                return this.#f;
              }
              set _isDraggable(i) {
                this.#f = i, this.div?.classList.toggle("draggable", i);
              }
              center() {
                const [i, n] = this.pageDimensions;
                switch (this.parentRotation) {
                  case 90:
                    this.x -= this.height * n / (i * 2), this.y += this.width * i / (n * 2);
                    break;
                  case 180:
                    this.x += this.width / 2, this.y += this.height / 2;
                    break;
                  case 270:
                    this.x += this.height * n / (i * 2), this.y -= this.width * i / (n * 2);
                    break;
                  default:
                    this.x -= this.width / 2, this.y -= this.height / 2;
                    break;
                }
                this.fixAndSetPosition();
              }
              addCommands(i) {
                this._uiManager.addCommands(i);
              }
              get currentLayer() {
                return this._uiManager.currentLayer;
              }
              setInBackground() {
                this.div.style.zIndex = 0;
              }
              setInForeground() {
                this.div.style.zIndex = this.#p;
              }
              setParent(i) {
                i !== null && (this.pageIndex = i.pageIndex, this.pageDimensions = i.pageDimensions), this.parent = i;
              }
              focusin(i) {
                this._focusEventsAllowed && (this.#r ? this.#r = !1 : this.parent.setSelected(this));
              }
              focusout(i) {
                !this._focusEventsAllowed || !this.isAttachedToDOM || i.relatedTarget?.closest(`#${this.id}`) || (i.preventDefault(), this.parent?.isMultipleSelection || this.commitOrRemove());
              }
              commitOrRemove() {
                this.isEmpty() ? this.remove() : this.commit();
              }
              commit() {
                this.addToAnnotationStorage();
              }
              addToAnnotationStorage() {
                this._uiManager.addToAnnotationStorage(this);
              }
              setAt(i, n, o, d) {
                const [h, e] = this.parentDimensions;
                [o, d] = this.screenToPageTranslation(o, d), this.x = (i + o) / h, this.y = (n + d) / e, this.fixAndSetPosition();
              }
              #g(i, n, o) {
                let [d, h] = i;
                [n, o] = this.screenToPageTranslation(n, o), this.x += n / d, this.y += o / h, this.fixAndSetPosition();
              }
              translate(i, n) {
                this.#g(this.parentDimensions, i, n);
              }
              translateInPage(i, n) {
                this.#g(this.pageDimensions, i, n), this.div.scrollIntoView({
                  block: "nearest"
                });
              }
              drag(i, n) {
                const [o, d] = this.parentDimensions;
                if (this.x += i / o, this.y += n / d, this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                  const {
                    x: c,
                    y
                  } = this.div.getBoundingClientRect();
                  this.parent.findNewParent(this, c, y) && (this.x -= Math.floor(this.x), this.y -= Math.floor(this.y));
                }
                let {
                  x: h,
                  y: e
                } = this;
                const [l, u] = this.#m();
                h += l, e += u, this.div.style.left = `${(100 * h).toFixed(2)}%`, this.div.style.top = `${(100 * e).toFixed(2)}%`, this.div.scrollIntoView({
                  block: "nearest"
                });
              }
              #m() {
                const [i, n] = this.parentDimensions, {
                  _borderLineWidth: o
                } = E, d = o / i, h = o / n;
                switch (this.rotation) {
                  case 90:
                    return [-d, h];
                  case 180:
                    return [d, h];
                  case 270:
                    return [d, -h];
                  default:
                    return [-d, -h];
                }
              }
              fixAndSetPosition() {
                const [i, n] = this.pageDimensions;
                let {
                  x: o,
                  y: d,
                  width: h,
                  height: e
                } = this;
                switch (h *= i, e *= n, o *= i, d *= n, this.rotation) {
                  case 0:
                    o = Math.max(0, Math.min(i - h, o)), d = Math.max(0, Math.min(n - e, d));
                    break;
                  case 90:
                    o = Math.max(0, Math.min(i - e, o)), d = Math.min(n, Math.max(h, d));
                    break;
                  case 180:
                    o = Math.min(i, Math.max(h, o)), d = Math.min(n, Math.max(e, d));
                    break;
                  case 270:
                    o = Math.min(i, Math.max(e, o)), d = Math.max(0, Math.min(n - h, d));
                    break;
                }
                this.x = o /= i, this.y = d /= n;
                const [l, u] = this.#m();
                o += l, d += u;
                const {
                  style: c
                } = this.div;
                c.left = `${(100 * o).toFixed(2)}%`, c.top = `${(100 * d).toFixed(2)}%`, this.moveInDOM();
              }
              static #v(i, n, o) {
                switch (o) {
                  case 90:
                    return [n, -i];
                  case 180:
                    return [-i, -n];
                  case 270:
                    return [-n, i];
                  default:
                    return [i, n];
                }
              }
              screenToPageTranslation(i, n) {
                return E.#v(i, n, this.parentRotation);
              }
              pageTranslationToScreen(i, n) {
                return E.#v(i, n, 360 - this.parentRotation);
              }
              #d(i) {
                switch (i) {
                  case 90: {
                    const [n, o] = this.pageDimensions;
                    return [0, -n / o, o / n, 0];
                  }
                  case 180:
                    return [-1, 0, 0, -1];
                  case 270: {
                    const [n, o] = this.pageDimensions;
                    return [0, n / o, -o / n, 0];
                  }
                  default:
                    return [1, 0, 0, 1];
                }
              }
              get parentScale() {
                return this._uiManager.viewParameters.realScale;
              }
              get parentRotation() {
                return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
              }
              get parentDimensions() {
                const {
                  parentScale: i,
                  pageDimensions: [n, o]
                } = this, d = n * i, h = o * i;
                return f.FeatureTest.isCSSRoundSupported ? [Math.round(d), Math.round(h)] : [d, h];
              }
              setDims(i, n) {
                const [o, d] = this.parentDimensions;
                this.div.style.width = `${(100 * i / o).toFixed(2)}%`, this.#s || (this.div.style.height = `${(100 * n / d).toFixed(2)}%`), this.#n?.classList.toggle("small", i < E.SMALL_EDITOR_SIZE || n < E.SMALL_EDITOR_SIZE);
              }
              fixDims() {
                const {
                  style: i
                } = this.div, {
                  height: n,
                  width: o
                } = i, d = o.endsWith("%"), h = !this.#s && n.endsWith("%");
                if (d && h)
                  return;
                const [e, l] = this.parentDimensions;
                d || (i.width = `${(100 * parseFloat(o) / e).toFixed(2)}%`), !this.#s && !h && (i.height = `${(100 * parseFloat(n) / l).toFixed(2)}%`);
              }
              getInitialTranslation() {
                return [0, 0];
              }
              #b() {
                if (this.#a)
                  return;
                this.#a = document.createElement("div"), this.#a.classList.add("resizers");
                const i = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
                this._willKeepAspectRatio || i.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                for (const n of i) {
                  const o = document.createElement("div");
                  this.#a.append(o), o.classList.add("resizer", n), o.addEventListener("pointerdown", this.#x.bind(this, n)), o.addEventListener("contextmenu", S.noContextMenu);
                }
                this.div.prepend(this.#a);
              }
              #x(i, n) {
                n.preventDefault();
                const {
                  isMac: o
                } = f.FeatureTest.platform;
                if (n.button !== 0 || n.ctrlKey && o)
                  return;
                const d = this.#A.bind(this, i), h = this._isDraggable;
                this._isDraggable = !1;
                const e = {
                  passive: !0,
                  capture: !0
                };
                window.addEventListener("pointermove", d, e);
                const l = this.x, u = this.y, c = this.width, y = this.height, C = this.parent.div.style.cursor, R = this.div.style.cursor;
                this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(n.target).cursor;
                const s = () => {
                  this._isDraggable = h, window.removeEventListener("pointerup", s), window.removeEventListener("blur", s), window.removeEventListener("pointermove", d, e), this.parent.div.style.cursor = C, this.div.style.cursor = R;
                  const m = this.x, F = this.y, B = this.width, k = this.height;
                  m === l && F === u && B === c && k === y || this.addCommands({
                    cmd: () => {
                      this.width = B, this.height = k, this.x = m, this.y = F;
                      const [V, z] = this.parentDimensions;
                      this.setDims(V * B, z * k), this.fixAndSetPosition();
                    },
                    undo: () => {
                      this.width = c, this.height = y, this.x = l, this.y = u;
                      const [V, z] = this.parentDimensions;
                      this.setDims(V * c, z * y), this.fixAndSetPosition();
                    },
                    mustExec: !0
                  });
                };
                window.addEventListener("pointerup", s), window.addEventListener("blur", s);
              }
              #A(i, n) {
                const [o, d] = this.parentDimensions, h = this.x, e = this.y, l = this.width, u = this.height, c = E.MIN_SIZE / o, y = E.MIN_SIZE / d, C = (N) => Math.round(N * 1e4) / 1e4, R = this.#d(this.rotation), s = (N, b) => [R[0] * N + R[2] * b, R[1] * N + R[3] * b], m = this.#d(360 - this.rotation), F = (N, b) => [m[0] * N + m[2] * b, m[1] * N + m[3] * b];
                let B, k, V = !1, z = !1;
                switch (i) {
                  case "topLeft":
                    V = !0, B = (N, b) => [0, 0], k = (N, b) => [N, b];
                    break;
                  case "topMiddle":
                    B = (N, b) => [N / 2, 0], k = (N, b) => [N / 2, b];
                    break;
                  case "topRight":
                    V = !0, B = (N, b) => [N, 0], k = (N, b) => [0, b];
                    break;
                  case "middleRight":
                    z = !0, B = (N, b) => [N, b / 2], k = (N, b) => [0, b / 2];
                    break;
                  case "bottomRight":
                    V = !0, B = (N, b) => [N, b], k = (N, b) => [0, 0];
                    break;
                  case "bottomMiddle":
                    B = (N, b) => [N / 2, b], k = (N, b) => [N / 2, 0];
                    break;
                  case "bottomLeft":
                    V = !0, B = (N, b) => [0, b], k = (N, b) => [N, 0];
                    break;
                  case "middleLeft":
                    z = !0, B = (N, b) => [0, b / 2], k = (N, b) => [N, b / 2];
                    break;
                }
                const K = B(l, u), J = k(l, u);
                let $ = s(...J);
                const j = C(h + $[0]), G = C(e + $[1]);
                let M = 1, x = 1, [A, g] = this.screenToPageTranslation(n.movementX, n.movementY);
                if ([A, g] = F(A / o, g / d), V) {
                  const N = Math.hypot(l, u);
                  M = x = Math.max(Math.min(Math.hypot(J[0] - K[0] - A, J[1] - K[1] - g) / N, 1 / l, 1 / u), c / l, y / u);
                } else z ? M = Math.max(c, Math.min(1, Math.abs(J[0] - K[0] - A))) / l : x = Math.max(y, Math.min(1, Math.abs(J[1] - K[1] - g))) / u;
                const I = C(l * M), U = C(u * x);
                $ = s(...k(I, U));
                const _ = j - $[0], H = G - $[1];
                this.width = I, this.height = U, this.x = _, this.y = H, this.setDims(o * I, d * U), this.fixAndSetPosition();
              }
              async addAltTextButton() {
                if (this.#n)
                  return;
                const i = this.#n = document.createElement("button");
                i.className = "altText";
                const n = await E._l10nPromise.get("editor_alt_text_button_label");
                i.textContent = n, i.setAttribute("aria-label", n), i.tabIndex = "0", i.addEventListener("contextmenu", S.noContextMenu), i.addEventListener("pointerdown", (o) => o.stopPropagation()), i.addEventListener("click", (o) => {
                  o.preventDefault(), this._uiManager.editAltText(this);
                }, {
                  capture: !0
                }), i.addEventListener("keydown", (o) => {
                  o.target === i && o.key === "Enter" && (o.preventDefault(), this._uiManager.editAltText(this));
                }), this.#S(), this.div.append(i), E.SMALL_EDITOR_SIZE || (E.SMALL_EDITOR_SIZE = Math.min(128, Math.round(i.getBoundingClientRect().width * 1.4)));
              }
              async #S() {
                const i = this.#n;
                if (!i)
                  return;
                if (!this.#t && !this.#e) {
                  i.classList.remove("done"), this.#i?.remove();
                  return;
                }
                E._l10nPromise.get("editor_alt_text_edit_button_label").then((o) => {
                  i.setAttribute("aria-label", o);
                });
                let n = this.#i;
                if (!n) {
                  this.#i = n = document.createElement("span"), n.className = "tooltip", n.setAttribute("role", "tooltip");
                  const o = n.id = `alt-text-tooltip-${this.id}`;
                  i.setAttribute("aria-describedby", o);
                  const d = 100;
                  i.addEventListener("mouseenter", () => {
                    this.#o = setTimeout(() => {
                      this.#o = null, this.#i.classList.add("show"), this._uiManager._eventBus.dispatch("reporttelemetry", {
                        source: this,
                        details: {
                          type: "editing",
                          subtype: this.editorType,
                          data: {
                            action: "alt_text_tooltip"
                          }
                        }
                      });
                    }, d);
                  }), i.addEventListener("mouseleave", () => {
                    clearTimeout(this.#o), this.#o = null, this.#i?.classList.remove("show");
                  });
                }
                i.classList.add("done"), n.innerText = this.#e ? await E._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#t, n.parentNode || i.append(n);
              }
              getClientDimensions() {
                return this.div.getBoundingClientRect();
              }
              get altTextData() {
                return {
                  altText: this.#t,
                  decorative: this.#e
                };
              }
              set altTextData(i) {
                let {
                  altText: n,
                  decorative: o
                } = i;
                this.#t === n && this.#e === o || (this.#t = n, this.#e = o, this.#S());
              }
              render() {
                this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.setAttribute("tabIndex", 0), this.setInForeground(), this.div.addEventListener("focusin", this.#l), this.div.addEventListener("focusout", this.#c);
                const [i, n] = this.parentDimensions;
                this.parentRotation % 180 !== 0 && (this.div.style.maxWidth = `${(100 * n / i).toFixed(2)}%`, this.div.style.maxHeight = `${(100 * i / n).toFixed(2)}%`);
                const [o, d] = this.getInitialTranslation();
                return this.translate(o, d), (0, a.bindEvents)(this, this.div, ["pointerdown"]), this.div;
              }
              pointerdown(i) {
                const {
                  isMac: n
                } = f.FeatureTest.platform;
                if (i.button !== 0 || i.ctrlKey && n) {
                  i.preventDefault();
                  return;
                }
                this.#r = !0, this.#E(i);
              }
              #E(i) {
                if (!this._isDraggable)
                  return;
                const n = this._uiManager.isSelected(this);
                this._uiManager.setUpDragSession();
                let o, d;
                n && (o = {
                  passive: !0,
                  capture: !0
                }, d = (e) => {
                  const [l, u] = this.screenToPageTranslation(e.movementX, e.movementY);
                  this._uiManager.dragSelectedEditors(l, u);
                }, window.addEventListener("pointermove", d, o));
                const h = () => {
                  if (window.removeEventListener("pointerup", h), window.removeEventListener("blur", h), n && window.removeEventListener("pointermove", d, o), this.#r = !1, !this._uiManager.endDragSession()) {
                    const {
                      isMac: e
                    } = f.FeatureTest.platform;
                    i.ctrlKey && !e || i.shiftKey || i.metaKey && e ? this.parent.toggleSelected(this) : this.parent.setSelected(this);
                  }
                };
                window.addEventListener("pointerup", h), window.addEventListener("blur", h);
              }
              moveInDOM() {
                this.parent?.moveEditorInDOM(this);
              }
              _setParentAndPosition(i, n, o) {
                i.changeParent(this), this.x = n, this.y = o, this.fixAndSetPosition();
              }
              getRect(i, n) {
                const o = this.parentScale, [d, h] = this.pageDimensions, [e, l] = this.pageTranslation, u = i / o, c = n / o, y = this.x * d, C = this.y * h, R = this.width * d, s = this.height * h;
                switch (this.rotation) {
                  case 0:
                    return [y + u + e, h - C - c - s + l, y + u + R + e, h - C - c + l];
                  case 90:
                    return [y + c + e, h - C + u + l, y + c + s + e, h - C + u + R + l];
                  case 180:
                    return [y - u - R + e, h - C + c + l, y - u + e, h - C + c + s + l];
                  case 270:
                    return [y - c - s + e, h - C - u - R + l, y - c + e, h - C - u + l];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              getRectInCurrentCoords(i, n) {
                const [o, d, h, e] = i, l = h - o, u = e - d;
                switch (this.rotation) {
                  case 0:
                    return [o, n - e, l, u];
                  case 90:
                    return [o, n - d, u, l];
                  case 180:
                    return [h, n - d, l, u];
                  case 270:
                    return [h, n - e, u, l];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              onceAdded() {
              }
              isEmpty() {
                return !1;
              }
              enableEditMode() {
                this.#u = !0;
              }
              disableEditMode() {
                this.#u = !1;
              }
              isInEditMode() {
                return this.#u;
              }
              shouldGetKeyboardEvents() {
                return !1;
              }
              needsToBeRebuilt() {
                return this.div && !this.isAttachedToDOM;
              }
              rebuild() {
                this.div?.addEventListener("focusin", this.#l), this.div?.addEventListener("focusout", this.#c);
              }
              serialize() {
                (0, f.unreachable)("An editor must be serializable");
              }
              static deserialize(i, n, o) {
                const d = new this.prototype.constructor({
                  parent: n,
                  id: n.getNextId(),
                  uiManager: o
                });
                d.rotation = i.rotation;
                const [h, e] = d.pageDimensions, [l, u, c, y] = d.getRectInCurrentCoords(i.rect, e);
                return d.x = l / h, d.y = u / e, d.width = c / h, d.height = y / e, d;
              }
              remove() {
                this.div.removeEventListener("focusin", this.#l), this.div.removeEventListener("focusout", this.#c), this.isEmpty() || this.commit(), this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this), this.#n?.remove(), this.#n = null, this.#i = null;
              }
              get isResizable() {
                return !1;
              }
              makeResizable() {
                this.isResizable && (this.#b(), this.#a.classList.remove("hidden"));
              }
              select() {
                this.makeResizable(), this.div?.classList.add("selectedEditor");
              }
              unselect() {
                this.#a?.classList.add("hidden"), this.div?.classList.remove("selectedEditor"), this.div?.contains(document.activeElement) && this._uiManager.currentLayer.div.focus();
              }
              updateParams(i, n) {
              }
              disableEditing() {
                this.#n && (this.#n.hidden = !0);
              }
              enableEditing() {
                this.#n && (this.#n.hidden = !1);
              }
              enterInEditMode() {
              }
              get contentDiv() {
                return this.div;
              }
              get isEditing() {
                return this.#h;
              }
              set isEditing(i) {
                this.#h = i, this.parent && (i ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null));
              }
              setAspectRatio(i, n) {
                this.#s = !0;
                const o = i / n, {
                  style: d
                } = this.div;
                d.aspectRatio = o, d.height = "auto";
              }
              static get MIN_SIZE() {
                return 16;
              }
            }
            p.AnnotationEditor = E;
            class v extends E {
              constructor(i) {
                super(i), this.annotationElementId = i.annotationElementId, this.deleted = !0;
              }
              serialize() {
                return {
                  id: this.annotationElementId,
                  deleted: !0,
                  pageIndex: this.pageIndex
                };
              }
            }
          }),
          /* 165 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.KeyboardManager = p.CommandManager = p.ColorManager = p.AnnotationEditorUIManager = void 0, p.bindEvents = S, p.opacityToHex = E, t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123), t(2), t(89), t(125), t(136), t(138), t(141), t(143), t(145), t(147), t(166);
            var a = t(1), f = t(168);
            function S(h, e, l) {
              for (const u of l)
                e.addEventListener(u, h[u].bind(h));
            }
            function E(h) {
              return Math.round(Math.min(255, Math.max(1, 255 * h))).toString(16).padStart(2, "0");
            }
            class v {
              #t = 0;
              getId() {
                return `${a.AnnotationEditorPrefix}${this.#t++}`;
              }
            }
            class T {
              #t = (0, a.getUuid)();
              #e = 0;
              #n = null;
              static get _isSVGFittingCanvas() {
                const e = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>', u = new OffscreenCanvas(1, 3).getContext("2d"), c = new Image();
                c.src = e;
                const y = c.decode().then(() => (u.drawImage(c, 0, 0, 1, 1, 0, 0, 1, 3), new Uint32Array(u.getImageData(0, 0, 1, 1).data.buffer)[0] === 0));
                return (0, a.shadow)(this, "_isSVGFittingCanvas", y);
              }
              async #i(e, l) {
                this.#n ||= /* @__PURE__ */ new Map();
                let u = this.#n.get(e);
                if (u === null)
                  return null;
                if (u?.bitmap)
                  return u.refCounter += 1, u;
                try {
                  u ||= {
                    bitmap: null,
                    id: `image_${this.#t}_${this.#e++}`,
                    refCounter: 0,
                    isSvg: !1
                  };
                  let c;
                  if (typeof l == "string") {
                    u.url = l;
                    const y = await fetch(l);
                    if (!y.ok)
                      throw new Error(y.statusText);
                    c = await y.blob();
                  } else
                    c = u.file = l;
                  if (c.type === "image/svg+xml") {
                    const y = T._isSVGFittingCanvas, C = new FileReader(), R = new Image(), s = new Promise((m, F) => {
                      R.onload = () => {
                        u.bitmap = R, u.isSvg = !0, m();
                      }, C.onload = async () => {
                        const B = u.svgUrl = C.result;
                        R.src = await y ? `${B}#svgView(preserveAspectRatio(none))` : B;
                      }, R.onerror = C.onerror = F;
                    });
                    C.readAsDataURL(c), await s;
                  } else
                    u.bitmap = await createImageBitmap(c);
                  u.refCounter = 1;
                } catch (c) {
                  console.error(c), u = null;
                }
                return this.#n.set(e, u), u && this.#n.set(u.id, u), u;
              }
              async getFromFile(e) {
                const {
                  lastModified: l,
                  name: u,
                  size: c,
                  type: y
                } = e;
                return this.#i(`${l}_${u}_${c}_${y}`, e);
              }
              async getFromUrl(e) {
                return this.#i(e, e);
              }
              async getFromId(e) {
                this.#n ||= /* @__PURE__ */ new Map();
                const l = this.#n.get(e);
                return l ? l.bitmap ? (l.refCounter += 1, l) : l.file ? this.getFromFile(l.file) : this.getFromUrl(l.url) : null;
              }
              getSvgUrl(e) {
                const l = this.#n.get(e);
                return l?.isSvg ? l.svgUrl : null;
              }
              deleteId(e) {
                this.#n ||= /* @__PURE__ */ new Map();
                const l = this.#n.get(e);
                l && (l.refCounter -= 1, l.refCounter === 0 && (l.bitmap = null));
              }
              isValidId(e) {
                return e.startsWith(`image_${this.#t}_`);
              }
            }
            class i {
              #t = [];
              #e = !1;
              #n;
              #i = -1;
              constructor() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 128;
                this.#n = e;
              }
              add(e) {
                let {
                  cmd: l,
                  undo: u,
                  mustExec: c,
                  type: y = NaN,
                  overwriteIfSameType: C = !1,
                  keepUndo: R = !1
                } = e;
                if (c && l(), this.#e)
                  return;
                const s = {
                  cmd: l,
                  undo: u,
                  type: y
                };
                if (this.#i === -1) {
                  this.#t.length > 0 && (this.#t.length = 0), this.#i = 0, this.#t.push(s);
                  return;
                }
                if (C && this.#t[this.#i].type === y) {
                  R && (s.undo = this.#t[this.#i].undo), this.#t[this.#i] = s;
                  return;
                }
                const m = this.#i + 1;
                m === this.#n ? this.#t.splice(0, 1) : (this.#i = m, m < this.#t.length && this.#t.splice(m)), this.#t.push(s);
              }
              undo() {
                this.#i !== -1 && (this.#e = !0, this.#t[this.#i].undo(), this.#e = !1, this.#i -= 1);
              }
              redo() {
                this.#i < this.#t.length - 1 && (this.#i += 1, this.#e = !0, this.#t[this.#i].cmd(), this.#e = !1);
              }
              hasSomethingToUndo() {
                return this.#i !== -1;
              }
              hasSomethingToRedo() {
                return this.#i < this.#t.length - 1;
              }
              destroy() {
                this.#t = null;
              }
            }
            p.CommandManager = i;
            class n {
              constructor(e) {
                this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
                const {
                  isMac: l
                } = a.FeatureTest.platform;
                for (const [u, c, y = {}] of e)
                  for (const C of u) {
                    const R = C.startsWith("mac+");
                    l && R ? (this.callbacks.set(C.slice(4), {
                      callback: c,
                      options: y
                    }), this.allKeys.add(C.split("+").at(-1))) : !l && !R && (this.callbacks.set(C, {
                      callback: c,
                      options: y
                    }), this.allKeys.add(C.split("+").at(-1)));
                  }
              }
              #t(e) {
                e.altKey && this.buffer.push("alt"), e.ctrlKey && this.buffer.push("ctrl"), e.metaKey && this.buffer.push("meta"), e.shiftKey && this.buffer.push("shift"), this.buffer.push(e.key);
                const l = this.buffer.join("+");
                return this.buffer.length = 0, l;
              }
              exec(e, l) {
                if (!this.allKeys.has(l.key))
                  return;
                const u = this.callbacks.get(this.#t(l));
                if (!u)
                  return;
                const {
                  callback: c,
                  options: {
                    bubbles: y = !1,
                    args: C = [],
                    checker: R = null
                  }
                } = u;
                R && !R(e, l) || (c.bind(e, ...C)(), y || (l.stopPropagation(), l.preventDefault()));
              }
            }
            p.KeyboardManager = n;
            class o {
              static _colorsMapping = /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]);
              get _colors() {
                const e = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
                return (0, f.getColorValues)(e), (0, a.shadow)(this, "_colors", e);
              }
              convert(e) {
                const l = (0, f.getRGB)(e);
                if (!window.matchMedia("(forced-colors: active)").matches)
                  return l;
                for (const [u, c] of this._colors)
                  if (c.every((y, C) => y === l[C]))
                    return o._colorsMapping.get(u);
                return l;
              }
              getHexCode(e) {
                const l = this._colors.get(e);
                return l ? a.Util.makeHexColor(...l) : e;
              }
            }
            p.ColorManager = o;
            class d {
              #t = null;
              #e = /* @__PURE__ */ new Map();
              #n = /* @__PURE__ */ new Map();
              #i = null;
              #o = null;
              #s = new i();
              #a = 0;
              #l = /* @__PURE__ */ new Set();
              #c = null;
              #r = null;
              #h = /* @__PURE__ */ new Set();
              #u = null;
              #f = new v();
              #p = !1;
              #g = !1;
              #m = null;
              #v = a.AnnotationEditorType.NONE;
              #d = /* @__PURE__ */ new Set();
              #b = null;
              #x = this.blur.bind(this);
              #A = this.focus.bind(this);
              #S = this.copy.bind(this);
              #E = this.cut.bind(this);
              #O = this.paste.bind(this);
              #L = this.keydown.bind(this);
              #F = this.onEditingAction.bind(this);
              #y = this.onPageChanging.bind(this);
              #w = this.onScaleChanging.bind(this);
              #R = this.onRotationChanging.bind(this);
              #k = {
                isEditing: !1,
                isEmpty: !0,
                hasSomethingToUndo: !1,
                hasSomethingToRedo: !1,
                hasSelectedEditor: !1
              };
              #P = [0, 0];
              #C = null;
              #M = null;
              #N = null;
              static TRANSLATE_SMALL = 1;
              static TRANSLATE_BIG = 10;
              static get _keyboardManager() {
                const e = d.prototype, l = (y) => {
                  const {
                    activeElement: C
                  } = document;
                  return C && y.#M.contains(C) && y.hasSomethingToControl();
                }, u = this.TRANSLATE_SMALL, c = this.TRANSLATE_BIG;
                return (0, a.shadow)(this, "_keyboardManager", new n([[["ctrl+a", "mac+meta+a"], e.selectAll], [["ctrl+z", "mac+meta+z"], e.undo], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], e.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], e.delete], [["Escape", "mac+Escape"], e.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], e.translateSelectedEditors, {
                  args: [-u, 0],
                  checker: l
                }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], e.translateSelectedEditors, {
                  args: [-c, 0],
                  checker: l
                }], [["ArrowRight", "mac+ArrowRight"], e.translateSelectedEditors, {
                  args: [u, 0],
                  checker: l
                }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], e.translateSelectedEditors, {
                  args: [c, 0],
                  checker: l
                }], [["ArrowUp", "mac+ArrowUp"], e.translateSelectedEditors, {
                  args: [0, -u],
                  checker: l
                }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], e.translateSelectedEditors, {
                  args: [0, -c],
                  checker: l
                }], [["ArrowDown", "mac+ArrowDown"], e.translateSelectedEditors, {
                  args: [0, u],
                  checker: l
                }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], e.translateSelectedEditors, {
                  args: [0, c],
                  checker: l
                }]]));
              }
              constructor(e, l, u, c, y, C) {
                this.#M = e, this.#N = l, this.#i = u, this._eventBus = c, this._eventBus._on("editingaction", this.#F), this._eventBus._on("pagechanging", this.#y), this._eventBus._on("scalechanging", this.#w), this._eventBus._on("rotationchanging", this.#R), this.#o = y.annotationStorage, this.#u = y.filterFactory, this.#b = C, this.viewParameters = {
                  realScale: f.PixelsPerInch.PDF_TO_CSS_UNITS,
                  rotation: 0
                };
              }
              destroy() {
                this.#D(), this.#U(), this._eventBus._off("editingaction", this.#F), this._eventBus._off("pagechanging", this.#y), this._eventBus._off("scalechanging", this.#w), this._eventBus._off("rotationchanging", this.#R);
                for (const e of this.#n.values())
                  e.destroy();
                this.#n.clear(), this.#e.clear(), this.#h.clear(), this.#t = null, this.#d.clear(), this.#s.destroy(), this.#i.destroy();
              }
              get hcmFilter() {
                return (0, a.shadow)(this, "hcmFilter", this.#b ? this.#u.addHCMFilter(this.#b.foreground, this.#b.background) : "none");
              }
              get direction() {
                return (0, a.shadow)(this, "direction", getComputedStyle(this.#M).direction);
              }
              editAltText(e) {
                this.#i?.editAltText(this, e);
              }
              onPageChanging(e) {
                let {
                  pageNumber: l
                } = e;
                this.#a = l - 1;
              }
              focusMainContainer() {
                this.#M.focus();
              }
              findParent(e, l) {
                for (const u of this.#n.values()) {
                  const {
                    x: c,
                    y,
                    width: C,
                    height: R
                  } = u.div.getBoundingClientRect();
                  if (e >= c && e <= c + C && l >= y && l <= y + R)
                    return u;
                }
                return null;
              }
              disableUserSelect() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                this.#N.classList.toggle("noUserSelect", e);
              }
              addShouldRescale(e) {
                this.#h.add(e);
              }
              removeShouldRescale(e) {
                this.#h.delete(e);
              }
              onScaleChanging(e) {
                let {
                  scale: l
                } = e;
                this.commitOrRemove(), this.viewParameters.realScale = l * f.PixelsPerInch.PDF_TO_CSS_UNITS;
                for (const u of this.#h)
                  u.onScaleChanging();
              }
              onRotationChanging(e) {
                let {
                  pagesRotation: l
                } = e;
                this.commitOrRemove(), this.viewParameters.rotation = l;
              }
              addToAnnotationStorage(e) {
                !e.isEmpty() && this.#o && !this.#o.has(e.id) && this.#o.setValue(e.id, e);
              }
              #B() {
                window.addEventListener("focus", this.#A), window.addEventListener("blur", this.#x);
              }
              #U() {
                window.removeEventListener("focus", this.#A), window.removeEventListener("blur", this.#x);
              }
              blur() {
                if (!this.hasSelection)
                  return;
                const {
                  activeElement: e
                } = document;
                for (const l of this.#d)
                  if (l.div.contains(e)) {
                    this.#m = [l, e], l._focusEventsAllowed = !1;
                    break;
                  }
              }
              focus() {
                if (!this.#m)
                  return;
                const [e, l] = this.#m;
                this.#m = null, l.addEventListener("focusin", () => {
                  e._focusEventsAllowed = !0;
                }, {
                  once: !0
                }), l.focus();
              }
              #V() {
                window.addEventListener("keydown", this.#L, {
                  capture: !0
                });
              }
              #D() {
                window.removeEventListener("keydown", this.#L, {
                  capture: !0
                });
              }
              #_() {
                document.addEventListener("copy", this.#S), document.addEventListener("cut", this.#E), document.addEventListener("paste", this.#O);
              }
              #I() {
                document.removeEventListener("copy", this.#S), document.removeEventListener("cut", this.#E), document.removeEventListener("paste", this.#O);
              }
              addEditListeners() {
                this.#V(), this.#_();
              }
              removeEditListeners() {
                this.#D(), this.#I();
              }
              copy(e) {
                if (e.preventDefault(), this.#t?.commitOrRemove(), !this.hasSelection)
                  return;
                const l = [];
                for (const u of this.#d) {
                  const c = u.serialize(!0);
                  c && l.push(c);
                }
                l.length !== 0 && e.clipboardData.setData("application/pdfjs", JSON.stringify(l));
              }
              cut(e) {
                this.copy(e), this.delete();
              }
              paste(e) {
                e.preventDefault();
                const {
                  clipboardData: l
                } = e;
                for (const y of l.items)
                  for (const C of this.#r)
                    if (C.isHandlingMimeForPasting(y.type)) {
                      C.paste(y, this.currentLayer);
                      return;
                    }
                let u = l.getData("application/pdfjs");
                if (!u)
                  return;
                try {
                  u = JSON.parse(u);
                } catch (y) {
                  (0, a.warn)(`paste: "${y.message}".`);
                  return;
                }
                if (!Array.isArray(u))
                  return;
                this.unselectAll();
                const c = this.currentLayer;
                try {
                  const y = [];
                  for (const s of u) {
                    const m = c.deserialize(s);
                    if (!m)
                      return;
                    y.push(m);
                  }
                  const C = () => {
                    for (const s of y)
                      this.#z(s);
                    this.#$(y);
                  }, R = () => {
                    for (const s of y)
                      s.remove();
                  };
                  this.addCommands({
                    cmd: C,
                    undo: R,
                    mustExec: !0
                  });
                } catch (y) {
                  (0, a.warn)(`paste: "${y.message}".`);
                }
              }
              keydown(e) {
                this.getActive()?.shouldGetKeyboardEvents() || d._keyboardManager.exec(this, e);
              }
              onEditingAction(e) {
                ["undo", "redo", "delete", "selectAll"].includes(e.name) && this[e.name]();
              }
              #T(e) {
                Object.entries(e).some((u) => {
                  let [c, y] = u;
                  return this.#k[c] !== y;
                }) && this._eventBus.dispatch("annotationeditorstateschanged", {
                  source: this,
                  details: Object.assign(this.#k, e)
                });
              }
              #H(e) {
                this._eventBus.dispatch("annotationeditorparamschanged", {
                  source: this,
                  details: e
                });
              }
              setEditingState(e) {
                e ? (this.#B(), this.#V(), this.#_(), this.#T({
                  isEditing: this.#v !== a.AnnotationEditorType.NONE,
                  isEmpty: this.#W(),
                  hasSomethingToUndo: this.#s.hasSomethingToUndo(),
                  hasSomethingToRedo: this.#s.hasSomethingToRedo(),
                  hasSelectedEditor: !1
                })) : (this.#U(), this.#D(), this.#I(), this.#T({
                  isEditing: !1
                }), this.disableUserSelect(!1));
              }
              registerEditorTypes(e) {
                if (!this.#r) {
                  this.#r = e;
                  for (const l of this.#r)
                    this.#H(l.defaultPropertiesToUpdate);
                }
              }
              getId() {
                return this.#f.getId();
              }
              get currentLayer() {
                return this.#n.get(this.#a);
              }
              getLayer(e) {
                return this.#n.get(e);
              }
              get currentPageIndex() {
                return this.#a;
              }
              addLayer(e) {
                this.#n.set(e.pageIndex, e), this.#p ? e.enable() : e.disable();
              }
              removeLayer(e) {
                this.#n.delete(e.pageIndex);
              }
              updateMode(e) {
                let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this.#v !== e) {
                  if (this.#v = e, e === a.AnnotationEditorType.NONE) {
                    this.setEditingState(!1), this.#X();
                    return;
                  }
                  this.setEditingState(!0), this.#G(), this.unselectAll();
                  for (const u of this.#n.values())
                    u.updateMode(e);
                  if (l) {
                    for (const u of this.#e.values())
                      if (u.annotationElementId === l) {
                        this.setSelected(u), u.enterInEditMode();
                        break;
                      }
                  }
                }
              }
              updateToolbar(e) {
                e !== this.#v && this._eventBus.dispatch("switchannotationeditormode", {
                  source: this,
                  mode: e
                });
              }
              updateParams(e, l) {
                if (this.#r) {
                  if (e === a.AnnotationEditorParamsType.CREATE) {
                    this.currentLayer.addNewEditor(e);
                    return;
                  }
                  for (const u of this.#d)
                    u.updateParams(e, l);
                  for (const u of this.#r)
                    u.updateDefaultParams(e, l);
                }
              }
              enableWaiting() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                if (this.#g !== e) {
                  this.#g = e;
                  for (const l of this.#n.values())
                    e ? l.disableClick() : l.enableClick(), l.div.classList.toggle("waiting", e);
                }
              }
              #G() {
                if (!this.#p) {
                  this.#p = !0;
                  for (const e of this.#n.values())
                    e.enable();
                }
              }
              #X() {
                if (this.unselectAll(), this.#p) {
                  this.#p = !1;
                  for (const e of this.#n.values())
                    e.disable();
                }
              }
              getEditors(e) {
                const l = [];
                for (const u of this.#e.values())
                  u.pageIndex === e && l.push(u);
                return l;
              }
              getEditor(e) {
                return this.#e.get(e);
              }
              addEditor(e) {
                this.#e.set(e.id, e);
              }
              removeEditor(e) {
                this.#e.delete(e.id), this.unselect(e), (!e.annotationElementId || !this.#l.has(e.annotationElementId)) && this.#o?.remove(e.id);
              }
              addDeletedAnnotationElement(e) {
                this.#l.add(e.annotationElementId), e.deleted = !0;
              }
              isDeletedAnnotationElement(e) {
                return this.#l.has(e);
              }
              removeDeletedAnnotationElement(e) {
                this.#l.delete(e.annotationElementId), e.deleted = !1;
              }
              #z(e) {
                const l = this.#n.get(e.pageIndex);
                l ? l.addOrRebuild(e) : this.addEditor(e);
              }
              setActiveEditor(e) {
                this.#t !== e && (this.#t = e, e && this.#H(e.propertiesToUpdate));
              }
              toggleSelected(e) {
                if (this.#d.has(e)) {
                  this.#d.delete(e), e.unselect(), this.#T({
                    hasSelectedEditor: this.hasSelection
                  });
                  return;
                }
                this.#d.add(e), e.select(), this.#H(e.propertiesToUpdate), this.#T({
                  hasSelectedEditor: !0
                });
              }
              setSelected(e) {
                for (const l of this.#d)
                  l !== e && l.unselect();
                this.#d.clear(), this.#d.add(e), e.select(), this.#H(e.propertiesToUpdate), this.#T({
                  hasSelectedEditor: !0
                });
              }
              isSelected(e) {
                return this.#d.has(e);
              }
              unselect(e) {
                e.unselect(), this.#d.delete(e), this.#T({
                  hasSelectedEditor: this.hasSelection
                });
              }
              get hasSelection() {
                return this.#d.size !== 0;
              }
              undo() {
                this.#s.undo(), this.#T({
                  hasSomethingToUndo: this.#s.hasSomethingToUndo(),
                  hasSomethingToRedo: !0,
                  isEmpty: this.#W()
                });
              }
              redo() {
                this.#s.redo(), this.#T({
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: this.#s.hasSomethingToRedo(),
                  isEmpty: this.#W()
                });
              }
              addCommands(e) {
                this.#s.add(e), this.#T({
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: !1,
                  isEmpty: this.#W()
                });
              }
              #W() {
                if (this.#e.size === 0)
                  return !0;
                if (this.#e.size === 1)
                  for (const e of this.#e.values())
                    return e.isEmpty();
                return !1;
              }
              delete() {
                if (this.commitOrRemove(), !this.hasSelection)
                  return;
                const e = [...this.#d], l = () => {
                  for (const c of e)
                    c.remove();
                }, u = () => {
                  for (const c of e)
                    this.#z(c);
                };
                this.addCommands({
                  cmd: l,
                  undo: u,
                  mustExec: !0
                });
              }
              commitOrRemove() {
                this.#t?.commitOrRemove();
              }
              hasSomethingToControl() {
                return this.#t || this.hasSelection;
              }
              #$(e) {
                this.#d.clear();
                for (const l of e)
                  l.isEmpty() || (this.#d.add(l), l.select());
                this.#T({
                  hasSelectedEditor: !0
                });
              }
              selectAll() {
                for (const e of this.#d)
                  e.commit();
                this.#$(this.#e.values());
              }
              unselectAll() {
                if (this.#t) {
                  this.#t.commitOrRemove();
                  return;
                }
                if (this.hasSelection) {
                  for (const e of this.#d)
                    e.unselect();
                  this.#d.clear(), this.#T({
                    hasSelectedEditor: !1
                  });
                }
              }
              translateSelectedEditors(e, l) {
                if (arguments.length > 2 && arguments[2] !== void 0 && arguments[2] || this.commitOrRemove(), !this.hasSelection)
                  return;
                this.#P[0] += e, this.#P[1] += l;
                const [c, y] = this.#P, C = [...this.#d], R = 1e3;
                this.#C && clearTimeout(this.#C), this.#C = setTimeout(() => {
                  this.#C = null, this.#P[0] = this.#P[1] = 0, this.addCommands({
                    cmd: () => {
                      for (const s of C)
                        this.#e.has(s.id) && s.translateInPage(c, y);
                    },
                    undo: () => {
                      for (const s of C)
                        this.#e.has(s.id) && s.translateInPage(-c, -y);
                    },
                    mustExec: !1
                  });
                }, R);
                for (const s of C)
                  s.translateInPage(e, l);
              }
              setUpDragSession() {
                if (this.hasSelection) {
                  this.disableUserSelect(!0), this.#c = /* @__PURE__ */ new Map();
                  for (const e of this.#d)
                    this.#c.set(e, {
                      savedX: e.x,
                      savedY: e.y,
                      savedPageIndex: e.pageIndex,
                      newX: 0,
                      newY: 0,
                      newPageIndex: -1
                    });
                }
              }
              endDragSession() {
                if (!this.#c)
                  return !1;
                this.disableUserSelect(!1);
                const e = this.#c;
                this.#c = null;
                let l = !1;
                for (const [{
                  x: c,
                  y,
                  pageIndex: C
                }, R] of e)
                  R.newX = c, R.newY = y, R.newPageIndex = C, l ||= c !== R.savedX || y !== R.savedY || C !== R.savedPageIndex;
                if (!l)
                  return !1;
                const u = (c, y, C, R) => {
                  if (this.#e.has(c.id)) {
                    const s = this.#n.get(R);
                    s ? c._setParentAndPosition(s, y, C) : (c.pageIndex = R, c.x = y, c.y = C);
                  }
                };
                return this.addCommands({
                  cmd: () => {
                    for (const [c, {
                      newX: y,
                      newY: C,
                      newPageIndex: R
                    }] of e)
                      u(c, y, C, R);
                  },
                  undo: () => {
                    for (const [c, {
                      savedX: y,
                      savedY: C,
                      savedPageIndex: R
                    }] of e)
                      u(c, y, C, R);
                  },
                  mustExec: !0
                }), !0;
              }
              dragSelectedEditors(e, l) {
                if (this.#c)
                  for (const u of this.#c.keys())
                    u.drag(e, l);
              }
              rebuild(e) {
                if (e.parent === null) {
                  const l = this.getLayer(e.pageIndex);
                  l ? (l.changeParent(e), l.addOrRebuild(e)) : (this.addEditor(e), this.addToAnnotationStorage(e), e.rebuild());
                } else
                  e.parent.addOrRebuild(e);
              }
              isActive(e) {
                return this.#t === e;
              }
              getActive() {
                return this.#t;
              }
              getMode() {
                return this.#v;
              }
              get imageManager() {
                return (0, a.shadow)(this, "imageManager", new T());
              }
            }
            p.AnnotationEditorUIManager = d;
          }),
          /* 166 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(6), S = t(4), E = t(24), v = t(14), T = t(8), i = t(21), n = t(20), o = t(91), d = t(39), h = t(77), e = t(64), l = t(159), u = t(7), c = t(167), y = t(27), C = S.JSON, R = S.Number, s = S.SyntaxError, m = C && C.parse, F = E("Object", "keys"), B = Object.getOwnPropertyDescriptor, k = v("".charAt), V = v("".slice), z = v(/./.exec), K = v([].push), J = /^\d$/, $ = /^[1-9]$/, j = /^(?:-|\d)$/, G = /^[\t\n\r ]$/, M = 0, x = 1, A = function(b, w) {
              b = h(b);
              var O = new _(b, 0), D = O.parse(), L = D.value, W = O.skip(G, D.end);
              if (W < b.length)
                throw s('Unexpected extra character: "' + k(b, W) + '" after the parsed data at: ' + W);
              return i(w) ? g({ "": L }, "", w, D) : L;
            }, g = function(b, w, O, D) {
              var L = b[w], W = D && L === D.value, X = W && typeof D.source == "string" ? { source: D.source } : {}, q, ct, nt, Y, Q;
              if (n(L)) {
                var et = o(L), Z = W ? D.nodes : et ? [] : {};
                if (et)
                  for (q = Z.length, nt = e(L), Y = 0; Y < nt; Y++)
                    I(L, Y, g(L, "" + Y, O, Y < q ? Z[Y] : void 0));
                else
                  for (ct = F(L), nt = e(ct), Y = 0; Y < nt; Y++)
                    Q = ct[Y], I(L, Q, g(L, Q, O, d(Z, Q) ? Z[Q] : void 0));
              }
              return T(O, b, w, L, X);
            }, I = function(b, w, O) {
              if (f) {
                var D = B(b, w);
                if (D && !D.configurable)
                  return;
              }
              O === void 0 ? delete b[w] : l(b, w, O);
            }, U = function(b, w, O, D) {
              this.value = b, this.end = w, this.source = O, this.nodes = D;
            }, _ = function(b, w) {
              this.source = b, this.index = w;
            };
            _.prototype = {
              fork: function(b) {
                return new _(this.source, b);
              },
              parse: function() {
                var b = this.source, w = this.skip(G, this.index), O = this.fork(w), D = k(b, w);
                if (z(j, D))
                  return O.number();
                switch (D) {
                  case "{":
                    return O.object();
                  case "[":
                    return O.array();
                  case '"':
                    return O.string();
                  case "t":
                    return O.keyword(!0);
                  case "f":
                    return O.keyword(!1);
                  case "n":
                    return O.keyword(null);
                }
                throw s('Unexpected character: "' + D + '" at: ' + w);
              },
              node: function(b, w, O, D, L) {
                return new U(w, D, b ? null : V(this.source, O, D), L);
              },
              object: function() {
                for (var b = this.source, w = this.index + 1, O = !1, D = {}, L = {}; w < b.length; ) {
                  if (w = this.until([
                    '"',
                    "}"
                  ], w), k(b, w) === "}" && !O) {
                    w++;
                    break;
                  }
                  var W = this.fork(w).string(), X = W.value;
                  w = W.end, w = this.until([":"], w) + 1, w = this.skip(G, w), W = this.fork(w).parse(), l(L, X, W), l(D, X, W.value), w = this.until([
                    ",",
                    "}"
                  ], W.end);
                  var q = k(b, w);
                  if (q === ",")
                    O = !0, w++;
                  else if (q === "}") {
                    w++;
                    break;
                  }
                }
                return this.node(x, D, this.index, w, L);
              },
              array: function() {
                for (var b = this.source, w = this.index + 1, O = !1, D = [], L = []; w < b.length; ) {
                  if (w = this.skip(G, w), k(b, w) === "]" && !O) {
                    w++;
                    break;
                  }
                  var W = this.fork(w).parse();
                  if (K(L, W), K(D, W.value), w = this.until([
                    ",",
                    "]"
                  ], W.end), k(b, w) === ",")
                    O = !0, w++;
                  else if (k(b, w) === "]") {
                    w++;
                    break;
                  }
                }
                return this.node(x, D, this.index, w, L);
              },
              string: function() {
                var b = this.index, w = c(this.source, this.index + 1);
                return this.node(M, w.value, b, w.end);
              },
              number: function() {
                var b = this.source, w = this.index, O = w;
                if (k(b, O) === "-" && O++, k(b, O) === "0")
                  O++;
                else if (z($, k(b, O)))
                  O = this.skip(J, ++O);
                else
                  throw s("Failed to parse number at: " + O);
                if (k(b, O) === "." && (O = this.skip(J, ++O)), k(b, O) === "e" || k(b, O) === "E") {
                  O++, (k(b, O) === "+" || k(b, O) === "-") && O++;
                  var D = O;
                  if (O = this.skip(J, O), D === O)
                    throw s("Failed to parse number's exponent value at: " + O);
                }
                return this.node(M, R(V(b, w, O)), w, O);
              },
              keyword: function(b) {
                var w = "" + b, O = this.index, D = O + w.length;
                if (V(this.source, O, D) !== w)
                  throw s("Failed to parse value at: " + O);
                return this.node(M, b, O, D);
              },
              skip: function(b, w) {
                for (var O = this.source; w < O.length && z(b, k(O, w)); w++)
                  ;
                return w;
              },
              until: function(b, w) {
                w = this.skip(G, w);
                for (var O = k(this.source, w), D = 0; D < b.length; D++)
                  if (b[D] === O)
                    return w;
                throw s('Unexpected character: "' + O + '" at: ' + w);
              }
            };
            var H = u(function() {
              var b = "9007199254740993", w;
              return m(b, function(O, D, L) {
                w = L.source;
              }), w !== b;
            }), N = y && !u(function() {
              return 1 / m("-0 	") !== -1 / 0;
            });
            a({
              target: "JSON",
              stat: !0,
              forced: H
            }, {
              parse: function(w, O) {
                return N && !i(O) ? m(w) : A(w, O);
              }
            });
          }),
          /* 167 */
          /***/
          ((P, p, t) => {
            var a = t(14), f = t(39), S = SyntaxError, E = parseInt, v = String.fromCharCode, T = a("".charAt), i = a("".slice), n = a(/./.exec), o = {
              '\\"': '"',
              "\\\\": "\\",
              "\\/": "/",
              "\\b": "\b",
              "\\f": "\f",
              "\\n": `
`,
              "\\r": "\r",
              "\\t": "	"
            }, d = /^[\da-f]{4}$/i, h = /^[\u0000-\u001F]$/;
            P.exports = function(e, l) {
              for (var u = !0, c = ""; l < e.length; ) {
                var y = T(e, l);
                if (y === "\\") {
                  var C = i(e, l, l + 2);
                  if (f(o, C))
                    c += o[C], l += 2;
                  else if (C === "\\u") {
                    l += 2;
                    var R = i(e, l, l + 4);
                    if (!n(d, R))
                      throw S("Bad Unicode escape at: " + l);
                    c += v(E(R, 16)), l += 4;
                  } else
                    throw S('Unknown escape sequence: "' + C + '"');
                } else if (y === '"') {
                  u = !1, l++;
                  break;
                } else {
                  if (n(h, y))
                    throw S("Bad control character in string literal at: " + l);
                  c += y, l++;
                }
              }
              if (u)
                throw S("Unterminated string at: " + l);
              return {
                value: c,
                end: l
              };
            };
          }),
          /* 168 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.StatTimer = p.RenderingCancelledException = p.PixelsPerInch = p.PageViewport = p.PDFDateString = p.DOMStandardFontDataFactory = p.DOMSVGFactory = p.DOMFilterFactory = p.DOMCanvasFactory = p.DOMCMapReaderFactory = void 0, p.deprecated = F, p.getColorValues = K, p.getCurrentTransform = J, p.getCurrentTransformInverse = $, p.getFilenameFromUrl = c, p.getPdfFilenameFromUrl = y, p.getRGB = z, p.getXfaPageViewport = V, p.isDataScheme = l, p.isPdfFile = u, p.isValidFetchUrl = R, p.loadScript = m, p.noContextMenu = s, p.setLayerDimensions = j, t(2), t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123), t(89), t(84), t(86), t(87);
            var a = t(169), f = t(1);
            const S = "http://www.w3.org/2000/svg";
            class E {
              static CSS = 96;
              static PDF = 72;
              static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
            }
            p.PixelsPerInch = E;
            class v extends a.BaseFilterFactory {
              #t;
              #e;
              #n;
              #i;
              #o;
              #s;
              #a;
              #l;
              #c;
              #r;
              #h = 0;
              constructor() {
                let {
                  docId: M,
                  ownerDocument: x = globalThis.document
                } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                super(), this.#n = M, this.#i = x;
              }
              get #u() {
                return this.#t ||= /* @__PURE__ */ new Map();
              }
              get #f() {
                if (!this.#e) {
                  const M = this.#i.createElement("div"), {
                    style: x
                  } = M;
                  x.visibility = "hidden", x.contain = "strict", x.width = x.height = 0, x.position = "absolute", x.top = x.left = 0, x.zIndex = -1;
                  const A = this.#i.createElementNS(S, "svg");
                  A.setAttribute("width", 0), A.setAttribute("height", 0), this.#e = this.#i.createElementNS(S, "defs"), M.append(A), A.append(this.#e), this.#i.body.append(M);
                }
                return this.#e;
              }
              addFilter(M) {
                if (!M)
                  return "none";
                let x = this.#u.get(M);
                if (x)
                  return x;
                let A, g, I, U;
                if (M.length === 1) {
                  const b = M[0], w = new Array(256);
                  for (let O = 0; O < 256; O++)
                    w[O] = b[O] / 255;
                  U = A = g = I = w.join(",");
                } else {
                  const [b, w, O] = M, D = new Array(256), L = new Array(256), W = new Array(256);
                  for (let X = 0; X < 256; X++)
                    D[X] = b[X] / 255, L[X] = w[X] / 255, W[X] = O[X] / 255;
                  A = D.join(","), g = L.join(","), I = W.join(","), U = `${A}${g}${I}`;
                }
                if (x = this.#u.get(U), x)
                  return this.#u.set(M, x), x;
                const _ = `g_${this.#n}_transfer_map_${this.#h++}`, H = `url(#${_})`;
                this.#u.set(M, H), this.#u.set(U, H);
                const N = this.#g(_);
                return this.#v(A, g, I, N), H;
              }
              addHCMFilter(M, x) {
                const A = `${M}-${x}`;
                if (this.#s === A)
                  return this.#a;
                if (this.#s = A, this.#a = "none", this.#o?.remove(), !M || !x)
                  return this.#a;
                const g = this.#d(M);
                M = f.Util.makeHexColor(...g);
                const I = this.#d(x);
                if (x = f.Util.makeHexColor(...I), this.#f.style.color = "", M === "#000000" && x === "#ffffff" || M === x)
                  return this.#a;
                const U = new Array(256);
                for (let w = 0; w <= 255; w++) {
                  const O = w / 255;
                  U[w] = O <= 0.03928 ? O / 12.92 : ((O + 0.055) / 1.055) ** 2.4;
                }
                const _ = U.join(","), H = `g_${this.#n}_hcm_filter`, N = this.#l = this.#g(H);
                this.#v(_, _, _, N), this.#p(N);
                const b = (w, O) => {
                  const D = g[w] / 255, L = I[w] / 255, W = new Array(O + 1);
                  for (let X = 0; X <= O; X++)
                    W[X] = D + X / O * (L - D);
                  return W.join(",");
                };
                return this.#v(b(0, 5), b(1, 5), b(2, 5), N), this.#a = `url(#${H})`, this.#a;
              }
              addHighlightHCMFilter(M, x, A, g) {
                const I = `${M}-${x}-${A}-${g}`;
                if (this.#c === I)
                  return this.#r;
                if (this.#c = I, this.#r = "none", this.#l?.remove(), !M || !x)
                  return this.#r;
                const [U, _] = [M, x].map(this.#d.bind(this));
                let H = Math.round(0.2126 * U[0] + 0.7152 * U[1] + 0.0722 * U[2]), N = Math.round(0.2126 * _[0] + 0.7152 * _[1] + 0.0722 * _[2]), [b, w] = [A, g].map(this.#d.bind(this));
                N < H && ([H, N, b, w] = [N, H, w, b]), this.#f.style.color = "";
                const O = (W, X, q) => {
                  const ct = new Array(256), nt = (N - H) / q, Y = W / 255, Q = (X - W) / (255 * q);
                  let et = 0;
                  for (let Z = 0; Z <= q; Z++) {
                    const at = Math.round(H + Z * nt), lt = Y + Z * Q;
                    for (let ft = et; ft <= at; ft++)
                      ct[ft] = lt;
                    et = at + 1;
                  }
                  for (let Z = et; Z < 256; Z++)
                    ct[Z] = ct[et - 1];
                  return ct.join(",");
                }, D = `g_${this.#n}_hcm_highlight_filter`, L = this.#l = this.#g(D);
                return this.#p(L), this.#v(O(b[0], w[0], 5), O(b[1], w[1], 5), O(b[2], w[2], 5), L), this.#r = `url(#${D})`, this.#r;
              }
              destroy() {
                arguments.length > 0 && arguments[0] !== void 0 && arguments[0] && (this.#a || this.#r) || (this.#e && (this.#e.parentNode.parentNode.remove(), this.#e = null), this.#t && (this.#t.clear(), this.#t = null), this.#h = 0);
              }
              #p(M) {
                const x = this.#i.createElementNS(S, "feColorMatrix");
                x.setAttribute("type", "matrix"), x.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"), M.append(x);
              }
              #g(M) {
                const x = this.#i.createElementNS(S, "filter");
                return x.setAttribute("color-interpolation-filters", "sRGB"), x.setAttribute("id", M), this.#f.append(x), x;
              }
              #m(M, x, A) {
                const g = this.#i.createElementNS(S, x);
                g.setAttribute("type", "discrete"), g.setAttribute("tableValues", A), M.append(g);
              }
              #v(M, x, A, g) {
                const I = this.#i.createElementNS(S, "feComponentTransfer");
                g.append(I), this.#m(I, "feFuncR", M), this.#m(I, "feFuncG", x), this.#m(I, "feFuncB", A);
              }
              #d(M) {
                return this.#f.style.color = M, z(getComputedStyle(this.#f).getPropertyValue("color"));
              }
            }
            p.DOMFilterFactory = v;
            class T extends a.BaseCanvasFactory {
              constructor() {
                let {
                  ownerDocument: M = globalThis.document
                } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                super(), this._document = M;
              }
              _createCanvas(M, x) {
                const A = this._document.createElement("canvas");
                return A.width = M, A.height = x, A;
              }
            }
            p.DOMCanvasFactory = T;
            async function i(G) {
              let M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              if (R(G, document.baseURI)) {
                const x = await fetch(G);
                if (!x.ok)
                  throw new Error(x.statusText);
                return M ? new Uint8Array(await x.arrayBuffer()) : (0, f.stringToBytes)(await x.text());
              }
              return new Promise((x, A) => {
                const g = new XMLHttpRequest();
                g.open("GET", G, !0), M && (g.responseType = "arraybuffer"), g.onreadystatechange = () => {
                  if (g.readyState === XMLHttpRequest.DONE) {
                    if (g.status === 200 || g.status === 0) {
                      let I;
                      if (M && g.response ? I = new Uint8Array(g.response) : !M && g.responseText && (I = (0, f.stringToBytes)(g.responseText)), I) {
                        x(I);
                        return;
                      }
                    }
                    A(new Error(g.statusText));
                  }
                }, g.send(null);
              });
            }
            class n extends a.BaseCMapReaderFactory {
              _fetchData(M, x) {
                return i(M, this.isCompressed).then((A) => ({
                  cMapData: A,
                  compressionType: x
                }));
              }
            }
            p.DOMCMapReaderFactory = n;
            class o extends a.BaseStandardFontDataFactory {
              _fetchData(M) {
                return i(M, !0);
              }
            }
            p.DOMStandardFontDataFactory = o;
            class d extends a.BaseSVGFactory {
              _createSVG(M) {
                return document.createElementNS(S, M);
              }
            }
            p.DOMSVGFactory = d;
            class h {
              constructor(M) {
                let {
                  viewBox: x,
                  scale: A,
                  rotation: g,
                  offsetX: I = 0,
                  offsetY: U = 0,
                  dontFlip: _ = !1
                } = M;
                this.viewBox = x, this.scale = A, this.rotation = g, this.offsetX = I, this.offsetY = U;
                const H = (x[2] + x[0]) / 2, N = (x[3] + x[1]) / 2;
                let b, w, O, D;
                switch (g %= 360, g < 0 && (g += 360), g) {
                  case 180:
                    b = -1, w = 0, O = 0, D = 1;
                    break;
                  case 90:
                    b = 0, w = 1, O = 1, D = 0;
                    break;
                  case 270:
                    b = 0, w = -1, O = -1, D = 0;
                    break;
                  case 0:
                    b = 1, w = 0, O = 0, D = -1;
                    break;
                  default:
                    throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                }
                _ && (O = -O, D = -D);
                let L, W, X, q;
                b === 0 ? (L = Math.abs(N - x[1]) * A + I, W = Math.abs(H - x[0]) * A + U, X = (x[3] - x[1]) * A, q = (x[2] - x[0]) * A) : (L = Math.abs(H - x[0]) * A + I, W = Math.abs(N - x[1]) * A + U, X = (x[2] - x[0]) * A, q = (x[3] - x[1]) * A), this.transform = [b * A, w * A, O * A, D * A, L - b * A * H - O * A * N, W - w * A * H - D * A * N], this.width = X, this.height = q;
              }
              get rawDims() {
                const {
                  viewBox: M
                } = this;
                return (0, f.shadow)(this, "rawDims", {
                  pageWidth: M[2] - M[0],
                  pageHeight: M[3] - M[1],
                  pageX: M[0],
                  pageY: M[1]
                });
              }
              clone() {
                let {
                  scale: M = this.scale,
                  rotation: x = this.rotation,
                  offsetX: A = this.offsetX,
                  offsetY: g = this.offsetY,
                  dontFlip: I = !1
                } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return new h({
                  viewBox: this.viewBox.slice(),
                  scale: M,
                  rotation: x,
                  offsetX: A,
                  offsetY: g,
                  dontFlip: I
                });
              }
              convertToViewportPoint(M, x) {
                return f.Util.applyTransform([M, x], this.transform);
              }
              convertToViewportRectangle(M) {
                const x = f.Util.applyTransform([M[0], M[1]], this.transform), A = f.Util.applyTransform([M[2], M[3]], this.transform);
                return [x[0], x[1], A[0], A[1]];
              }
              convertToPdfPoint(M, x) {
                return f.Util.applyInverseTransform([M, x], this.transform);
              }
            }
            p.PageViewport = h;
            class e extends f.BaseException {
              constructor(M) {
                let x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                super(M, "RenderingCancelledException"), this.extraDelay = x;
              }
            }
            p.RenderingCancelledException = e;
            function l(G) {
              const M = G.length;
              let x = 0;
              for (; x < M && G[x].trim() === ""; )
                x++;
              return G.substring(x, x + 5).toLowerCase() === "data:";
            }
            function u(G) {
              return typeof G == "string" && /\.pdf$/i.test(G);
            }
            function c(G) {
              return arguments.length > 1 && arguments[1] !== void 0 && arguments[1] || ([G] = G.split(/[#?]/, 1)), G.substring(G.lastIndexOf("/") + 1);
            }
            function y(G) {
              let M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "document.pdf";
              if (typeof G != "string")
                return M;
              if (l(G))
                return (0, f.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), M;
              const x = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, A = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, g = x.exec(G);
              let I = A.exec(g[1]) || A.exec(g[2]) || A.exec(g[3]);
              if (I && (I = I[0], I.includes("%")))
                try {
                  I = A.exec(decodeURIComponent(I))[0];
                } catch {
                }
              return I || M;
            }
            class C {
              started = /* @__PURE__ */ Object.create(null);
              times = [];
              time(M) {
                M in this.started && (0, f.warn)(`Timer is already running for ${M}`), this.started[M] = Date.now();
              }
              timeEnd(M) {
                M in this.started || (0, f.warn)(`Timer has not been started for ${M}`), this.times.push({
                  name: M,
                  start: this.started[M],
                  end: Date.now()
                }), delete this.started[M];
              }
              toString() {
                const M = [];
                let x = 0;
                for (const {
                  name: A
                } of this.times)
                  x = Math.max(A.length, x);
                for (const {
                  name: A,
                  start: g,
                  end: I
                } of this.times)
                  M.push(`${A.padEnd(x)} ${I - g}ms
`);
                return M.join("");
              }
            }
            p.StatTimer = C;
            function R(G, M) {
              try {
                const {
                  protocol: x
                } = M ? new URL(G, M) : new URL(G);
                return x === "http:" || x === "https:";
              } catch {
                return !1;
              }
            }
            function s(G) {
              G.preventDefault();
            }
            function m(G) {
              let M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              return new Promise((x, A) => {
                const g = document.createElement("script");
                g.src = G, g.onload = function(I) {
                  M && g.remove(), x(I);
                }, g.onerror = function() {
                  A(new Error(`Cannot load script at: ${g.src}`));
                }, (document.head || document.documentElement).append(g);
              });
            }
            function F(G) {
              console.log("Deprecated API usage: " + G);
            }
            let B;
            class k {
              static toDateObject(M) {
                if (!M || typeof M != "string")
                  return null;
                B ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                const x = B.exec(M);
                if (!x)
                  return null;
                const A = parseInt(x[1], 10);
                let g = parseInt(x[2], 10);
                g = g >= 1 && g <= 12 ? g - 1 : 0;
                let I = parseInt(x[3], 10);
                I = I >= 1 && I <= 31 ? I : 1;
                let U = parseInt(x[4], 10);
                U = U >= 0 && U <= 23 ? U : 0;
                let _ = parseInt(x[5], 10);
                _ = _ >= 0 && _ <= 59 ? _ : 0;
                let H = parseInt(x[6], 10);
                H = H >= 0 && H <= 59 ? H : 0;
                const N = x[7] || "Z";
                let b = parseInt(x[8], 10);
                b = b >= 0 && b <= 23 ? b : 0;
                let w = parseInt(x[9], 10) || 0;
                return w = w >= 0 && w <= 59 ? w : 0, N === "-" ? (U += b, _ += w) : N === "+" && (U -= b, _ -= w), new Date(Date.UTC(A, g, I, U, _, H));
              }
            }
            p.PDFDateString = k;
            function V(G, M) {
              let {
                scale: x = 1,
                rotation: A = 0
              } = M;
              const {
                width: g,
                height: I
              } = G.attributes.style, U = [0, 0, parseInt(g), parseInt(I)];
              return new h({
                viewBox: U,
                scale: x,
                rotation: A
              });
            }
            function z(G) {
              if (G.startsWith("#")) {
                const M = parseInt(G.slice(1), 16);
                return [(M & 16711680) >> 16, (M & 65280) >> 8, M & 255];
              }
              return G.startsWith("rgb(") ? G.slice(4, -1).split(",").map((M) => parseInt(M)) : G.startsWith("rgba(") ? G.slice(5, -1).split(",").map((M) => parseInt(M)).slice(0, 3) : ((0, f.warn)(`Not a valid color format: "${G}"`), [0, 0, 0]);
            }
            function K(G) {
              const M = document.createElement("span");
              M.style.visibility = "hidden", document.body.append(M);
              for (const x of G.keys()) {
                M.style.color = x;
                const A = window.getComputedStyle(M).color;
                G.set(x, z(A));
              }
              M.remove();
            }
            function J(G) {
              const {
                a: M,
                b: x,
                c: A,
                d: g,
                e: I,
                f: U
              } = G.getTransform();
              return [M, x, A, g, I, U];
            }
            function $(G) {
              const {
                a: M,
                b: x,
                c: A,
                d: g,
                e: I,
                f: U
              } = G.getTransform().invertSelf();
              return [M, x, A, g, I, U];
            }
            function j(G, M) {
              let x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
              if (M instanceof h) {
                const {
                  pageWidth: g,
                  pageHeight: I
                } = M.rawDims, {
                  style: U
                } = G, _ = f.FeatureTest.isCSSRoundSupported, H = `var(--scale-factor) * ${g}px`, N = `var(--scale-factor) * ${I}px`, b = _ ? `round(${H}, 1px)` : `calc(${H})`, w = _ ? `round(${N}, 1px)` : `calc(${N})`;
                !x || M.rotation % 180 === 0 ? (U.width = b, U.height = w) : (U.width = w, U.height = b);
              }
              A && G.setAttribute("data-main-rotation", M.rotation);
            }
          }),
          /* 169 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.BaseStandardFontDataFactory = p.BaseSVGFactory = p.BaseFilterFactory = p.BaseCanvasFactory = p.BaseCMapReaderFactory = void 0, t(2);
            var a = t(1);
            class f {
              constructor() {
                this.constructor === f && (0, a.unreachable)("Cannot initialize BaseFilterFactory.");
              }
              addFilter(n) {
                return "none";
              }
              addHCMFilter(n, o) {
                return "none";
              }
              addHighlightHCMFilter(n, o, d, h) {
                return "none";
              }
              destroy() {
              }
            }
            p.BaseFilterFactory = f;
            class S {
              constructor() {
                this.constructor === S && (0, a.unreachable)("Cannot initialize BaseCanvasFactory.");
              }
              create(n, o) {
                if (n <= 0 || o <= 0)
                  throw new Error("Invalid canvas size");
                const d = this._createCanvas(n, o);
                return {
                  canvas: d,
                  context: d.getContext("2d")
                };
              }
              reset(n, o, d) {
                if (!n.canvas)
                  throw new Error("Canvas is not specified");
                if (o <= 0 || d <= 0)
                  throw new Error("Invalid canvas size");
                n.canvas.width = o, n.canvas.height = d;
              }
              destroy(n) {
                if (!n.canvas)
                  throw new Error("Canvas is not specified");
                n.canvas.width = 0, n.canvas.height = 0, n.canvas = null, n.context = null;
              }
              _createCanvas(n, o) {
                (0, a.unreachable)("Abstract method `_createCanvas` called.");
              }
            }
            p.BaseCanvasFactory = S;
            class E {
              constructor(n) {
                let {
                  baseUrl: o = null,
                  isCompressed: d = !0
                } = n;
                this.constructor === E && (0, a.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = o, this.isCompressed = d;
              }
              async fetch(n) {
                let {
                  name: o
                } = n;
                if (!this.baseUrl)
                  throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                if (!o)
                  throw new Error("CMap name must be specified.");
                const d = this.baseUrl + o + (this.isCompressed ? ".bcmap" : ""), h = this.isCompressed ? a.CMapCompressionType.BINARY : a.CMapCompressionType.NONE;
                return this._fetchData(d, h).catch((e) => {
                  throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${d}`);
                });
              }
              _fetchData(n, o) {
                (0, a.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            p.BaseCMapReaderFactory = E;
            class v {
              constructor(n) {
                let {
                  baseUrl: o = null
                } = n;
                this.constructor === v && (0, a.unreachable)("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = o;
              }
              async fetch(n) {
                let {
                  filename: o
                } = n;
                if (!this.baseUrl)
                  throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                if (!o)
                  throw new Error("Font filename must be specified.");
                const d = `${this.baseUrl}${o}`;
                return this._fetchData(d).catch((h) => {
                  throw new Error(`Unable to load font data at: ${d}`);
                });
              }
              _fetchData(n) {
                (0, a.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            p.BaseStandardFontDataFactory = v;
            class T {
              constructor() {
                this.constructor === T && (0, a.unreachable)("Cannot initialize BaseSVGFactory.");
              }
              create(n, o) {
                let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                if (n <= 0 || o <= 0)
                  throw new Error("Invalid SVG dimensions");
                const h = this._createSVG("svg:svg");
                return h.setAttribute("version", "1.1"), d || (h.setAttribute("width", `${n}px`), h.setAttribute("height", `${o}px`)), h.setAttribute("preserveAspectRatio", "none"), h.setAttribute("viewBox", `0 0 ${n} ${o}`), h;
              }
              createElement(n) {
                if (typeof n != "string")
                  throw new Error("Invalid SVG element type");
                return this._createSVG(n);
              }
              _createSVG(n) {
                (0, a.unreachable)("Abstract method `_createSVG` called.");
              }
            }
            p.BaseSVGFactory = T;
          }),
          /* 170 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.MurmurHash3_64 = void 0, t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123), t(2);
            var a = t(1);
            const f = 3285377520, S = 4294901760, E = 65535;
            class v {
              constructor(i) {
                this.h1 = i ? i & 4294967295 : f, this.h2 = i ? i & 4294967295 : f;
              }
              update(i) {
                let n, o;
                if (typeof i == "string") {
                  n = new Uint8Array(i.length * 2), o = 0;
                  for (let F = 0, B = i.length; F < B; F++) {
                    const k = i.charCodeAt(F);
                    k <= 255 ? n[o++] = k : (n[o++] = k >>> 8, n[o++] = k & 255);
                  }
                } else if ((0, a.isArrayBuffer)(i))
                  n = i.slice(), o = n.byteLength;
                else
                  throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                const d = o >> 2, h = o - d * 4, e = new Uint32Array(n.buffer, 0, d);
                let l = 0, u = 0, c = this.h1, y = this.h2;
                const C = 3432918353, R = 461845907, s = C & E, m = R & E;
                for (let F = 0; F < d; F++)
                  F & 1 ? (l = e[F], l = l * C & S | l * s & E, l = l << 15 | l >>> 17, l = l * R & S | l * m & E, c ^= l, c = c << 13 | c >>> 19, c = c * 5 + 3864292196) : (u = e[F], u = u * C & S | u * s & E, u = u << 15 | u >>> 17, u = u * R & S | u * m & E, y ^= u, y = y << 13 | y >>> 19, y = y * 5 + 3864292196);
                switch (l = 0, h) {
                  case 3:
                    l ^= n[d * 4 + 2] << 16;
                  case 2:
                    l ^= n[d * 4 + 1] << 8;
                  case 1:
                    l ^= n[d * 4], l = l * C & S | l * s & E, l = l << 15 | l >>> 17, l = l * R & S | l * m & E, d & 1 ? c ^= l : y ^= l;
                }
                this.h1 = c, this.h2 = y;
              }
              hexdigest() {
                let i = this.h1, n = this.h2;
                return i ^= n >>> 1, i = i * 3981806797 & S | i * 36045 & E, n = n * 4283543511 & S | ((n << 16 | i >>> 16) * 2950163797 & S) >>> 16, i ^= n >>> 1, i = i * 444984403 & S | i * 60499 & E, n = n * 3301882366 & S | ((n << 16 | i >>> 16) * 3120437893 & S) >>> 16, i ^= n >>> 1, (i >>> 0).toString(16).padStart(8, "0") + (n >>> 0).toString(16).padStart(8, "0");
              }
            }
            p.MurmurHash3_64 = v;
          }),
          /* 171 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.FontLoader = p.FontFaceObject = void 0, t(125), t(136), t(138), t(141), t(143), t(145), t(147), t(89), t(149);
            var a = t(1);
            class f {
              #t = /* @__PURE__ */ new Set();
              constructor(v) {
                let {
                  ownerDocument: T = globalThis.document,
                  styleElement: i = null
                } = v;
                this._document = T, this.nativeFontFaces = /* @__PURE__ */ new Set(), this.styleElement = null, this.loadingRequests = [], this.loadTestFontId = 0;
              }
              addNativeFontFace(v) {
                this.nativeFontFaces.add(v), this._document.fonts.add(v);
              }
              removeNativeFontFace(v) {
                this.nativeFontFaces.delete(v), this._document.fonts.delete(v);
              }
              insertRule(v) {
                this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
                const T = this.styleElement.sheet;
                T.insertRule(v, T.cssRules.length);
              }
              clear() {
                for (const v of this.nativeFontFaces)
                  this._document.fonts.delete(v);
                this.nativeFontFaces.clear(), this.#t.clear(), this.styleElement && (this.styleElement.remove(), this.styleElement = null);
              }
              async loadSystemFont(v) {
                if (!(!v || this.#t.has(v.loadedName))) {
                  if ((0, a.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set."), this.isFontLoadingAPISupported) {
                    const {
                      loadedName: T,
                      src: i,
                      style: n
                    } = v, o = new FontFace(T, i, n);
                    this.addNativeFontFace(o);
                    try {
                      await o.load(), this.#t.add(T);
                    } catch {
                      (0, a.warn)(`Cannot load system font: ${v.baseFontName}, installing it could help to improve PDF rendering.`), this.removeNativeFontFace(o);
                    }
                    return;
                  }
                  (0, a.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                }
              }
              async bind(v) {
                if (v.attached || v.missingFile && !v.systemFontInfo)
                  return;
                if (v.attached = !0, v.systemFontInfo) {
                  await this.loadSystemFont(v.systemFontInfo);
                  return;
                }
                if (this.isFontLoadingAPISupported) {
                  const i = v.createNativeFontFace();
                  if (i) {
                    this.addNativeFontFace(i);
                    try {
                      await i.loaded;
                    } catch (n) {
                      throw (0, a.warn)(`Failed to load font '${i.family}': '${n}'.`), v.disableFontFace = !0, n;
                    }
                  }
                  return;
                }
                const T = v.createFontFaceRule();
                if (T) {
                  if (this.insertRule(T), this.isSyncFontLoadingSupported)
                    return;
                  await new Promise((i) => {
                    const n = this._queueLoadingCallback(i);
                    this._prepareFontLoadEvent(v, n);
                  });
                }
              }
              get isFontLoadingAPISupported() {
                const v = !!this._document?.fonts;
                return (0, a.shadow)(this, "isFontLoadingAPISupported", v);
              }
              get isSyncFontLoadingSupported() {
                let v = !1;
                return (a.isNodeJS || typeof navigator < "u" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) && (v = !0), (0, a.shadow)(this, "isSyncFontLoadingSupported", v);
              }
              _queueLoadingCallback(v) {
                function T() {
                  for ((0, a.assert)(!n.done, "completeRequest() cannot be called twice."), n.done = !0; i.length > 0 && i[0].done; ) {
                    const o = i.shift();
                    setTimeout(o.callback, 0);
                  }
                }
                const {
                  loadingRequests: i
                } = this, n = {
                  done: !1,
                  complete: T,
                  callback: v
                };
                return i.push(n), n;
              }
              get _loadTestFont() {
                const v = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                return (0, a.shadow)(this, "_loadTestFont", v);
              }
              _prepareFontLoadEvent(v, T) {
                function i(V, z) {
                  return V.charCodeAt(z) << 24 | V.charCodeAt(z + 1) << 16 | V.charCodeAt(z + 2) << 8 | V.charCodeAt(z + 3) & 255;
                }
                function n(V, z, K, J) {
                  const $ = V.substring(0, z), j = V.substring(z + K);
                  return $ + J + j;
                }
                let o, d;
                const h = this._document.createElement("canvas");
                h.width = 1, h.height = 1;
                const e = h.getContext("2d");
                let l = 0;
                function u(V, z) {
                  if (++l > 30) {
                    (0, a.warn)("Load test font never loaded."), z();
                    return;
                  }
                  if (e.font = "30px " + V, e.fillText(".", 0, 20), e.getImageData(0, 0, 1, 1).data[3] > 0) {
                    z();
                    return;
                  }
                  setTimeout(u.bind(null, V, z));
                }
                const c = `lt${Date.now()}${this.loadTestFontId++}`;
                let y = this._loadTestFont;
                y = n(y, 976, c.length, c);
                const R = 16, s = 1482184792;
                let m = i(y, R);
                for (o = 0, d = c.length - 3; o < d; o += 4)
                  m = m - s + i(c, o) | 0;
                o < c.length && (m = m - s + i(c + "XXX", o) | 0), y = n(y, R, 4, (0, a.string32)(m));
                const F = `url(data:font/opentype;base64,${btoa(y)});`, B = `@font-face {font-family:"${c}";src:${F}}`;
                this.insertRule(B);
                const k = this._document.createElement("div");
                k.style.visibility = "hidden", k.style.width = k.style.height = "10px", k.style.position = "absolute", k.style.top = k.style.left = "0px";
                for (const V of [v.loadedName, c]) {
                  const z = this._document.createElement("span");
                  z.textContent = "Hi", z.style.fontFamily = V, k.append(z);
                }
                this._document.body.append(k), u(c, () => {
                  k.remove(), T.complete();
                });
              }
            }
            p.FontLoader = f;
            class S {
              constructor(v, T) {
                let {
                  isEvalSupported: i = !0,
                  disableFontFace: n = !1,
                  ignoreErrors: o = !1,
                  inspectFont: d = null
                } = T;
                this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
                for (const h in v)
                  this[h] = v[h];
                this.isEvalSupported = i !== !1, this.disableFontFace = n === !0, this.ignoreErrors = o === !0, this._inspectFont = d;
              }
              createNativeFontFace() {
                if (!this.data || this.disableFontFace)
                  return null;
                let v;
                if (!this.cssFontInfo)
                  v = new FontFace(this.loadedName, this.data, {});
                else {
                  const T = {
                    weight: this.cssFontInfo.fontWeight
                  };
                  this.cssFontInfo.italicAngle && (T.style = `oblique ${this.cssFontInfo.italicAngle}deg`), v = new FontFace(this.cssFontInfo.fontFamily, this.data, T);
                }
                return this._inspectFont?.(this), v;
              }
              createFontFaceRule() {
                if (!this.data || this.disableFontFace)
                  return null;
                const v = (0, a.bytesToString)(this.data), T = `url(data:${this.mimetype};base64,${btoa(v)});`;
                let i;
                if (!this.cssFontInfo)
                  i = `@font-face {font-family:"${this.loadedName}";src:${T}}`;
                else {
                  let n = `font-weight: ${this.cssFontInfo.fontWeight};`;
                  this.cssFontInfo.italicAngle && (n += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), i = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${n}src:${T}}`;
                }
                return this._inspectFont?.(this, T), i;
              }
              getPathGenerator(v, T) {
                if (this.compiledGlyphs[T] !== void 0)
                  return this.compiledGlyphs[T];
                let i;
                try {
                  i = v.get(this.loadedName + "_path_" + T);
                } catch (n) {
                  if (!this.ignoreErrors)
                    throw n;
                  return (0, a.warn)(`getPathGenerator - ignoring character: "${n}".`), this.compiledGlyphs[T] = function(o, d) {
                  };
                }
                if (this.isEvalSupported && a.FeatureTest.isEvalSupported) {
                  const n = [];
                  for (const o of i) {
                    const d = o.args !== void 0 ? o.args.join(",") : "";
                    n.push("c.", o.cmd, "(", d, `);
`);
                  }
                  return this.compiledGlyphs[T] = new Function("c", "size", n.join(""));
                }
                return this.compiledGlyphs[T] = function(n, o) {
                  for (const d of i)
                    d.cmd === "scale" && (d.args = [o, -o]), n[d.cmd].apply(n, d.args);
                };
              }
            }
            p.FontFaceObject = S;
          }),
          /* 172 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.NodeStandardFontDataFactory = p.NodeFilterFactory = p.NodeCanvasFactory = p.NodeCMapReaderFactory = void 0, t(2), t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123);
            var a = t(169), f = t(1);
            (function() {
              if (!(globalThis.DOMMatrix || !f.isNodeJS))
                try {
                  globalThis.DOMMatrix = require$$6.DOMMatrix;
                } catch (o) {
                  (0, f.warn)(`Cannot polyfill \`DOMMatrix\`, rendering may be broken: "${o}".`);
                }
            })(), (function() {
              if (!(globalThis.Path2D || !f.isNodeJS))
                try {
                  const {
                    CanvasRenderingContext2D: o
                  } = require$$6, {
                    polyfillPath2D: d
                  } = requirePath2dPolyfill_esm();
                  globalThis.CanvasRenderingContext2D = o, d(globalThis);
                } catch (o) {
                  (0, f.warn)(`Cannot polyfill \`Path2D\`, rendering may be broken: "${o}".`);
                }
            })();
            const S = function(n) {
              return new Promise((o, d) => {
                require$$6.readFile(n, (e, l) => {
                  if (e || !l) {
                    d(new Error(e));
                    return;
                  }
                  o(new Uint8Array(l));
                });
              });
            };
            class E extends a.BaseFilterFactory {
            }
            p.NodeFilterFactory = E;
            class v extends a.BaseCanvasFactory {
              _createCanvas(o, d) {
                return require$$6.createCanvas(o, d);
              }
            }
            p.NodeCanvasFactory = v;
            class T extends a.BaseCMapReaderFactory {
              _fetchData(o, d) {
                return S(o).then((h) => ({
                  cMapData: h,
                  compressionType: d
                }));
              }
            }
            p.NodeCMapReaderFactory = T;
            class i extends a.BaseStandardFontDataFactory {
              _fetchData(o) {
                return S(o);
              }
            }
            p.NodeStandardFontDataFactory = i;
          }),
          /* 173 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.CanvasGraphics = void 0, t(2), t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123), t(89);
            var a = t(1), f = t(168), S = t(174), E = t(175);
            const v = 16, T = 100, i = 4096, n = 15, o = 10, d = 1e3, h = 16;
            function e(x, A) {
              if (x._removeMirroring)
                throw new Error("Context is already forwarding operations.");
              x.__originalSave = x.save, x.__originalRestore = x.restore, x.__originalRotate = x.rotate, x.__originalScale = x.scale, x.__originalTranslate = x.translate, x.__originalTransform = x.transform, x.__originalSetTransform = x.setTransform, x.__originalResetTransform = x.resetTransform, x.__originalClip = x.clip, x.__originalMoveTo = x.moveTo, x.__originalLineTo = x.lineTo, x.__originalBezierCurveTo = x.bezierCurveTo, x.__originalRect = x.rect, x.__originalClosePath = x.closePath, x.__originalBeginPath = x.beginPath, x._removeMirroring = () => {
                x.save = x.__originalSave, x.restore = x.__originalRestore, x.rotate = x.__originalRotate, x.scale = x.__originalScale, x.translate = x.__originalTranslate, x.transform = x.__originalTransform, x.setTransform = x.__originalSetTransform, x.resetTransform = x.__originalResetTransform, x.clip = x.__originalClip, x.moveTo = x.__originalMoveTo, x.lineTo = x.__originalLineTo, x.bezierCurveTo = x.__originalBezierCurveTo, x.rect = x.__originalRect, x.closePath = x.__originalClosePath, x.beginPath = x.__originalBeginPath, delete x._removeMirroring;
              }, x.save = function() {
                A.save(), this.__originalSave();
              }, x.restore = function() {
                A.restore(), this.__originalRestore();
              }, x.translate = function(I, U) {
                A.translate(I, U), this.__originalTranslate(I, U);
              }, x.scale = function(I, U) {
                A.scale(I, U), this.__originalScale(I, U);
              }, x.transform = function(I, U, _, H, N, b) {
                A.transform(I, U, _, H, N, b), this.__originalTransform(I, U, _, H, N, b);
              }, x.setTransform = function(I, U, _, H, N, b) {
                A.setTransform(I, U, _, H, N, b), this.__originalSetTransform(I, U, _, H, N, b);
              }, x.resetTransform = function() {
                A.resetTransform(), this.__originalResetTransform();
              }, x.rotate = function(I) {
                A.rotate(I), this.__originalRotate(I);
              }, x.clip = function(I) {
                A.clip(I), this.__originalClip(I);
              }, x.moveTo = function(g, I) {
                A.moveTo(g, I), this.__originalMoveTo(g, I);
              }, x.lineTo = function(g, I) {
                A.lineTo(g, I), this.__originalLineTo(g, I);
              }, x.bezierCurveTo = function(g, I, U, _, H, N) {
                A.bezierCurveTo(g, I, U, _, H, N), this.__originalBezierCurveTo(g, I, U, _, H, N);
              }, x.rect = function(g, I, U, _) {
                A.rect(g, I, U, _), this.__originalRect(g, I, U, _);
              }, x.closePath = function() {
                A.closePath(), this.__originalClosePath();
              }, x.beginPath = function() {
                A.beginPath(), this.__originalBeginPath();
              };
            }
            class l {
              constructor(A) {
                this.canvasFactory = A, this.cache = /* @__PURE__ */ Object.create(null);
              }
              getCanvas(A, g, I) {
                let U;
                return this.cache[A] !== void 0 ? (U = this.cache[A], this.canvasFactory.reset(U, g, I)) : (U = this.canvasFactory.create(g, I), this.cache[A] = U), U;
              }
              delete(A) {
                delete this.cache[A];
              }
              clear() {
                for (const A in this.cache) {
                  const g = this.cache[A];
                  this.canvasFactory.destroy(g), delete this.cache[A];
                }
              }
            }
            function u(x, A, g, I, U, _, H, N, b, w) {
              const [O, D, L, W, X, q] = (0, f.getCurrentTransform)(x);
              if (D === 0 && L === 0) {
                const Y = H * O + X, Q = Math.round(Y), et = N * W + q, Z = Math.round(et), at = (H + b) * O + X, lt = Math.abs(Math.round(at) - Q) || 1, ft = (N + w) * W + q, pt = Math.abs(Math.round(ft) - Z) || 1;
                return x.setTransform(Math.sign(O), 0, 0, Math.sign(W), Q, Z), x.drawImage(A, g, I, U, _, 0, 0, lt, pt), x.setTransform(O, D, L, W, X, q), [lt, pt];
              }
              if (O === 0 && W === 0) {
                const Y = N * L + X, Q = Math.round(Y), et = H * D + q, Z = Math.round(et), at = (N + w) * L + X, lt = Math.abs(Math.round(at) - Q) || 1, ft = (H + b) * D + q, pt = Math.abs(Math.round(ft) - Z) || 1;
                return x.setTransform(0, Math.sign(D), Math.sign(L), 0, Q, Z), x.drawImage(A, g, I, U, _, 0, 0, pt, lt), x.setTransform(O, D, L, W, X, q), [pt, lt];
              }
              x.drawImage(A, g, I, U, _, H, N, b, w);
              const ct = Math.hypot(O, D), nt = Math.hypot(L, W);
              return [ct * b, nt * w];
            }
            function c(x) {
              const {
                width: A,
                height: g
              } = x;
              if (A > d || g > d)
                return null;
              const I = 1e3, U = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), _ = A + 1;
              let H = new Uint8Array(_ * (g + 1)), N, b, w;
              const O = A + 7 & -8;
              let D = new Uint8Array(O * g), L = 0;
              for (const nt of x.data) {
                let Y = 128;
                for (; Y > 0; )
                  D[L++] = nt & Y ? 0 : 255, Y >>= 1;
              }
              let W = 0;
              for (L = 0, D[L] !== 0 && (H[0] = 1, ++W), b = 1; b < A; b++)
                D[L] !== D[L + 1] && (H[b] = D[L] ? 2 : 1, ++W), L++;
              for (D[L] !== 0 && (H[b] = 2, ++W), N = 1; N < g; N++) {
                L = N * O, w = N * _, D[L - O] !== D[L] && (H[w] = D[L] ? 1 : 8, ++W);
                let nt = (D[L] ? 4 : 0) + (D[L - O] ? 8 : 0);
                for (b = 1; b < A; b++)
                  nt = (nt >> 2) + (D[L + 1] ? 4 : 0) + (D[L - O + 1] ? 8 : 0), U[nt] && (H[w + b] = U[nt], ++W), L++;
                if (D[L - O] !== D[L] && (H[w + b] = D[L] ? 2 : 4, ++W), W > I)
                  return null;
              }
              for (L = O * (g - 1), w = N * _, D[L] !== 0 && (H[w] = 8, ++W), b = 1; b < A; b++)
                D[L] !== D[L + 1] && (H[w + b] = D[L] ? 4 : 8, ++W), L++;
              if (D[L] !== 0 && (H[w + b] = 4, ++W), W > I)
                return null;
              const X = new Int32Array([0, _, -1, 0, -_, 0, 0, 0, 1]), q = new Path2D();
              for (N = 0; W && N <= g; N++) {
                let nt = N * _;
                const Y = nt + A;
                for (; nt < Y && !H[nt]; )
                  nt++;
                if (nt === Y)
                  continue;
                q.moveTo(nt % _, N);
                const Q = nt;
                let et = H[nt];
                do {
                  const Z = X[et];
                  do
                    nt += Z;
                  while (!H[nt]);
                  const at = H[nt];
                  at !== 5 && at !== 10 ? (et = at, H[nt] = 0) : (et = at & 51 * et >> 4, H[nt] &= et >> 2 | et << 2), q.lineTo(nt % _, nt / _ | 0), H[nt] || --W;
                } while (Q !== nt);
                --N;
              }
              return D = null, H = null, function(nt) {
                nt.save(), nt.scale(1 / A, -1 / g), nt.translate(0, -g), nt.fill(q), nt.beginPath(), nt.restore();
              };
            }
            class y {
              constructor(A, g) {
                this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = a.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = a.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = a.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = "none", this.startNewPathAndClipBox([0, 0, A, g]);
              }
              clone() {
                const A = Object.create(this);
                return A.clipBox = this.clipBox.slice(), A;
              }
              setCurrentPoint(A, g) {
                this.x = A, this.y = g;
              }
              updatePathMinMax(A, g, I) {
                [g, I] = a.Util.applyTransform([g, I], A), this.minX = Math.min(this.minX, g), this.minY = Math.min(this.minY, I), this.maxX = Math.max(this.maxX, g), this.maxY = Math.max(this.maxY, I);
              }
              updateRectMinMax(A, g) {
                const I = a.Util.applyTransform(g, A), U = a.Util.applyTransform(g.slice(2), A);
                this.minX = Math.min(this.minX, I[0], U[0]), this.minY = Math.min(this.minY, I[1], U[1]), this.maxX = Math.max(this.maxX, I[0], U[0]), this.maxY = Math.max(this.maxY, I[1], U[1]);
              }
              updateScalingPathMinMax(A, g) {
                a.Util.scaleMinMax(A, g), this.minX = Math.min(this.minX, g[0]), this.maxX = Math.max(this.maxX, g[1]), this.minY = Math.min(this.minY, g[2]), this.maxY = Math.max(this.maxY, g[3]);
              }
              updateCurvePathMinMax(A, g, I, U, _, H, N, b, w, O) {
                const D = a.Util.bezierBoundingBox(g, I, U, _, H, N, b, w);
                if (O) {
                  O[0] = Math.min(O[0], D[0], D[2]), O[1] = Math.max(O[1], D[0], D[2]), O[2] = Math.min(O[2], D[1], D[3]), O[3] = Math.max(O[3], D[1], D[3]);
                  return;
                }
                this.updateRectMinMax(A, D);
              }
              getPathBoundingBox() {
                let A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : S.PathType.FILL, g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                const I = [this.minX, this.minY, this.maxX, this.maxY];
                if (A === S.PathType.STROKE) {
                  g || (0, a.unreachable)("Stroke bounding box must include transform.");
                  const U = a.Util.singularValueDecompose2dScale(g), _ = U[0] * this.lineWidth / 2, H = U[1] * this.lineWidth / 2;
                  I[0] -= _, I[1] -= H, I[2] += _, I[3] += H;
                }
                return I;
              }
              updateClipFromPath() {
                const A = a.Util.intersect(this.clipBox, this.getPathBoundingBox());
                this.startNewPathAndClipBox(A || [0, 0, 0, 0]);
              }
              isEmptyClip() {
                return this.minX === 1 / 0;
              }
              startNewPathAndClipBox(A) {
                this.clipBox = A, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
              }
              getClippedPathBoundingBox() {
                let A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : S.PathType.FILL, g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return a.Util.intersect(this.clipBox, this.getPathBoundingBox(A, g));
              }
            }
            function C(x, A) {
              if (typeof ImageData < "u" && A instanceof ImageData) {
                x.putImageData(A, 0, 0);
                return;
              }
              const g = A.height, I = A.width, U = g % h, _ = (g - U) / h, H = U === 0 ? _ : _ + 1, N = x.createImageData(I, h);
              let b = 0, w;
              const O = A.data, D = N.data;
              let L, W, X, q;
              if (A.kind === a.ImageKind.GRAYSCALE_1BPP) {
                const ct = O.byteLength, nt = new Uint32Array(D.buffer, 0, D.byteLength >> 2), Y = nt.length, Q = I + 7 >> 3, et = 4294967295, Z = a.FeatureTest.isLittleEndian ? 4278190080 : 255;
                for (L = 0; L < H; L++) {
                  for (X = L < _ ? h : U, w = 0, W = 0; W < X; W++) {
                    const at = ct - b;
                    let lt = 0;
                    const ft = at > Q ? I : at * 8 - 7, pt = ft & -8;
                    let vt = 0, yt = 0;
                    for (; lt < pt; lt += 8)
                      yt = O[b++], nt[w++] = yt & 128 ? et : Z, nt[w++] = yt & 64 ? et : Z, nt[w++] = yt & 32 ? et : Z, nt[w++] = yt & 16 ? et : Z, nt[w++] = yt & 8 ? et : Z, nt[w++] = yt & 4 ? et : Z, nt[w++] = yt & 2 ? et : Z, nt[w++] = yt & 1 ? et : Z;
                    for (; lt < ft; lt++)
                      vt === 0 && (yt = O[b++], vt = 128), nt[w++] = yt & vt ? et : Z, vt >>= 1;
                  }
                  for (; w < Y; )
                    nt[w++] = 0;
                  x.putImageData(N, 0, L * h);
                }
              } else if (A.kind === a.ImageKind.RGBA_32BPP) {
                for (W = 0, q = I * h * 4, L = 0; L < _; L++)
                  D.set(O.subarray(b, b + q)), b += q, x.putImageData(N, 0, W), W += h;
                L < H && (q = I * U * 4, D.set(O.subarray(b, b + q)), x.putImageData(N, 0, W));
              } else if (A.kind === a.ImageKind.RGB_24BPP)
                for (X = h, q = I * X, L = 0; L < H; L++) {
                  for (L >= _ && (X = U, q = I * X), w = 0, W = q; W--; )
                    D[w++] = O[b++], D[w++] = O[b++], D[w++] = O[b++], D[w++] = 255;
                  x.putImageData(N, 0, L * h);
                }
              else
                throw new Error(`bad image kind: ${A.kind}`);
            }
            function R(x, A) {
              if (A.bitmap) {
                x.drawImage(A.bitmap, 0, 0);
                return;
              }
              const g = A.height, I = A.width, U = g % h, _ = (g - U) / h, H = U === 0 ? _ : _ + 1, N = x.createImageData(I, h);
              let b = 0;
              const w = A.data, O = N.data;
              for (let D = 0; D < H; D++) {
                const L = D < _ ? h : U;
                ({
                  srcPos: b
                } = (0, E.convertBlackAndWhiteToRGBA)({
                  src: w,
                  srcPos: b,
                  dest: O,
                  width: I,
                  height: L,
                  nonBlackColor: 0
                })), x.putImageData(N, 0, D * h);
              }
            }
            function s(x, A) {
              const g = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
              for (const I of g)
                x[I] !== void 0 && (A[I] = x[I]);
              x.setLineDash !== void 0 && (A.setLineDash(x.getLineDash()), A.lineDashOffset = x.lineDashOffset);
            }
            function m(x) {
              if (x.strokeStyle = x.fillStyle = "#000000", x.fillRule = "nonzero", x.globalAlpha = 1, x.lineWidth = 1, x.lineCap = "butt", x.lineJoin = "miter", x.miterLimit = 10, x.globalCompositeOperation = "source-over", x.font = "10px sans-serif", x.setLineDash !== void 0 && (x.setLineDash([]), x.lineDashOffset = 0), !a.isNodeJS) {
                const {
                  filter: A
                } = x;
                A !== "none" && A !== "" && (x.filter = "none");
              }
            }
            function F(x, A, g, I) {
              const U = x.length;
              for (let _ = 3; _ < U; _ += 4) {
                const H = x[_];
                if (H === 0)
                  x[_ - 3] = A, x[_ - 2] = g, x[_ - 1] = I;
                else if (H < 255) {
                  const N = 255 - H;
                  x[_ - 3] = x[_ - 3] * H + A * N >> 8, x[_ - 2] = x[_ - 2] * H + g * N >> 8, x[_ - 1] = x[_ - 1] * H + I * N >> 8;
                }
              }
            }
            function B(x, A, g) {
              const I = x.length, U = 1 / 255;
              for (let _ = 3; _ < I; _ += 4) {
                const H = g ? g[x[_]] : x[_];
                A[_] = A[_] * H * U | 0;
              }
            }
            function k(x, A, g) {
              const I = x.length;
              for (let U = 3; U < I; U += 4) {
                const _ = x[U - 3] * 77 + x[U - 2] * 152 + x[U - 1] * 28;
                A[U] = g ? A[U] * g[_ >> 8] >> 8 : A[U] * _ >> 16;
              }
            }
            function V(x, A, g, I, U, _, H, N, b, w, O) {
              const D = !!_, L = D ? _[0] : 0, W = D ? _[1] : 0, X = D ? _[2] : 0, q = U === "Luminosity" ? k : B, nt = Math.min(I, Math.ceil(1048576 / g));
              for (let Y = 0; Y < I; Y += nt) {
                const Q = Math.min(nt, I - Y), et = x.getImageData(N - w, Y + (b - O), g, Q), Z = A.getImageData(N, Y + b, g, Q);
                D && F(et.data, L, W, X), q(et.data, Z.data, H), A.putImageData(Z, N, Y + b);
              }
            }
            function z(x, A, g, I) {
              const U = I[0], _ = I[1], H = I[2] - U, N = I[3] - _;
              H === 0 || N === 0 || (V(A.context, g, H, N, A.subtype, A.backdrop, A.transferMap, U, _, A.offsetX, A.offsetY), x.save(), x.globalAlpha = 1, x.globalCompositeOperation = "source-over", x.setTransform(1, 0, 0, 1, 0, 0), x.drawImage(g.canvas, 0, 0), x.restore());
            }
            function K(x, A) {
              const g = a.Util.singularValueDecompose2dScale(x);
              g[0] = Math.fround(g[0]), g[1] = Math.fround(g[1]);
              const I = Math.fround((globalThis.devicePixelRatio || 1) * f.PixelsPerInch.PDF_TO_CSS_UNITS);
              return A !== void 0 ? A : g[0] <= I || g[1] <= I;
            }
            const J = ["butt", "round", "square"], $ = ["miter", "round", "bevel"], j = {}, G = {};
            class M {
              constructor(A, g, I, U, _, H, N, b) {
                let {
                  optionalContentConfig: w,
                  markedContentStack: O = null
                } = H;
                this.ctx = A, this.current = new y(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = g, this.objs = I, this.canvasFactory = U, this.filterFactory = _, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = O || [], this.optionalContentConfig = w, this.cachedCanvases = new l(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = N, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.pageColors = b, this._cachedScaleForStroking = [-1, 0], this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
              }
              getObject(A) {
                let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return typeof A == "string" ? A.startsWith("g_") ? this.commonObjs.get(A) : this.objs.get(A) : g;
              }
              beginDrawing(A) {
                let {
                  transform: g,
                  viewport: I,
                  transparency: U = !1,
                  background: _ = null
                } = A;
                const H = this.ctx.canvas.width, N = this.ctx.canvas.height, b = this.ctx.fillStyle;
                if (this.ctx.fillStyle = _ || "#ffffff", this.ctx.fillRect(0, 0, H, N), this.ctx.fillStyle = b, U) {
                  const w = this.cachedCanvases.getCanvas("transparent", H, N);
                  this.compositeCtx = this.ctx, this.transparentCanvas = w.canvas, this.ctx = w.context, this.ctx.save(), this.ctx.transform(...(0, f.getCurrentTransform)(this.compositeCtx));
                }
                this.ctx.save(), m(this.ctx), g && (this.ctx.transform(...g), this.outputScaleX = g[0], this.outputScaleY = g[0]), this.ctx.transform(...I.transform), this.viewportScale = I.scale, this.baseTransform = (0, f.getCurrentTransform)(this.ctx);
              }
              executeOperatorList(A, g, I, U) {
                const _ = A.argsArray, H = A.fnArray;
                let N = g || 0;
                const b = _.length;
                if (b === N)
                  return N;
                const w = b - N > o && typeof I == "function", O = w ? Date.now() + n : 0;
                let D = 0;
                const L = this.commonObjs, W = this.objs;
                let X;
                for (; ; ) {
                  if (U !== void 0 && N === U.nextBreakPoint)
                    return U.breakIt(N, I), N;
                  if (X = H[N], X !== a.OPS.dependency)
                    this[X].apply(this, _[N]);
                  else
                    for (const q of _[N]) {
                      const ct = q.startsWith("g_") ? L : W;
                      if (!ct.has(q))
                        return ct.get(q, I), N;
                    }
                  if (N++, N === b)
                    return N;
                  if (w && ++D > o) {
                    if (Date.now() > O)
                      return I(), N;
                    D = 0;
                  }
                }
              }
              #t() {
                for (; this.stateStack.length || this.inSMaskMode; )
                  this.restore();
                this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
              }
              endDrawing() {
                this.#t(), this.cachedCanvases.clear(), this.cachedPatterns.clear();
                for (const A of this._cachedBitmapsMap.values()) {
                  for (const g of A.values())
                    typeof HTMLCanvasElement < "u" && g instanceof HTMLCanvasElement && (g.width = g.height = 0);
                  A.clear();
                }
                this._cachedBitmapsMap.clear(), this.#e();
              }
              #e() {
                if (this.pageColors) {
                  const A = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                  if (A !== "none") {
                    const g = this.ctx.filter;
                    this.ctx.filter = A, this.ctx.drawImage(this.ctx.canvas, 0, 0), this.ctx.filter = g;
                  }
                }
              }
              _scaleImage(A, g) {
                const I = A.width, U = A.height;
                let _ = Math.max(Math.hypot(g[0], g[1]), 1), H = Math.max(Math.hypot(g[2], g[3]), 1), N = I, b = U, w = "prescale1", O, D;
                for (; _ > 2 && N > 1 || H > 2 && b > 1; ) {
                  let L = N, W = b;
                  _ > 2 && N > 1 && (L = N >= 16384 ? Math.floor(N / 2) - 1 || 1 : Math.ceil(N / 2), _ /= N / L), H > 2 && b > 1 && (W = b >= 16384 ? Math.floor(b / 2) - 1 || 1 : Math.ceil(b) / 2, H /= b / W), O = this.cachedCanvases.getCanvas(w, L, W), D = O.context, D.clearRect(0, 0, L, W), D.drawImage(A, 0, 0, N, b, 0, 0, L, W), A = O.canvas, N = L, b = W, w = w === "prescale1" ? "prescale2" : "prescale1";
                }
                return {
                  img: A,
                  paintWidth: N,
                  paintHeight: b
                };
              }
              _createMaskCanvas(A) {
                const g = this.ctx, {
                  width: I,
                  height: U
                } = A, _ = this.current.fillColor, H = this.current.patternFill, N = (0, f.getCurrentTransform)(g);
                let b, w, O, D;
                if ((A.bitmap || A.data) && A.count > 1) {
                  const lt = A.bitmap || A.data.buffer;
                  w = JSON.stringify(H ? N : [N.slice(0, 4), _]), b = this._cachedBitmapsMap.get(lt), b || (b = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(lt, b));
                  const ft = b.get(w);
                  if (ft && !H) {
                    const pt = Math.round(Math.min(N[0], N[2]) + N[4]), vt = Math.round(Math.min(N[1], N[3]) + N[5]);
                    return {
                      canvas: ft,
                      offsetX: pt,
                      offsetY: vt
                    };
                  }
                  O = ft;
                }
                O || (D = this.cachedCanvases.getCanvas("maskCanvas", I, U), R(D.context, A));
                let L = a.Util.transform(N, [1 / I, 0, 0, -1 / U, 0, 0]);
                L = a.Util.transform(L, [1, 0, 0, 1, 0, -U]);
                const W = a.Util.applyTransform([0, 0], L), X = a.Util.applyTransform([I, U], L), q = a.Util.normalizeRect([W[0], W[1], X[0], X[1]]), ct = Math.round(q[2] - q[0]) || 1, nt = Math.round(q[3] - q[1]) || 1, Y = this.cachedCanvases.getCanvas("fillCanvas", ct, nt), Q = Y.context, et = Math.min(W[0], X[0]), Z = Math.min(W[1], X[1]);
                Q.translate(-et, -Z), Q.transform(...L), O || (O = this._scaleImage(D.canvas, (0, f.getCurrentTransformInverse)(Q)), O = O.img, b && H && b.set(w, O)), Q.imageSmoothingEnabled = K((0, f.getCurrentTransform)(Q), A.interpolate), u(Q, O, 0, 0, O.width, O.height, 0, 0, I, U), Q.globalCompositeOperation = "source-in";
                const at = a.Util.transform((0, f.getCurrentTransformInverse)(Q), [1, 0, 0, 1, -et, -Z]);
                return Q.fillStyle = H ? _.getPattern(g, this, at, S.PathType.FILL) : _, Q.fillRect(0, 0, I, U), b && !H && (this.cachedCanvases.delete("fillCanvas"), b.set(w, Y.canvas)), {
                  canvas: Y.canvas,
                  offsetX: Math.round(et),
                  offsetY: Math.round(Z)
                };
              }
              setLineWidth(A) {
                A !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1), this.current.lineWidth = A, this.ctx.lineWidth = A;
              }
              setLineCap(A) {
                this.ctx.lineCap = J[A];
              }
              setLineJoin(A) {
                this.ctx.lineJoin = $[A];
              }
              setMiterLimit(A) {
                this.ctx.miterLimit = A;
              }
              setDash(A, g) {
                const I = this.ctx;
                I.setLineDash !== void 0 && (I.setLineDash(A), I.lineDashOffset = g);
              }
              setRenderingIntent(A) {
              }
              setFlatness(A) {
              }
              setGState(A) {
                for (const [g, I] of A)
                  switch (g) {
                    case "LW":
                      this.setLineWidth(I);
                      break;
                    case "LC":
                      this.setLineCap(I);
                      break;
                    case "LJ":
                      this.setLineJoin(I);
                      break;
                    case "ML":
                      this.setMiterLimit(I);
                      break;
                    case "D":
                      this.setDash(I[0], I[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(I);
                      break;
                    case "FL":
                      this.setFlatness(I);
                      break;
                    case "Font":
                      this.setFont(I[0], I[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = I;
                      break;
                    case "ca":
                      this.current.fillAlpha = I, this.ctx.globalAlpha = I;
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = I;
                      break;
                    case "SMask":
                      this.current.activeSMask = I ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
                      break;
                    case "TR":
                      this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(I);
                      break;
                  }
              }
              get inSMaskMode() {
                return !!this.suspendedCtx;
              }
              checkSMaskState() {
                const A = this.inSMaskMode;
                this.current.activeSMask && !A ? this.beginSMaskMode() : !this.current.activeSMask && A && this.endSMaskMode();
              }
              beginSMaskMode() {
                if (this.inSMaskMode)
                  throw new Error("beginSMaskMode called while already in smask mode");
                const A = this.ctx.canvas.width, g = this.ctx.canvas.height, I = "smaskGroupAt" + this.groupLevel, U = this.cachedCanvases.getCanvas(I, A, g);
                this.suspendedCtx = this.ctx, this.ctx = U.context;
                const _ = this.ctx;
                _.setTransform(...(0, f.getCurrentTransform)(this.suspendedCtx)), s(this.suspendedCtx, _), e(_, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
              }
              endSMaskMode() {
                if (!this.inSMaskMode)
                  throw new Error("endSMaskMode called while not in smask mode");
                this.ctx._removeMirroring(), s(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
              }
              compose(A) {
                if (!this.current.activeSMask)
                  return;
                A ? (A[0] = Math.floor(A[0]), A[1] = Math.floor(A[1]), A[2] = Math.ceil(A[2]), A[3] = Math.ceil(A[3])) : A = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
                const g = this.current.activeSMask, I = this.suspendedCtx;
                z(I, g, this.ctx, A), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
              }
              save() {
                this.inSMaskMode ? (s(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
                const A = this.current;
                this.stateStack.push(A), this.current = A.clone();
              }
              restore() {
                this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), s(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null);
              }
              transform(A, g, I, U, _, H) {
                this.ctx.transform(A, g, I, U, _, H), this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
              }
              constructPath(A, g, I) {
                const U = this.ctx, _ = this.current;
                let H = _.x, N = _.y, b, w;
                const O = (0, f.getCurrentTransform)(U), D = O[0] === 0 && O[3] === 0 || O[1] === 0 && O[2] === 0, L = D ? I.slice(0) : null;
                for (let W = 0, X = 0, q = A.length; W < q; W++)
                  switch (A[W] | 0) {
                    case a.OPS.rectangle:
                      H = g[X++], N = g[X++];
                      const ct = g[X++], nt = g[X++], Y = H + ct, Q = N + nt;
                      U.moveTo(H, N), ct === 0 || nt === 0 ? U.lineTo(Y, Q) : (U.lineTo(Y, N), U.lineTo(Y, Q), U.lineTo(H, Q)), D || _.updateRectMinMax(O, [H, N, Y, Q]), U.closePath();
                      break;
                    case a.OPS.moveTo:
                      H = g[X++], N = g[X++], U.moveTo(H, N), D || _.updatePathMinMax(O, H, N);
                      break;
                    case a.OPS.lineTo:
                      H = g[X++], N = g[X++], U.lineTo(H, N), D || _.updatePathMinMax(O, H, N);
                      break;
                    case a.OPS.curveTo:
                      b = H, w = N, H = g[X + 4], N = g[X + 5], U.bezierCurveTo(g[X], g[X + 1], g[X + 2], g[X + 3], H, N), _.updateCurvePathMinMax(O, b, w, g[X], g[X + 1], g[X + 2], g[X + 3], H, N, L), X += 6;
                      break;
                    case a.OPS.curveTo2:
                      b = H, w = N, U.bezierCurveTo(H, N, g[X], g[X + 1], g[X + 2], g[X + 3]), _.updateCurvePathMinMax(O, b, w, H, N, g[X], g[X + 1], g[X + 2], g[X + 3], L), H = g[X + 2], N = g[X + 3], X += 4;
                      break;
                    case a.OPS.curveTo3:
                      b = H, w = N, H = g[X + 2], N = g[X + 3], U.bezierCurveTo(g[X], g[X + 1], H, N, H, N), _.updateCurvePathMinMax(O, b, w, g[X], g[X + 1], H, N, H, N, L), X += 4;
                      break;
                    case a.OPS.closePath:
                      U.closePath();
                      break;
                  }
                D && _.updateScalingPathMinMax(O, L), _.setCurrentPoint(H, N);
              }
              closePath() {
                this.ctx.closePath();
              }
              stroke() {
                let A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                const g = this.ctx, I = this.current.strokeColor;
                g.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof I == "object" && I?.getPattern ? (g.save(), g.strokeStyle = I.getPattern(g, this, (0, f.getCurrentTransformInverse)(g), S.PathType.STROKE), this.rescaleAndStroke(!1), g.restore()) : this.rescaleAndStroke(!0)), A && this.consumePath(this.current.getClippedPathBoundingBox()), g.globalAlpha = this.current.fillAlpha;
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              fill() {
                let A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                const g = this.ctx, I = this.current.fillColor, U = this.current.patternFill;
                let _ = !1;
                U && (g.save(), g.fillStyle = I.getPattern(g, this, (0, f.getCurrentTransformInverse)(g), S.PathType.FILL), _ = !0);
                const H = this.current.getClippedPathBoundingBox();
                this.contentVisible && H !== null && (this.pendingEOFill ? (g.fill("evenodd"), this.pendingEOFill = !1) : g.fill()), _ && g.restore(), A && this.consumePath(H);
              }
              eoFill() {
                this.pendingEOFill = !0, this.fill();
              }
              fillStroke() {
                this.fill(!1), this.stroke(!1), this.consumePath();
              }
              eoFillStroke() {
                this.pendingEOFill = !0, this.fillStroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.pendingEOFill = !0, this.closePath(), this.fillStroke();
              }
              endPath() {
                this.consumePath();
              }
              clip() {
                this.pendingClip = j;
              }
              eoClip() {
                this.pendingClip = G;
              }
              beginText() {
                this.current.textMatrix = a.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              endText() {
                const A = this.pendingTextPaths, g = this.ctx;
                if (A === void 0) {
                  g.beginPath();
                  return;
                }
                g.save(), g.beginPath();
                for (const I of A)
                  g.setTransform(...I.transform), g.translate(I.x, I.y), I.addToPath(g, I.fontSize);
                g.restore(), g.clip(), g.beginPath(), delete this.pendingTextPaths;
              }
              setCharSpacing(A) {
                this.current.charSpacing = A;
              }
              setWordSpacing(A) {
                this.current.wordSpacing = A;
              }
              setHScale(A) {
                this.current.textHScale = A / 100;
              }
              setLeading(A) {
                this.current.leading = -A;
              }
              setFont(A, g) {
                const I = this.commonObjs.get(A), U = this.current;
                if (!I)
                  throw new Error(`Can't find font for ${A}`);
                if (U.fontMatrix = I.fontMatrix || a.FONT_IDENTITY_MATRIX, (U.fontMatrix[0] === 0 || U.fontMatrix[3] === 0) && (0, a.warn)("Invalid font matrix for font " + A), g < 0 ? (g = -g, U.fontDirection = -1) : U.fontDirection = 1, this.current.font = I, this.current.fontSize = g, I.isType3Font)
                  return;
                const _ = I.loadedName || "sans-serif", H = I.systemFontInfo?.css || `"${_}", ${I.fallbackName}`;
                let N = "normal";
                I.black ? N = "900" : I.bold && (N = "bold");
                const b = I.italic ? "italic" : "normal";
                let w = g;
                g < v ? w = v : g > T && (w = T), this.current.fontSizeScale = g / w, this.ctx.font = `${b} ${N} ${w}px ${H}`;
              }
              setTextRenderingMode(A) {
                this.current.textRenderingMode = A;
              }
              setTextRise(A) {
                this.current.textRise = A;
              }
              moveText(A, g) {
                this.current.x = this.current.lineX += A, this.current.y = this.current.lineY += g;
              }
              setLeadingMoveText(A, g) {
                this.setLeading(-g), this.moveText(A, g);
              }
              setTextMatrix(A, g, I, U, _, H) {
                this.current.textMatrix = [A, g, I, U, _, H], this.current.textMatrixScale = Math.hypot(A, g), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              paintChar(A, g, I, U) {
                const _ = this.ctx, H = this.current, N = H.font, b = H.textRenderingMode, w = H.fontSize / H.fontSizeScale, O = b & a.TextRenderingMode.FILL_STROKE_MASK, D = !!(b & a.TextRenderingMode.ADD_TO_PATH_FLAG), L = H.patternFill && !N.missingFile;
                let W;
                (N.disableFontFace || D || L) && (W = N.getPathGenerator(this.commonObjs, A)), N.disableFontFace || L ? (_.save(), _.translate(g, I), _.beginPath(), W(_, w), U && _.setTransform(...U), (O === a.TextRenderingMode.FILL || O === a.TextRenderingMode.FILL_STROKE) && _.fill(), (O === a.TextRenderingMode.STROKE || O === a.TextRenderingMode.FILL_STROKE) && _.stroke(), _.restore()) : ((O === a.TextRenderingMode.FILL || O === a.TextRenderingMode.FILL_STROKE) && _.fillText(A, g, I), (O === a.TextRenderingMode.STROKE || O === a.TextRenderingMode.FILL_STROKE) && _.strokeText(A, g, I)), D && (this.pendingTextPaths ||= []).push({
                  transform: (0, f.getCurrentTransform)(_),
                  x: g,
                  y: I,
                  fontSize: w,
                  addToPath: W
                });
              }
              get isFontSubpixelAAEnabled() {
                const {
                  context: A
                } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                A.scale(1.5, 1), A.fillText("I", 0, 10);
                const g = A.getImageData(0, 0, 10, 10).data;
                let I = !1;
                for (let U = 3; U < g.length; U += 4)
                  if (g[U] > 0 && g[U] < 255) {
                    I = !0;
                    break;
                  }
                return (0, a.shadow)(this, "isFontSubpixelAAEnabled", I);
              }
              showText(A) {
                const g = this.current, I = g.font;
                if (I.isType3Font)
                  return this.showType3Text(A);
                const U = g.fontSize;
                if (U === 0)
                  return;
                const _ = this.ctx, H = g.fontSizeScale, N = g.charSpacing, b = g.wordSpacing, w = g.fontDirection, O = g.textHScale * w, D = A.length, L = I.vertical, W = L ? 1 : -1, X = I.defaultVMetrics, q = U * g.fontMatrix[0], ct = g.textRenderingMode === a.TextRenderingMode.FILL && !I.disableFontFace && !g.patternFill;
                _.save(), _.transform(...g.textMatrix), _.translate(g.x, g.y + g.textRise), w > 0 ? _.scale(O, -1) : _.scale(O, 1);
                let nt;
                if (g.patternFill) {
                  _.save();
                  const at = g.fillColor.getPattern(_, this, (0, f.getCurrentTransformInverse)(_), S.PathType.FILL);
                  nt = (0, f.getCurrentTransform)(_), _.restore(), _.fillStyle = at;
                }
                let Y = g.lineWidth;
                const Q = g.textMatrixScale;
                if (Q === 0 || Y === 0) {
                  const at = g.textRenderingMode & a.TextRenderingMode.FILL_STROKE_MASK;
                  (at === a.TextRenderingMode.STROKE || at === a.TextRenderingMode.FILL_STROKE) && (Y = this.getSinglePixelWidth());
                } else
                  Y /= Q;
                if (H !== 1 && (_.scale(H, H), Y /= H), _.lineWidth = Y, I.isInvalidPDFjsFont) {
                  const at = [];
                  let lt = 0;
                  for (const ft of A)
                    at.push(ft.unicode), lt += ft.width;
                  _.fillText(at.join(""), 0, 0), g.x += lt * q * O, _.restore(), this.compose();
                  return;
                }
                let et = 0, Z;
                for (Z = 0; Z < D; ++Z) {
                  const at = A[Z];
                  if (typeof at == "number") {
                    et += W * at * U / 1e3;
                    continue;
                  }
                  let lt = !1;
                  const ft = (at.isSpace ? b : 0) + N, pt = at.fontChar, vt = at.accent;
                  let yt, xt, wt = at.width;
                  if (L) {
                    const Ct = at.vmetric || X, Mt = -(at.vmetric ? Ct[1] : wt * 0.5) * q, Rt = Ct[2] * q;
                    wt = Ct ? -Ct[0] : wt, yt = Mt / H, xt = (et + Rt) / H;
                  } else
                    yt = et / H, xt = 0;
                  if (I.remeasure && wt > 0) {
                    const Ct = _.measureText(pt).width * 1e3 / U * H;
                    if (wt < Ct && this.isFontSubpixelAAEnabled) {
                      const Mt = wt / Ct;
                      lt = !0, _.save(), _.scale(Mt, 1), yt /= Mt;
                    } else wt !== Ct && (yt += (wt - Ct) / 2e3 * U / H);
                  }
                  if (this.contentVisible && (at.isInFont || I.missingFile)) {
                    if (ct && !vt)
                      _.fillText(pt, yt, xt);
                    else if (this.paintChar(pt, yt, xt, nt), vt) {
                      const Ct = yt + U * vt.offset.x / H, Mt = xt - U * vt.offset.y / H;
                      this.paintChar(vt.fontChar, Ct, Mt, nt);
                    }
                  }
                  const _t = L ? wt * q - ft * w : wt * q + ft * w;
                  et += _t, lt && _.restore();
                }
                L ? g.y -= et : g.x += et * O, _.restore(), this.compose();
              }
              showType3Text(A) {
                const g = this.ctx, I = this.current, U = I.font, _ = I.fontSize, H = I.fontDirection, N = U.vertical ? 1 : -1, b = I.charSpacing, w = I.wordSpacing, O = I.textHScale * H, D = I.fontMatrix || a.FONT_IDENTITY_MATRIX, L = A.length, W = I.textRenderingMode === a.TextRenderingMode.INVISIBLE;
                let X, q, ct, nt;
                if (!(W || _ === 0)) {
                  for (this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null, g.save(), g.transform(...I.textMatrix), g.translate(I.x, I.y), g.scale(O, H), X = 0; X < L; ++X) {
                    if (q = A[X], typeof q == "number") {
                      nt = N * q * _ / 1e3, this.ctx.translate(nt, 0), I.x += nt * O;
                      continue;
                    }
                    const Y = (q.isSpace ? w : 0) + b, Q = U.charProcOperatorList[q.operatorListId];
                    if (!Q) {
                      (0, a.warn)(`Type3 character "${q.operatorListId}" is not available.`);
                      continue;
                    }
                    this.contentVisible && (this.processingType3 = q, this.save(), g.scale(_, _), g.transform(...D), this.executeOperatorList(Q), this.restore()), ct = a.Util.applyTransform([q.width, 0], D)[0] * _ + Y, g.translate(ct, 0), I.x += ct * O;
                  }
                  g.restore(), this.processingType3 = null;
                }
              }
              setCharWidth(A, g) {
              }
              setCharWidthAndBounds(A, g, I, U, _, H) {
                this.ctx.rect(I, U, _ - I, H - U), this.ctx.clip(), this.endPath();
              }
              getColorN_Pattern(A) {
                let g;
                if (A[0] === "TilingPattern") {
                  const I = A[1], U = this.baseTransform || (0, f.getCurrentTransform)(this.ctx), _ = {
                    createCanvasGraphics: (H) => new M(H, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                      optionalContentConfig: this.optionalContentConfig,
                      markedContentStack: this.markedContentStack
                    })
                  };
                  g = new S.TilingPattern(A, I, this.ctx, _, U);
                } else
                  g = this._getPattern(A[1], A[2]);
                return g;
              }
              setStrokeColorN() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              }
              setFillColorN() {
                this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
              }
              setStrokeRGBColor(A, g, I) {
                const U = a.Util.makeHexColor(A, g, I);
                this.ctx.strokeStyle = U, this.current.strokeColor = U;
              }
              setFillRGBColor(A, g, I) {
                const U = a.Util.makeHexColor(A, g, I);
                this.ctx.fillStyle = U, this.current.fillColor = U, this.current.patternFill = !1;
              }
              _getPattern(A) {
                let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, I;
                return this.cachedPatterns.has(A) ? I = this.cachedPatterns.get(A) : (I = (0, S.getShadingPattern)(this.getObject(A)), this.cachedPatterns.set(A, I)), g && (I.matrix = g), I;
              }
              shadingFill(A) {
                if (!this.contentVisible)
                  return;
                const g = this.ctx;
                this.save();
                const I = this._getPattern(A);
                g.fillStyle = I.getPattern(g, this, (0, f.getCurrentTransformInverse)(g), S.PathType.SHADING);
                const U = (0, f.getCurrentTransformInverse)(g);
                if (U) {
                  const {
                    width: _,
                    height: H
                  } = g.canvas, [N, b, w, O] = a.Util.getAxialAlignedBoundingBox([0, 0, _, H], U);
                  this.ctx.fillRect(N, b, w - N, O - b);
                } else
                  this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                this.compose(this.current.getClippedPathBoundingBox()), this.restore();
              }
              beginInlineImage() {
                (0, a.unreachable)("Should not call beginInlineImage");
              }
              beginImageData() {
                (0, a.unreachable)("Should not call beginImageData");
              }
              paintFormXObjectBegin(A, g) {
                if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(A) && A.length === 6 && this.transform(...A), this.baseTransform = (0, f.getCurrentTransform)(this.ctx), g)) {
                  const I = g[2] - g[0], U = g[3] - g[1];
                  this.ctx.rect(g[0], g[1], I, U), this.current.updateRectMinMax((0, f.getCurrentTransform)(this.ctx), g), this.clip(), this.endPath();
                }
              }
              paintFormXObjectEnd() {
                this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
              }
              beginGroup(A) {
                if (!this.contentVisible)
                  return;
                this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
                const g = this.ctx;
                A.isolated || (0, a.info)("TODO: Support non-isolated groups."), A.knockout && (0, a.warn)("Knockout groups not supported.");
                const I = (0, f.getCurrentTransform)(g);
                if (A.matrix && g.transform(...A.matrix), !A.bbox)
                  throw new Error("Bounding box is required.");
                let U = a.Util.getAxialAlignedBoundingBox(A.bbox, (0, f.getCurrentTransform)(g));
                const _ = [0, 0, g.canvas.width, g.canvas.height];
                U = a.Util.intersect(U, _) || [0, 0, 0, 0];
                const H = Math.floor(U[0]), N = Math.floor(U[1]);
                let b = Math.max(Math.ceil(U[2]) - H, 1), w = Math.max(Math.ceil(U[3]) - N, 1), O = 1, D = 1;
                b > i && (O = b / i, b = i), w > i && (D = w / i, w = i), this.current.startNewPathAndClipBox([0, 0, b, w]);
                let L = "groupAt" + this.groupLevel;
                A.smask && (L += "_smask_" + this.smaskCounter++ % 2);
                const W = this.cachedCanvases.getCanvas(L, b, w), X = W.context;
                X.scale(1 / O, 1 / D), X.translate(-H, -N), X.transform(...I), A.smask ? this.smaskStack.push({
                  canvas: W.canvas,
                  context: X,
                  offsetX: H,
                  offsetY: N,
                  scaleX: O,
                  scaleY: D,
                  subtype: A.smask.subtype,
                  backdrop: A.smask.backdrop,
                  transferMap: A.smask.transferMap || null,
                  startTransformInverse: null
                }) : (g.setTransform(1, 0, 0, 1, 0, 0), g.translate(H, N), g.scale(O, D), g.save()), s(g, X), this.ctx = X, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(g), this.groupLevel++;
              }
              endGroup(A) {
                if (!this.contentVisible)
                  return;
                this.groupLevel--;
                const g = this.ctx, I = this.groupStack.pop();
                if (this.ctx = I, this.ctx.imageSmoothingEnabled = !1, A.smask)
                  this.tempSMask = this.smaskStack.pop(), this.restore();
                else {
                  this.ctx.restore();
                  const U = (0, f.getCurrentTransform)(this.ctx);
                  this.restore(), this.ctx.save(), this.ctx.setTransform(...U);
                  const _ = a.Util.getAxialAlignedBoundingBox([0, 0, g.canvas.width, g.canvas.height], U);
                  this.ctx.drawImage(g.canvas, 0, 0), this.ctx.restore(), this.compose(_);
                }
              }
              beginAnnotation(A, g, I, U, _) {
                if (this.#t(), m(this.ctx), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Array.isArray(g) && g.length === 4) {
                  const H = g[2] - g[0], N = g[3] - g[1];
                  if (_ && this.annotationCanvasMap) {
                    I = I.slice(), I[4] -= g[0], I[5] -= g[1], g = g.slice(), g[0] = g[1] = 0, g[2] = H, g[3] = N;
                    const [b, w] = a.Util.singularValueDecompose2dScale((0, f.getCurrentTransform)(this.ctx)), {
                      viewportScale: O
                    } = this, D = Math.ceil(H * this.outputScaleX * O), L = Math.ceil(N * this.outputScaleY * O);
                    this.annotationCanvas = this.canvasFactory.create(D, L);
                    const {
                      canvas: W,
                      context: X
                    } = this.annotationCanvas;
                    this.annotationCanvasMap.set(A, W), this.annotationCanvas.savedCtx = this.ctx, this.ctx = X, this.ctx.save(), this.ctx.setTransform(b, 0, 0, -w, 0, N * w), m(this.ctx);
                  } else
                    m(this.ctx), this.ctx.rect(g[0], g[1], H, N), this.ctx.clip(), this.endPath();
                }
                this.current = new y(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...I), this.transform(...U);
              }
              endAnnotation() {
                this.annotationCanvas && (this.ctx.restore(), this.#e(), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
              }
              paintImageMaskXObject(A) {
                if (!this.contentVisible)
                  return;
                const g = A.count;
                A = this.getObject(A.data, A), A.count = g;
                const I = this.ctx, U = this.processingType3;
                if (U && (U.compiled === void 0 && (U.compiled = c(A)), U.compiled)) {
                  U.compiled(I);
                  return;
                }
                const _ = this._createMaskCanvas(A), H = _.canvas;
                I.save(), I.setTransform(1, 0, 0, 1, 0, 0), I.drawImage(H, _.offsetX, _.offsetY), I.restore(), this.compose();
              }
              paintImageMaskXObjectRepeat(A, g) {
                let I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, U = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, _ = arguments.length > 4 ? arguments[4] : void 0, H = arguments.length > 5 ? arguments[5] : void 0;
                if (!this.contentVisible)
                  return;
                A = this.getObject(A.data, A);
                const N = this.ctx;
                N.save();
                const b = (0, f.getCurrentTransform)(N);
                N.transform(g, I, U, _, 0, 0);
                const w = this._createMaskCanvas(A);
                N.setTransform(1, 0, 0, 1, w.offsetX - b[4], w.offsetY - b[5]);
                for (let O = 0, D = H.length; O < D; O += 2) {
                  const L = a.Util.transform(b, [g, I, U, _, H[O], H[O + 1]]), [W, X] = a.Util.applyTransform([0, 0], L);
                  N.drawImage(w.canvas, W, X);
                }
                N.restore(), this.compose();
              }
              paintImageMaskXObjectGroup(A) {
                if (!this.contentVisible)
                  return;
                const g = this.ctx, I = this.current.fillColor, U = this.current.patternFill;
                for (const _ of A) {
                  const {
                    data: H,
                    width: N,
                    height: b,
                    transform: w
                  } = _, O = this.cachedCanvases.getCanvas("maskCanvas", N, b), D = O.context;
                  D.save();
                  const L = this.getObject(H, _);
                  R(D, L), D.globalCompositeOperation = "source-in", D.fillStyle = U ? I.getPattern(D, this, (0, f.getCurrentTransformInverse)(g), S.PathType.FILL) : I, D.fillRect(0, 0, N, b), D.restore(), g.save(), g.transform(...w), g.scale(1, -1), u(g, O.canvas, 0, 0, N, b, 0, -1, 1, 1), g.restore();
                }
                this.compose();
              }
              paintImageXObject(A) {
                if (!this.contentVisible)
                  return;
                const g = this.getObject(A);
                if (!g) {
                  (0, a.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(g);
              }
              paintImageXObjectRepeat(A, g, I, U) {
                if (!this.contentVisible)
                  return;
                const _ = this.getObject(A);
                if (!_) {
                  (0, a.warn)("Dependent image isn't ready yet");
                  return;
                }
                const H = _.width, N = _.height, b = [];
                for (let w = 0, O = U.length; w < O; w += 2)
                  b.push({
                    transform: [g, 0, 0, I, U[w], U[w + 1]],
                    x: 0,
                    y: 0,
                    w: H,
                    h: N
                  });
                this.paintInlineImageXObjectGroup(_, b);
              }
              applyTransferMapsToCanvas(A) {
                return this.current.transferMaps !== "none" && (A.filter = this.current.transferMaps, A.drawImage(A.canvas, 0, 0), A.filter = "none"), A.canvas;
              }
              applyTransferMapsToBitmap(A) {
                if (this.current.transferMaps === "none")
                  return A.bitmap;
                const {
                  bitmap: g,
                  width: I,
                  height: U
                } = A, _ = this.cachedCanvases.getCanvas("inlineImage", I, U), H = _.context;
                return H.filter = this.current.transferMaps, H.drawImage(g, 0, 0), H.filter = "none", _.canvas;
              }
              paintInlineImageXObject(A) {
                if (!this.contentVisible)
                  return;
                const g = A.width, I = A.height, U = this.ctx;
                if (this.save(), !a.isNodeJS) {
                  const {
                    filter: N
                  } = U;
                  N !== "none" && N !== "" && (U.filter = "none");
                }
                U.scale(1 / g, -1 / I);
                let _;
                if (A.bitmap)
                  _ = this.applyTransferMapsToBitmap(A);
                else if (typeof HTMLElement == "function" && A instanceof HTMLElement || !A.data)
                  _ = A;
                else {
                  const b = this.cachedCanvases.getCanvas("inlineImage", g, I).context;
                  C(b, A), _ = this.applyTransferMapsToCanvas(b);
                }
                const H = this._scaleImage(_, (0, f.getCurrentTransformInverse)(U));
                U.imageSmoothingEnabled = K((0, f.getCurrentTransform)(U), A.interpolate), u(U, H.img, 0, 0, H.paintWidth, H.paintHeight, 0, -I, g, I), this.compose(), this.restore();
              }
              paintInlineImageXObjectGroup(A, g) {
                if (!this.contentVisible)
                  return;
                const I = this.ctx;
                let U;
                if (A.bitmap)
                  U = A.bitmap;
                else {
                  const _ = A.width, H = A.height, b = this.cachedCanvases.getCanvas("inlineImage", _, H).context;
                  C(b, A), U = this.applyTransferMapsToCanvas(b);
                }
                for (const _ of g)
                  I.save(), I.transform(..._.transform), I.scale(1, -1), u(I, U, _.x, _.y, _.w, _.h, 0, -1, 1, 1), I.restore();
                this.compose();
              }
              paintSolidColorImageMask() {
                this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
              }
              markPoint(A) {
              }
              markPointProps(A, g) {
              }
              beginMarkedContent(A) {
                this.markedContentStack.push({
                  visible: !0
                });
              }
              beginMarkedContentProps(A, g) {
                A === "OC" ? this.markedContentStack.push({
                  visible: this.optionalContentConfig.isVisible(g)
                }) : this.markedContentStack.push({
                  visible: !0
                }), this.contentVisible = this.isContentVisible();
              }
              endMarkedContent() {
                this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
              }
              beginCompat() {
              }
              endCompat() {
              }
              consumePath(A) {
                const g = this.current.isEmptyClip();
                this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(A);
                const I = this.ctx;
                this.pendingClip && (g || (this.pendingClip === G ? I.clip("evenodd") : I.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), I.beginPath();
              }
              getSinglePixelWidth() {
                if (!this._cachedGetSinglePixelWidth) {
                  const A = (0, f.getCurrentTransform)(this.ctx);
                  if (A[1] === 0 && A[2] === 0)
                    this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(A[0]), Math.abs(A[3]));
                  else {
                    const g = Math.abs(A[0] * A[3] - A[2] * A[1]), I = Math.hypot(A[0], A[2]), U = Math.hypot(A[1], A[3]);
                    this._cachedGetSinglePixelWidth = Math.max(I, U) / g;
                  }
                }
                return this._cachedGetSinglePixelWidth;
              }
              getScaleForStroking() {
                if (this._cachedScaleForStroking[0] === -1) {
                  const {
                    lineWidth: A
                  } = this.current, {
                    a: g,
                    b: I,
                    c: U,
                    d: _
                  } = this.ctx.getTransform();
                  let H, N;
                  if (I === 0 && U === 0) {
                    const b = Math.abs(g), w = Math.abs(_);
                    if (b === w)
                      if (A === 0)
                        H = N = 1 / b;
                      else {
                        const O = b * A;
                        H = N = O < 1 ? 1 / O : 1;
                      }
                    else if (A === 0)
                      H = 1 / b, N = 1 / w;
                    else {
                      const O = b * A, D = w * A;
                      H = O < 1 ? 1 / O : 1, N = D < 1 ? 1 / D : 1;
                    }
                  } else {
                    const b = Math.abs(g * _ - I * U), w = Math.hypot(g, I), O = Math.hypot(U, _);
                    if (A === 0)
                      H = O / b, N = w / b;
                    else {
                      const D = A * b;
                      H = O > D ? O / D : 1, N = w > D ? w / D : 1;
                    }
                  }
                  this._cachedScaleForStroking[0] = H, this._cachedScaleForStroking[1] = N;
                }
                return this._cachedScaleForStroking;
              }
              rescaleAndStroke(A) {
                const {
                  ctx: g
                } = this, {
                  lineWidth: I
                } = this.current, [U, _] = this.getScaleForStroking();
                if (g.lineWidth = I || 1, U === 1 && _ === 1) {
                  g.stroke();
                  return;
                }
                const H = g.getLineDash();
                if (A && g.save(), g.scale(U, _), H.length > 0) {
                  const N = Math.max(U, _);
                  g.setLineDash(H.map((b) => b / N)), g.lineDashOffset /= N;
                }
                g.stroke(), A && g.restore();
              }
              isContentVisible() {
                for (let A = this.markedContentStack.length - 1; A >= 0; A--)
                  if (!this.markedContentStack[A].visible)
                    return !1;
                return !0;
              }
            }
            p.CanvasGraphics = M;
            for (const x in a.OPS)
              M.prototype[x] !== void 0 && (M.prototype[a.OPS[x]] = M.prototype[x]);
          }),
          /* 174 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.TilingPattern = p.PathType = void 0, p.getShadingPattern = h, t(2);
            var a = t(1), f = t(168);
            const S = {
              FILL: "Fill",
              STROKE: "Stroke",
              SHADING: "Shading"
            };
            p.PathType = S;
            function E(u, c) {
              if (!c)
                return;
              const y = c[2] - c[0], C = c[3] - c[1], R = new Path2D();
              R.rect(c[0], c[1], y, C), u.clip(R);
            }
            class v {
              constructor() {
                this.constructor === v && (0, a.unreachable)("Cannot initialize BaseShadingPattern.");
              }
              getPattern() {
                (0, a.unreachable)("Abstract method `getPattern` called.");
              }
            }
            class T extends v {
              constructor(c) {
                super(), this._type = c[1], this._bbox = c[2], this._colorStops = c[3], this._p0 = c[4], this._p1 = c[5], this._r0 = c[6], this._r1 = c[7], this.matrix = null;
              }
              _createGradient(c) {
                let y;
                this._type === "axial" ? y = c.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (y = c.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
                for (const C of this._colorStops)
                  y.addColorStop(C[0], C[1]);
                return y;
              }
              getPattern(c, y, C, R) {
                let s;
                if (R === S.STROKE || R === S.FILL) {
                  const m = y.current.getClippedPathBoundingBox(R, (0, f.getCurrentTransform)(c)) || [0, 0, 0, 0], F = Math.ceil(m[2] - m[0]) || 1, B = Math.ceil(m[3] - m[1]) || 1, k = y.cachedCanvases.getCanvas("pattern", F, B, !0), V = k.context;
                  V.clearRect(0, 0, V.canvas.width, V.canvas.height), V.beginPath(), V.rect(0, 0, V.canvas.width, V.canvas.height), V.translate(-m[0], -m[1]), C = a.Util.transform(C, [1, 0, 0, 1, m[0], m[1]]), V.transform(...y.baseTransform), this.matrix && V.transform(...this.matrix), E(V, this._bbox), V.fillStyle = this._createGradient(V), V.fill(), s = c.createPattern(k.canvas, "no-repeat");
                  const z = new DOMMatrix(C);
                  s.setTransform(z);
                } else
                  E(c, this._bbox), s = this._createGradient(c);
                return s;
              }
            }
            function i(u, c, y, C, R, s, m, F) {
              const B = c.coords, k = c.colors, V = u.data, z = u.width * 4;
              let K;
              B[y + 1] > B[C + 1] && (K = y, y = C, C = K, K = s, s = m, m = K), B[C + 1] > B[R + 1] && (K = C, C = R, R = K, K = m, m = F, F = K), B[y + 1] > B[C + 1] && (K = y, y = C, C = K, K = s, s = m, m = K);
              const J = (B[y] + c.offsetX) * c.scaleX, $ = (B[y + 1] + c.offsetY) * c.scaleY, j = (B[C] + c.offsetX) * c.scaleX, G = (B[C + 1] + c.offsetY) * c.scaleY, M = (B[R] + c.offsetX) * c.scaleX, x = (B[R + 1] + c.offsetY) * c.scaleY;
              if ($ >= x)
                return;
              const A = k[s], g = k[s + 1], I = k[s + 2], U = k[m], _ = k[m + 1], H = k[m + 2], N = k[F], b = k[F + 1], w = k[F + 2], O = Math.round($), D = Math.round(x);
              let L, W, X, q, ct, nt, Y, Q;
              for (let et = O; et <= D; et++) {
                if (et < G) {
                  const pt = et < $ ? 0 : ($ - et) / ($ - G);
                  L = J - (J - j) * pt, W = A - (A - U) * pt, X = g - (g - _) * pt, q = I - (I - H) * pt;
                } else {
                  let pt;
                  et > x ? pt = 1 : G === x ? pt = 0 : pt = (G - et) / (G - x), L = j - (j - M) * pt, W = U - (U - N) * pt, X = _ - (_ - b) * pt, q = H - (H - w) * pt;
                }
                let Z;
                et < $ ? Z = 0 : et > x ? Z = 1 : Z = ($ - et) / ($ - x), ct = J - (J - M) * Z, nt = A - (A - N) * Z, Y = g - (g - b) * Z, Q = I - (I - w) * Z;
                const at = Math.round(Math.min(L, ct)), lt = Math.round(Math.max(L, ct));
                let ft = z * et + at * 4;
                for (let pt = at; pt <= lt; pt++)
                  Z = (L - pt) / (L - ct), Z < 0 ? Z = 0 : Z > 1 && (Z = 1), V[ft++] = W - (W - nt) * Z | 0, V[ft++] = X - (X - Y) * Z | 0, V[ft++] = q - (q - Q) * Z | 0, V[ft++] = 255;
              }
            }
            function n(u, c, y) {
              const C = c.coords, R = c.colors;
              let s, m;
              switch (c.type) {
                case "lattice":
                  const F = c.verticesPerRow, B = Math.floor(C.length / F) - 1, k = F - 1;
                  for (s = 0; s < B; s++) {
                    let V = s * F;
                    for (let z = 0; z < k; z++, V++)
                      i(u, y, C[V], C[V + 1], C[V + F], R[V], R[V + 1], R[V + F]), i(u, y, C[V + F + 1], C[V + 1], C[V + F], R[V + F + 1], R[V + 1], R[V + F]);
                  }
                  break;
                case "triangles":
                  for (s = 0, m = C.length; s < m; s += 3)
                    i(u, y, C[s], C[s + 1], C[s + 2], R[s], R[s + 1], R[s + 2]);
                  break;
                default:
                  throw new Error("illegal figure");
              }
            }
            class o extends v {
              constructor(c) {
                super(), this._coords = c[2], this._colors = c[3], this._figures = c[4], this._bounds = c[5], this._bbox = c[7], this._background = c[8], this.matrix = null;
              }
              _createMeshCanvas(c, y, C) {
                const F = Math.floor(this._bounds[0]), B = Math.floor(this._bounds[1]), k = Math.ceil(this._bounds[2]) - F, V = Math.ceil(this._bounds[3]) - B, z = Math.min(Math.ceil(Math.abs(k * c[0] * 1.1)), 3e3), K = Math.min(Math.ceil(Math.abs(V * c[1] * 1.1)), 3e3), J = k / z, $ = V / K, j = {
                  coords: this._coords,
                  colors: this._colors,
                  offsetX: -F,
                  offsetY: -B,
                  scaleX: 1 / J,
                  scaleY: 1 / $
                }, G = z + 4, M = K + 4, x = C.getCanvas("mesh", G, M, !1), A = x.context, g = A.createImageData(z, K);
                if (y) {
                  const U = g.data;
                  for (let _ = 0, H = U.length; _ < H; _ += 4)
                    U[_] = y[0], U[_ + 1] = y[1], U[_ + 2] = y[2], U[_ + 3] = 255;
                }
                for (const U of this._figures)
                  n(g, U, j);
                return A.putImageData(g, 2, 2), {
                  canvas: x.canvas,
                  offsetX: F - 2 * J,
                  offsetY: B - 2 * $,
                  scaleX: J,
                  scaleY: $
                };
              }
              getPattern(c, y, C, R) {
                E(c, this._bbox);
                let s;
                if (R === S.SHADING)
                  s = a.Util.singularValueDecompose2dScale((0, f.getCurrentTransform)(c));
                else if (s = a.Util.singularValueDecompose2dScale(y.baseTransform), this.matrix) {
                  const F = a.Util.singularValueDecompose2dScale(this.matrix);
                  s = [s[0] * F[0], s[1] * F[1]];
                }
                const m = this._createMeshCanvas(s, R === S.SHADING ? null : this._background, y.cachedCanvases);
                return R !== S.SHADING && (c.setTransform(...y.baseTransform), this.matrix && c.transform(...this.matrix)), c.translate(m.offsetX, m.offsetY), c.scale(m.scaleX, m.scaleY), c.createPattern(m.canvas, "no-repeat");
              }
            }
            class d extends v {
              getPattern() {
                return "hotpink";
              }
            }
            function h(u) {
              switch (u[0]) {
                case "RadialAxial":
                  return new T(u);
                case "Mesh":
                  return new o(u);
                case "Dummy":
                  return new d();
              }
              throw new Error(`Unknown IR type: ${u[0]}`);
            }
            const e = {
              COLORED: 1,
              UNCOLORED: 2
            };
            class l {
              static MAX_PATTERN_SIZE = 3e3;
              constructor(c, y, C, R, s) {
                this.operatorList = c[2], this.matrix = c[3] || [1, 0, 0, 1, 0, 0], this.bbox = c[4], this.xstep = c[5], this.ystep = c[6], this.paintType = c[7], this.tilingType = c[8], this.color = y, this.ctx = C, this.canvasGraphicsFactory = R, this.baseTransform = s;
              }
              createPatternCanvas(c) {
                const y = this.operatorList, C = this.bbox, R = this.xstep, s = this.ystep, m = this.paintType, F = this.tilingType, B = this.color, k = this.canvasGraphicsFactory;
                (0, a.info)("TilingType: " + F);
                const V = C[0], z = C[1], K = C[2], J = C[3], $ = a.Util.singularValueDecompose2dScale(this.matrix), j = a.Util.singularValueDecompose2dScale(this.baseTransform), G = [$[0] * j[0], $[1] * j[1]], M = this.getSizeAndScale(R, this.ctx.canvas.width, G[0]), x = this.getSizeAndScale(s, this.ctx.canvas.height, G[1]), A = c.cachedCanvases.getCanvas("pattern", M.size, x.size, !0), g = A.context, I = k.createCanvasGraphics(g);
                I.groupLevel = c.groupLevel, this.setFillAndStrokeStyleToContext(I, m, B);
                let U = V, _ = z, H = K, N = J;
                return V < 0 && (U = 0, H += Math.abs(V)), z < 0 && (_ = 0, N += Math.abs(z)), g.translate(-(M.scale * U), -(x.scale * _)), I.transform(M.scale, 0, 0, x.scale, 0, 0), g.save(), this.clipBbox(I, U, _, H, N), I.baseTransform = (0, f.getCurrentTransform)(I.ctx), I.executeOperatorList(y), I.endDrawing(), {
                  canvas: A.canvas,
                  scaleX: M.scale,
                  scaleY: x.scale,
                  offsetX: U,
                  offsetY: _
                };
              }
              getSizeAndScale(c, y, C) {
                c = Math.abs(c);
                const R = Math.max(l.MAX_PATTERN_SIZE, y);
                let s = Math.ceil(c * C);
                return s >= R ? s = R : C = s / c, {
                  scale: C,
                  size: s
                };
              }
              clipBbox(c, y, C, R, s) {
                const m = R - y, F = s - C;
                c.ctx.rect(y, C, m, F), c.current.updateRectMinMax((0, f.getCurrentTransform)(c.ctx), [y, C, R, s]), c.clip(), c.endPath();
              }
              setFillAndStrokeStyleToContext(c, y, C) {
                const R = c.ctx, s = c.current;
                switch (y) {
                  case e.COLORED:
                    const m = this.ctx;
                    R.fillStyle = m.fillStyle, R.strokeStyle = m.strokeStyle, s.fillColor = m.fillStyle, s.strokeColor = m.strokeStyle;
                    break;
                  case e.UNCOLORED:
                    const F = a.Util.makeHexColor(C[0], C[1], C[2]);
                    R.fillStyle = F, R.strokeStyle = F, s.fillColor = F, s.strokeColor = F;
                    break;
                  default:
                    throw new a.FormatError(`Unsupported paint type: ${y}`);
                }
              }
              getPattern(c, y, C, R) {
                let s = C;
                R !== S.SHADING && (s = a.Util.transform(s, y.baseTransform), this.matrix && (s = a.Util.transform(s, this.matrix)));
                const m = this.createPatternCanvas(y);
                let F = new DOMMatrix(s);
                F = F.translate(m.offsetX, m.offsetY), F = F.scale(1 / m.scaleX, 1 / m.scaleY);
                const B = c.createPattern(m.canvas, "repeat");
                return B.setTransform(F), B;
              }
            }
            p.TilingPattern = l;
          }),
          /* 175 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.convertBlackAndWhiteToRGBA = S, p.convertToRGBA = f, p.grayToRGBA = v, t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123);
            var a = t(1);
            function f(T) {
              switch (T.kind) {
                case a.ImageKind.GRAYSCALE_1BPP:
                  return S(T);
                case a.ImageKind.RGB_24BPP:
                  return E(T);
              }
              return null;
            }
            function S(T) {
              let {
                src: i,
                srcPos: n = 0,
                dest: o,
                width: d,
                height: h,
                nonBlackColor: e = 4294967295,
                inverseDecode: l = !1
              } = T;
              const u = a.FeatureTest.isLittleEndian ? 4278190080 : 255, [c, y] = l ? [e, u] : [u, e], C = d >> 3, R = d & 7, s = i.length;
              o = new Uint32Array(o.buffer);
              let m = 0;
              for (let F = 0; F < h; F++) {
                for (const k = n + C; n < k; n++) {
                  const V = n < s ? i[n] : 255;
                  o[m++] = V & 128 ? y : c, o[m++] = V & 64 ? y : c, o[m++] = V & 32 ? y : c, o[m++] = V & 16 ? y : c, o[m++] = V & 8 ? y : c, o[m++] = V & 4 ? y : c, o[m++] = V & 2 ? y : c, o[m++] = V & 1 ? y : c;
                }
                if (R === 0)
                  continue;
                const B = n < s ? i[n++] : 255;
                for (let k = 0; k < R; k++)
                  o[m++] = B & 1 << 7 - k ? y : c;
              }
              return {
                srcPos: n,
                destPos: m
              };
            }
            function E(T) {
              let {
                src: i,
                srcPos: n = 0,
                dest: o,
                destPos: d = 0,
                width: h,
                height: e
              } = T, l = 0;
              const u = i.length >> 2, c = new Uint32Array(i.buffer, n, u);
              if (a.FeatureTest.isLittleEndian) {
                for (; l < u - 2; l += 3, d += 4) {
                  const y = c[l], C = c[l + 1], R = c[l + 2];
                  o[d] = y | 4278190080, o[d + 1] = y >>> 24 | C << 8 | 4278190080, o[d + 2] = C >>> 16 | R << 16 | 4278190080, o[d + 3] = R >>> 8 | 4278190080;
                }
                for (let y = l * 4, C = i.length; y < C; y += 3)
                  o[d++] = i[y] | i[y + 1] << 8 | i[y + 2] << 16 | 4278190080;
              } else {
                for (; l < u - 2; l += 3, d += 4) {
                  const y = c[l], C = c[l + 1], R = c[l + 2];
                  o[d] = y | 255, o[d + 1] = y << 24 | C >>> 8 | 255, o[d + 2] = C << 16 | R >>> 16 | 255, o[d + 3] = R << 8 | 255;
                }
                for (let y = l * 4, C = i.length; y < C; y += 3)
                  o[d++] = i[y] << 24 | i[y + 1] << 16 | i[y + 2] << 8 | 255;
              }
              return {
                srcPos: n,
                destPos: d
              };
            }
            function v(T, i) {
              if (a.FeatureTest.isLittleEndian)
                for (let n = 0, o = T.length; n < o; n++)
                  i[n] = T[n] * 65793 | 4278190080;
              else
                for (let n = 0, o = T.length; n < o; n++)
                  i[n] = T[n] * 16843008 | 255;
            }
          }),
          /* 176 */
          /***/
          ((P, p) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.GlobalWorkerOptions = void 0;
            const t = /* @__PURE__ */ Object.create(null);
            p.GlobalWorkerOptions = t, t.workerPort = null, t.workerSrc = "";
          }),
          /* 177 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.MessageHandler = void 0, t(2);
            var a = t(1);
            const f = {
              DATA: 1,
              ERROR: 2
            }, S = {
              CANCEL: 1,
              CANCEL_COMPLETE: 2,
              CLOSE: 3,
              ENQUEUE: 4,
              ERROR: 5,
              PULL: 6,
              PULL_COMPLETE: 7,
              START_COMPLETE: 8
            };
            function E(T) {
              switch (T instanceof Error || typeof T == "object" && T !== null || (0, a.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), T.name) {
                case "AbortException":
                  return new a.AbortException(T.message);
                case "MissingPDFException":
                  return new a.MissingPDFException(T.message);
                case "PasswordException":
                  return new a.PasswordException(T.message, T.code);
                case "UnexpectedResponseException":
                  return new a.UnexpectedResponseException(T.message, T.status);
                case "UnknownErrorException":
                  return new a.UnknownErrorException(T.message, T.details);
                default:
                  return new a.UnknownErrorException(T.message, T.toString());
              }
            }
            class v {
              constructor(i, n, o) {
                this.sourceName = i, this.targetName = n, this.comObj = o, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (d) => {
                  const h = d.data;
                  if (h.targetName !== this.sourceName)
                    return;
                  if (h.stream) {
                    this.#e(h);
                    return;
                  }
                  if (h.callback) {
                    const l = h.callbackId, u = this.callbackCapabilities[l];
                    if (!u)
                      throw new Error(`Cannot resolve callback ${l}`);
                    if (delete this.callbackCapabilities[l], h.callback === f.DATA)
                      u.resolve(h.data);
                    else if (h.callback === f.ERROR)
                      u.reject(E(h.reason));
                    else
                      throw new Error("Unexpected callback case");
                    return;
                  }
                  const e = this.actionHandler[h.action];
                  if (!e)
                    throw new Error(`Unknown action from worker: ${h.action}`);
                  if (h.callbackId) {
                    const l = this.sourceName, u = h.sourceName;
                    new Promise(function(c) {
                      c(e(h.data));
                    }).then(function(c) {
                      o.postMessage({
                        sourceName: l,
                        targetName: u,
                        callback: f.DATA,
                        callbackId: h.callbackId,
                        data: c
                      });
                    }, function(c) {
                      o.postMessage({
                        sourceName: l,
                        targetName: u,
                        callback: f.ERROR,
                        callbackId: h.callbackId,
                        reason: E(c)
                      });
                    });
                    return;
                  }
                  if (h.streamId) {
                    this.#t(h);
                    return;
                  }
                  e(h.data);
                }, o.addEventListener("message", this._onComObjOnMessage);
              }
              on(i, n) {
                const o = this.actionHandler;
                if (o[i])
                  throw new Error(`There is already an actionName called "${i}"`);
                o[i] = n;
              }
              send(i, n, o) {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: i,
                  data: n
                }, o);
              }
              sendWithPromise(i, n, o) {
                const d = this.callbackId++, h = new a.PromiseCapability();
                this.callbackCapabilities[d] = h;
                try {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: i,
                    callbackId: d,
                    data: n
                  }, o);
                } catch (e) {
                  h.reject(e);
                }
                return h.promise;
              }
              sendWithStream(i, n, o, d) {
                const h = this.streamId++, e = this.sourceName, l = this.targetName, u = this.comObj;
                return new ReadableStream({
                  start: (c) => {
                    const y = new a.PromiseCapability();
                    return this.streamControllers[h] = {
                      controller: c,
                      startCall: y,
                      pullCall: null,
                      cancelCall: null,
                      isClosed: !1
                    }, u.postMessage({
                      sourceName: e,
                      targetName: l,
                      action: i,
                      streamId: h,
                      data: n,
                      desiredSize: c.desiredSize
                    }, d), y.promise;
                  },
                  pull: (c) => {
                    const y = new a.PromiseCapability();
                    return this.streamControllers[h].pullCall = y, u.postMessage({
                      sourceName: e,
                      targetName: l,
                      stream: S.PULL,
                      streamId: h,
                      desiredSize: c.desiredSize
                    }), y.promise;
                  },
                  cancel: (c) => {
                    (0, a.assert)(c instanceof Error, "cancel must have a valid reason");
                    const y = new a.PromiseCapability();
                    return this.streamControllers[h].cancelCall = y, this.streamControllers[h].isClosed = !0, u.postMessage({
                      sourceName: e,
                      targetName: l,
                      stream: S.CANCEL,
                      streamId: h,
                      reason: E(c)
                    }), y.promise;
                  }
                }, o);
              }
              #t(i) {
                const n = i.streamId, o = this.sourceName, d = i.sourceName, h = this.comObj, e = this, l = this.actionHandler[i.action], u = {
                  enqueue(c) {
                    let y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, C = arguments.length > 2 ? arguments[2] : void 0;
                    if (this.isCancelled)
                      return;
                    const R = this.desiredSize;
                    this.desiredSize -= y, R > 0 && this.desiredSize <= 0 && (this.sinkCapability = new a.PromiseCapability(), this.ready = this.sinkCapability.promise), h.postMessage({
                      sourceName: o,
                      targetName: d,
                      stream: S.ENQUEUE,
                      streamId: n,
                      chunk: c
                    }, C);
                  },
                  close() {
                    this.isCancelled || (this.isCancelled = !0, h.postMessage({
                      sourceName: o,
                      targetName: d,
                      stream: S.CLOSE,
                      streamId: n
                    }), delete e.streamSinks[n]);
                  },
                  error(c) {
                    (0, a.assert)(c instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, h.postMessage({
                      sourceName: o,
                      targetName: d,
                      stream: S.ERROR,
                      streamId: n,
                      reason: E(c)
                    }));
                  },
                  sinkCapability: new a.PromiseCapability(),
                  onPull: null,
                  onCancel: null,
                  isCancelled: !1,
                  desiredSize: i.desiredSize,
                  ready: null
                };
                u.sinkCapability.resolve(), u.ready = u.sinkCapability.promise, this.streamSinks[n] = u, new Promise(function(c) {
                  c(l(i.data, u));
                }).then(function() {
                  h.postMessage({
                    sourceName: o,
                    targetName: d,
                    stream: S.START_COMPLETE,
                    streamId: n,
                    success: !0
                  });
                }, function(c) {
                  h.postMessage({
                    sourceName: o,
                    targetName: d,
                    stream: S.START_COMPLETE,
                    streamId: n,
                    reason: E(c)
                  });
                });
              }
              #e(i) {
                const n = i.streamId, o = this.sourceName, d = i.sourceName, h = this.comObj, e = this.streamControllers[n], l = this.streamSinks[n];
                switch (i.stream) {
                  case S.START_COMPLETE:
                    i.success ? e.startCall.resolve() : e.startCall.reject(E(i.reason));
                    break;
                  case S.PULL_COMPLETE:
                    i.success ? e.pullCall.resolve() : e.pullCall.reject(E(i.reason));
                    break;
                  case S.PULL:
                    if (!l) {
                      h.postMessage({
                        sourceName: o,
                        targetName: d,
                        stream: S.PULL_COMPLETE,
                        streamId: n,
                        success: !0
                      });
                      break;
                    }
                    l.desiredSize <= 0 && i.desiredSize > 0 && l.sinkCapability.resolve(), l.desiredSize = i.desiredSize, new Promise(function(u) {
                      u(l.onPull?.());
                    }).then(function() {
                      h.postMessage({
                        sourceName: o,
                        targetName: d,
                        stream: S.PULL_COMPLETE,
                        streamId: n,
                        success: !0
                      });
                    }, function(u) {
                      h.postMessage({
                        sourceName: o,
                        targetName: d,
                        stream: S.PULL_COMPLETE,
                        streamId: n,
                        reason: E(u)
                      });
                    });
                    break;
                  case S.ENQUEUE:
                    if ((0, a.assert)(e, "enqueue should have stream controller"), e.isClosed)
                      break;
                    e.controller.enqueue(i.chunk);
                    break;
                  case S.CLOSE:
                    if ((0, a.assert)(e, "close should have stream controller"), e.isClosed)
                      break;
                    e.isClosed = !0, e.controller.close(), this.#n(e, n);
                    break;
                  case S.ERROR:
                    (0, a.assert)(e, "error should have stream controller"), e.controller.error(E(i.reason)), this.#n(e, n);
                    break;
                  case S.CANCEL_COMPLETE:
                    i.success ? e.cancelCall.resolve() : e.cancelCall.reject(E(i.reason)), this.#n(e, n);
                    break;
                  case S.CANCEL:
                    if (!l)
                      break;
                    new Promise(function(u) {
                      u(l.onCancel?.(E(i.reason)));
                    }).then(function() {
                      h.postMessage({
                        sourceName: o,
                        targetName: d,
                        stream: S.CANCEL_COMPLETE,
                        streamId: n,
                        success: !0
                      });
                    }, function(u) {
                      h.postMessage({
                        sourceName: o,
                        targetName: d,
                        stream: S.CANCEL_COMPLETE,
                        streamId: n,
                        reason: E(u)
                      });
                    }), l.sinkCapability.reject(E(i.reason)), l.isCancelled = !0, delete this.streamSinks[n];
                    break;
                  default:
                    throw new Error("Unexpected stream case");
                }
              }
              async #n(i, n) {
                await Promise.allSettled([i.startCall?.promise, i.pullCall?.promise, i.cancelCall?.promise]), delete this.streamControllers[n];
              }
              destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }
            p.MessageHandler = v;
          }),
          /* 178 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.Metadata = void 0;
            var a = t(1);
            class f {
              #t;
              #e;
              constructor(E) {
                let {
                  parsedData: v,
                  rawData: T
                } = E;
                this.#t = v, this.#e = T;
              }
              getRaw() {
                return this.#e;
              }
              get(E) {
                return this.#t.get(E) ?? null;
              }
              getAll() {
                return (0, a.objectFromMap)(this.#t);
              }
              has(E) {
                return this.#t.has(E);
              }
            }
            p.Metadata = f;
          }),
          /* 179 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.OptionalContentConfig = void 0;
            var a = t(1), f = t(170);
            const S = /* @__PURE__ */ Symbol("INTERNAL");
            class E {
              #t = !0;
              constructor(i, n) {
                this.name = i, this.intent = n;
              }
              get visible() {
                return this.#t;
              }
              _setVisible(i, n) {
                i !== S && (0, a.unreachable)("Internal method `_setVisible` called."), this.#t = n;
              }
            }
            class v {
              #t = null;
              #e = /* @__PURE__ */ new Map();
              #n = null;
              #i = null;
              constructor(i) {
                if (this.name = null, this.creator = null, i !== null) {
                  this.name = i.name, this.creator = i.creator, this.#i = i.order;
                  for (const n of i.groups)
                    this.#e.set(n.id, new E(n.name, n.intent));
                  if (i.baseState === "OFF")
                    for (const n of this.#e.values())
                      n._setVisible(S, !1);
                  for (const n of i.on)
                    this.#e.get(n)._setVisible(S, !0);
                  for (const n of i.off)
                    this.#e.get(n)._setVisible(S, !1);
                  this.#n = this.getHash();
                }
              }
              #o(i) {
                const n = i.length;
                if (n < 2)
                  return !0;
                const o = i[0];
                for (let d = 1; d < n; d++) {
                  const h = i[d];
                  let e;
                  if (Array.isArray(h))
                    e = this.#o(h);
                  else if (this.#e.has(h))
                    e = this.#e.get(h).visible;
                  else
                    return (0, a.warn)(`Optional content group not found: ${h}`), !0;
                  switch (o) {
                    case "And":
                      if (!e)
                        return !1;
                      break;
                    case "Or":
                      if (e)
                        return !0;
                      break;
                    case "Not":
                      return !e;
                    default:
                      return !0;
                  }
                }
                return o === "And";
              }
              isVisible(i) {
                if (this.#e.size === 0)
                  return !0;
                if (!i)
                  return (0, a.warn)("Optional content group not defined."), !0;
                if (i.type === "OCG")
                  return this.#e.has(i.id) ? this.#e.get(i.id).visible : ((0, a.warn)(`Optional content group not found: ${i.id}`), !0);
                if (i.type === "OCMD") {
                  if (i.expression)
                    return this.#o(i.expression);
                  if (!i.policy || i.policy === "AnyOn") {
                    for (const n of i.ids) {
                      if (!this.#e.has(n))
                        return (0, a.warn)(`Optional content group not found: ${n}`), !0;
                      if (this.#e.get(n).visible)
                        return !0;
                    }
                    return !1;
                  } else if (i.policy === "AllOn") {
                    for (const n of i.ids) {
                      if (!this.#e.has(n))
                        return (0, a.warn)(`Optional content group not found: ${n}`), !0;
                      if (!this.#e.get(n).visible)
                        return !1;
                    }
                    return !0;
                  } else if (i.policy === "AnyOff") {
                    for (const n of i.ids) {
                      if (!this.#e.has(n))
                        return (0, a.warn)(`Optional content group not found: ${n}`), !0;
                      if (!this.#e.get(n).visible)
                        return !0;
                    }
                    return !1;
                  } else if (i.policy === "AllOff") {
                    for (const n of i.ids) {
                      if (!this.#e.has(n))
                        return (0, a.warn)(`Optional content group not found: ${n}`), !0;
                      if (this.#e.get(n).visible)
                        return !1;
                    }
                    return !0;
                  }
                  return (0, a.warn)(`Unknown optional content policy ${i.policy}.`), !0;
                }
                return (0, a.warn)(`Unknown group type ${i.type}.`), !0;
              }
              setVisibility(i) {
                let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                if (!this.#e.has(i)) {
                  (0, a.warn)(`Optional content group not found: ${i}`);
                  return;
                }
                this.#e.get(i)._setVisible(S, !!n), this.#t = null;
              }
              get hasInitialVisibility() {
                return this.#n === null || this.getHash() === this.#n;
              }
              getOrder() {
                return this.#e.size ? this.#i ? this.#i.slice() : [...this.#e.keys()] : null;
              }
              getGroups() {
                return this.#e.size > 0 ? (0, a.objectFromMap)(this.#e) : null;
              }
              getGroup(i) {
                return this.#e.get(i) || null;
              }
              getHash() {
                if (this.#t !== null)
                  return this.#t;
                const i = new f.MurmurHash3_64();
                for (const [n, o] of this.#e)
                  i.update(`${n}:${o.visible}`);
                return this.#t = i.hexdigest();
              }
            }
            p.OptionalContentConfig = v;
          }),
          /* 180 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.PDFDataTransportStream = void 0, t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123), t(89);
            var a = t(1), f = t(168);
            class S {
              constructor(i, n) {
                let {
                  length: o,
                  initialData: d,
                  progressiveDone: h = !1,
                  contentDispositionFilename: e = null,
                  disableRange: l = !1,
                  disableStream: u = !1
                } = i;
                if ((0, a.assert)(n, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = h, this._contentDispositionFilename = e, d?.length > 0) {
                  const c = d instanceof Uint8Array && d.byteLength === d.buffer.byteLength ? d.buffer : new Uint8Array(d).buffer;
                  this._queuedChunks.push(c);
                }
                this._pdfDataRangeTransport = n, this._isStreamingSupported = !u, this._isRangeSupported = !l, this._contentLength = o, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((c, y) => {
                  this._onReceiveData({
                    begin: c,
                    chunk: y
                  });
                }), this._pdfDataRangeTransport.addProgressListener((c, y) => {
                  this._onProgress({
                    loaded: c,
                    total: y
                  });
                }), this._pdfDataRangeTransport.addProgressiveReadListener((c) => {
                  this._onReceiveData({
                    chunk: c
                  });
                }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                  this._onProgressiveDone();
                }), this._pdfDataRangeTransport.transportReady();
              }
              _onReceiveData(i) {
                let {
                  begin: n,
                  chunk: o
                } = i;
                const d = o instanceof Uint8Array && o.byteLength === o.buffer.byteLength ? o.buffer : new Uint8Array(o).buffer;
                if (n === void 0)
                  this._fullRequestReader ? this._fullRequestReader._enqueue(d) : this._queuedChunks.push(d);
                else {
                  const h = this._rangeReaders.some(function(e) {
                    return e._begin !== n ? !1 : (e._enqueue(d), !0);
                  });
                  (0, a.assert)(h, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                }
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              _onProgress(i) {
                i.total === void 0 ? this._rangeReaders[0]?.onProgress?.({
                  loaded: i.loaded
                }) : this._fullRequestReader?.onProgress?.({
                  loaded: i.loaded,
                  total: i.total
                });
              }
              _onProgressiveDone() {
                this._fullRequestReader?.progressiveDone(), this._progressiveDone = !0;
              }
              _removeRangeReader(i) {
                const n = this._rangeReaders.indexOf(i);
                n >= 0 && this._rangeReaders.splice(n, 1);
              }
              getFullReader() {
                (0, a.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                const i = this._queuedChunks;
                return this._queuedChunks = null, new E(this, i, this._progressiveDone, this._contentDispositionFilename);
              }
              getRangeReader(i, n) {
                if (n <= this._progressiveDataLength)
                  return null;
                const o = new v(this, i, n);
                return this._pdfDataRangeTransport.requestDataRange(i, n), this._rangeReaders.push(o), o;
              }
              cancelAllRequests(i) {
                this._fullRequestReader?.cancel(i);
                for (const n of this._rangeReaders.slice(0))
                  n.cancel(i);
                this._pdfDataRangeTransport.abort();
              }
            }
            p.PDFDataTransportStream = S;
            class E {
              constructor(i, n) {
                let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, d = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                this._stream = i, this._done = o || !1, this._filename = (0, f.isPdfFile)(d) ? d : null, this._queuedChunks = n || [], this._loaded = 0;
                for (const h of this._queuedChunks)
                  this._loaded += h.byteLength;
                this._requests = [], this._headersReady = Promise.resolve(), i._fullRequestReader = this, this.onProgress = null;
              }
              _enqueue(i) {
                this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: i,
                  done: !1
                }) : this._queuedChunks.push(i), this._loaded += i.byteLength);
              }
              get headersReady() {
                return this._headersReady;
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._stream._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._stream._isStreamingSupported;
              }
              get contentLength() {
                return this._stream._contentLength;
              }
              async read() {
                if (this._queuedChunks.length > 0)
                  return {
                    value: this._queuedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const i = new a.PromiseCapability();
                return this._requests.push(i), i.promise;
              }
              cancel(i) {
                this._done = !0;
                for (const n of this._requests)
                  n.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0;
              }
              progressiveDone() {
                this._done || (this._done = !0);
              }
            }
            class v {
              constructor(i, n, o) {
                this._stream = i, this._begin = n, this._end = o, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
              }
              _enqueue(i) {
                if (!this._done) {
                  if (this._requests.length === 0)
                    this._queuedChunk = i;
                  else {
                    this._requests.shift().resolve({
                      value: i,
                      done: !1
                    });
                    for (const o of this._requests)
                      o.resolve({
                        value: void 0,
                        done: !0
                      });
                    this._requests.length = 0;
                  }
                  this._done = !0, this._stream._removeRangeReader(this);
                }
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._queuedChunk) {
                  const n = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: n,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const i = new a.PromiseCapability();
                return this._requests.push(i), i.promise;
              }
              cancel(i) {
                this._done = !0;
                for (const n of this._requests)
                  n.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._stream._removeRangeReader(this);
              }
            }
          }),
          /* 181 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.PDFFetchStream = void 0, t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123), t(89);
            var a = t(1), f = t(182);
            function S(o, d, h) {
              return {
                method: "GET",
                headers: o,
                signal: h.signal,
                mode: "cors",
                credentials: d ? "include" : "same-origin",
                redirect: "follow"
              };
            }
            function E(o) {
              const d = new Headers();
              for (const h in o) {
                const e = o[h];
                e !== void 0 && d.append(h, e);
              }
              return d;
            }
            function v(o) {
              return o instanceof Uint8Array ? o.buffer : o instanceof ArrayBuffer ? o : ((0, a.warn)(`getArrayBuffer - unexpected data format: ${o}`), new Uint8Array(o).buffer);
            }
            class T {
              constructor(d) {
                this.source = d, this.isHttp = /^https?:/i.test(d.url), this.httpHeaders = this.isHttp && d.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, a.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new i(this), this._fullRequestReader;
              }
              getRangeReader(d, h) {
                if (h <= this._progressiveDataLength)
                  return null;
                const e = new n(this, d, h);
                return this._rangeRequestReaders.push(e), e;
              }
              cancelAllRequests(d) {
                this._fullRequestReader?.cancel(d);
                for (const h of this._rangeRequestReaders.slice(0))
                  h.cancel(d);
              }
            }
            p.PDFFetchStream = T;
            class i {
              constructor(d) {
                this._stream = d, this._reader = null, this._loaded = 0, this._filename = null;
                const h = d.source;
                this._withCredentials = h.withCredentials || !1, this._contentLength = h.length, this._headersCapability = new a.PromiseCapability(), this._disableRange = h.disableRange || !1, this._rangeChunkSize = h.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !h.disableStream, this._isRangeSupported = !h.disableRange, this._headers = E(this._stream.httpHeaders);
                const e = h.url;
                fetch(e, S(this._headers, this._withCredentials, this._abortController)).then((l) => {
                  if (!(0, f.validateResponseStatus)(l.status))
                    throw (0, f.createResponseStatusError)(l.status, e);
                  this._reader = l.body.getReader(), this._headersCapability.resolve();
                  const u = (C) => l.headers.get(C), {
                    allowRangeRequests: c,
                    suggestedLength: y
                  } = (0, f.validateRangeRequestCapabilities)({
                    getResponseHeader: u,
                    isHttp: this._stream.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = c, this._contentLength = y || this._contentLength, this._filename = (0, f.extractFilenameFromHeader)(u), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new a.AbortException("Streaming is disabled."));
                }).catch(this._headersCapability.reject), this.onProgress = null;
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._headersCapability.promise;
                const {
                  value: d,
                  done: h
                } = await this._reader.read();
                return h ? {
                  value: d,
                  done: h
                } : (this._loaded += d.byteLength, this.onProgress?.({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: v(d),
                  done: !1
                });
              }
              cancel(d) {
                this._reader?.cancel(d), this._abortController.abort();
              }
            }
            class n {
              constructor(d, h, e) {
                this._stream = d, this._reader = null, this._loaded = 0;
                const l = d.source;
                this._withCredentials = l.withCredentials || !1, this._readCapability = new a.PromiseCapability(), this._isStreamingSupported = !l.disableStream, this._abortController = new AbortController(), this._headers = E(this._stream.httpHeaders), this._headers.append("Range", `bytes=${h}-${e - 1}`);
                const u = l.url;
                fetch(u, S(this._headers, this._withCredentials, this._abortController)).then((c) => {
                  if (!(0, f.validateResponseStatus)(c.status))
                    throw (0, f.createResponseStatusError)(c.status, u);
                  this._readCapability.resolve(), this._reader = c.body.getReader();
                }).catch(this._readCapability.reject), this.onProgress = null;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._readCapability.promise;
                const {
                  value: d,
                  done: h
                } = await this._reader.read();
                return h ? {
                  value: d,
                  done: h
                } : (this._loaded += d.byteLength, this.onProgress?.({
                  loaded: this._loaded
                }), {
                  value: v(d),
                  done: !1
                });
              }
              cancel(d) {
                this._reader?.cancel(d), this._abortController.abort();
              }
            }
          }),
          /* 182 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.createResponseStatusError = T, p.extractFilenameFromHeader = v, p.validateRangeRequestCapabilities = E, p.validateResponseStatus = i;
            var a = t(1), f = t(183), S = t(168);
            function E(n) {
              let {
                getResponseHeader: o,
                isHttp: d,
                rangeChunkSize: h,
                disableRange: e
              } = n;
              const l = {
                allowRangeRequests: !1,
                suggestedLength: void 0
              }, u = parseInt(o("Content-Length"), 10);
              return !Number.isInteger(u) || (l.suggestedLength = u, u <= 2 * h) || e || !d || o("Accept-Ranges") !== "bytes" || (o("Content-Encoding") || "identity") !== "identity" || (l.allowRangeRequests = !0), l;
            }
            function v(n) {
              const o = n("Content-Disposition");
              if (o) {
                let d = (0, f.getFilenameFromContentDispositionHeader)(o);
                if (d.includes("%"))
                  try {
                    d = decodeURIComponent(d);
                  } catch {
                  }
                if ((0, S.isPdfFile)(d))
                  return d;
              }
              return null;
            }
            function T(n, o) {
              return n === 404 || n === 0 && o.startsWith("file:") ? new a.MissingPDFException('Missing PDF "' + o + '".') : new a.UnexpectedResponseException(`Unexpected server response (${n}) while retrieving PDF "${o}".`, n);
            }
            function i(n) {
              return n === 200 || n === 206;
            }
          }),
          /* 183 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.getFilenameFromContentDispositionHeader = f, t(89), t(149);
            var a = t(1);
            function f(S) {
              let E = !0, v = T("filename\\*", "i").exec(S);
              if (v) {
                v = v[1];
                let l = d(v);
                return l = unescape(l), l = h(l), l = e(l), n(l);
              }
              if (v = o(S), v) {
                const l = e(v);
                return n(l);
              }
              if (v = T("filename", "i").exec(S), v) {
                v = v[1];
                let l = d(v);
                return l = e(l), n(l);
              }
              function T(l, u) {
                return new RegExp("(?:^|;)\\s*" + l + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', u);
              }
              function i(l, u) {
                if (l) {
                  if (!/^[\x00-\xFF]+$/.test(u))
                    return u;
                  try {
                    const c = new TextDecoder(l, {
                      fatal: !0
                    }), y = (0, a.stringToBytes)(u);
                    u = c.decode(y), E = !1;
                  } catch {
                  }
                }
                return u;
              }
              function n(l) {
                return E && /[\x80-\xff]/.test(l) && (l = i("utf-8", l), E && (l = i("iso-8859-1", l))), l;
              }
              function o(l) {
                const u = [];
                let c;
                const y = T("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                for (; (c = y.exec(l)) !== null; ) {
                  let [, R, s, m] = c;
                  if (R = parseInt(R, 10), R in u) {
                    if (R === 0)
                      break;
                    continue;
                  }
                  u[R] = [s, m];
                }
                const C = [];
                for (let R = 0; R < u.length && R in u; ++R) {
                  let [s, m] = u[R];
                  m = d(m), s && (m = unescape(m), R === 0 && (m = h(m))), C.push(m);
                }
                return C.join("");
              }
              function d(l) {
                if (l.startsWith('"')) {
                  const u = l.slice(1).split('\\"');
                  for (let c = 0; c < u.length; ++c) {
                    const y = u[c].indexOf('"');
                    y !== -1 && (u[c] = u[c].slice(0, y), u.length = c + 1), u[c] = u[c].replaceAll(/\\(.)/g, "$1");
                  }
                  l = u.join('"');
                }
                return l;
              }
              function h(l) {
                const u = l.indexOf("'");
                if (u === -1)
                  return l;
                const c = l.slice(0, u), C = l.slice(u + 1).replace(/^[^']*'/, "");
                return i(c, C);
              }
              function e(l) {
                return !l.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(l) ? l : l.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(u, c, y, C) {
                  if (y === "q" || y === "Q")
                    return C = C.replaceAll("_", " "), C = C.replaceAll(/=([0-9a-fA-F]{2})/g, function(R, s) {
                      return String.fromCharCode(parseInt(s, 16));
                    }), i(c, C);
                  try {
                    C = atob(C);
                  } catch {
                  }
                  return i(c, C);
                });
              }
              return "";
            }
          }),
          /* 184 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.PDFNetworkStream = void 0, t(89);
            var a = t(1), f = t(182);
            const S = 200, E = 206;
            function v(d) {
              const h = d.response;
              return typeof h != "string" ? h : (0, a.stringToBytes)(h).buffer;
            }
            class T {
              constructor(h) {
                let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.url = h, this.isHttp = /^https?:/i.test(h), this.httpHeaders = this.isHttp && e.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = e.withCredentials || !1, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
              }
              requestRange(h, e, l) {
                const u = {
                  begin: h,
                  end: e
                };
                for (const c in l)
                  u[c] = l[c];
                return this.request(u);
              }
              requestFull(h) {
                return this.request(h);
              }
              request(h) {
                const e = new XMLHttpRequest(), l = this.currXhrId++, u = this.pendingRequests[l] = {
                  xhr: e
                };
                e.open("GET", this.url), e.withCredentials = this.withCredentials;
                for (const c in this.httpHeaders) {
                  const y = this.httpHeaders[c];
                  y !== void 0 && e.setRequestHeader(c, y);
                }
                return this.isHttp && "begin" in h && "end" in h ? (e.setRequestHeader("Range", `bytes=${h.begin}-${h.end - 1}`), u.expectedStatus = E) : u.expectedStatus = S, e.responseType = "arraybuffer", h.onError && (e.onerror = function(c) {
                  h.onError(e.status);
                }), e.onreadystatechange = this.onStateChange.bind(this, l), e.onprogress = this.onProgress.bind(this, l), u.onHeadersReceived = h.onHeadersReceived, u.onDone = h.onDone, u.onError = h.onError, u.onProgress = h.onProgress, e.send(null), l;
              }
              onProgress(h, e) {
                const l = this.pendingRequests[h];
                l && l.onProgress?.(e);
              }
              onStateChange(h, e) {
                const l = this.pendingRequests[h];
                if (!l)
                  return;
                const u = l.xhr;
                if (u.readyState >= 2 && l.onHeadersReceived && (l.onHeadersReceived(), delete l.onHeadersReceived), u.readyState !== 4 || !(h in this.pendingRequests))
                  return;
                if (delete this.pendingRequests[h], u.status === 0 && this.isHttp) {
                  l.onError?.(u.status);
                  return;
                }
                const c = u.status || S;
                if (!(c === S && l.expectedStatus === E) && c !== l.expectedStatus) {
                  l.onError?.(u.status);
                  return;
                }
                const C = v(u);
                if (c === E) {
                  const R = u.getResponseHeader("Content-Range"), s = /bytes (\d+)-(\d+)\/(\d+)/.exec(R);
                  l.onDone({
                    begin: parseInt(s[1], 10),
                    chunk: C
                  });
                } else C ? l.onDone({
                  begin: 0,
                  chunk: C
                }) : l.onError?.(u.status);
              }
              getRequestXhr(h) {
                return this.pendingRequests[h].xhr;
              }
              isPendingRequest(h) {
                return h in this.pendingRequests;
              }
              abortRequest(h) {
                const e = this.pendingRequests[h].xhr;
                delete this.pendingRequests[h], e.abort();
              }
            }
            class i {
              constructor(h) {
                this._source = h, this._manager = new T(h.url, {
                  httpHeaders: h.httpHeaders,
                  withCredentials: h.withCredentials
                }), this._rangeChunkSize = h.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              _onRangeRequestReaderClosed(h) {
                const e = this._rangeRequestReaders.indexOf(h);
                e >= 0 && this._rangeRequestReaders.splice(e, 1);
              }
              getFullReader() {
                return (0, a.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new n(this._manager, this._source), this._fullRequestReader;
              }
              getRangeReader(h, e) {
                const l = new o(this._manager, h, e);
                return l.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(l), l;
              }
              cancelAllRequests(h) {
                this._fullRequestReader?.cancel(h);
                for (const e of this._rangeRequestReaders.slice(0))
                  e.cancel(h);
              }
            }
            p.PDFNetworkStream = i;
            class n {
              constructor(h, e) {
                this._manager = h;
                const l = {
                  onHeadersReceived: this._onHeadersReceived.bind(this),
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = e.url, this._fullRequestId = h.requestFull(l), this._headersReceivedCapability = new a.PromiseCapability(), this._disableRange = e.disableRange || !1, this._contentLength = e.length, this._rangeChunkSize = e.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
              }
              _onHeadersReceived() {
                const h = this._fullRequestId, e = this._manager.getRequestXhr(h), l = (y) => e.getResponseHeader(y), {
                  allowRangeRequests: u,
                  suggestedLength: c
                } = (0, f.validateRangeRequestCapabilities)({
                  getResponseHeader: l,
                  isHttp: this._manager.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                u && (this._isRangeSupported = !0), this._contentLength = c || this._contentLength, this._filename = (0, f.extractFilenameFromHeader)(l), this._isRangeSupported && this._manager.abortRequest(h), this._headersReceivedCapability.resolve();
              }
              _onDone(h) {
                if (h && (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: h.chunk,
                  done: !1
                }) : this._cachedChunks.push(h.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
                  for (const e of this._requests)
                    e.resolve({
                      value: void 0,
                      done: !0
                    });
                  this._requests.length = 0;
                }
              }
              _onError(h) {
                this._storedError = (0, f.createResponseStatusError)(h, this._url), this._headersReceivedCapability.reject(this._storedError);
                for (const e of this._requests)
                  e.reject(this._storedError);
                this._requests.length = 0, this._cachedChunks.length = 0;
              }
              _onProgress(h) {
                this.onProgress?.({
                  loaded: h.loaded,
                  total: h.lengthComputable ? h.total : this._contentLength
                });
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              get contentLength() {
                return this._contentLength;
              }
              get headersReady() {
                return this._headersReceivedCapability.promise;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._cachedChunks.length > 0)
                  return {
                    value: this._cachedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const h = new a.PromiseCapability();
                return this._requests.push(h), h.promise;
              }
              cancel(h) {
                this._done = !0, this._headersReceivedCapability.reject(h);
                for (const e of this._requests)
                  e.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
              }
            }
            class o {
              constructor(h, e, l) {
                this._manager = h;
                const u = {
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = h.url, this._requestId = h.requestRange(e, l, u), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
              }
              _close() {
                this.onClosed?.(this);
              }
              _onDone(h) {
                const e = h.chunk;
                this._requests.length > 0 ? this._requests.shift().resolve({
                  value: e,
                  done: !1
                }) : this._queuedChunk = e, this._done = !0;
                for (const l of this._requests)
                  l.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._close();
              }
              _onError(h) {
                this._storedError = (0, f.createResponseStatusError)(h, this._url);
                for (const e of this._requests)
                  e.reject(this._storedError);
                this._requests.length = 0, this._queuedChunk = null;
              }
              _onProgress(h) {
                this.isStreamingSupported || this.onProgress?.({
                  loaded: h.loaded
                });
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._queuedChunk !== null) {
                  const e = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: e,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const h = new a.PromiseCapability();
                return this._requests.push(h), h.promise;
              }
              cancel(h) {
                this._done = !0;
                for (const e of this._requests)
                  e.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
              }
            }
          }),
          /* 185 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.PDFNodeStream = void 0, t(89), t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123);
            var a = t(1), f = t(182);
            const S = /^file:\/\/\/[a-zA-Z]:\//;
            function E(l) {
              const u = require$$6, c = u.parse(l);
              return c.protocol === "file:" || c.host ? c : /^[a-z]:[/\\]/i.test(l) ? u.parse(`file:///${l}`) : (c.host || (c.protocol = "file:"), c);
            }
            class v {
              constructor(u) {
                this.source = u, this.url = E(u.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && u.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, a.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new h(this) : new o(this), this._fullRequestReader;
              }
              getRangeReader(u, c) {
                if (c <= this._progressiveDataLength)
                  return null;
                const y = this.isFsUrl ? new e(this, u, c) : new d(this, u, c);
                return this._rangeRequestReaders.push(y), y;
              }
              cancelAllRequests(u) {
                this._fullRequestReader?.cancel(u);
                for (const c of this._rangeRequestReaders.slice(0))
                  c.cancel(u);
              }
            }
            p.PDFNodeStream = v;
            class T {
              constructor(u) {
                this._url = u.url, this._done = !1, this._storedError = null, this.onProgress = null;
                const c = u.source;
                this._contentLength = c.length, this._loaded = 0, this._filename = null, this._disableRange = c.disableRange || !1, this._rangeChunkSize = c.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !c.disableStream, this._isRangeSupported = !c.disableRange, this._readableStream = null, this._readCapability = new a.PromiseCapability(), this._headersCapability = new a.PromiseCapability();
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const u = this._readableStream.read();
                return u === null ? (this._readCapability = new a.PromiseCapability(), this.read()) : (this._loaded += u.length, this.onProgress?.({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: new Uint8Array(u).buffer,
                  done: !1
                });
              }
              cancel(u) {
                if (!this._readableStream) {
                  this._error(u);
                  return;
                }
                this._readableStream.destroy(u);
              }
              _error(u) {
                this._storedError = u, this._readCapability.resolve();
              }
              _setReadableStream(u) {
                this._readableStream = u, u.on("readable", () => {
                  this._readCapability.resolve();
                }), u.on("end", () => {
                  u.destroy(), this._done = !0, this._readCapability.resolve();
                }), u.on("error", (c) => {
                  this._error(c);
                }), !this._isStreamingSupported && this._isRangeSupported && this._error(new a.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            class i {
              constructor(u) {
                this._url = u.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = new a.PromiseCapability();
                const c = u.source;
                this._isStreamingSupported = !c.disableStream;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const u = this._readableStream.read();
                return u === null ? (this._readCapability = new a.PromiseCapability(), this.read()) : (this._loaded += u.length, this.onProgress?.({
                  loaded: this._loaded
                }), {
                  value: new Uint8Array(u).buffer,
                  done: !1
                });
              }
              cancel(u) {
                if (!this._readableStream) {
                  this._error(u);
                  return;
                }
                this._readableStream.destroy(u);
              }
              _error(u) {
                this._storedError = u, this._readCapability.resolve();
              }
              _setReadableStream(u) {
                this._readableStream = u, u.on("readable", () => {
                  this._readCapability.resolve();
                }), u.on("end", () => {
                  u.destroy(), this._done = !0, this._readCapability.resolve();
                }), u.on("error", (c) => {
                  this._error(c);
                }), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            function n(l, u) {
              return {
                protocol: l.protocol,
                auth: l.auth,
                host: l.hostname,
                port: l.port,
                path: l.path,
                method: "GET",
                headers: u
              };
            }
            class o extends T {
              constructor(u) {
                super(u);
                const c = (y) => {
                  if (y.statusCode === 404) {
                    const m = new a.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = m, this._headersCapability.reject(m);
                    return;
                  }
                  this._headersCapability.resolve(), this._setReadableStream(y);
                  const C = (m) => this._readableStream.headers[m.toLowerCase()], {
                    allowRangeRequests: R,
                    suggestedLength: s
                  } = (0, f.validateRangeRequestCapabilities)({
                    getResponseHeader: C,
                    isHttp: u.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = R, this._contentLength = s || this._contentLength, this._filename = (0, f.extractFilenameFromHeader)(C);
                };
                if (this._request = null, this._url.protocol === "http:") {
                  const y = require$$6;
                  this._request = y.request(n(this._url, u.httpHeaders), c);
                } else {
                  const y = require$$6;
                  this._request = y.request(n(this._url, u.httpHeaders), c);
                }
                this._request.on("error", (y) => {
                  this._storedError = y, this._headersCapability.reject(y);
                }), this._request.end();
              }
            }
            class d extends i {
              constructor(u, c, y) {
                super(u), this._httpHeaders = {};
                for (const R in u.httpHeaders) {
                  const s = u.httpHeaders[R];
                  s !== void 0 && (this._httpHeaders[R] = s);
                }
                this._httpHeaders.Range = `bytes=${c}-${y - 1}`;
                const C = (R) => {
                  if (R.statusCode === 404) {
                    const s = new a.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = s;
                    return;
                  }
                  this._setReadableStream(R);
                };
                if (this._request = null, this._url.protocol === "http:") {
                  const R = require$$6;
                  this._request = R.request(n(this._url, this._httpHeaders), C);
                } else {
                  const R = require$$6;
                  this._request = R.request(n(this._url, this._httpHeaders), C);
                }
                this._request.on("error", (R) => {
                  this._storedError = R;
                }), this._request.end();
              }
            }
            class h extends T {
              constructor(u) {
                super(u);
                let c = decodeURIComponent(this._url.path);
                S.test(this._url.href) && (c = c.replace(/^\//, ""));
                const y = require$$6;
                y.lstat(c, (C, R) => {
                  if (C) {
                    C.code === "ENOENT" && (C = new a.MissingPDFException(`Missing PDF "${c}".`)), this._storedError = C, this._headersCapability.reject(C);
                    return;
                  }
                  this._contentLength = R.size, this._setReadableStream(y.createReadStream(c)), this._headersCapability.resolve();
                });
              }
            }
            class e extends i {
              constructor(u, c, y) {
                super(u);
                let C = decodeURIComponent(this._url.path);
                S.test(this._url.href) && (C = C.replace(/^\//, ""));
                const R = require$$6;
                this._setReadableStream(R.createReadStream(C, {
                  start: c,
                  end: y - 1
                }));
              }
            }
          }),
          /* 186 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.SVGGraphics = void 0, t(84), t(86), t(87), t(93), t(101), t(102), t(105), t(107), t(109), t(113), t(116), t(123), t(2), t(89), t(187);
            var a = t(168), f = t(1);
            const S = {
              fontStyle: "normal",
              fontWeight: "normal",
              fillColor: "#000000"
            }, E = "http://www.w3.org/XML/1998/namespace", v = "http://www.w3.org/1999/xlink", T = ["butt", "round", "square"], i = ["miter", "round", "bevel"], n = function(R) {
              let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              if (URL.createObjectURL && typeof Blob < "u" && !m)
                return URL.createObjectURL(new Blob([R], {
                  type: s
                }));
              const F = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
              let B = `data:${s};base64,`;
              for (let k = 0, V = R.length; k < V; k += 3) {
                const z = R[k] & 255, K = R[k + 1] & 255, J = R[k + 2] & 255, $ = z >> 2, j = (z & 3) << 4 | K >> 4, G = k + 1 < V ? (K & 15) << 2 | J >> 6 : 64, M = k + 2 < V ? J & 63 : 64;
                B += F[$] + F[j] + F[G] + F[M];
              }
              return B;
            }, o = (function() {
              const R = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), s = 12, m = new Int32Array(256);
              for (let J = 0; J < 256; J++) {
                let $ = J;
                for (let j = 0; j < 8; j++)
                  $ = $ & 1 ? 3988292384 ^ $ >> 1 & 2147483647 : $ >> 1 & 2147483647;
                m[J] = $;
              }
              function F(J, $, j) {
                let G = -1;
                for (let M = $; M < j; M++) {
                  const x = (G ^ J[M]) & 255, A = m[x];
                  G = G >>> 8 ^ A;
                }
                return G ^ -1;
              }
              function B(J, $, j, G) {
                let M = G;
                const x = $.length;
                j[M] = x >> 24 & 255, j[M + 1] = x >> 16 & 255, j[M + 2] = x >> 8 & 255, j[M + 3] = x & 255, M += 4, j[M] = J.charCodeAt(0) & 255, j[M + 1] = J.charCodeAt(1) & 255, j[M + 2] = J.charCodeAt(2) & 255, j[M + 3] = J.charCodeAt(3) & 255, M += 4, j.set($, M), M += $.length;
                const A = F(j, G + 4, M);
                j[M] = A >> 24 & 255, j[M + 1] = A >> 16 & 255, j[M + 2] = A >> 8 & 255, j[M + 3] = A & 255;
              }
              function k(J, $, j) {
                let G = 1, M = 0;
                for (let x = $; x < j; ++x)
                  G = (G + (J[x] & 255)) % 65521, M = (M + G) % 65521;
                return M << 16 | G;
              }
              function V(J) {
                if (!f.isNodeJS)
                  return z(J);
                try {
                  const $ = parseInt(process.versions.node) >= 8 ? J : Buffer.from(J), j = require$$6.deflateSync($, {
                    level: 9
                  });
                  return j instanceof Uint8Array ? j : new Uint8Array(j);
                } catch ($) {
                  (0, f.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + $);
                }
                return z(J);
              }
              function z(J) {
                let $ = J.length;
                const j = 65535, G = Math.ceil($ / j), M = new Uint8Array(2 + $ + G * 5 + 4);
                let x = 0;
                M[x++] = 120, M[x++] = 156;
                let A = 0;
                for (; $ > j; )
                  M[x++] = 0, M[x++] = 255, M[x++] = 255, M[x++] = 0, M[x++] = 0, M.set(J.subarray(A, A + j), x), x += j, A += j, $ -= j;
                M[x++] = 1, M[x++] = $ & 255, M[x++] = $ >> 8 & 255, M[x++] = ~$ & 65535 & 255, M[x++] = (~$ & 65535) >> 8 & 255, M.set(J.subarray(A), x), x += J.length - A;
                const g = k(J, 0, J.length);
                return M[x++] = g >> 24 & 255, M[x++] = g >> 16 & 255, M[x++] = g >> 8 & 255, M[x++] = g & 255, M;
              }
              function K(J, $, j, G) {
                const M = J.width, x = J.height;
                let A, g, I;
                const U = J.data;
                switch ($) {
                  case f.ImageKind.GRAYSCALE_1BPP:
                    g = 0, A = 1, I = M + 7 >> 3;
                    break;
                  case f.ImageKind.RGB_24BPP:
                    g = 2, A = 8, I = M * 3;
                    break;
                  case f.ImageKind.RGBA_32BPP:
                    g = 6, A = 8, I = M * 4;
                    break;
                  default:
                    throw new Error("invalid format");
                }
                const _ = new Uint8Array((1 + I) * x);
                let H = 0, N = 0;
                for (let W = 0; W < x; ++W)
                  _[H++] = 0, _.set(U.subarray(N, N + I), H), N += I, H += I;
                if ($ === f.ImageKind.GRAYSCALE_1BPP && G) {
                  H = 0;
                  for (let W = 0; W < x; W++) {
                    H++;
                    for (let X = 0; X < I; X++)
                      _[H++] ^= 255;
                  }
                }
                const b = new Uint8Array([M >> 24 & 255, M >> 16 & 255, M >> 8 & 255, M & 255, x >> 24 & 255, x >> 16 & 255, x >> 8 & 255, x & 255, A, g, 0, 0, 0]), w = V(_), O = R.length + s * 3 + b.length + w.length, D = new Uint8Array(O);
                let L = 0;
                return D.set(R, L), L += R.length, B("IHDR", b, D, L), L += s + b.length, B("IDATA", w, D, L), L += s + w.length, B("IEND", new Uint8Array(0), D, L), n(D, "image/png", j);
              }
              return function($, j, G) {
                const M = $.kind === void 0 ? f.ImageKind.GRAYSCALE_1BPP : $.kind;
                return K($, M, j, G);
              };
            })();
            class d {
              constructor() {
                this.fontSizeScale = 1, this.fontWeight = S.fontWeight, this.fontSize = 0, this.textMatrix = f.IDENTITY_MATRIX, this.fontMatrix = f.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = f.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = S.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
              }
              clone() {
                return Object.create(this);
              }
              setCurrentPoint(s, m) {
                this.x = s, this.y = m;
              }
            }
            function h(R) {
              let s = [];
              const m = [];
              for (const F of R) {
                if (F.fn === "save") {
                  s.push({
                    fnId: 92,
                    fn: "group",
                    items: []
                  }), m.push(s), s = s.at(-1).items;
                  continue;
                }
                F.fn === "restore" ? s = m.pop() : s.push(F);
              }
              return s;
            }
            function e(R) {
              if (Number.isInteger(R))
                return R.toString();
              const s = R.toFixed(10);
              let m = s.length - 1;
              if (s[m] !== "0")
                return s;
              do
                m--;
              while (s[m] === "0");
              return s.substring(0, s[m] === "." ? m : m + 1);
            }
            function l(R) {
              if (R[4] === 0 && R[5] === 0) {
                if (R[1] === 0 && R[2] === 0)
                  return R[0] === 1 && R[3] === 1 ? "" : `scale(${e(R[0])} ${e(R[3])})`;
                if (R[0] === R[3] && R[1] === -R[2]) {
                  const s = Math.acos(R[0]) * 180 / Math.PI;
                  return `rotate(${e(s)})`;
                }
              } else if (R[0] === 1 && R[1] === 0 && R[2] === 0 && R[3] === 1)
                return `translate(${e(R[4])} ${e(R[5])})`;
              return `matrix(${e(R[0])} ${e(R[1])} ${e(R[2])} ${e(R[3])} ${e(R[4])} ${e(R[5])})`;
            }
            let u = 0, c = 0, y = 0;
            class C {
              constructor(s, m) {
                let F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                (0, a.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future."), this.svgFactory = new a.DOMSVGFactory(), this.current = new d(), this.transformMatrix = f.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = s, this.objs = m, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!F, this._operatorIdMapping = [];
                for (const B in f.OPS)
                  this._operatorIdMapping[f.OPS[B]] = B;
              }
              getObject(s) {
                let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return typeof s == "string" ? s.startsWith("g_") ? this.commonObjs.get(s) : this.objs.get(s) : m;
              }
              save() {
                this.transformStack.push(this.transformMatrix);
                const s = this.current;
                this.extraStack.push(s), this.current = s.clone();
              }
              restore() {
                this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
              }
              group(s) {
                this.save(), this.executeOpTree(s), this.restore();
              }
              loadDependencies(s) {
                const m = s.fnArray, F = s.argsArray;
                for (let B = 0, k = m.length; B < k; B++)
                  if (m[B] === f.OPS.dependency)
                    for (const V of F[B]) {
                      const z = V.startsWith("g_") ? this.commonObjs : this.objs, K = new Promise((J) => {
                        z.get(V, J);
                      });
                      this.current.dependencies.push(K);
                    }
                return Promise.all(this.current.dependencies);
              }
              transform(s, m, F, B, k, V) {
                const z = [s, m, F, B, k, V];
                this.transformMatrix = f.Util.transform(this.transformMatrix, z), this.tgrp = null;
              }
              getSVG(s, m) {
                this.viewport = m;
                const F = this._initialize(m);
                return this.loadDependencies(s).then(() => (this.transformMatrix = f.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(s)), F));
              }
              convertOpList(s) {
                const m = this._operatorIdMapping, F = s.argsArray, B = s.fnArray, k = [];
                for (let V = 0, z = B.length; V < z; V++) {
                  const K = B[V];
                  k.push({
                    fnId: K,
                    fn: m[K],
                    args: F[V]
                  });
                }
                return h(k);
              }
              executeOpTree(s) {
                for (const m of s) {
                  const F = m.fn, B = m.fnId, k = m.args;
                  switch (B | 0) {
                    case f.OPS.beginText:
                      this.beginText();
                      break;
                    case f.OPS.dependency:
                      break;
                    case f.OPS.setLeading:
                      this.setLeading(k);
                      break;
                    case f.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(k[0], k[1]);
                      break;
                    case f.OPS.setFont:
                      this.setFont(k);
                      break;
                    case f.OPS.showText:
                      this.showText(k[0]);
                      break;
                    case f.OPS.showSpacedText:
                      this.showText(k[0]);
                      break;
                    case f.OPS.endText:
                      this.endText();
                      break;
                    case f.OPS.moveText:
                      this.moveText(k[0], k[1]);
                      break;
                    case f.OPS.setCharSpacing:
                      this.setCharSpacing(k[0]);
                      break;
                    case f.OPS.setWordSpacing:
                      this.setWordSpacing(k[0]);
                      break;
                    case f.OPS.setHScale:
                      this.setHScale(k[0]);
                      break;
                    case f.OPS.setTextMatrix:
                      this.setTextMatrix(k[0], k[1], k[2], k[3], k[4], k[5]);
                      break;
                    case f.OPS.setTextRise:
                      this.setTextRise(k[0]);
                      break;
                    case f.OPS.setTextRenderingMode:
                      this.setTextRenderingMode(k[0]);
                      break;
                    case f.OPS.setLineWidth:
                      this.setLineWidth(k[0]);
                      break;
                    case f.OPS.setLineJoin:
                      this.setLineJoin(k[0]);
                      break;
                    case f.OPS.setLineCap:
                      this.setLineCap(k[0]);
                      break;
                    case f.OPS.setMiterLimit:
                      this.setMiterLimit(k[0]);
                      break;
                    case f.OPS.setFillRGBColor:
                      this.setFillRGBColor(k[0], k[1], k[2]);
                      break;
                    case f.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(k[0], k[1], k[2]);
                      break;
                    case f.OPS.setStrokeColorN:
                      this.setStrokeColorN(k);
                      break;
                    case f.OPS.setFillColorN:
                      this.setFillColorN(k);
                      break;
                    case f.OPS.shadingFill:
                      this.shadingFill(k[0]);
                      break;
                    case f.OPS.setDash:
                      this.setDash(k[0], k[1]);
                      break;
                    case f.OPS.setRenderingIntent:
                      this.setRenderingIntent(k[0]);
                      break;
                    case f.OPS.setFlatness:
                      this.setFlatness(k[0]);
                      break;
                    case f.OPS.setGState:
                      this.setGState(k[0]);
                      break;
                    case f.OPS.fill:
                      this.fill();
                      break;
                    case f.OPS.eoFill:
                      this.eoFill();
                      break;
                    case f.OPS.stroke:
                      this.stroke();
                      break;
                    case f.OPS.fillStroke:
                      this.fillStroke();
                      break;
                    case f.OPS.eoFillStroke:
                      this.eoFillStroke();
                      break;
                    case f.OPS.clip:
                      this.clip("nonzero");
                      break;
                    case f.OPS.eoClip:
                      this.clip("evenodd");
                      break;
                    case f.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask();
                      break;
                    case f.OPS.paintImageXObject:
                      this.paintImageXObject(k[0]);
                      break;
                    case f.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(k[0]);
                      break;
                    case f.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(k[0]);
                      break;
                    case f.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(k[0], k[1]);
                      break;
                    case f.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd();
                      break;
                    case f.OPS.closePath:
                      this.closePath();
                      break;
                    case f.OPS.closeStroke:
                      this.closeStroke();
                      break;
                    case f.OPS.closeFillStroke:
                      this.closeFillStroke();
                      break;
                    case f.OPS.closeEOFillStroke:
                      this.closeEOFillStroke();
                      break;
                    case f.OPS.nextLine:
                      this.nextLine();
                      break;
                    case f.OPS.transform:
                      this.transform(k[0], k[1], k[2], k[3], k[4], k[5]);
                      break;
                    case f.OPS.constructPath:
                      this.constructPath(k[0], k[1]);
                      break;
                    case f.OPS.endPath:
                      this.endPath();
                      break;
                    case 92:
                      this.group(m.items);
                      break;
                    default:
                      (0, f.warn)(`Unimplemented operator ${F}`);
                      break;
                  }
                }
              }
              setWordSpacing(s) {
                this.current.wordSpacing = s;
              }
              setCharSpacing(s) {
                this.current.charSpacing = s;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              setTextMatrix(s, m, F, B, k, V) {
                const z = this.current;
                z.textMatrix = z.lineMatrix = [s, m, F, B, k, V], z.textMatrixScale = Math.hypot(s, m), z.x = z.lineX = 0, z.y = z.lineY = 0, z.xcoords = [], z.ycoords = [], z.tspan = this.svgFactory.createElement("svg:tspan"), z.tspan.setAttributeNS(null, "font-family", z.fontFamily), z.tspan.setAttributeNS(null, "font-size", `${e(z.fontSize)}px`), z.tspan.setAttributeNS(null, "y", e(-z.y)), z.txtElement = this.svgFactory.createElement("svg:text"), z.txtElement.append(z.tspan);
              }
              beginText() {
                const s = this.current;
                s.x = s.lineX = 0, s.y = s.lineY = 0, s.textMatrix = f.IDENTITY_MATRIX, s.lineMatrix = f.IDENTITY_MATRIX, s.textMatrixScale = 1, s.tspan = this.svgFactory.createElement("svg:tspan"), s.txtElement = this.svgFactory.createElement("svg:text"), s.txtgrp = this.svgFactory.createElement("svg:g"), s.xcoords = [], s.ycoords = [];
              }
              moveText(s, m) {
                const F = this.current;
                F.x = F.lineX += s, F.y = F.lineY += m, F.xcoords = [], F.ycoords = [], F.tspan = this.svgFactory.createElement("svg:tspan"), F.tspan.setAttributeNS(null, "font-family", F.fontFamily), F.tspan.setAttributeNS(null, "font-size", `${e(F.fontSize)}px`), F.tspan.setAttributeNS(null, "y", e(-F.y));
              }
              showText(s) {
                const m = this.current, F = m.font, B = m.fontSize;
                if (B === 0)
                  return;
                const k = m.fontSizeScale, V = m.charSpacing, z = m.wordSpacing, K = m.fontDirection, J = m.textHScale * K, $ = F.vertical, j = $ ? 1 : -1, G = F.defaultVMetrics, M = B * m.fontMatrix[0];
                let x = 0;
                for (const I of s) {
                  if (I === null) {
                    x += K * z;
                    continue;
                  } else if (typeof I == "number") {
                    x += j * I * B / 1e3;
                    continue;
                  }
                  const U = (I.isSpace ? z : 0) + V, _ = I.fontChar;
                  let H, N, b = I.width;
                  if ($) {
                    let O;
                    const D = I.vmetric || G;
                    O = I.vmetric ? D[1] : b * 0.5, O = -O * M;
                    const L = D[2] * M;
                    b = D ? -D[0] : b, H = O / k, N = (x + L) / k;
                  } else
                    H = x / k, N = 0;
                  (I.isInFont || F.missingFile) && (m.xcoords.push(m.x + H), $ && m.ycoords.push(-m.y + N), m.tspan.textContent += _);
                  const w = $ ? b * M - U * K : b * M + U * K;
                  x += w;
                }
                m.tspan.setAttributeNS(null, "x", m.xcoords.map(e).join(" ")), $ ? m.tspan.setAttributeNS(null, "y", m.ycoords.map(e).join(" ")) : m.tspan.setAttributeNS(null, "y", e(-m.y)), $ ? m.y -= x : m.x += x * J, m.tspan.setAttributeNS(null, "font-family", m.fontFamily), m.tspan.setAttributeNS(null, "font-size", `${e(m.fontSize)}px`), m.fontStyle !== S.fontStyle && m.tspan.setAttributeNS(null, "font-style", m.fontStyle), m.fontWeight !== S.fontWeight && m.tspan.setAttributeNS(null, "font-weight", m.fontWeight);
                const A = m.textRenderingMode & f.TextRenderingMode.FILL_STROKE_MASK;
                if (A === f.TextRenderingMode.FILL || A === f.TextRenderingMode.FILL_STROKE ? (m.fillColor !== S.fillColor && m.tspan.setAttributeNS(null, "fill", m.fillColor), m.fillAlpha < 1 && m.tspan.setAttributeNS(null, "fill-opacity", m.fillAlpha)) : m.textRenderingMode === f.TextRenderingMode.ADD_TO_PATH ? m.tspan.setAttributeNS(null, "fill", "transparent") : m.tspan.setAttributeNS(null, "fill", "none"), A === f.TextRenderingMode.STROKE || A === f.TextRenderingMode.FILL_STROKE) {
                  const I = 1 / (m.textMatrixScale || 1);
                  this._setStrokeAttributes(m.tspan, I);
                }
                let g = m.textMatrix;
                m.textRise !== 0 && (g = g.slice(), g[5] += m.textRise), m.txtElement.setAttributeNS(null, "transform", `${l(g)} scale(${e(J)}, -1)`), m.txtElement.setAttributeNS(E, "xml:space", "preserve"), m.txtElement.append(m.tspan), m.txtgrp.append(m.txtElement), this._ensureTransformGroup().append(m.txtElement);
              }
              setLeadingMoveText(s, m) {
                this.setLeading(-m), this.moveText(s, m);
              }
              addFontStyle(s) {
                if (!s.data)
                  throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.append(this.cssStyle));
                const m = n(s.data, s.mimetype, this.forceDataSchema);
                this.cssStyle.textContent += `@font-face { font-family: "${s.loadedName}"; src: url(${m}); }
`;
              }
              setFont(s) {
                const m = this.current, F = this.commonObjs.get(s[0]);
                let B = s[1];
                m.font = F, this.embedFonts && !F.missingFile && !this.embeddedFonts[F.loadedName] && (this.addFontStyle(F), this.embeddedFonts[F.loadedName] = F), m.fontMatrix = F.fontMatrix || f.FONT_IDENTITY_MATRIX;
                let k = "normal";
                F.black ? k = "900" : F.bold && (k = "bold");
                const V = F.italic ? "italic" : "normal";
                B < 0 ? (B = -B, m.fontDirection = -1) : m.fontDirection = 1, m.fontSize = B, m.fontFamily = F.loadedName, m.fontWeight = k, m.fontStyle = V, m.tspan = this.svgFactory.createElement("svg:tspan"), m.tspan.setAttributeNS(null, "y", e(-m.y)), m.xcoords = [], m.ycoords = [];
              }
              endText() {
                const s = this.current;
                s.textRenderingMode & f.TextRenderingMode.ADD_TO_PATH_FLAG && s.txtElement?.hasChildNodes() && (s.element = s.txtElement, this.clip("nonzero"), this.endPath());
              }
              setLineWidth(s) {
                s > 0 && (this.current.lineWidth = s);
              }
              setLineCap(s) {
                this.current.lineCap = T[s];
              }
              setLineJoin(s) {
                this.current.lineJoin = i[s];
              }
              setMiterLimit(s) {
                this.current.miterLimit = s;
              }
              setStrokeAlpha(s) {
                this.current.strokeAlpha = s;
              }
              setStrokeRGBColor(s, m, F) {
                this.current.strokeColor = f.Util.makeHexColor(s, m, F);
              }
              setFillAlpha(s) {
                this.current.fillAlpha = s;
              }
              setFillRGBColor(s, m, F) {
                this.current.fillColor = f.Util.makeHexColor(s, m, F), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
              }
              setStrokeColorN(s) {
                this.current.strokeColor = this._makeColorN_Pattern(s);
              }
              setFillColorN(s) {
                this.current.fillColor = this._makeColorN_Pattern(s);
              }
              shadingFill(s) {
                const {
                  width: m,
                  height: F
                } = this.viewport, B = f.Util.inverseTransform(this.transformMatrix), [k, V, z, K] = f.Util.getAxialAlignedBoundingBox([0, 0, m, F], B), J = this.svgFactory.createElement("svg:rect");
                J.setAttributeNS(null, "x", k), J.setAttributeNS(null, "y", V), J.setAttributeNS(null, "width", z - k), J.setAttributeNS(null, "height", K - V), J.setAttributeNS(null, "fill", this._makeShadingPattern(s)), this.current.fillAlpha < 1 && J.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().append(J);
              }
              _makeColorN_Pattern(s) {
                return s[0] === "TilingPattern" ? this._makeTilingPattern(s) : this._makeShadingPattern(s);
              }
              _makeTilingPattern(s) {
                const m = s[1], F = s[2], B = s[3] || f.IDENTITY_MATRIX, [k, V, z, K] = s[4], J = s[5], $ = s[6], j = s[7], G = `shading${y++}`, [M, x, A, g] = f.Util.normalizeRect([...f.Util.applyTransform([k, V], B), ...f.Util.applyTransform([z, K], B)]), [I, U] = f.Util.singularValueDecompose2dScale(B), _ = J * I, H = $ * U, N = this.svgFactory.createElement("svg:pattern");
                N.setAttributeNS(null, "id", G), N.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), N.setAttributeNS(null, "width", _), N.setAttributeNS(null, "height", H), N.setAttributeNS(null, "x", `${M}`), N.setAttributeNS(null, "y", `${x}`);
                const b = this.svg, w = this.transformMatrix, O = this.current.fillColor, D = this.current.strokeColor, L = this.svgFactory.create(A - M, g - x);
                if (this.svg = L, this.transformMatrix = B, j === 2) {
                  const W = f.Util.makeHexColor(...m);
                  this.current.fillColor = W, this.current.strokeColor = W;
                }
                return this.executeOpTree(this.convertOpList(F)), this.svg = b, this.transformMatrix = w, this.current.fillColor = O, this.current.strokeColor = D, N.append(L.childNodes[0]), this.defs.append(N), `url(#${G})`;
              }
              _makeShadingPattern(s) {
                switch (typeof s == "string" && (s = this.objs.get(s)), s[0]) {
                  case "RadialAxial":
                    const m = `shading${y++}`, F = s[3];
                    let B;
                    switch (s[1]) {
                      case "axial":
                        const k = s[4], V = s[5];
                        B = this.svgFactory.createElement("svg:linearGradient"), B.setAttributeNS(null, "id", m), B.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), B.setAttributeNS(null, "x1", k[0]), B.setAttributeNS(null, "y1", k[1]), B.setAttributeNS(null, "x2", V[0]), B.setAttributeNS(null, "y2", V[1]);
                        break;
                      case "radial":
                        const z = s[4], K = s[5], J = s[6], $ = s[7];
                        B = this.svgFactory.createElement("svg:radialGradient"), B.setAttributeNS(null, "id", m), B.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), B.setAttributeNS(null, "cx", K[0]), B.setAttributeNS(null, "cy", K[1]), B.setAttributeNS(null, "r", $), B.setAttributeNS(null, "fx", z[0]), B.setAttributeNS(null, "fy", z[1]), B.setAttributeNS(null, "fr", J);
                        break;
                      default:
                        throw new Error(`Unknown RadialAxial type: ${s[1]}`);
                    }
                    for (const k of F) {
                      const V = this.svgFactory.createElement("svg:stop");
                      V.setAttributeNS(null, "offset", k[0]), V.setAttributeNS(null, "stop-color", k[1]), B.append(V);
                    }
                    return this.defs.append(B), `url(#${m})`;
                  case "Mesh":
                    return (0, f.warn)("Unimplemented pattern Mesh"), null;
                  case "Dummy":
                    return "hotpink";
                  default:
                    throw new Error(`Unknown IR type: ${s[0]}`);
                }
              }
              setDash(s, m) {
                this.current.dashArray = s, this.current.dashPhase = m;
              }
              constructPath(s, m) {
                const F = this.current;
                let B = F.x, k = F.y, V = [], z = 0;
                for (const K of s)
                  switch (K | 0) {
                    case f.OPS.rectangle:
                      B = m[z++], k = m[z++];
                      const J = m[z++], $ = m[z++], j = B + J, G = k + $;
                      V.push("M", e(B), e(k), "L", e(j), e(k), "L", e(j), e(G), "L", e(B), e(G), "Z");
                      break;
                    case f.OPS.moveTo:
                      B = m[z++], k = m[z++], V.push("M", e(B), e(k));
                      break;
                    case f.OPS.lineTo:
                      B = m[z++], k = m[z++], V.push("L", e(B), e(k));
                      break;
                    case f.OPS.curveTo:
                      B = m[z + 4], k = m[z + 5], V.push("C", e(m[z]), e(m[z + 1]), e(m[z + 2]), e(m[z + 3]), e(B), e(k)), z += 6;
                      break;
                    case f.OPS.curveTo2:
                      V.push("C", e(B), e(k), e(m[z]), e(m[z + 1]), e(m[z + 2]), e(m[z + 3])), B = m[z + 2], k = m[z + 3], z += 4;
                      break;
                    case f.OPS.curveTo3:
                      B = m[z + 2], k = m[z + 3], V.push("C", e(m[z]), e(m[z + 1]), e(B), e(k), e(B), e(k)), z += 4;
                      break;
                    case f.OPS.closePath:
                      V.push("Z");
                      break;
                  }
                V = V.join(" "), F.path && s.length > 0 && s[0] !== f.OPS.rectangle && s[0] !== f.OPS.moveTo ? V = F.path.getAttributeNS(null, "d") + V : (F.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().append(F.path)), F.path.setAttributeNS(null, "d", V), F.path.setAttributeNS(null, "fill", "none"), F.element = F.path, F.setCurrentPoint(B, k);
              }
              endPath() {
                const s = this.current;
                if (s.path = null, !this.pendingClip)
                  return;
                if (!s.element) {
                  this.pendingClip = null;
                  return;
                }
                const m = `clippath${u++}`, F = this.svgFactory.createElement("svg:clipPath");
                F.setAttributeNS(null, "id", m), F.setAttributeNS(null, "transform", l(this.transformMatrix));
                const B = s.element.cloneNode(!0);
                if (this.pendingClip === "evenodd" ? B.setAttributeNS(null, "clip-rule", "evenodd") : B.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, F.append(B), this.defs.append(F), s.activeClipUrl) {
                  s.clipGroup = null;
                  for (const k of this.extraStack)
                    k.clipGroup = null;
                  F.setAttributeNS(null, "clip-path", s.activeClipUrl);
                }
                s.activeClipUrl = `url(#${m})`, this.tgrp = null;
              }
              clip(s) {
                this.pendingClip = s;
              }
              closePath() {
                const s = this.current;
                if (s.path) {
                  const m = `${s.path.getAttributeNS(null, "d")}Z`;
                  s.path.setAttributeNS(null, "d", m);
                }
              }
              setLeading(s) {
                this.current.leading = -s;
              }
              setTextRise(s) {
                this.current.textRise = s;
              }
              setTextRenderingMode(s) {
                this.current.textRenderingMode = s;
              }
              setHScale(s) {
                this.current.textHScale = s / 100;
              }
              setRenderingIntent(s) {
              }
              setFlatness(s) {
              }
              setGState(s) {
                for (const [m, F] of s)
                  switch (m) {
                    case "LW":
                      this.setLineWidth(F);
                      break;
                    case "LC":
                      this.setLineCap(F);
                      break;
                    case "LJ":
                      this.setLineJoin(F);
                      break;
                    case "ML":
                      this.setMiterLimit(F);
                      break;
                    case "D":
                      this.setDash(F[0], F[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(F);
                      break;
                    case "FL":
                      this.setFlatness(F);
                      break;
                    case "Font":
                      this.setFont(F);
                      break;
                    case "CA":
                      this.setStrokeAlpha(F);
                      break;
                    case "ca":
                      this.setFillAlpha(F);
                      break;
                    default:
                      (0, f.warn)(`Unimplemented graphic state operator ${m}`);
                      break;
                  }
              }
              fill() {
                const s = this.current;
                s.element && (s.element.setAttributeNS(null, "fill", s.fillColor), s.element.setAttributeNS(null, "fill-opacity", s.fillAlpha), this.endPath());
              }
              stroke() {
                const s = this.current;
                s.element && (this._setStrokeAttributes(s.element), s.element.setAttributeNS(null, "fill", "none"), this.endPath());
              }
              _setStrokeAttributes(s) {
                let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                const F = this.current;
                let B = F.dashArray;
                m !== 1 && B.length > 0 && (B = B.map(function(k) {
                  return m * k;
                })), s.setAttributeNS(null, "stroke", F.strokeColor), s.setAttributeNS(null, "stroke-opacity", F.strokeAlpha), s.setAttributeNS(null, "stroke-miterlimit", e(F.miterLimit)), s.setAttributeNS(null, "stroke-linecap", F.lineCap), s.setAttributeNS(null, "stroke-linejoin", F.lineJoin), s.setAttributeNS(null, "stroke-width", e(m * F.lineWidth) + "px"), s.setAttributeNS(null, "stroke-dasharray", B.map(e).join(" ")), s.setAttributeNS(null, "stroke-dashoffset", e(m * F.dashPhase) + "px");
              }
              eoFill() {
                this.current.element?.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
              }
              fillStroke() {
                this.stroke(), this.fill();
              }
              eoFillStroke() {
                this.current.element?.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.closePath(), this.eoFillStroke();
              }
              paintSolidColorImageMask() {
                const s = this.svgFactory.createElement("svg:rect");
                s.setAttributeNS(null, "x", "0"), s.setAttributeNS(null, "y", "0"), s.setAttributeNS(null, "width", "1px"), s.setAttributeNS(null, "height", "1px"), s.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().append(s);
              }
              paintImageXObject(s) {
                const m = this.getObject(s);
                if (!m) {
                  (0, f.warn)(`Dependent image with object ID ${s} is not ready yet`);
                  return;
                }
                this.paintInlineImageXObject(m);
              }
              paintInlineImageXObject(s, m) {
                const F = s.width, B = s.height, k = o(s, this.forceDataSchema, !!m), V = this.svgFactory.createElement("svg:rect");
                V.setAttributeNS(null, "x", "0"), V.setAttributeNS(null, "y", "0"), V.setAttributeNS(null, "width", e(F)), V.setAttributeNS(null, "height", e(B)), this.current.element = V, this.clip("nonzero");
                const z = this.svgFactory.createElement("svg:image");
                z.setAttributeNS(v, "xlink:href", k), z.setAttributeNS(null, "x", "0"), z.setAttributeNS(null, "y", e(-B)), z.setAttributeNS(null, "width", e(F) + "px"), z.setAttributeNS(null, "height", e(B) + "px"), z.setAttributeNS(null, "transform", `scale(${e(1 / F)} ${e(-1 / B)})`), m ? m.append(z) : this._ensureTransformGroup().append(z);
              }
              paintImageMaskXObject(s) {
                const m = this.getObject(s.data, s);
                if (m.bitmap) {
                  (0, f.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                  return;
                }
                const F = this.current, B = m.width, k = m.height, V = F.fillColor;
                F.maskId = `mask${c++}`;
                const z = this.svgFactory.createElement("svg:mask");
                z.setAttributeNS(null, "id", F.maskId);
                const K = this.svgFactory.createElement("svg:rect");
                K.setAttributeNS(null, "x", "0"), K.setAttributeNS(null, "y", "0"), K.setAttributeNS(null, "width", e(B)), K.setAttributeNS(null, "height", e(k)), K.setAttributeNS(null, "fill", V), K.setAttributeNS(null, "mask", `url(#${F.maskId})`), this.defs.append(z), this._ensureTransformGroup().append(K), this.paintInlineImageXObject(m, z);
              }
              paintFormXObjectBegin(s, m) {
                if (Array.isArray(s) && s.length === 6 && this.transform(s[0], s[1], s[2], s[3], s[4], s[5]), m) {
                  const F = m[2] - m[0], B = m[3] - m[1], k = this.svgFactory.createElement("svg:rect");
                  k.setAttributeNS(null, "x", m[0]), k.setAttributeNS(null, "y", m[1]), k.setAttributeNS(null, "width", e(F)), k.setAttributeNS(null, "height", e(B)), this.current.element = k, this.clip("nonzero"), this.endPath();
                }
              }
              paintFormXObjectEnd() {
              }
              _initialize(s) {
                const m = this.svgFactory.create(s.width, s.height), F = this.svgFactory.createElement("svg:defs");
                m.append(F), this.defs = F;
                const B = this.svgFactory.createElement("svg:g");
                return B.setAttributeNS(null, "transform", l(s.transform)), m.append(B), this.svg = B, m;
              }
              _ensureClipGroup() {
                if (!this.current.clipGroup) {
                  const s = this.svgFactory.createElement("svg:g");
                  s.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.append(s), this.current.clipGroup = s;
                }
                return this.current.clipGroup;
              }
              _ensureTransformGroup() {
                return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", l(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().append(this.tgrp) : this.svg.append(this.tgrp)), this.tgrp;
              }
            }
            p.SVGGraphics = C;
          }),
          /* 187 */
          /***/
          ((P, p, t) => {
            var a = t(3), f = t(188), S = t(193);
            a({
              target: "Array",
              proto: !0
            }, {
              group: function(v) {
                var T = arguments.length > 1 ? arguments[1] : void 0;
                return f(this, v, T);
              }
            }), S("group");
          }),
          /* 188 */
          /***/
          ((P, p, t) => {
            var a = t(99), f = t(14), S = t(13), E = t(40), v = t(18), T = t(64), i = t(189), n = t(108), o = Array, d = f([].push);
            P.exports = function(h, e, l, u) {
              for (var c = E(h), y = S(c), C = a(e, l), R = i(null), s = T(y), m = 0, F, B, k; s > m; m++)
                k = y[m], B = v(C(k, m, c)), B in R ? d(R[B], k) : R[B] = [k];
              if (u && (F = u(c), F !== o))
                for (B in R)
                  R[B] = n(F, R[B]);
              return R;
            };
          }),
          /* 189 */
          /***/
          ((P, p, t) => {
            var a = t(47), f = t(190), S = t(66), E = t(55), v = t(192), T = t(43), i = t(54), n = ">", o = "<", d = "prototype", h = "script", e = i("IE_PROTO"), l = function() {
            }, u = function(s) {
              return o + h + n + s + o + "/" + h + n;
            }, c = function(s) {
              s.write(u("")), s.close();
              var m = s.parentWindow.Object;
              return s = null, m;
            }, y = function() {
              var s = T("iframe"), m = "java" + h + ":", F;
              return s.style.display = "none", v.appendChild(s), s.src = String(m), F = s.contentWindow.document, F.open(), F.write(u("document.F=Object")), F.close(), F.F;
            }, C, R = function() {
              try {
                C = new ActiveXObject("htmlfile");
              } catch {
              }
              R = typeof document < "u" ? document.domain && C ? c(C) : y() : c(C);
              for (var s = S.length; s--; )
                delete R[d][S[s]];
              return R();
            };
            E[e] = !0, P.exports = Object.create || function(m, F) {
              var B;
              return m !== null ? (l[d] = a(m), B = new l(), l[d] = null, B[e] = m) : B = R(), F === void 0 ? B : f.f(B, F);
            };
          }),
          /* 190 */
          /***/
          ((P, p, t) => {
            var a = t(6), f = t(46), S = t(45), E = t(47), v = t(12), T = t(191);
            p.f = a && !f ? Object.defineProperties : function(n, o) {
              E(n);
              for (var d = v(o), h = T(o), e = h.length, l = 0, u; e > l; )
                S.f(n, u = h[l++], d[u]);
              return n;
            };
          }),
          /* 191 */
          /***/
          ((P, p, t) => {
            var a = t(59), f = t(66);
            P.exports = Object.keys || function(E) {
              return a(E, f);
            };
          }),
          /* 192 */
          /***/
          ((P, p, t) => {
            var a = t(24);
            P.exports = a("document", "documentElement");
          }),
          /* 193 */
          /***/
          ((P, p, t) => {
            var a = t(34), f = t(189), S = t(45).f, E = a("unscopables"), v = Array.prototype;
            v[E] === void 0 && S(v, E, {
              configurable: !0,
              value: f(null)
            }), P.exports = function(T) {
              v[E][T] = !0;
            };
          }),
          /* 194 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.XfaText = void 0, t(89);
            class a {
              static textContent(S) {
                const E = [], v = {
                  items: E,
                  styles: /* @__PURE__ */ Object.create(null)
                };
                function T(i) {
                  if (!i)
                    return;
                  let n = null;
                  const o = i.name;
                  if (o === "#text")
                    n = i.value;
                  else if (a.shouldBuildText(o))
                    i?.attributes?.textContent ? n = i.attributes.textContent : i.value && (n = i.value);
                  else return;
                  if (n !== null && E.push({
                    str: n
                  }), !!i.children)
                    for (const d of i.children)
                      T(d);
                }
                return T(S), v;
              }
              static shouldBuildText(S) {
                return !(S === "textarea" || S === "input" || S === "option" || S === "select");
              }
            }
            p.XfaText = a;
          }),
          /* 195 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.TextLayerRenderTask = void 0, p.renderTextLayer = l, p.updateTextLayer = u, t(89), t(2);
            var a = t(1), f = t(168);
            const S = 1e5, E = 30, v = 0.8, T = /* @__PURE__ */ new Map();
            function i(c, y) {
              let C;
              if (y && a.FeatureTest.isOffscreenCanvasSupported)
                C = new OffscreenCanvas(c, c).getContext("2d", {
                  alpha: !1
                });
              else {
                const R = document.createElement("canvas");
                R.width = R.height = c, C = R.getContext("2d", {
                  alpha: !1
                });
              }
              return C;
            }
            function n(c, y) {
              const C = T.get(c);
              if (C)
                return C;
              const R = i(E, y);
              R.font = `${E}px ${c}`;
              const s = R.measureText("");
              let m = s.fontBoundingBoxAscent, F = Math.abs(s.fontBoundingBoxDescent);
              if (m) {
                const k = m / (m + F);
                return T.set(c, k), R.canvas.width = R.canvas.height = 0, k;
              }
              R.strokeStyle = "red", R.clearRect(0, 0, E, E), R.strokeText("g", 0, 0);
              let B = R.getImageData(0, 0, E, E).data;
              F = 0;
              for (let k = B.length - 1 - 3; k >= 0; k -= 4)
                if (B[k] > 0) {
                  F = Math.ceil(k / 4 / E);
                  break;
                }
              R.clearRect(0, 0, E, E), R.strokeText("A", 0, E), B = R.getImageData(0, 0, E, E).data, m = 0;
              for (let k = 0, V = B.length; k < V; k += 4)
                if (B[k] > 0) {
                  m = E - Math.floor(k / 4 / E);
                  break;
                }
              if (R.canvas.width = R.canvas.height = 0, m) {
                const k = m / (m + F);
                return T.set(c, k), k;
              }
              return T.set(c, v), v;
            }
            function o(c, y, C) {
              const R = document.createElement("span"), s = {
                angle: 0,
                canvasWidth: 0,
                hasText: y.str !== "",
                hasEOL: y.hasEOL,
                fontSize: 0
              };
              c._textDivs.push(R);
              const m = a.Util.transform(c._transform, y.transform);
              let F = Math.atan2(m[1], m[0]);
              const B = C[y.fontName];
              B.vertical && (F += Math.PI / 2);
              const k = Math.hypot(m[2], m[3]), V = k * n(B.fontFamily, c._isOffscreenCanvasSupported);
              let z, K;
              F === 0 ? (z = m[4], K = m[5] - V) : (z = m[4] + V * Math.sin(F), K = m[5] - V * Math.cos(F));
              const J = "calc(var(--scale-factor)*", $ = R.style;
              c._container === c._rootContainer ? ($.left = `${(100 * z / c._pageWidth).toFixed(2)}%`, $.top = `${(100 * K / c._pageHeight).toFixed(2)}%`) : ($.left = `${J}${z.toFixed(2)}px)`, $.top = `${J}${K.toFixed(2)}px)`), $.fontSize = `${J}${k.toFixed(2)}px)`, $.fontFamily = B.fontFamily, s.fontSize = k, R.setAttribute("role", "presentation"), R.textContent = y.str, R.dir = y.dir, c._fontInspectorEnabled && (R.dataset.fontName = y.fontName), F !== 0 && (s.angle = F * (180 / Math.PI));
              let j = !1;
              if (y.str.length > 1)
                j = !0;
              else if (y.str !== " " && y.transform[0] !== y.transform[3]) {
                const G = Math.abs(y.transform[0]), M = Math.abs(y.transform[3]);
                G !== M && Math.max(G, M) / Math.min(G, M) > 1.5 && (j = !0);
              }
              j && (s.canvasWidth = B.vertical ? y.height : y.width), c._textDivProperties.set(R, s), c._isReadableStream && c._layoutText(R);
            }
            function d(c) {
              const {
                div: y,
                scale: C,
                properties: R,
                ctx: s,
                prevFontSize: m,
                prevFontFamily: F
              } = c, {
                style: B
              } = y;
              let k = "";
              if (R.canvasWidth !== 0 && R.hasText) {
                const {
                  fontFamily: V
                } = B, {
                  canvasWidth: z,
                  fontSize: K
                } = R;
                (m !== K || F !== V) && (s.font = `${K * C}px ${V}`, c.prevFontSize = K, c.prevFontFamily = V);
                const {
                  width: J
                } = s.measureText(y.textContent);
                J > 0 && (k = `scaleX(${z * C / J})`);
              }
              R.angle !== 0 && (k = `rotate(${R.angle}deg) ${k}`), k.length > 0 && (B.transform = k);
            }
            function h(c) {
              if (c._canceled)
                return;
              const y = c._textDivs, C = c._capability;
              if (y.length > S) {
                C.resolve();
                return;
              }
              if (!c._isReadableStream)
                for (const s of y)
                  c._layoutText(s);
              C.resolve();
            }
            class e {
              constructor(y) {
                let {
                  textContentSource: C,
                  container: R,
                  viewport: s,
                  textDivs: m,
                  textDivProperties: F,
                  textContentItemsStr: B,
                  isOffscreenCanvasSupported: k
                } = y;
                this._textContentSource = C, this._isReadableStream = C instanceof ReadableStream, this._container = this._rootContainer = R, this._textDivs = m || [], this._textContentItemsStr = B || [], this._isOffscreenCanvasSupported = k, this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled, this._reader = null, this._textDivProperties = F || /* @__PURE__ */ new WeakMap(), this._canceled = !1, this._capability = new a.PromiseCapability(), this._layoutTextParams = {
                  prevFontSize: null,
                  prevFontFamily: null,
                  div: null,
                  scale: s.scale * (globalThis.devicePixelRatio || 1),
                  properties: null,
                  ctx: i(0, k)
                };
                const {
                  pageWidth: V,
                  pageHeight: z,
                  pageX: K,
                  pageY: J
                } = s.rawDims;
                this._transform = [1, 0, 0, -1, -K, J + z], this._pageWidth = V, this._pageHeight = z, (0, f.setLayerDimensions)(R, s), this._capability.promise.finally(() => {
                  this._layoutTextParams = null;
                }).catch(() => {
                });
              }
              get promise() {
                return this._capability.promise;
              }
              cancel() {
                this._canceled = !0, this._reader && (this._reader.cancel(new a.AbortException("TextLayer task cancelled.")).catch(() => {
                }), this._reader = null), this._capability.reject(new a.AbortException("TextLayer task cancelled."));
              }
              _processItems(y, C) {
                for (const R of y) {
                  if (R.str === void 0) {
                    if (R.type === "beginMarkedContentProps" || R.type === "beginMarkedContent") {
                      const s = this._container;
                      this._container = document.createElement("span"), this._container.classList.add("markedContent"), R.id !== null && this._container.setAttribute("id", `${R.id}`), s.append(this._container);
                    } else R.type === "endMarkedContent" && (this._container = this._container.parentNode);
                    continue;
                  }
                  this._textContentItemsStr.push(R.str), o(this, R, C);
                }
              }
              _layoutText(y) {
                const C = this._layoutTextParams.properties = this._textDivProperties.get(y);
                if (this._layoutTextParams.div = y, d(this._layoutTextParams), C.hasText && this._container.append(y), C.hasEOL) {
                  const R = document.createElement("br");
                  R.setAttribute("role", "presentation"), this._container.append(R);
                }
              }
              _render() {
                const y = new a.PromiseCapability();
                let C = /* @__PURE__ */ Object.create(null);
                if (this._isReadableStream) {
                  const R = () => {
                    this._reader.read().then((s) => {
                      let {
                        value: m,
                        done: F
                      } = s;
                      if (F) {
                        y.resolve();
                        return;
                      }
                      Object.assign(C, m.styles), this._processItems(m.items, C), R();
                    }, y.reject);
                  };
                  this._reader = this._textContentSource.getReader(), R();
                } else if (this._textContentSource) {
                  const {
                    items: R,
                    styles: s
                  } = this._textContentSource;
                  this._processItems(R, s), y.resolve();
                } else
                  throw new Error('No "textContentSource" parameter specified.');
                y.promise.then(() => {
                  C = null, h(this);
                }, this._capability.reject);
              }
            }
            p.TextLayerRenderTask = e;
            function l(c) {
              !c.textContentSource && (c.textContent || c.textContentStream) && ((0, f.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead."), c.textContentSource = c.textContent || c.textContentStream);
              const {
                container: y,
                viewport: C
              } = c, R = getComputedStyle(y), s = R.getPropertyValue("visibility"), m = parseFloat(R.getPropertyValue("--scale-factor"));
              s === "visible" && (!m || Math.abs(m - C.scale) > 1e-5) && console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
              const F = new e(c);
              return F._render(), F;
            }
            function u(c) {
              let {
                container: y,
                viewport: C,
                textDivs: R,
                textDivProperties: s,
                isOffscreenCanvasSupported: m,
                mustRotate: F = !0,
                mustRescale: B = !0
              } = c;
              if (F && (0, f.setLayerDimensions)(y, {
                rotation: C.rotation
              }), B) {
                const k = i(0, m), z = {
                  prevFontSize: null,
                  prevFontFamily: null,
                  div: null,
                  scale: C.scale * (globalThis.devicePixelRatio || 1),
                  properties: null,
                  ctx: k
                };
                for (const K of R)
                  z.properties = s.get(K), z.div = K, d(z);
              }
            }
          }),
          /* 196 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.AnnotationEditorLayer = void 0, t(125), t(136), t(138), t(141), t(143), t(145), t(147);
            var a = t(1), f = t(164), S = t(197), E = t(202), v = t(168), T = t(203);
            class i {
              #t;
              #e = !1;
              #n = null;
              #i = this.pointerup.bind(this);
              #o = this.pointerdown.bind(this);
              #s = /* @__PURE__ */ new Map();
              #a = !1;
              #l = !1;
              #c = !1;
              #r;
              static _initialized = !1;
              constructor(o) {
                let {
                  uiManager: d,
                  pageIndex: h,
                  div: e,
                  accessibilityManager: l,
                  annotationLayer: u,
                  viewport: c,
                  l10n: y
                } = o;
                const C = [S.FreeTextEditor, E.InkEditor, T.StampEditor];
                if (!i._initialized) {
                  i._initialized = !0;
                  for (const R of C)
                    R.initialize(y);
                }
                d.registerEditorTypes(C), this.#r = d, this.pageIndex = h, this.div = e, this.#t = l, this.#n = u, this.viewport = c, this.#r.addLayer(this);
              }
              get isEmpty() {
                return this.#s.size === 0;
              }
              updateToolbar(o) {
                this.#r.updateToolbar(o);
              }
              updateMode() {
                let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.#r.getMode();
                this.#p(), o === a.AnnotationEditorType.INK ? (this.addInkEditorIfNeeded(!1), this.disableClick()) : this.enableClick(), o !== a.AnnotationEditorType.NONE && (this.div.classList.toggle("freeTextEditing", o === a.AnnotationEditorType.FREETEXT), this.div.classList.toggle("inkEditing", o === a.AnnotationEditorType.INK), this.div.classList.toggle("stampEditing", o === a.AnnotationEditorType.STAMP), this.div.hidden = !1);
              }
              addInkEditorIfNeeded(o) {
                if (!o && this.#r.getMode() !== a.AnnotationEditorType.INK)
                  return;
                if (!o) {
                  for (const h of this.#s.values())
                    if (h.isEmpty()) {
                      h.setInBackground();
                      return;
                    }
                }
                this.#u({
                  offsetX: 0,
                  offsetY: 0
                }, !1).setInBackground();
              }
              setEditingState(o) {
                this.#r.setEditingState(o);
              }
              addCommands(o) {
                this.#r.addCommands(o);
              }
              enable() {
                this.div.style.pointerEvents = "auto";
                const o = /* @__PURE__ */ new Set();
                for (const h of this.#s.values())
                  h.enableEditing(), h.annotationElementId && o.add(h.annotationElementId);
                if (!this.#n)
                  return;
                const d = this.#n.getEditableAnnotations();
                for (const h of d) {
                  if (h.hide(), this.#r.isDeletedAnnotationElement(h.data.id) || o.has(h.data.id))
                    continue;
                  const e = this.deserialize(h);
                  e && (this.addOrRebuild(e), e.enableEditing());
                }
              }
              disable() {
                this.#c = !0, this.div.style.pointerEvents = "none";
                const o = /* @__PURE__ */ new Set();
                for (const d of this.#s.values()) {
                  if (d.disableEditing(), !d.annotationElementId || d.serialize() !== null) {
                    o.add(d.annotationElementId);
                    continue;
                  }
                  this.getEditableAnnotation(d.annotationElementId)?.show(), d.remove();
                }
                if (this.#n) {
                  const d = this.#n.getEditableAnnotations();
                  for (const h of d) {
                    const {
                      id: e
                    } = h.data;
                    o.has(e) || this.#r.isDeletedAnnotationElement(e) || h.show();
                  }
                }
                this.#p(), this.isEmpty && (this.div.hidden = !0), this.#c = !1;
              }
              getEditableAnnotation(o) {
                return this.#n?.getEditableAnnotation(o) || null;
              }
              setActiveEditor(o) {
                this.#r.getActive() !== o && this.#r.setActiveEditor(o);
              }
              enableClick() {
                this.div.addEventListener("pointerdown", this.#o), this.div.addEventListener("pointerup", this.#i);
              }
              disableClick() {
                this.div.removeEventListener("pointerdown", this.#o), this.div.removeEventListener("pointerup", this.#i);
              }
              attach(o) {
                this.#s.set(o.id, o);
                const {
                  annotationElementId: d
                } = o;
                d && this.#r.isDeletedAnnotationElement(d) && this.#r.removeDeletedAnnotationElement(o);
              }
              detach(o) {
                this.#s.delete(o.id), this.#t?.removePointerInTextLayer(o.contentDiv), !this.#c && o.annotationElementId && this.#r.addDeletedAnnotationElement(o);
              }
              remove(o) {
                this.detach(o), this.#r.removeEditor(o), o.div.contains(document.activeElement) && setTimeout(() => {
                  this.#r.focusMainContainer();
                }, 0), o.div.remove(), o.isAttachedToDOM = !1, this.#l || this.addInkEditorIfNeeded(!1);
              }
              changeParent(o) {
                o.parent !== this && (o.annotationElementId && (this.#r.addDeletedAnnotationElement(o.annotationElementId), f.AnnotationEditor.deleteAnnotationElement(o), o.annotationElementId = null), this.attach(o), o.parent?.detach(o), o.setParent(this), o.div && o.isAttachedToDOM && (o.div.remove(), this.div.append(o.div)));
              }
              add(o) {
                if (this.changeParent(o), this.#r.addEditor(o), this.attach(o), !o.isAttachedToDOM) {
                  const d = o.render();
                  this.div.append(d), o.isAttachedToDOM = !0;
                }
                o.fixAndSetPosition(), o.onceAdded(), this.#r.addToAnnotationStorage(o);
              }
              moveEditorInDOM(o) {
                if (!o.isAttachedToDOM)
                  return;
                const {
                  activeElement: d
                } = document;
                o.div.contains(d) && (o._focusEventsAllowed = !1, setTimeout(() => {
                  o.div.contains(document.activeElement) ? o._focusEventsAllowed = !0 : (o.div.addEventListener("focusin", () => {
                    o._focusEventsAllowed = !0;
                  }, {
                    once: !0
                  }), d.focus());
                }, 0)), o._structTreeParentId = this.#t?.moveElementInDOM(this.div, o.div, o.contentDiv, !0);
              }
              addOrRebuild(o) {
                o.needsToBeRebuilt() ? o.rebuild() : this.add(o);
              }
              addUndoableEditor(o) {
                const d = () => o._uiManager.rebuild(o), h = () => {
                  o.remove();
                };
                this.addCommands({
                  cmd: d,
                  undo: h,
                  mustExec: !1
                });
              }
              getNextId() {
                return this.#r.getId();
              }
              #h(o) {
                switch (this.#r.getMode()) {
                  case a.AnnotationEditorType.FREETEXT:
                    return new S.FreeTextEditor(o);
                  case a.AnnotationEditorType.INK:
                    return new E.InkEditor(o);
                  case a.AnnotationEditorType.STAMP:
                    return new T.StampEditor(o);
                }
                return null;
              }
              pasteEditor(o, d) {
                this.#r.updateToolbar(o), this.#r.updateMode(o);
                const {
                  offsetX: h,
                  offsetY: e
                } = this.#f(), l = this.getNextId(), u = this.#h({
                  parent: this,
                  id: l,
                  x: h,
                  y: e,
                  uiManager: this.#r,
                  isCentered: !0,
                  ...d
                });
                u && this.add(u);
              }
              deserialize(o) {
                switch (o.annotationType ?? o.annotationEditorType) {
                  case a.AnnotationEditorType.FREETEXT:
                    return S.FreeTextEditor.deserialize(o, this, this.#r);
                  case a.AnnotationEditorType.INK:
                    return E.InkEditor.deserialize(o, this, this.#r);
                  case a.AnnotationEditorType.STAMP:
                    return T.StampEditor.deserialize(o, this, this.#r);
                }
                return null;
              }
              #u(o, d) {
                const h = this.getNextId(), e = this.#h({
                  parent: this,
                  id: h,
                  x: o.offsetX,
                  y: o.offsetY,
                  uiManager: this.#r,
                  isCentered: d
                });
                return e && this.add(e), e;
              }
              #f() {
                const {
                  x: o,
                  y: d,
                  width: h,
                  height: e
                } = this.div.getBoundingClientRect(), l = Math.max(0, o), u = Math.max(0, d), c = Math.min(window.innerWidth, o + h), y = Math.min(window.innerHeight, d + e), C = (l + c) / 2 - o, R = (u + y) / 2 - d, [s, m] = this.viewport.rotation % 180 === 0 ? [C, R] : [R, C];
                return {
                  offsetX: s,
                  offsetY: m
                };
              }
              addNewEditor() {
                this.#u(this.#f(), !0);
              }
              setSelected(o) {
                this.#r.setSelected(o);
              }
              toggleSelected(o) {
                this.#r.toggleSelected(o);
              }
              isSelected(o) {
                return this.#r.isSelected(o);
              }
              unselect(o) {
                this.#r.unselect(o);
              }
              pointerup(o) {
                const {
                  isMac: d
                } = a.FeatureTest.platform;
                if (!(o.button !== 0 || o.ctrlKey && d) && o.target === this.div && this.#a) {
                  if (this.#a = !1, !this.#e) {
                    this.#e = !0;
                    return;
                  }
                  if (this.#r.getMode() === a.AnnotationEditorType.STAMP) {
                    this.#r.unselectAll();
                    return;
                  }
                  this.#u(o, !1);
                }
              }
              pointerdown(o) {
                if (this.#a) {
                  this.#a = !1;
                  return;
                }
                const {
                  isMac: d
                } = a.FeatureTest.platform;
                if (o.button !== 0 || o.ctrlKey && d || o.target !== this.div)
                  return;
                this.#a = !0;
                const h = this.#r.getActive();
                this.#e = !h || h.isEmpty();
              }
              findNewParent(o, d, h) {
                const e = this.#r.findParent(d, h);
                return e === null || e === this ? !1 : (e.changeParent(o), !0);
              }
              destroy() {
                this.#r.getActive()?.parent === this && (this.#r.commitOrRemove(), this.#r.setActiveEditor(null));
                for (const o of this.#s.values())
                  this.#t?.removePointerInTextLayer(o.contentDiv), o.setParent(null), o.isAttachedToDOM = !1, o.div.remove();
                this.div = null, this.#s.clear(), this.#r.removeLayer(this);
              }
              #p() {
                this.#l = !0;
                for (const o of this.#s.values())
                  o.isEmpty() && o.remove();
                this.#l = !1;
              }
              render(o) {
                let {
                  viewport: d
                } = o;
                this.viewport = d, (0, v.setLayerDimensions)(this.div, d);
                for (const h of this.#r.getEditors(this.pageIndex))
                  this.add(h);
                this.updateMode();
              }
              update(o) {
                let {
                  viewport: d
                } = o;
                this.#r.commitOrRemove(), this.viewport = d, (0, v.setLayerDimensions)(this.div, {
                  rotation: d.rotation
                }), this.updateMode();
              }
              get pageDimensions() {
                const {
                  pageWidth: o,
                  pageHeight: d
                } = this.viewport.rawDims;
                return [o, d];
              }
            }
            p.AnnotationEditorLayer = i;
          }),
          /* 197 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.FreeTextEditor = void 0, t(89);
            var a = t(1), f = t(165), S = t(164), E = t(198);
            class v extends S.AnnotationEditor {
              #t = this.editorDivBlur.bind(this);
              #e = this.editorDivFocus.bind(this);
              #n = this.editorDivInput.bind(this);
              #i = this.editorDivKeydown.bind(this);
              #o;
              #s = "";
              #a = `${this.id}-editor`;
              #l;
              #c = null;
              static _freeTextDefaultContent = "";
              static _internalPadding = 0;
              static _defaultColor = null;
              static _defaultFontSize = 10;
              static get _keyboardManager() {
                const i = v.prototype, n = (h) => h.isEmpty(), o = f.AnnotationEditorUIManager.TRANSLATE_SMALL, d = f.AnnotationEditorUIManager.TRANSLATE_BIG;
                return (0, a.shadow)(this, "_keyboardManager", new f.KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], i.commitOrRemove, {
                  bubbles: !0
                }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], i.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], i._translateEmpty, {
                  args: [-o, 0],
                  checker: n
                }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], i._translateEmpty, {
                  args: [-d, 0],
                  checker: n
                }], [["ArrowRight", "mac+ArrowRight"], i._translateEmpty, {
                  args: [o, 0],
                  checker: n
                }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], i._translateEmpty, {
                  args: [d, 0],
                  checker: n
                }], [["ArrowUp", "mac+ArrowUp"], i._translateEmpty, {
                  args: [0, -o],
                  checker: n
                }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], i._translateEmpty, {
                  args: [0, -d],
                  checker: n
                }], [["ArrowDown", "mac+ArrowDown"], i._translateEmpty, {
                  args: [0, o],
                  checker: n
                }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], i._translateEmpty, {
                  args: [0, d],
                  checker: n
                }]]));
              }
              static _type = "freetext";
              constructor(i) {
                super({
                  ...i,
                  name: "freeTextEditor"
                }), this.#o = i.color || v._defaultColor || S.AnnotationEditor._defaultLineColor, this.#l = i.fontSize || v._defaultFontSize;
              }
              static initialize(i) {
                S.AnnotationEditor.initialize(i, {
                  strings: ["free_text2_default_content", "editor_free_text2_aria_label"]
                });
                const n = getComputedStyle(document.documentElement);
                this._internalPadding = parseFloat(n.getPropertyValue("--freetext-padding"));
              }
              static updateDefaultParams(i, n) {
                switch (i) {
                  case a.AnnotationEditorParamsType.FREETEXT_SIZE:
                    v._defaultFontSize = n;
                    break;
                  case a.AnnotationEditorParamsType.FREETEXT_COLOR:
                    v._defaultColor = n;
                    break;
                }
              }
              updateParams(i, n) {
                switch (i) {
                  case a.AnnotationEditorParamsType.FREETEXT_SIZE:
                    this.#r(n);
                    break;
                  case a.AnnotationEditorParamsType.FREETEXT_COLOR:
                    this.#h(n);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[a.AnnotationEditorParamsType.FREETEXT_SIZE, v._defaultFontSize], [a.AnnotationEditorParamsType.FREETEXT_COLOR, v._defaultColor || S.AnnotationEditor._defaultLineColor]];
              }
              get propertiesToUpdate() {
                return [[a.AnnotationEditorParamsType.FREETEXT_SIZE, this.#l], [a.AnnotationEditorParamsType.FREETEXT_COLOR, this.#o]];
              }
              #r(i) {
                const n = (d) => {
                  this.editorDiv.style.fontSize = `calc(${d}px * var(--scale-factor))`, this.translate(0, -(d - this.#l) * this.parentScale), this.#l = d, this.#f();
                }, o = this.#l;
                this.addCommands({
                  cmd: () => {
                    n(i);
                  },
                  undo: () => {
                    n(o);
                  },
                  mustExec: !0,
                  type: a.AnnotationEditorParamsType.FREETEXT_SIZE,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              #h(i) {
                const n = this.#o;
                this.addCommands({
                  cmd: () => {
                    this.#o = this.editorDiv.style.color = i;
                  },
                  undo: () => {
                    this.#o = this.editorDiv.style.color = n;
                  },
                  mustExec: !0,
                  type: a.AnnotationEditorParamsType.FREETEXT_COLOR,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              _translateEmpty(i, n) {
                this._uiManager.translateSelectedEditors(i, n, !0);
              }
              getInitialTranslation() {
                const i = this.parentScale;
                return [-v._internalPadding * i, -(v._internalPadding + this.#l) * i];
              }
              rebuild() {
                this.parent && (super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this)));
              }
              enableEditMode() {
                this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(a.AnnotationEditorType.FREETEXT), super.enableEditMode(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this._isDraggable = !1, this.div.removeAttribute("aria-activedescendant"), this.editorDiv.addEventListener("keydown", this.#i), this.editorDiv.addEventListener("focus", this.#e), this.editorDiv.addEventListener("blur", this.#t), this.editorDiv.addEventListener("input", this.#n));
              }
              disableEditMode() {
                this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", this.#a), this._isDraggable = !0, this.editorDiv.removeEventListener("keydown", this.#i), this.editorDiv.removeEventListener("focus", this.#e), this.editorDiv.removeEventListener("blur", this.#t), this.editorDiv.removeEventListener("input", this.#n), this.div.focus({
                  preventScroll: !0
                }), this.isEditing = !1, this.parent.div.classList.add("freeTextEditing"));
              }
              focusin(i) {
                this._focusEventsAllowed && (super.focusin(i), i.target !== this.editorDiv && this.editorDiv.focus());
              }
              onceAdded() {
                if (this.width) {
                  this.#m();
                  return;
                }
                this.enableEditMode(), this.editorDiv.focus(), this._initialOptions?.isCentered && this.center(), this._initialOptions = null;
              }
              isEmpty() {
                return !this.editorDiv || this.editorDiv.innerText.trim() === "";
              }
              remove() {
                this.isEditing = !1, this.parent && (this.parent.setEditingState(!0), this.parent.div.classList.add("freeTextEditing")), super.remove();
              }
              #u() {
                const i = this.editorDiv.getElementsByTagName("div");
                if (i.length === 0)
                  return this.editorDiv.innerText;
                const n = [];
                for (const o of i)
                  n.push(o.innerText.replace(/\r\n?|\n/, ""));
                return n.join(`
`);
              }
              #f() {
                const [i, n] = this.parentDimensions;
                let o;
                if (this.isAttachedToDOM)
                  o = this.div.getBoundingClientRect();
                else {
                  const {
                    currentLayer: d,
                    div: h
                  } = this, e = h.style.display;
                  h.style.display = "hidden", d.div.append(this.div), o = h.getBoundingClientRect(), h.remove(), h.style.display = e;
                }
                this.rotation % 180 === this.parentRotation % 180 ? (this.width = o.width / i, this.height = o.height / n) : (this.width = o.height / i, this.height = o.width / n), this.fixAndSetPosition();
              }
              commit() {
                if (!this.isInEditMode())
                  return;
                super.commit(), this.disableEditMode();
                const i = this.#s, n = this.#s = this.#u().trimEnd();
                if (i === n)
                  return;
                const o = (d) => {
                  if (this.#s = d, !d) {
                    this.remove();
                    return;
                  }
                  this.#p(), this._uiManager.rebuild(this), this.#f();
                };
                this.addCommands({
                  cmd: () => {
                    o(n);
                  },
                  undo: () => {
                    o(i);
                  },
                  mustExec: !1
                }), this.#f();
              }
              shouldGetKeyboardEvents() {
                return this.isInEditMode();
              }
              enterInEditMode() {
                this.enableEditMode(), this.editorDiv.focus();
              }
              dblclick(i) {
                this.enterInEditMode();
              }
              keydown(i) {
                i.target === this.div && i.key === "Enter" && (this.enterInEditMode(), i.preventDefault());
              }
              editorDivKeydown(i) {
                v._keyboardManager.exec(this, i);
              }
              editorDivFocus(i) {
                this.isEditing = !0;
              }
              editorDivBlur(i) {
                this.isEditing = !1;
              }
              editorDivInput(i) {
                this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
              }
              disableEditing() {
                this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
              }
              enableEditing() {
                this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
              }
              render() {
                if (this.div)
                  return this.div;
                let i, n;
                this.width && (i = this.x, n = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", this.#a), this.enableEditing(), S.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((d) => this.editorDiv?.setAttribute("aria-label", d)), S.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((d) => this.editorDiv?.setAttribute("default-content", d)), this.editorDiv.contentEditable = !0;
                const {
                  style: o
                } = this.editorDiv;
                if (o.fontSize = `calc(${this.#l}px * var(--scale-factor))`, o.color = this.#o, this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), (0, f.bindEvents)(this, this.div, ["dblclick", "keydown"]), this.width) {
                  const [d, h] = this.parentDimensions;
                  if (this.annotationElementId) {
                    const {
                      position: e
                    } = this.#c;
                    let [l, u] = this.getInitialTranslation();
                    [l, u] = this.pageTranslationToScreen(l, u);
                    const [c, y] = this.pageDimensions, [C, R] = this.pageTranslation;
                    let s, m;
                    switch (this.rotation) {
                      case 0:
                        s = i + (e[0] - C) / c, m = n + this.height - (e[1] - R) / y;
                        break;
                      case 90:
                        s = i + (e[0] - C) / c, m = n - (e[1] - R) / y, [l, u] = [u, -l];
                        break;
                      case 180:
                        s = i - this.width + (e[0] - C) / c, m = n - (e[1] - R) / y, [l, u] = [-l, -u];
                        break;
                      case 270:
                        s = i + (e[0] - C - this.height * y) / c, m = n + (e[1] - R - this.width * c) / y, [l, u] = [-u, l];
                        break;
                    }
                    this.setAt(s * d, m * h, l, u);
                  } else
                    this.setAt(i * d, n * h, this.width * d, this.height * h);
                  this.#p(), this._isDraggable = !0, this.editorDiv.contentEditable = !1;
                } else
                  this._isDraggable = !1, this.editorDiv.contentEditable = !0;
                return this.div;
              }
              #p() {
                if (this.editorDiv.replaceChildren(), !!this.#s)
                  for (const i of this.#s.split(`
`)) {
                    const n = document.createElement("div");
                    n.append(i ? document.createTextNode(i) : document.createElement("br")), this.editorDiv.append(n);
                  }
              }
              get contentDiv() {
                return this.editorDiv;
              }
              static deserialize(i, n, o) {
                let d = null;
                if (i instanceof E.FreeTextAnnotationElement) {
                  const {
                    data: {
                      defaultAppearanceData: {
                        fontSize: e,
                        fontColor: l
                      },
                      rect: u,
                      rotation: c,
                      id: y
                    },
                    textContent: C,
                    textPosition: R,
                    parent: {
                      page: {
                        pageNumber: s
                      }
                    }
                  } = i;
                  if (!C || C.length === 0)
                    return null;
                  d = i = {
                    annotationType: a.AnnotationEditorType.FREETEXT,
                    color: Array.from(l),
                    fontSize: e,
                    value: C.join(`
`),
                    position: R,
                    pageIndex: s - 1,
                    rect: u,
                    rotation: c,
                    id: y,
                    deleted: !1
                  };
                }
                const h = super.deserialize(i, n, o);
                return h.#l = i.fontSize, h.#o = a.Util.makeHexColor(...i.color), h.#s = i.value, h.annotationElementId = i.id || null, h.#c = d, h;
              }
              serialize() {
                let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                if (this.isEmpty())
                  return null;
                if (this.deleted)
                  return {
                    pageIndex: this.pageIndex,
                    id: this.annotationElementId,
                    deleted: !0
                  };
                const n = v._internalPadding * this.parentScale, o = this.getRect(n, n), d = S.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#o), h = {
                  annotationType: a.AnnotationEditorType.FREETEXT,
                  color: d,
                  fontSize: this.#l,
                  value: this.#s,
                  pageIndex: this.pageIndex,
                  rect: o,
                  rotation: this.rotation,
                  structTreeParentId: this._structTreeParentId
                };
                return i ? h : this.annotationElementId && !this.#g(h) ? null : (h.id = this.annotationElementId, h);
              }
              #g(i) {
                const {
                  value: n,
                  fontSize: o,
                  color: d,
                  rect: h,
                  pageIndex: e
                } = this.#c;
                return i.value !== n || i.fontSize !== o || i.rect.some((l, u) => Math.abs(l - h[u]) >= 1) || i.color.some((l, u) => l !== d[u]) || i.pageIndex !== e;
              }
              #m() {
                let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                if (!this.annotationElementId)
                  return;
                if (this.#f(), !i && (this.width === 0 || this.height === 0)) {
                  setTimeout(() => this.#m(!0), 0);
                  return;
                }
                const n = v._internalPadding * this.parentScale;
                this.#c.rect = this.getRect(n, n);
              }
            }
            p.FreeTextEditor = v;
          }),
          /* 198 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.StampAnnotationElement = p.InkAnnotationElement = p.FreeTextAnnotationElement = p.AnnotationLayer = void 0, t(89), t(125), t(136), t(138), t(141), t(143), t(145), t(147);
            var a = t(1), f = t(168), S = t(163), E = t(199), v = t(200), T = t(201);
            const i = 1e3, n = 9, o = /* @__PURE__ */ new WeakSet();
            function d(N) {
              return {
                width: N[2] - N[0],
                height: N[3] - N[1]
              };
            }
            class h {
              static create(b) {
                switch (b.data.annotationType) {
                  case a.AnnotationType.LINK:
                    return new l(b);
                  case a.AnnotationType.TEXT:
                    return new u(b);
                  case a.AnnotationType.WIDGET:
                    switch (b.data.fieldType) {
                      case "Tx":
                        return new y(b);
                      case "Btn":
                        return b.data.radioButton ? new s(b) : b.data.checkBox ? new R(b) : new m(b);
                      case "Ch":
                        return new F(b);
                      case "Sig":
                        return new C(b);
                    }
                    return new c(b);
                  case a.AnnotationType.POPUP:
                    return new B(b);
                  case a.AnnotationType.FREETEXT:
                    return new V(b);
                  case a.AnnotationType.LINE:
                    return new z(b);
                  case a.AnnotationType.SQUARE:
                    return new K(b);
                  case a.AnnotationType.CIRCLE:
                    return new J(b);
                  case a.AnnotationType.POLYLINE:
                    return new $(b);
                  case a.AnnotationType.CARET:
                    return new G(b);
                  case a.AnnotationType.INK:
                    return new M(b);
                  case a.AnnotationType.POLYGON:
                    return new j(b);
                  case a.AnnotationType.HIGHLIGHT:
                    return new x(b);
                  case a.AnnotationType.UNDERLINE:
                    return new A(b);
                  case a.AnnotationType.SQUIGGLY:
                    return new g(b);
                  case a.AnnotationType.STRIKEOUT:
                    return new I(b);
                  case a.AnnotationType.STAMP:
                    return new U(b);
                  case a.AnnotationType.FILEATTACHMENT:
                    return new _(b);
                  default:
                    return new e(b);
                }
              }
            }
            class e {
              #t = !1;
              constructor(b) {
                let {
                  isRenderable: w = !1,
                  ignoreBorder: O = !1,
                  createQuadrilaterals: D = !1
                } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.isRenderable = w, this.data = b.data, this.layer = b.layer, this.linkService = b.linkService, this.downloadManager = b.downloadManager, this.imageResourcesPath = b.imageResourcesPath, this.renderForms = b.renderForms, this.svgFactory = b.svgFactory, this.annotationStorage = b.annotationStorage, this.enableScripting = b.enableScripting, this.hasJSActions = b.hasJSActions, this._fieldObjects = b.fieldObjects, this.parent = b.parent, w && (this.container = this._createContainer(O)), D && this._createQuadrilaterals();
              }
              static _hasPopupData(b) {
                let {
                  titleObj: w,
                  contentsObj: O,
                  richText: D
                } = b;
                return !!(w?.str || O?.str || D?.str);
              }
              get hasPopupData() {
                return e._hasPopupData(this.data);
              }
              _createContainer(b) {
                const {
                  data: w,
                  parent: {
                    page: O,
                    viewport: D
                  }
                } = this, L = document.createElement("section");
                L.setAttribute("data-annotation-id", w.id), this instanceof c || (L.tabIndex = i), L.style.zIndex = this.parent.zIndex++, this.data.popupRef && L.setAttribute("aria-haspopup", "dialog"), w.noRotate && L.classList.add("norotate");
                const {
                  pageWidth: W,
                  pageHeight: X,
                  pageX: q,
                  pageY: ct
                } = D.rawDims;
                if (!w.rect || this instanceof B) {
                  const {
                    rotation: Z
                  } = w;
                  return !w.hasOwnCanvas && Z !== 0 && this.setRotation(Z, L), L;
                }
                const {
                  width: nt,
                  height: Y
                } = d(w.rect), Q = a.Util.normalizeRect([w.rect[0], O.view[3] - w.rect[1] + O.view[1], w.rect[2], O.view[3] - w.rect[3] + O.view[1]]);
                if (!b && w.borderStyle.width > 0) {
                  L.style.borderWidth = `${w.borderStyle.width}px`;
                  const Z = w.borderStyle.horizontalCornerRadius, at = w.borderStyle.verticalCornerRadius;
                  if (Z > 0 || at > 0) {
                    const ft = `calc(${Z}px * var(--scale-factor)) / calc(${at}px * var(--scale-factor))`;
                    L.style.borderRadius = ft;
                  } else if (this instanceof s) {
                    const ft = `calc(${nt}px * var(--scale-factor)) / calc(${Y}px * var(--scale-factor))`;
                    L.style.borderRadius = ft;
                  }
                  switch (w.borderStyle.style) {
                    case a.AnnotationBorderStyleType.SOLID:
                      L.style.borderStyle = "solid";
                      break;
                    case a.AnnotationBorderStyleType.DASHED:
                      L.style.borderStyle = "dashed";
                      break;
                    case a.AnnotationBorderStyleType.BEVELED:
                      (0, a.warn)("Unimplemented border style: beveled");
                      break;
                    case a.AnnotationBorderStyleType.INSET:
                      (0, a.warn)("Unimplemented border style: inset");
                      break;
                    case a.AnnotationBorderStyleType.UNDERLINE:
                      L.style.borderBottomStyle = "solid";
                      break;
                  }
                  const lt = w.borderColor || null;
                  lt ? (this.#t = !0, L.style.borderColor = a.Util.makeHexColor(lt[0] | 0, lt[1] | 0, lt[2] | 0)) : L.style.borderWidth = 0;
                }
                L.style.left = `${100 * (Q[0] - q) / W}%`, L.style.top = `${100 * (Q[1] - ct) / X}%`;
                const {
                  rotation: et
                } = w;
                return w.hasOwnCanvas || et === 0 ? (L.style.width = `${100 * nt / W}%`, L.style.height = `${100 * Y / X}%`) : this.setRotation(et, L), L;
              }
              setRotation(b) {
                let w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.container;
                if (!this.data.rect)
                  return;
                const {
                  pageWidth: O,
                  pageHeight: D
                } = this.parent.viewport.rawDims, {
                  width: L,
                  height: W
                } = d(this.data.rect);
                let X, q;
                b % 180 === 0 ? (X = 100 * L / O, q = 100 * W / D) : (X = 100 * W / O, q = 100 * L / D), w.style.width = `${X}%`, w.style.height = `${q}%`, w.setAttribute("data-main-rotation", (360 - b) % 360);
              }
              get _commonActions() {
                const b = (w, O, D) => {
                  const L = D.detail[w], W = L[0], X = L.slice(1);
                  D.target.style[O] = E.ColorConverters[`${W}_HTML`](X), this.annotationStorage.setValue(this.data.id, {
                    [O]: E.ColorConverters[`${W}_rgb`](X)
                  });
                };
                return (0, a.shadow)(this, "_commonActions", {
                  display: (w) => {
                    const {
                      display: O
                    } = w.detail, D = O % 2 === 1;
                    this.container.style.visibility = D ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      noView: D,
                      noPrint: O === 1 || O === 2
                    });
                  },
                  print: (w) => {
                    this.annotationStorage.setValue(this.data.id, {
                      noPrint: !w.detail.print
                    });
                  },
                  hidden: (w) => {
                    const {
                      hidden: O
                    } = w.detail;
                    this.container.style.visibility = O ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      noPrint: O,
                      noView: O
                    });
                  },
                  focus: (w) => {
                    setTimeout(() => w.target.focus({
                      preventScroll: !1
                    }), 0);
                  },
                  userName: (w) => {
                    w.target.title = w.detail.userName;
                  },
                  readonly: (w) => {
                    w.target.disabled = w.detail.readonly;
                  },
                  required: (w) => {
                    this._setRequired(w.target, w.detail.required);
                  },
                  bgColor: (w) => {
                    b("bgColor", "backgroundColor", w);
                  },
                  fillColor: (w) => {
                    b("fillColor", "backgroundColor", w);
                  },
                  fgColor: (w) => {
                    b("fgColor", "color", w);
                  },
                  textColor: (w) => {
                    b("textColor", "color", w);
                  },
                  borderColor: (w) => {
                    b("borderColor", "borderColor", w);
                  },
                  strokeColor: (w) => {
                    b("strokeColor", "borderColor", w);
                  },
                  rotation: (w) => {
                    const O = w.detail.rotation;
                    this.setRotation(O), this.annotationStorage.setValue(this.data.id, {
                      rotation: O
                    });
                  }
                });
              }
              _dispatchEventFromSandbox(b, w) {
                const O = this._commonActions;
                for (const D of Object.keys(w.detail))
                  (b[D] || O[D])?.(w);
              }
              _setDefaultPropertiesFromJS(b) {
                if (!this.enableScripting)
                  return;
                const w = this.annotationStorage.getRawValue(this.data.id);
                if (!w)
                  return;
                const O = this._commonActions;
                for (const [D, L] of Object.entries(w)) {
                  const W = O[D];
                  if (W) {
                    const X = {
                      detail: {
                        [D]: L
                      },
                      target: b
                    };
                    W(X), delete w[D];
                  }
                }
              }
              _createQuadrilaterals() {
                if (!this.container)
                  return;
                const {
                  quadPoints: b
                } = this.data;
                if (!b)
                  return;
                const [w, O, D, L] = this.data.rect;
                if (b.length === 1) {
                  const [, {
                    x: at,
                    y: lt
                  }, {
                    x: ft,
                    y: pt
                  }] = b[0];
                  if (D === at && L === lt && w === ft && O === pt)
                    return;
                }
                const {
                  style: W
                } = this.container;
                let X;
                if (this.#t) {
                  const {
                    borderColor: at,
                    borderWidth: lt
                  } = W;
                  W.borderWidth = 0, X = ["url('data:image/svg+xml;utf8,", '<svg xmlns="http://www.w3.org/2000/svg"', ' preserveAspectRatio="none" viewBox="0 0 1 1">', `<g fill="transparent" stroke="${at}" stroke-width="${lt}">`], this.container.classList.add("hasBorder");
                }
                const q = D - w, ct = L - O, {
                  svgFactory: nt
                } = this, Y = nt.createElement("svg");
                Y.classList.add("quadrilateralsContainer"), Y.setAttribute("width", 0), Y.setAttribute("height", 0);
                const Q = nt.createElement("defs");
                Y.append(Q);
                const et = nt.createElement("clipPath"), Z = `clippath_${this.data.id}`;
                et.setAttribute("id", Z), et.setAttribute("clipPathUnits", "objectBoundingBox"), Q.append(et);
                for (const [, {
                  x: at,
                  y: lt
                }, {
                  x: ft,
                  y: pt
                }] of b) {
                  const vt = nt.createElement("rect"), yt = (ft - w) / q, xt = (L - lt) / ct, wt = (at - ft) / q, _t = (lt - pt) / ct;
                  vt.setAttribute("x", yt), vt.setAttribute("y", xt), vt.setAttribute("width", wt), vt.setAttribute("height", _t), et.append(vt), X?.push(`<rect vector-effect="non-scaling-stroke" x="${yt}" y="${xt}" width="${wt}" height="${_t}"/>`);
                }
                this.#t && (X.push("</g></svg>')"), W.backgroundImage = X.join("")), this.container.append(Y), this.container.style.clipPath = `url(#${Z})`;
              }
              _createPopup() {
                const {
                  container: b,
                  data: w
                } = this;
                b.setAttribute("aria-haspopup", "dialog");
                const O = new B({
                  data: {
                    color: w.color,
                    titleObj: w.titleObj,
                    modificationDate: w.modificationDate,
                    contentsObj: w.contentsObj,
                    richText: w.richText,
                    parentRect: w.rect,
                    borderStyle: 0,
                    id: `popup_${w.id}`,
                    rotation: w.rotation
                  },
                  parent: this.parent,
                  elements: [this]
                });
                this.parent.div.append(O.render());
              }
              render() {
                (0, a.unreachable)("Abstract method `AnnotationElement.render` called");
              }
              _getElementsByName(b) {
                let w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                const O = [];
                if (this._fieldObjects) {
                  const D = this._fieldObjects[b];
                  if (D)
                    for (const {
                      page: L,
                      id: W,
                      exportValues: X
                    } of D) {
                      if (L === -1 || W === w)
                        continue;
                      const q = typeof X == "string" ? X : null, ct = document.querySelector(`[data-element-id="${W}"]`);
                      if (ct && !o.has(ct)) {
                        (0, a.warn)(`_getElementsByName - element not allowed: ${W}`);
                        continue;
                      }
                      O.push({
                        id: W,
                        exportValue: q,
                        domElement: ct
                      });
                    }
                  return O;
                }
                for (const D of document.getElementsByName(b)) {
                  const {
                    exportValue: L
                  } = D, W = D.getAttribute("data-element-id");
                  W !== w && o.has(D) && O.push({
                    id: W,
                    exportValue: L,
                    domElement: D
                  });
                }
                return O;
              }
              show() {
                this.container && (this.container.hidden = !1), this.popup?.maybeShow();
              }
              hide() {
                this.container && (this.container.hidden = !0), this.popup?.forceHide();
              }
              getElementsToTriggerPopup() {
                return this.container;
              }
              addHighlightArea() {
                const b = this.getElementsToTriggerPopup();
                if (Array.isArray(b))
                  for (const w of b)
                    w.classList.add("highlightArea");
                else
                  b.classList.add("highlightArea");
              }
              _editOnDoubleClick() {
                const {
                  annotationEditorType: b,
                  data: {
                    id: w
                  }
                } = this;
                this.container.addEventListener("dblclick", () => {
                  this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                    source: this,
                    mode: b,
                    editId: w
                  });
                });
              }
            }
            class l extends e {
              constructor(b) {
                let w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !!w?.ignoreBorder,
                  createQuadrilaterals: !0
                }), this.isTooltipOnly = b.data.isTooltipOnly;
              }
              render() {
                const {
                  data: b,
                  linkService: w
                } = this, O = document.createElement("a");
                O.setAttribute("data-element-id", b.id);
                let D = !1;
                return b.url ? (w.addLinkAttributes(O, b.url, b.newWindow), D = !0) : b.action ? (this._bindNamedAction(O, b.action), D = !0) : b.attachment ? (this._bindAttachment(O, b.attachment), D = !0) : b.setOCGState ? (this.#e(O, b.setOCGState), D = !0) : b.dest ? (this._bindLink(O, b.dest), D = !0) : (b.actions && (b.actions.Action || b.actions["Mouse Up"] || b.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(O, b), D = !0), b.resetForm ? (this._bindResetFormAction(O, b.resetForm), D = !0) : this.isTooltipOnly && !D && (this._bindLink(O, ""), D = !0)), this.container.classList.add("linkAnnotation"), D && this.container.append(O), this.container;
              }
              #t() {
                this.container.setAttribute("data-internal-link", "");
              }
              _bindLink(b, w) {
                b.href = this.linkService.getDestinationHash(w), b.onclick = () => (w && this.linkService.goToDestination(w), !1), (w || w === "") && this.#t();
              }
              _bindNamedAction(b, w) {
                b.href = this.linkService.getAnchorUrl(""), b.onclick = () => (this.linkService.executeNamedAction(w), !1), this.#t();
              }
              _bindAttachment(b, w) {
                b.href = this.linkService.getAnchorUrl(""), b.onclick = () => (this.downloadManager?.openOrDownloadData(this.container, w.content, w.filename), !1), this.#t();
              }
              #e(b, w) {
                b.href = this.linkService.getAnchorUrl(""), b.onclick = () => (this.linkService.executeSetOCGState(w), !1), this.#t();
              }
              _bindJSAction(b, w) {
                b.href = this.linkService.getAnchorUrl("");
                const O = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
                for (const D of Object.keys(w.actions)) {
                  const L = O.get(D);
                  L && (b[L] = () => (this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: w.id,
                      name: D
                    }
                  }), !1));
                }
                b.onclick || (b.onclick = () => !1), this.#t();
              }
              _bindResetFormAction(b, w) {
                const O = b.onclick;
                if (O || (b.href = this.linkService.getAnchorUrl("")), this.#t(), !this._fieldObjects) {
                  (0, a.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), O || (b.onclick = () => !1);
                  return;
                }
                b.onclick = () => {
                  O?.();
                  const {
                    fields: D,
                    refs: L,
                    include: W
                  } = w, X = [];
                  if (D.length !== 0 || L.length !== 0) {
                    const nt = new Set(L);
                    for (const Y of D) {
                      const Q = this._fieldObjects[Y] || [];
                      for (const {
                        id: et
                      } of Q)
                        nt.add(et);
                    }
                    for (const Y of Object.values(this._fieldObjects))
                      for (const Q of Y)
                        nt.has(Q.id) === W && X.push(Q);
                  } else
                    for (const nt of Object.values(this._fieldObjects))
                      X.push(...nt);
                  const q = this.annotationStorage, ct = [];
                  for (const nt of X) {
                    const {
                      id: Y
                    } = nt;
                    switch (ct.push(Y), nt.type) {
                      case "text": {
                        const et = nt.defaultValue || "";
                        q.setValue(Y, {
                          value: et
                        });
                        break;
                      }
                      case "checkbox":
                      case "radiobutton": {
                        const et = nt.defaultValue === nt.exportValues;
                        q.setValue(Y, {
                          value: et
                        });
                        break;
                      }
                      case "combobox":
                      case "listbox": {
                        const et = nt.defaultValue || "";
                        q.setValue(Y, {
                          value: et
                        });
                        break;
                      }
                      default:
                        continue;
                    }
                    const Q = document.querySelector(`[data-element-id="${Y}"]`);
                    if (Q) {
                      if (!o.has(Q)) {
                        (0, a.warn)(`_bindResetFormAction - element not allowed: ${Y}`);
                        continue;
                      }
                    } else continue;
                    Q.dispatchEvent(new Event("resetform"));
                  }
                  return this.enableScripting && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: "app",
                      ids: ct,
                      name: "ResetForm"
                    }
                  }), !1;
                };
              }
            }
            class u extends e {
              constructor(b) {
                super(b, {
                  isRenderable: !0
                });
              }
              render() {
                this.container.classList.add("textAnnotation");
                const b = document.createElement("img");
                return b.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", b.alt = "[{{type}} Annotation]", b.dataset.l10nId = "text_annotation_type", b.dataset.l10nArgs = JSON.stringify({
                  type: this.data.name
                }), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.append(b), this.container;
              }
            }
            class c extends e {
              render() {
                return this.data.alternativeText && (this.container.title = this.data.alternativeText), this.container;
              }
              showElementAndHideCanvas(b) {
                this.data.hasOwnCanvas && (b.previousSibling?.nodeName === "CANVAS" && (b.previousSibling.hidden = !0), b.hidden = !1);
              }
              _getKeyModifier(b) {
                const {
                  isWin: w,
                  isMac: O
                } = a.FeatureTest.platform;
                return w && b.ctrlKey || O && b.metaKey;
              }
              _setEventListener(b, w, O, D, L) {
                O.includes("mouse") ? b.addEventListener(O, (W) => {
                  this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: D,
                      value: L(W),
                      shift: W.shiftKey,
                      modifier: this._getKeyModifier(W)
                    }
                  });
                }) : b.addEventListener(O, (W) => {
                  if (O === "blur") {
                    if (!w.focused || !W.relatedTarget)
                      return;
                    w.focused = !1;
                  } else if (O === "focus") {
                    if (w.focused)
                      return;
                    w.focused = !0;
                  }
                  L && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: D,
                      value: L(W)
                    }
                  });
                });
              }
              _setEventListeners(b, w, O, D) {
                for (const [L, W] of O)
                  (W === "Action" || this.data.actions?.[W]) && ((W === "Focus" || W === "Blur") && (w ||= {
                    focused: !1
                  }), this._setEventListener(b, w, L, W, D), W === "Focus" && !this.data.actions?.Blur ? this._setEventListener(b, w, "blur", "Blur", null) : W === "Blur" && !this.data.actions?.Focus && this._setEventListener(b, w, "focus", "Focus", null));
              }
              _setBackgroundColor(b) {
                const w = this.data.backgroundColor || null;
                b.style.backgroundColor = w === null ? "transparent" : a.Util.makeHexColor(w[0], w[1], w[2]);
              }
              _setTextStyle(b) {
                const w = ["left", "center", "right"], {
                  fontColor: O
                } = this.data.defaultAppearanceData, D = this.data.defaultAppearanceData.fontSize || n, L = b.style;
                let W;
                const X = 2, q = (ct) => Math.round(10 * ct) / 10;
                if (this.data.multiLine) {
                  const ct = Math.abs(this.data.rect[3] - this.data.rect[1] - X), nt = Math.round(ct / (a.LINE_FACTOR * D)) || 1, Y = ct / nt;
                  W = Math.min(D, q(Y / a.LINE_FACTOR));
                } else {
                  const ct = Math.abs(this.data.rect[3] - this.data.rect[1] - X);
                  W = Math.min(D, q(ct / a.LINE_FACTOR));
                }
                L.fontSize = `calc(${W}px * var(--scale-factor))`, L.color = a.Util.makeHexColor(O[0], O[1], O[2]), this.data.textAlignment !== null && (L.textAlign = w[this.data.textAlignment]);
              }
              _setRequired(b, w) {
                w ? b.setAttribute("required", !0) : b.removeAttribute("required"), b.setAttribute("aria-required", w);
              }
            }
            class y extends c {
              constructor(b) {
                const w = b.renderForms || !b.data.hasAppearance && !!b.data.fieldValue;
                super(b, {
                  isRenderable: w
                });
              }
              setPropertyOnSiblings(b, w, O, D) {
                const L = this.annotationStorage;
                for (const W of this._getElementsByName(b.name, b.id))
                  W.domElement && (W.domElement[w] = O), L.setValue(W.id, {
                    [D]: O
                  });
              }
              render() {
                const b = this.annotationStorage, w = this.data.id;
                this.container.classList.add("textWidgetAnnotation");
                let O = null;
                if (this.renderForms) {
                  const D = b.getValue(w, {
                    value: this.data.fieldValue
                  });
                  let L = D.value || "";
                  const W = b.getValue(w, {
                    charLimit: this.data.maxLen
                  }).charLimit;
                  W && L.length > W && (L = L.slice(0, W));
                  let X = D.formattedValue || this.data.textContent?.join(`
`) || null;
                  X && this.data.comb && (X = X.replaceAll(/\s+/g, ""));
                  const q = {
                    userValue: L,
                    formattedValue: X,
                    lastCommittedValue: null,
                    commitKey: 1,
                    focused: !1
                  };
                  this.data.multiLine ? (O = document.createElement("textarea"), O.textContent = X ?? L, this.data.doNotScroll && (O.style.overflowY = "hidden")) : (O = document.createElement("input"), O.type = "text", O.setAttribute("value", X ?? L), this.data.doNotScroll && (O.style.overflowX = "hidden")), this.data.hasOwnCanvas && (O.hidden = !0), o.add(O), O.setAttribute("data-element-id", w), O.disabled = this.data.readOnly, O.name = this.data.fieldName, O.tabIndex = i, this._setRequired(O, this.data.required), W && (O.maxLength = W), O.addEventListener("input", (nt) => {
                    b.setValue(w, {
                      value: nt.target.value
                    }), this.setPropertyOnSiblings(O, "value", nt.target.value, "value"), q.formattedValue = null;
                  }), O.addEventListener("resetform", (nt) => {
                    const Y = this.data.defaultFieldValue ?? "";
                    O.value = q.userValue = Y, q.formattedValue = null;
                  });
                  let ct = (nt) => {
                    const {
                      formattedValue: Y
                    } = q;
                    Y != null && (nt.target.value = Y), nt.target.scrollLeft = 0;
                  };
                  if (this.enableScripting && this.hasJSActions) {
                    O.addEventListener("focus", (Y) => {
                      if (q.focused)
                        return;
                      const {
                        target: Q
                      } = Y;
                      q.userValue && (Q.value = q.userValue), q.lastCommittedValue = Q.value, q.commitKey = 1, q.focused = !0;
                    }), O.addEventListener("updatefromsandbox", (Y) => {
                      this.showElementAndHideCanvas(Y.target);
                      const Q = {
                        value(et) {
                          q.userValue = et.detail.value ?? "", b.setValue(w, {
                            value: q.userValue.toString()
                          }), et.target.value = q.userValue;
                        },
                        formattedValue(et) {
                          const {
                            formattedValue: Z
                          } = et.detail;
                          q.formattedValue = Z, Z != null && et.target !== document.activeElement && (et.target.value = Z), b.setValue(w, {
                            formattedValue: Z
                          });
                        },
                        selRange(et) {
                          et.target.setSelectionRange(...et.detail.selRange);
                        },
                        charLimit: (et) => {
                          const {
                            charLimit: Z
                          } = et.detail, {
                            target: at
                          } = et;
                          if (Z === 0) {
                            at.removeAttribute("maxLength");
                            return;
                          }
                          at.setAttribute("maxLength", Z);
                          let lt = q.userValue;
                          !lt || lt.length <= Z || (lt = lt.slice(0, Z), at.value = q.userValue = lt, b.setValue(w, {
                            value: lt
                          }), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                            source: this,
                            detail: {
                              id: w,
                              name: "Keystroke",
                              value: lt,
                              willCommit: !0,
                              commitKey: 1,
                              selStart: at.selectionStart,
                              selEnd: at.selectionEnd
                            }
                          }));
                        }
                      };
                      this._dispatchEventFromSandbox(Q, Y);
                    }), O.addEventListener("keydown", (Y) => {
                      q.commitKey = 1;
                      let Q = -1;
                      if (Y.key === "Escape" ? Q = 0 : Y.key === "Enter" && !this.data.multiLine ? Q = 2 : Y.key === "Tab" && (q.commitKey = 3), Q === -1)
                        return;
                      const {
                        value: et
                      } = Y.target;
                      q.lastCommittedValue !== et && (q.lastCommittedValue = et, q.userValue = et, this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: w,
                          name: "Keystroke",
                          value: et,
                          willCommit: !0,
                          commitKey: Q,
                          selStart: Y.target.selectionStart,
                          selEnd: Y.target.selectionEnd
                        }
                      }));
                    });
                    const nt = ct;
                    ct = null, O.addEventListener("blur", (Y) => {
                      if (!q.focused || !Y.relatedTarget)
                        return;
                      q.focused = !1;
                      const {
                        value: Q
                      } = Y.target;
                      q.userValue = Q, q.lastCommittedValue !== Q && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: w,
                          name: "Keystroke",
                          value: Q,
                          willCommit: !0,
                          commitKey: q.commitKey,
                          selStart: Y.target.selectionStart,
                          selEnd: Y.target.selectionEnd
                        }
                      }), nt(Y);
                    }), this.data.actions?.Keystroke && O.addEventListener("beforeinput", (Y) => {
                      q.lastCommittedValue = null;
                      const {
                        data: Q,
                        target: et
                      } = Y, {
                        value: Z,
                        selectionStart: at,
                        selectionEnd: lt
                      } = et;
                      let ft = at, pt = lt;
                      switch (Y.inputType) {
                        case "deleteWordBackward": {
                          const vt = Z.substring(0, at).match(/\w*[^\w]*$/);
                          vt && (ft -= vt[0].length);
                          break;
                        }
                        case "deleteWordForward": {
                          const vt = Z.substring(at).match(/^[^\w]*\w*/);
                          vt && (pt += vt[0].length);
                          break;
                        }
                        case "deleteContentBackward":
                          at === lt && (ft -= 1);
                          break;
                        case "deleteContentForward":
                          at === lt && (pt += 1);
                          break;
                      }
                      Y.preventDefault(), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: w,
                          name: "Keystroke",
                          value: Z,
                          change: Q || "",
                          willCommit: !1,
                          selStart: ft,
                          selEnd: pt
                        }
                      });
                    }), this._setEventListeners(O, q, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Y) => Y.target.value);
                  }
                  if (ct && O.addEventListener("blur", ct), this.data.comb) {
                    const Y = (this.data.rect[2] - this.data.rect[0]) / W;
                    O.classList.add("comb"), O.style.letterSpacing = `calc(${Y}px * var(--scale-factor) - 1ch)`;
                  }
                } else
                  O = document.createElement("div"), O.textContent = this.data.fieldValue, O.style.verticalAlign = "middle", O.style.display = "table-cell";
                return this._setTextStyle(O), this._setBackgroundColor(O), this._setDefaultPropertiesFromJS(O), this.container.append(O), this.container;
              }
            }
            class C extends c {
              constructor(b) {
                super(b, {
                  isRenderable: !!b.data.hasOwnCanvas
                });
              }
            }
            class R extends c {
              constructor(b) {
                super(b, {
                  isRenderable: b.renderForms
                });
              }
              render() {
                const b = this.annotationStorage, w = this.data, O = w.id;
                let D = b.getValue(O, {
                  value: w.exportValue === w.fieldValue
                }).value;
                typeof D == "string" && (D = D !== "Off", b.setValue(O, {
                  value: D
                })), this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                const L = document.createElement("input");
                return o.add(L), L.setAttribute("data-element-id", O), L.disabled = w.readOnly, this._setRequired(L, this.data.required), L.type = "checkbox", L.name = w.fieldName, D && L.setAttribute("checked", !0), L.setAttribute("exportValue", w.exportValue), L.tabIndex = i, L.addEventListener("change", (W) => {
                  const {
                    name: X,
                    checked: q
                  } = W.target;
                  for (const ct of this._getElementsByName(X, O)) {
                    const nt = q && ct.exportValue === w.exportValue;
                    ct.domElement && (ct.domElement.checked = nt), b.setValue(ct.id, {
                      value: nt
                    });
                  }
                  b.setValue(O, {
                    value: q
                  });
                }), L.addEventListener("resetform", (W) => {
                  const X = w.defaultFieldValue || "Off";
                  W.target.checked = X === w.exportValue;
                }), this.enableScripting && this.hasJSActions && (L.addEventListener("updatefromsandbox", (W) => {
                  const X = {
                    value(q) {
                      q.target.checked = q.detail.value !== "Off", b.setValue(O, {
                        value: q.target.checked
                      });
                    }
                  };
                  this._dispatchEventFromSandbox(X, W);
                }), this._setEventListeners(L, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (W) => W.target.checked)), this._setBackgroundColor(L), this._setDefaultPropertiesFromJS(L), this.container.append(L), this.container;
              }
            }
            class s extends c {
              constructor(b) {
                super(b, {
                  isRenderable: b.renderForms
                });
              }
              render() {
                this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                const b = this.annotationStorage, w = this.data, O = w.id;
                let D = b.getValue(O, {
                  value: w.fieldValue === w.buttonValue
                }).value;
                typeof D == "string" && (D = D !== w.buttonValue, b.setValue(O, {
                  value: D
                }));
                const L = document.createElement("input");
                if (o.add(L), L.setAttribute("data-element-id", O), L.disabled = w.readOnly, this._setRequired(L, this.data.required), L.type = "radio", L.name = w.fieldName, D && L.setAttribute("checked", !0), L.tabIndex = i, L.addEventListener("change", (W) => {
                  const {
                    name: X,
                    checked: q
                  } = W.target;
                  for (const ct of this._getElementsByName(X, O))
                    b.setValue(ct.id, {
                      value: !1
                    });
                  b.setValue(O, {
                    value: q
                  });
                }), L.addEventListener("resetform", (W) => {
                  const X = w.defaultFieldValue;
                  W.target.checked = X != null && X === w.buttonValue;
                }), this.enableScripting && this.hasJSActions) {
                  const W = w.buttonValue;
                  L.addEventListener("updatefromsandbox", (X) => {
                    const q = {
                      value: (ct) => {
                        const nt = W === ct.detail.value;
                        for (const Y of this._getElementsByName(ct.target.name)) {
                          const Q = nt && Y.id === O;
                          Y.domElement && (Y.domElement.checked = Q), b.setValue(Y.id, {
                            value: Q
                          });
                        }
                      }
                    };
                    this._dispatchEventFromSandbox(q, X);
                  }), this._setEventListeners(L, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (X) => X.target.checked);
                }
                return this._setBackgroundColor(L), this._setDefaultPropertiesFromJS(L), this.container.append(L), this.container;
              }
            }
            class m extends l {
              constructor(b) {
                super(b, {
                  ignoreBorder: b.data.hasAppearance
                });
              }
              render() {
                const b = super.render();
                b.classList.add("buttonWidgetAnnotation", "pushButton"), this.data.alternativeText && (b.title = this.data.alternativeText);
                const w = b.lastChild;
                return this.enableScripting && this.hasJSActions && w && (this._setDefaultPropertiesFromJS(w), w.addEventListener("updatefromsandbox", (O) => {
                  this._dispatchEventFromSandbox({}, O);
                })), b;
              }
            }
            class F extends c {
              constructor(b) {
                super(b, {
                  isRenderable: b.renderForms
                });
              }
              render() {
                this.container.classList.add("choiceWidgetAnnotation");
                const b = this.annotationStorage, w = this.data.id, O = b.getValue(w, {
                  value: this.data.fieldValue
                }), D = document.createElement("select");
                o.add(D), D.setAttribute("data-element-id", w), D.disabled = this.data.readOnly, this._setRequired(D, this.data.required), D.name = this.data.fieldName, D.tabIndex = i;
                let L = this.data.combo && this.data.options.length > 0;
                this.data.combo || (D.size = this.data.options.length, this.data.multiSelect && (D.multiple = !0)), D.addEventListener("resetform", (nt) => {
                  const Y = this.data.defaultFieldValue;
                  for (const Q of D.options)
                    Q.selected = Q.value === Y;
                });
                for (const nt of this.data.options) {
                  const Y = document.createElement("option");
                  Y.textContent = nt.displayValue, Y.value = nt.exportValue, O.value.includes(nt.exportValue) && (Y.setAttribute("selected", !0), L = !1), D.append(Y);
                }
                let W = null;
                if (L) {
                  const nt = document.createElement("option");
                  nt.value = " ", nt.setAttribute("hidden", !0), nt.setAttribute("selected", !0), D.prepend(nt), W = () => {
                    nt.remove(), D.removeEventListener("input", W), W = null;
                  }, D.addEventListener("input", W);
                }
                const X = (nt) => {
                  const Y = nt ? "value" : "textContent", {
                    options: Q,
                    multiple: et
                  } = D;
                  return et ? Array.prototype.filter.call(Q, (Z) => Z.selected).map((Z) => Z[Y]) : Q.selectedIndex === -1 ? null : Q[Q.selectedIndex][Y];
                };
                let q = X(!1);
                const ct = (nt) => {
                  const Y = nt.target.options;
                  return Array.prototype.map.call(Y, (Q) => ({
                    displayValue: Q.textContent,
                    exportValue: Q.value
                  }));
                };
                return this.enableScripting && this.hasJSActions ? (D.addEventListener("updatefromsandbox", (nt) => {
                  const Y = {
                    value(Q) {
                      W?.();
                      const et = Q.detail.value, Z = new Set(Array.isArray(et) ? et : [et]);
                      for (const at of D.options)
                        at.selected = Z.has(at.value);
                      b.setValue(w, {
                        value: X(!0)
                      }), q = X(!1);
                    },
                    multipleSelection(Q) {
                      D.multiple = !0;
                    },
                    remove(Q) {
                      const et = D.options, Z = Q.detail.remove;
                      et[Z].selected = !1, D.remove(Z), et.length > 0 && Array.prototype.findIndex.call(et, (lt) => lt.selected) === -1 && (et[0].selected = !0), b.setValue(w, {
                        value: X(!0),
                        items: ct(Q)
                      }), q = X(!1);
                    },
                    clear(Q) {
                      for (; D.length !== 0; )
                        D.remove(0);
                      b.setValue(w, {
                        value: null,
                        items: []
                      }), q = X(!1);
                    },
                    insert(Q) {
                      const {
                        index: et,
                        displayValue: Z,
                        exportValue: at
                      } = Q.detail.insert, lt = D.children[et], ft = document.createElement("option");
                      ft.textContent = Z, ft.value = at, lt ? lt.before(ft) : D.append(ft), b.setValue(w, {
                        value: X(!0),
                        items: ct(Q)
                      }), q = X(!1);
                    },
                    items(Q) {
                      const {
                        items: et
                      } = Q.detail;
                      for (; D.length !== 0; )
                        D.remove(0);
                      for (const Z of et) {
                        const {
                          displayValue: at,
                          exportValue: lt
                        } = Z, ft = document.createElement("option");
                        ft.textContent = at, ft.value = lt, D.append(ft);
                      }
                      D.options.length > 0 && (D.options[0].selected = !0), b.setValue(w, {
                        value: X(!0),
                        items: ct(Q)
                      }), q = X(!1);
                    },
                    indices(Q) {
                      const et = new Set(Q.detail.indices);
                      for (const Z of Q.target.options)
                        Z.selected = et.has(Z.index);
                      b.setValue(w, {
                        value: X(!0)
                      }), q = X(!1);
                    },
                    editable(Q) {
                      Q.target.disabled = !Q.detail.editable;
                    }
                  };
                  this._dispatchEventFromSandbox(Y, nt);
                }), D.addEventListener("input", (nt) => {
                  const Y = X(!0);
                  b.setValue(w, {
                    value: Y
                  }), nt.preventDefault(), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: w,
                      name: "Keystroke",
                      value: q,
                      changeEx: Y,
                      willCommit: !1,
                      commitKey: 1,
                      keyDown: !1
                    }
                  });
                }), this._setEventListeners(D, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (nt) => nt.target.value)) : D.addEventListener("input", function(nt) {
                  b.setValue(w, {
                    value: X(!0)
                  });
                }), this.data.combo && this._setTextStyle(D), this._setBackgroundColor(D), this._setDefaultPropertiesFromJS(D), this.container.append(D), this.container;
              }
            }
            class B extends e {
              constructor(b) {
                const {
                  data: w,
                  elements: O
                } = b;
                super(b, {
                  isRenderable: e._hasPopupData(w)
                }), this.elements = O;
              }
              render() {
                this.container.classList.add("popupAnnotation");
                const b = new k({
                  container: this.container,
                  color: this.data.color,
                  titleObj: this.data.titleObj,
                  modificationDate: this.data.modificationDate,
                  contentsObj: this.data.contentsObj,
                  richText: this.data.richText,
                  rect: this.data.rect,
                  parentRect: this.data.parentRect || null,
                  parent: this.parent,
                  elements: this.elements,
                  open: this.data.open
                }), w = [];
                for (const O of this.elements)
                  O.popup = b, w.push(O.data.id), O.addHighlightArea();
                return this.container.setAttribute("aria-controls", w.map((O) => `${a.AnnotationPrefix}${O}`).join(",")), this.container;
              }
            }
            class k {
              #t = null;
              #e = this.#d.bind(this);
              #n = this.#A.bind(this);
              #i = this.#x.bind(this);
              #o = this.#b.bind(this);
              #s = null;
              #a = null;
              #l = null;
              #c = null;
              #r = null;
              #h = null;
              #u = !1;
              #f = null;
              #p = null;
              #g = null;
              #m = null;
              #v = !1;
              constructor(b) {
                let {
                  container: w,
                  color: O,
                  elements: D,
                  titleObj: L,
                  modificationDate: W,
                  contentsObj: X,
                  richText: q,
                  parent: ct,
                  rect: nt,
                  parentRect: Y,
                  open: Q
                } = b;
                this.#a = w, this.#m = L, this.#l = X, this.#g = q, this.#r = ct, this.#s = O, this.#p = nt, this.#h = Y, this.#c = D;
                const et = f.PDFDateString.toDateObject(W);
                et && (this.#t = ct.l10n.get("annotation_date_string", {
                  date: et.toLocaleDateString(),
                  time: et.toLocaleTimeString()
                })), this.trigger = D.flatMap((Z) => Z.getElementsToTriggerPopup());
                for (const Z of this.trigger)
                  Z.addEventListener("click", this.#o), Z.addEventListener("mouseenter", this.#i), Z.addEventListener("mouseleave", this.#n), Z.classList.add("popupTriggerArea");
                for (const Z of D)
                  Z.container?.addEventListener("keydown", this.#e);
                this.#a.hidden = !0, Q && this.#b();
              }
              render() {
                if (this.#f)
                  return;
                const {
                  page: {
                    view: b
                  },
                  viewport: {
                    rawDims: {
                      pageWidth: w,
                      pageHeight: O,
                      pageX: D,
                      pageY: L
                    }
                  }
                } = this.#r, W = this.#f = document.createElement("div");
                if (W.className = "popup", this.#s) {
                  const vt = W.style.outlineColor = a.Util.makeHexColor(...this.#s);
                  CSS.supports("background-color", "color-mix(in srgb, red 30%, white)") ? W.style.backgroundColor = `color-mix(in srgb, ${vt} 30%, white)` : W.style.backgroundColor = a.Util.makeHexColor(...this.#s.map((xt) => Math.floor(0.7 * (255 - xt) + xt)));
                }
                const X = document.createElement("span");
                X.className = "header";
                const q = document.createElement("h1");
                if (X.append(q), {
                  dir: q.dir,
                  str: q.textContent
                } = this.#m, W.append(X), this.#t) {
                  const vt = document.createElement("span");
                  vt.classList.add("popupDate"), this.#t.then((yt) => {
                    vt.textContent = yt;
                  }), X.append(vt);
                }
                const ct = this.#l, nt = this.#g;
                if (nt?.str && (!ct?.str || ct.str === nt.str))
                  T.XfaLayer.render({
                    xfaHtml: nt.html,
                    intent: "richText",
                    div: W
                  }), W.lastChild.classList.add("richText", "popupContent");
                else {
                  const vt = this._formatContents(ct);
                  W.append(vt);
                }
                let Y = !!this.#h, Q = Y ? this.#h : this.#p;
                for (const vt of this.#c)
                  if (!Q || a.Util.intersect(vt.data.rect, Q) !== null) {
                    Q = vt.data.rect, Y = !0;
                    break;
                  }
                const et = a.Util.normalizeRect([Q[0], b[3] - Q[1] + b[1], Q[2], b[3] - Q[3] + b[1]]), at = Y ? Q[2] - Q[0] + 5 : 0, lt = et[0] + at, ft = et[1], {
                  style: pt
                } = this.#a;
                pt.left = `${100 * (lt - D) / w}%`, pt.top = `${100 * (ft - L) / O}%`, this.#a.append(W);
              }
              _formatContents(b) {
                let {
                  str: w,
                  dir: O
                } = b;
                const D = document.createElement("p");
                D.classList.add("popupContent"), D.dir = O;
                const L = w.split(/(?:\r\n?|\n)/);
                for (let W = 0, X = L.length; W < X; ++W) {
                  const q = L[W];
                  D.append(document.createTextNode(q)), W < X - 1 && D.append(document.createElement("br"));
                }
                return D;
              }
              #d(b) {
                b.altKey || b.shiftKey || b.ctrlKey || b.metaKey || (b.key === "Enter" || b.key === "Escape" && this.#u) && this.#b();
              }
              #b() {
                this.#u = !this.#u, this.#u ? (this.#x(), this.#a.addEventListener("click", this.#o), this.#a.addEventListener("keydown", this.#e)) : (this.#A(), this.#a.removeEventListener("click", this.#o), this.#a.removeEventListener("keydown", this.#e));
              }
              #x() {
                this.#f || this.render(), this.isVisible ? this.#u && this.#a.classList.add("focused") : (this.#a.hidden = !1, this.#a.style.zIndex = parseInt(this.#a.style.zIndex) + 1e3);
              }
              #A() {
                this.#a.classList.remove("focused"), !(this.#u || !this.isVisible) && (this.#a.hidden = !0, this.#a.style.zIndex = parseInt(this.#a.style.zIndex) - 1e3);
              }
              forceHide() {
                this.#v = this.isVisible, this.#v && (this.#a.hidden = !0);
              }
              maybeShow() {
                this.#v && (this.#v = !1, this.#a.hidden = !1);
              }
              get isVisible() {
                return this.#a.hidden === !1;
              }
            }
            class V extends e {
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0
                }), this.textContent = b.data.textContent, this.textPosition = b.data.textPosition, this.annotationEditorType = a.AnnotationEditorType.FREETEXT;
              }
              render() {
                if (this.container.classList.add("freeTextAnnotation"), this.textContent) {
                  const b = document.createElement("div");
                  b.classList.add("annotationTextContent"), b.setAttribute("role", "comment");
                  for (const w of this.textContent) {
                    const O = document.createElement("span");
                    O.textContent = w, b.append(O);
                  }
                  this.container.append(b);
                }
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
              }
            }
            p.FreeTextAnnotationElement = V;
            class z extends e {
              #t = null;
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.classList.add("lineAnnotation");
                const b = this.data, {
                  width: w,
                  height: O
                } = d(b.rect), D = this.svgFactory.create(w, O, !0), L = this.#t = this.svgFactory.createElement("svg:line");
                return L.setAttribute("x1", b.rect[2] - b.lineCoordinates[0]), L.setAttribute("y1", b.rect[3] - b.lineCoordinates[1]), L.setAttribute("x2", b.rect[2] - b.lineCoordinates[2]), L.setAttribute("y2", b.rect[3] - b.lineCoordinates[3]), L.setAttribute("stroke-width", b.borderStyle.width || 1), L.setAttribute("stroke", "transparent"), L.setAttribute("fill", "transparent"), D.append(L), this.container.append(D), !b.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#t;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            class K extends e {
              #t = null;
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.classList.add("squareAnnotation");
                const b = this.data, {
                  width: w,
                  height: O
                } = d(b.rect), D = this.svgFactory.create(w, O, !0), L = b.borderStyle.width, W = this.#t = this.svgFactory.createElement("svg:rect");
                return W.setAttribute("x", L / 2), W.setAttribute("y", L / 2), W.setAttribute("width", w - L), W.setAttribute("height", O - L), W.setAttribute("stroke-width", L || 1), W.setAttribute("stroke", "transparent"), W.setAttribute("fill", "transparent"), D.append(W), this.container.append(D), !b.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#t;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            class J extends e {
              #t = null;
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.classList.add("circleAnnotation");
                const b = this.data, {
                  width: w,
                  height: O
                } = d(b.rect), D = this.svgFactory.create(w, O, !0), L = b.borderStyle.width, W = this.#t = this.svgFactory.createElement("svg:ellipse");
                return W.setAttribute("cx", w / 2), W.setAttribute("cy", O / 2), W.setAttribute("rx", w / 2 - L / 2), W.setAttribute("ry", O / 2 - L / 2), W.setAttribute("stroke-width", L || 1), W.setAttribute("stroke", "transparent"), W.setAttribute("fill", "transparent"), D.append(W), this.container.append(D), !b.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#t;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            class $ extends e {
              #t = null;
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0
                }), this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.classList.add(this.containerClassName);
                const b = this.data, {
                  width: w,
                  height: O
                } = d(b.rect), D = this.svgFactory.create(w, O, !0);
                let L = [];
                for (const X of b.vertices) {
                  const q = X.x - b.rect[0], ct = b.rect[3] - X.y;
                  L.push(q + "," + ct);
                }
                L = L.join(" ");
                const W = this.#t = this.svgFactory.createElement(this.svgElementName);
                return W.setAttribute("points", L), W.setAttribute("stroke-width", b.borderStyle.width || 1), W.setAttribute("stroke", "transparent"), W.setAttribute("fill", "transparent"), D.append(W), this.container.append(D), !b.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#t;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            class j extends $ {
              constructor(b) {
                super(b), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
              }
            }
            class G extends e {
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.classList.add("caretAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
            }
            class M extends e {
              #t = [];
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0
                }), this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline", this.annotationEditorType = a.AnnotationEditorType.INK;
              }
              render() {
                this.container.classList.add(this.containerClassName);
                const b = this.data, {
                  width: w,
                  height: O
                } = d(b.rect), D = this.svgFactory.create(w, O, !0);
                for (const L of b.inkLists) {
                  let W = [];
                  for (const q of L) {
                    const ct = q.x - b.rect[0], nt = b.rect[3] - q.y;
                    W.push(`${ct},${nt}`);
                  }
                  W = W.join(" ");
                  const X = this.svgFactory.createElement(this.svgElementName);
                  this.#t.push(X), X.setAttribute("points", W), X.setAttribute("stroke-width", b.borderStyle.width || 1), X.setAttribute("stroke", "transparent"), X.setAttribute("fill", "transparent"), !b.popupRef && this.hasPopupData && this._createPopup(), D.append(X);
                }
                return this.container.append(D), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#t;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            p.InkAnnotationElement = M;
            class x extends e {
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("highlightAnnotation"), this.container;
              }
            }
            class A extends e {
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("underlineAnnotation"), this.container;
              }
            }
            class g extends e {
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("squigglyAnnotation"), this.container;
              }
            }
            class I extends e {
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("strikeoutAnnotation"), this.container;
              }
            }
            class U extends e {
              constructor(b) {
                super(b, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.classList.add("stampAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
            }
            p.StampAnnotationElement = U;
            class _ extends e {
              #t = null;
              constructor(b) {
                super(b, {
                  isRenderable: !0
                });
                const {
                  filename: w,
                  content: O
                } = this.data.file;
                this.filename = (0, f.getFilenameFromUrl)(w, !0), this.content = O, this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                  source: this,
                  filename: w,
                  content: O
                });
              }
              render() {
                this.container.classList.add("fileAttachmentAnnotation");
                const {
                  container: b,
                  data: w
                } = this;
                let O;
                w.hasAppearance || w.fillAlpha === 0 ? O = document.createElement("div") : (O = document.createElement("img"), O.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(w.name) ? "paperclip" : "pushpin"}.svg`, w.fillAlpha && w.fillAlpha < 1 && (O.style = `filter: opacity(${Math.round(w.fillAlpha * 100)}%);`)), O.addEventListener("dblclick", this.#e.bind(this)), this.#t = O;
                const {
                  isMac: D
                } = a.FeatureTest.platform;
                return b.addEventListener("keydown", (L) => {
                  L.key === "Enter" && (D ? L.metaKey : L.ctrlKey) && this.#e();
                }), !w.popupRef && this.hasPopupData ? this._createPopup() : O.classList.add("popupTriggerArea"), b.append(O), b;
              }
              getElementsToTriggerPopup() {
                return this.#t;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
              #e() {
                this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
              }
            }
            class H {
              #t = null;
              #e = null;
              #n = /* @__PURE__ */ new Map();
              constructor(b) {
                let {
                  div: w,
                  accessibilityManager: O,
                  annotationCanvasMap: D,
                  l10n: L,
                  page: W,
                  viewport: X
                } = b;
                this.div = w, this.#t = O, this.#e = D, this.l10n = L, this.page = W, this.viewport = X, this.zIndex = 0, this.l10n ||= v.NullL10n;
              }
              #i(b, w) {
                const O = b.firstChild || b;
                O.id = `${a.AnnotationPrefix}${w}`, this.div.append(b), this.#t?.moveElementInDOM(this.div, b, O, !1);
              }
              async render(b) {
                const {
                  annotations: w
                } = b, O = this.div;
                (0, f.setLayerDimensions)(O, this.viewport);
                const D = /* @__PURE__ */ new Map(), L = {
                  data: null,
                  layer: O,
                  linkService: b.linkService,
                  downloadManager: b.downloadManager,
                  imageResourcesPath: b.imageResourcesPath || "",
                  renderForms: b.renderForms !== !1,
                  svgFactory: new f.DOMSVGFactory(),
                  annotationStorage: b.annotationStorage || new S.AnnotationStorage(),
                  enableScripting: b.enableScripting === !0,
                  hasJSActions: b.hasJSActions,
                  fieldObjects: b.fieldObjects,
                  parent: this,
                  elements: null
                };
                for (const W of w) {
                  if (W.noHTML)
                    continue;
                  const X = W.annotationType === a.AnnotationType.POPUP;
                  if (X) {
                    const nt = D.get(W.id);
                    if (!nt)
                      continue;
                    L.elements = nt;
                  } else {
                    const {
                      width: nt,
                      height: Y
                    } = d(W.rect);
                    if (nt <= 0 || Y <= 0)
                      continue;
                  }
                  L.data = W;
                  const q = h.create(L);
                  if (!q.isRenderable)
                    continue;
                  if (!X && W.popupRef) {
                    const nt = D.get(W.popupRef);
                    nt ? nt.push(q) : D.set(W.popupRef, [q]);
                  }
                  q.annotationEditorType > 0 && this.#n.set(q.data.id, q);
                  const ct = q.render();
                  W.hidden && (ct.style.visibility = "hidden"), this.#i(ct, W.id);
                }
                this.#o(), await this.l10n.translate(O);
              }
              update(b) {
                let {
                  viewport: w
                } = b;
                const O = this.div;
                this.viewport = w, (0, f.setLayerDimensions)(O, {
                  rotation: w.rotation
                }), this.#o(), O.hidden = !1;
              }
              #o() {
                if (!this.#e)
                  return;
                const b = this.div;
                for (const [w, O] of this.#e) {
                  const D = b.querySelector(`[data-annotation-id="${w}"]`);
                  if (!D)
                    continue;
                  const {
                    firstChild: L
                  } = D;
                  L ? L.nodeName === "CANVAS" ? L.replaceWith(O) : L.before(O) : D.append(O);
                }
                this.#e.clear();
              }
              getEditableAnnotations() {
                return Array.from(this.#n.values());
              }
              getEditableAnnotation(b) {
                return this.#n.get(b);
              }
            }
            p.AnnotationLayer = H;
          }),
          /* 199 */
          /***/
          ((P, p) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.ColorConverters = void 0;
            function t(S) {
              return Math.floor(Math.max(0, Math.min(1, S)) * 255).toString(16).padStart(2, "0");
            }
            function a(S) {
              return Math.max(0, Math.min(255, 255 * S));
            }
            class f {
              static CMYK_G(E) {
                let [v, T, i, n] = E;
                return ["G", 1 - Math.min(1, 0.3 * v + 0.59 * i + 0.11 * T + n)];
              }
              static G_CMYK(E) {
                let [v] = E;
                return ["CMYK", 0, 0, 0, 1 - v];
              }
              static G_RGB(E) {
                let [v] = E;
                return ["RGB", v, v, v];
              }
              static G_rgb(E) {
                let [v] = E;
                return v = a(v), [v, v, v];
              }
              static G_HTML(E) {
                let [v] = E;
                const T = t(v);
                return `#${T}${T}${T}`;
              }
              static RGB_G(E) {
                let [v, T, i] = E;
                return ["G", 0.3 * v + 0.59 * T + 0.11 * i];
              }
              static RGB_rgb(E) {
                return E.map(a);
              }
              static RGB_HTML(E) {
                return `#${E.map(t).join("")}`;
              }
              static T_HTML() {
                return "#00000000";
              }
              static T_rgb() {
                return [null];
              }
              static CMYK_RGB(E) {
                let [v, T, i, n] = E;
                return ["RGB", 1 - Math.min(1, v + n), 1 - Math.min(1, i + n), 1 - Math.min(1, T + n)];
              }
              static CMYK_rgb(E) {
                let [v, T, i, n] = E;
                return [a(1 - Math.min(1, v + n)), a(1 - Math.min(1, i + n)), a(1 - Math.min(1, T + n))];
              }
              static CMYK_HTML(E) {
                const v = this.CMYK_RGB(E).slice(1);
                return this.RGB_HTML(v);
              }
              static RGB_CMYK(E) {
                let [v, T, i] = E;
                const n = 1 - v, o = 1 - T, d = 1 - i, h = Math.min(n, o, d);
                return ["CMYK", n, o, d, h];
              }
            }
            p.ColorConverters = f;
          }),
          /* 200 */
          /***/
          ((P, p) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.NullL10n = void 0, p.getL10nFallback = a;
            const t = {
              of_pages: "of {{pagesCount}}",
              page_of_pages: "({{pageNumber}} of {{pagesCount}})",
              document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
              document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
              document_properties_date_string: "{{date}}, {{time}}",
              document_properties_page_size_unit_inches: "in",
              document_properties_page_size_unit_millimeters: "mm",
              document_properties_page_size_orientation_portrait: "portrait",
              document_properties_page_size_orientation_landscape: "landscape",
              document_properties_page_size_name_a3: "A3",
              document_properties_page_size_name_a4: "A4",
              document_properties_page_size_name_letter: "Letter",
              document_properties_page_size_name_legal: "Legal",
              document_properties_page_size_dimension_string: "{{width}} × {{height}} {{unit}} ({{orientation}})",
              document_properties_page_size_dimension_name_string: "{{width}} × {{height}} {{unit}} ({{name}}, {{orientation}})",
              document_properties_linearized_yes: "Yes",
              document_properties_linearized_no: "No",
              additional_layers: "Additional Layers",
              page_landmark: "Page {{page}}",
              thumb_page_title: "Page {{page}}",
              thumb_page_canvas: "Thumbnail of Page {{page}}",
              find_reached_top: "Reached top of document, continued from bottom",
              find_reached_bottom: "Reached end of document, continued from top",
              "find_match_count[one]": "{{current}} of {{total}} match",
              "find_match_count[other]": "{{current}} of {{total}} matches",
              "find_match_count_limit[one]": "More than {{limit}} match",
              "find_match_count_limit[other]": "More than {{limit}} matches",
              find_not_found: "Phrase not found",
              page_scale_width: "Page Width",
              page_scale_fit: "Page Fit",
              page_scale_auto: "Automatic Zoom",
              page_scale_actual: "Actual Size",
              page_scale_percent: "{{scale}}%",
              loading_error: "An error occurred while loading the PDF.",
              invalid_file_error: "Invalid or corrupted PDF file.",
              missing_file_error: "Missing PDF file.",
              unexpected_response_error: "Unexpected server response.",
              rendering_error: "An error occurred while rendering the page.",
              annotation_date_string: "{{date}}, {{time}}",
              printing_not_supported: "Warning: Printing is not fully supported by this browser.",
              printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
              web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
              free_text2_default_content: "Start typing…",
              editor_free_text2_aria_label: "Text Editor",
              editor_ink2_aria_label: "Draw Editor",
              editor_ink_canvas_aria_label: "User-created image",
              editor_alt_text_button_label: "Alt text",
              editor_alt_text_edit_button_label: "Edit alt text",
              editor_alt_text_decorative_tooltip: "Marked as decorative"
            };
            t.print_progress_percent = "{{progress}}%";
            function a(E, v) {
              switch (E) {
                case "find_match_count":
                  E = `find_match_count[${v.total === 1 ? "one" : "other"}]`;
                  break;
                case "find_match_count_limit":
                  E = `find_match_count_limit[${v.limit === 1 ? "one" : "other"}]`;
                  break;
              }
              return t[E] || "";
            }
            function f(E, v) {
              return v ? E.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (T, i) => i in v ? v[i] : "{{" + i + "}}") : E;
            }
            const S = {
              async getLanguage() {
                return "en-us";
              },
              async getDirection() {
                return "ltr";
              },
              async get(E) {
                let v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : a(E, v);
                return f(T, v);
              },
              async translate(E) {
              }
            };
            p.NullL10n = S;
          }),
          /* 201 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.XfaLayer = void 0, t(89);
            var a = t(194);
            class f {
              static setupStorage(E, v, T, i, n) {
                const o = i.getValue(v, {
                  value: null
                });
                switch (T.name) {
                  case "textarea":
                    if (o.value !== null && (E.textContent = o.value), n === "print")
                      break;
                    E.addEventListener("input", (d) => {
                      i.setValue(v, {
                        value: d.target.value
                      });
                    });
                    break;
                  case "input":
                    if (T.attributes.type === "radio" || T.attributes.type === "checkbox") {
                      if (o.value === T.attributes.xfaOn ? E.setAttribute("checked", !0) : o.value === T.attributes.xfaOff && E.removeAttribute("checked"), n === "print")
                        break;
                      E.addEventListener("change", (d) => {
                        i.setValue(v, {
                          value: d.target.checked ? d.target.getAttribute("xfaOn") : d.target.getAttribute("xfaOff")
                        });
                      });
                    } else {
                      if (o.value !== null && E.setAttribute("value", o.value), n === "print")
                        break;
                      E.addEventListener("input", (d) => {
                        i.setValue(v, {
                          value: d.target.value
                        });
                      });
                    }
                    break;
                  case "select":
                    if (o.value !== null) {
                      E.setAttribute("value", o.value);
                      for (const d of T.children)
                        d.attributes.value === o.value ? d.attributes.selected = !0 : d.attributes.hasOwnProperty("selected") && delete d.attributes.selected;
                    }
                    E.addEventListener("input", (d) => {
                      const h = d.target.options, e = h.selectedIndex === -1 ? "" : h[h.selectedIndex].value;
                      i.setValue(v, {
                        value: e
                      });
                    });
                    break;
                }
              }
              static setAttributes(E) {
                let {
                  html: v,
                  element: T,
                  storage: i = null,
                  intent: n,
                  linkService: o
                } = E;
                const {
                  attributes: d
                } = T, h = v instanceof HTMLAnchorElement;
                d.type === "radio" && (d.name = `${d.name}-${n}`);
                for (const [e, l] of Object.entries(d))
                  if (l != null)
                    switch (e) {
                      case "class":
                        l.length && v.setAttribute(e, l.join(" "));
                        break;
                      case "dataId":
                        break;
                      case "id":
                        v.setAttribute("data-element-id", l);
                        break;
                      case "style":
                        Object.assign(v.style, l);
                        break;
                      case "textContent":
                        v.textContent = l;
                        break;
                      default:
                        (!h || e !== "href" && e !== "newWindow") && v.setAttribute(e, l);
                    }
                h && o.addLinkAttributes(v, d.href, d.newWindow), i && d.dataId && this.setupStorage(v, d.dataId, T, i);
              }
              static render(E) {
                const v = E.annotationStorage, T = E.linkService, i = E.xfaHtml, n = E.intent || "display", o = document.createElement(i.name);
                i.attributes && this.setAttributes({
                  html: o,
                  element: i,
                  intent: n,
                  linkService: T
                });
                const d = [[i, -1, o]], h = E.div;
                if (h.append(o), E.viewport) {
                  const l = `matrix(${E.viewport.transform.join(",")})`;
                  h.style.transform = l;
                }
                n !== "richText" && h.setAttribute("class", "xfaLayer xfaFont");
                const e = [];
                for (; d.length > 0; ) {
                  const [l, u, c] = d.at(-1);
                  if (u + 1 === l.children.length) {
                    d.pop();
                    continue;
                  }
                  const y = l.children[++d.at(-1)[1]];
                  if (y === null)
                    continue;
                  const {
                    name: C
                  } = y;
                  if (C === "#text") {
                    const s = document.createTextNode(y.value);
                    e.push(s), c.append(s);
                    continue;
                  }
                  const R = y?.attributes?.xmlns ? document.createElementNS(y.attributes.xmlns, C) : document.createElement(C);
                  if (c.append(R), y.attributes && this.setAttributes({
                    html: R,
                    element: y,
                    storage: v,
                    intent: n,
                    linkService: T
                  }), y.children && y.children.length > 0)
                    d.push([y, -1, R]);
                  else if (y.value) {
                    const s = document.createTextNode(y.value);
                    a.XfaText.shouldBuildText(C) && e.push(s), R.append(s);
                  }
                }
                for (const l of h.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
                  l.setAttribute("readOnly", !0);
                return {
                  textDivs: e
                };
              }
              static update(E) {
                const v = `matrix(${E.viewport.transform.join(",")})`;
                E.div.style.transform = v, E.div.hidden = !1;
              }
            }
            p.XfaLayer = f;
          }),
          /* 202 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.InkEditor = void 0, t(89), t(2);
            var a = t(1), f = t(164), S = t(198), E = t(168), v = t(165);
            class T extends f.AnnotationEditor {
              #t = 0;
              #e = 0;
              #n = this.canvasPointermove.bind(this);
              #i = this.canvasPointerleave.bind(this);
              #o = this.canvasPointerup.bind(this);
              #s = this.canvasPointerdown.bind(this);
              #a = new Path2D();
              #l = !1;
              #c = !1;
              #r = !1;
              #h = null;
              #u = 0;
              #f = 0;
              #p = null;
              static _defaultColor = null;
              static _defaultOpacity = 1;
              static _defaultThickness = 1;
              static _type = "ink";
              constructor(n) {
                super({
                  ...n,
                  name: "inkEditor"
                }), this.color = n.color || null, this.thickness = n.thickness || null, this.opacity = n.opacity || null, this.paths = [], this.bezierPath2D = [], this.allRawPaths = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0, this._willKeepAspectRatio = !0;
              }
              static initialize(n) {
                f.AnnotationEditor.initialize(n, {
                  strings: ["editor_ink_canvas_aria_label", "editor_ink2_aria_label"]
                });
              }
              static updateDefaultParams(n, o) {
                switch (n) {
                  case a.AnnotationEditorParamsType.INK_THICKNESS:
                    T._defaultThickness = o;
                    break;
                  case a.AnnotationEditorParamsType.INK_COLOR:
                    T._defaultColor = o;
                    break;
                  case a.AnnotationEditorParamsType.INK_OPACITY:
                    T._defaultOpacity = o / 100;
                    break;
                }
              }
              updateParams(n, o) {
                switch (n) {
                  case a.AnnotationEditorParamsType.INK_THICKNESS:
                    this.#g(o);
                    break;
                  case a.AnnotationEditorParamsType.INK_COLOR:
                    this.#m(o);
                    break;
                  case a.AnnotationEditorParamsType.INK_OPACITY:
                    this.#v(o);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[a.AnnotationEditorParamsType.INK_THICKNESS, T._defaultThickness], [a.AnnotationEditorParamsType.INK_COLOR, T._defaultColor || f.AnnotationEditor._defaultLineColor], [a.AnnotationEditorParamsType.INK_OPACITY, Math.round(T._defaultOpacity * 100)]];
              }
              get propertiesToUpdate() {
                return [[a.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || T._defaultThickness], [a.AnnotationEditorParamsType.INK_COLOR, this.color || T._defaultColor || f.AnnotationEditor._defaultLineColor], [a.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? T._defaultOpacity))]];
              }
              #g(n) {
                const o = this.thickness;
                this.addCommands({
                  cmd: () => {
                    this.thickness = n, this.#I();
                  },
                  undo: () => {
                    this.thickness = o, this.#I();
                  },
                  mustExec: !0,
                  type: a.AnnotationEditorParamsType.INK_THICKNESS,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              #m(n) {
                const o = this.color;
                this.addCommands({
                  cmd: () => {
                    this.color = n, this.#y();
                  },
                  undo: () => {
                    this.color = o, this.#y();
                  },
                  mustExec: !0,
                  type: a.AnnotationEditorParamsType.INK_COLOR,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              #v(n) {
                n /= 100;
                const o = this.opacity;
                this.addCommands({
                  cmd: () => {
                    this.opacity = n, this.#y();
                  },
                  undo: () => {
                    this.opacity = o, this.#y();
                  },
                  mustExec: !0,
                  type: a.AnnotationEditorParamsType.INK_OPACITY,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              rebuild() {
                this.parent && (super.rebuild(), this.div !== null && (this.canvas || (this.#R(), this.#k()), this.isAttachedToDOM || (this.parent.add(this), this.#P()), this.#I()));
              }
              remove() {
                this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, this.#h.disconnect(), this.#h = null, super.remove());
              }
              setParent(n) {
                !this.parent && n ? this._uiManager.removeShouldRescale(this) : this.parent && n === null && this._uiManager.addShouldRescale(this), super.setParent(n);
              }
              onScaleChanging() {
                const [n, o] = this.parentDimensions, d = this.width * n, h = this.height * o;
                this.setDimensions(d, h);
              }
              enableEditMode() {
                this.#l || this.canvas === null || (super.enableEditMode(), this._isDraggable = !1, this.canvas.addEventListener("pointerdown", this.#s));
              }
              disableEditMode() {
                !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this._isDraggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", this.#s));
              }
              onceAdded() {
                this._isDraggable = !this.isEmpty();
              }
              isEmpty() {
                return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
              }
              #d() {
                const {
                  parentRotation: n,
                  parentDimensions: [o, d]
                } = this;
                switch (n) {
                  case 90:
                    return [0, d, d, o];
                  case 180:
                    return [o, d, o, d];
                  case 270:
                    return [o, 0, d, o];
                  default:
                    return [0, 0, o, d];
                }
              }
              #b() {
                const {
                  ctx: n,
                  color: o,
                  opacity: d,
                  thickness: h,
                  parentScale: e,
                  scaleFactor: l
                } = this;
                n.lineWidth = h * e / l, n.lineCap = "round", n.lineJoin = "round", n.miterLimit = 10, n.strokeStyle = `${o}${(0, v.opacityToHex)(d)}`;
              }
              #x(n, o) {
                this.canvas.addEventListener("contextmenu", E.noContextMenu), this.canvas.addEventListener("pointerleave", this.#i), this.canvas.addEventListener("pointermove", this.#n), this.canvas.addEventListener("pointerup", this.#o), this.canvas.removeEventListener("pointerdown", this.#s), this.isEditing = !0, this.#r || (this.#r = !0, this.#P(), this.thickness ||= T._defaultThickness, this.color ||= T._defaultColor || f.AnnotationEditor._defaultLineColor, this.opacity ??= T._defaultOpacity), this.currentPath.push([n, o]), this.#c = !1, this.#b(), this.#p = () => {
                  this.#O(), this.#p && window.requestAnimationFrame(this.#p);
                }, window.requestAnimationFrame(this.#p);
              }
              #A(n, o) {
                const [d, h] = this.currentPath.at(-1);
                if (this.currentPath.length > 1 && n === d && o === h)
                  return;
                const e = this.currentPath;
                let l = this.#a;
                if (e.push([n, o]), this.#c = !0, e.length <= 2) {
                  l.moveTo(...e[0]), l.lineTo(n, o);
                  return;
                }
                e.length === 3 && (this.#a = l = new Path2D(), l.moveTo(...e[0])), this.#L(l, ...e.at(-3), ...e.at(-2), n, o);
              }
              #S() {
                if (this.currentPath.length === 0)
                  return;
                const n = this.currentPath.at(-1);
                this.#a.lineTo(...n);
              }
              #E(n, o) {
                this.#p = null, n = Math.min(Math.max(n, 0), this.canvas.width), o = Math.min(Math.max(o, 0), this.canvas.height), this.#A(n, o), this.#S();
                let d;
                if (this.currentPath.length !== 1)
                  d = this.#F();
                else {
                  const c = [n, o];
                  d = [[c, c.slice(), c.slice(), c]];
                }
                const h = this.#a, e = this.currentPath;
                this.currentPath = [], this.#a = new Path2D();
                const l = () => {
                  this.allRawPaths.push(e), this.paths.push(d), this.bezierPath2D.push(h), this.rebuild();
                }, u = () => {
                  this.allRawPaths.pop(), this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (this.#R(), this.#k()), this.#I());
                };
                this.addCommands({
                  cmd: l,
                  undo: u,
                  mustExec: !0
                });
              }
              #O() {
                if (!this.#c)
                  return;
                this.#c = !1;
                const n = Math.ceil(this.thickness * this.parentScale), o = this.currentPath.slice(-3), d = o.map((l) => l[0]), h = o.map((l) => l[1]);
                Math.min(...d) - n, Math.max(...d) + n, Math.min(...h) - n, Math.max(...h) + n;
                const {
                  ctx: e
                } = this;
                e.save(), e.clearRect(0, 0, this.canvas.width, this.canvas.height);
                for (const l of this.bezierPath2D)
                  e.stroke(l);
                e.stroke(this.#a), e.restore();
              }
              #L(n, o, d, h, e, l, u) {
                const c = (o + h) / 2, y = (d + e) / 2, C = (h + l) / 2, R = (e + u) / 2;
                n.bezierCurveTo(c + 2 * (h - c) / 3, y + 2 * (e - y) / 3, C + 2 * (h - C) / 3, R + 2 * (e - R) / 3, C, R);
              }
              #F() {
                const n = this.currentPath;
                if (n.length <= 2)
                  return [[n[0], n[0], n.at(-1), n.at(-1)]];
                const o = [];
                let d, [h, e] = n[0];
                for (d = 1; d < n.length - 2; d++) {
                  const [s, m] = n[d], [F, B] = n[d + 1], k = (s + F) / 2, V = (m + B) / 2, z = [h + 2 * (s - h) / 3, e + 2 * (m - e) / 3], K = [k + 2 * (s - k) / 3, V + 2 * (m - V) / 3];
                  o.push([[h, e], z, K, [k, V]]), [h, e] = [k, V];
                }
                const [l, u] = n[d], [c, y] = n[d + 1], C = [h + 2 * (l - h) / 3, e + 2 * (u - e) / 3], R = [c + 2 * (l - c) / 3, y + 2 * (u - y) / 3];
                return o.push([[h, e], C, R, [c, y]]), o;
              }
              #y() {
                if (this.isEmpty()) {
                  this.#M();
                  return;
                }
                this.#b();
                const {
                  canvas: n,
                  ctx: o
                } = this;
                o.setTransform(1, 0, 0, 1, 0, 0), o.clearRect(0, 0, n.width, n.height), this.#M();
                for (const d of this.bezierPath2D)
                  o.stroke(d);
              }
              commit() {
                this.#l || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), this.#l = !0, this.div.classList.add("disabled"), this.#I(!0), this.makeResizable(), this.parent.addInkEditorIfNeeded(!0), this.moveInDOM(), this.div.focus({
                  preventScroll: !0
                }));
              }
              focusin(n) {
                this._focusEventsAllowed && (super.focusin(n), this.enableEditMode());
              }
              canvasPointerdown(n) {
                n.button !== 0 || !this.isInEditMode() || this.#l || (this.setInForeground(), n.preventDefault(), n.type !== "mouse" && this.div.focus(), this.#x(n.offsetX, n.offsetY));
              }
              canvasPointermove(n) {
                n.preventDefault(), this.#A(n.offsetX, n.offsetY);
              }
              canvasPointerup(n) {
                n.preventDefault(), this.#w(n);
              }
              canvasPointerleave(n) {
                this.#w(n);
              }
              #w(n) {
                this.canvas.removeEventListener("pointerleave", this.#i), this.canvas.removeEventListener("pointermove", this.#n), this.canvas.removeEventListener("pointerup", this.#o), this.canvas.addEventListener("pointerdown", this.#s), setTimeout(() => {
                  this.canvas.removeEventListener("contextmenu", E.noContextMenu);
                }, 10), this.#E(n.offsetX, n.offsetY), this.addToAnnotationStorage(), this.setInBackground();
              }
              #R() {
                this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", f.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((n) => this.canvas?.setAttribute("aria-label", n)), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
              }
              #k() {
                this.#h = new ResizeObserver((n) => {
                  const o = n[0].contentRect;
                  o.width && o.height && this.setDimensions(o.width, o.height);
                }), this.#h.observe(this.div);
              }
              get isResizable() {
                return !this.isEmpty() && this.#l;
              }
              render() {
                if (this.div)
                  return this.div;
                let n, o;
                this.width && (n = this.x, o = this.y), super.render(), f.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((u) => this.div?.setAttribute("aria-label", u));
                const [d, h, e, l] = this.#d();
                if (this.setAt(d, h, 0, 0), this.setDims(e, l), this.#R(), this.width) {
                  const [u, c] = this.parentDimensions;
                  this.setAspectRatio(this.width * u, this.height * c), this.setAt(n * u, o * c, this.width * u, this.height * c), this.#r = !0, this.#P(), this.setDims(this.width * u, this.height * c), this.#y(), this.div.classList.add("disabled");
                } else
                  this.div.classList.add("editing"), this.enableEditMode();
                return this.#k(), this.div;
              }
              #P() {
                if (!this.#r)
                  return;
                const [n, o] = this.parentDimensions;
                this.canvas.width = Math.ceil(this.width * n), this.canvas.height = Math.ceil(this.height * o), this.#M();
              }
              setDimensions(n, o) {
                const d = Math.round(n), h = Math.round(o);
                if (this.#u === d && this.#f === h)
                  return;
                this.#u = d, this.#f = h, this.canvas.style.visibility = "hidden";
                const [e, l] = this.parentDimensions;
                this.width = n / e, this.height = o / l, this.fixAndSetPosition(), this.#l && this.#C(n, o), this.#P(), this.#y(), this.canvas.style.visibility = "visible", this.fixDims();
              }
              #C(n, o) {
                const d = this.#_(), h = (n - d) / this.#e, e = (o - d) / this.#t;
                this.scaleFactor = Math.min(h, e);
              }
              #M() {
                const n = this.#_() / 2;
                this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + n, this.translationY * this.scaleFactor + n);
              }
              static #N(n) {
                const o = new Path2D();
                for (let d = 0, h = n.length; d < h; d++) {
                  const [e, l, u, c] = n[d];
                  d === 0 && o.moveTo(...e), o.bezierCurveTo(l[0], l[1], u[0], u[1], c[0], c[1]);
                }
                return o;
              }
              static #B(n, o, d) {
                const [h, e, l, u] = o;
                switch (d) {
                  case 0:
                    for (let c = 0, y = n.length; c < y; c += 2)
                      n[c] += h, n[c + 1] = u - n[c + 1];
                    break;
                  case 90:
                    for (let c = 0, y = n.length; c < y; c += 2) {
                      const C = n[c];
                      n[c] = n[c + 1] + h, n[c + 1] = C + e;
                    }
                    break;
                  case 180:
                    for (let c = 0, y = n.length; c < y; c += 2)
                      n[c] = l - n[c], n[c + 1] += e;
                    break;
                  case 270:
                    for (let c = 0, y = n.length; c < y; c += 2) {
                      const C = n[c];
                      n[c] = l - n[c + 1], n[c + 1] = u - C;
                    }
                    break;
                  default:
                    throw new Error("Invalid rotation");
                }
                return n;
              }
              static #U(n, o, d) {
                const [h, e, l, u] = o;
                switch (d) {
                  case 0:
                    for (let c = 0, y = n.length; c < y; c += 2)
                      n[c] -= h, n[c + 1] = u - n[c + 1];
                    break;
                  case 90:
                    for (let c = 0, y = n.length; c < y; c += 2) {
                      const C = n[c];
                      n[c] = n[c + 1] - e, n[c + 1] = C - h;
                    }
                    break;
                  case 180:
                    for (let c = 0, y = n.length; c < y; c += 2)
                      n[c] = l - n[c], n[c + 1] -= e;
                    break;
                  case 270:
                    for (let c = 0, y = n.length; c < y; c += 2) {
                      const C = n[c];
                      n[c] = u - n[c + 1], n[c + 1] = l - C;
                    }
                    break;
                  default:
                    throw new Error("Invalid rotation");
                }
                return n;
              }
              #V(n, o, d, h) {
                const e = [], l = this.thickness / 2, u = n * o + l, c = n * d + l;
                for (const y of this.paths) {
                  const C = [], R = [];
                  for (let s = 0, m = y.length; s < m; s++) {
                    const [F, B, k, V] = y[s], z = n * F[0] + u, K = n * F[1] + c, J = n * B[0] + u, $ = n * B[1] + c, j = n * k[0] + u, G = n * k[1] + c, M = n * V[0] + u, x = n * V[1] + c;
                    s === 0 && (C.push(z, K), R.push(z, K)), C.push(J, $, j, G, M, x), R.push(J, $), s === m - 1 && R.push(M, x);
                  }
                  e.push({
                    bezier: T.#B(C, h, this.rotation),
                    points: T.#B(R, h, this.rotation)
                  });
                }
                return e;
              }
              #D() {
                let n = 1 / 0, o = -1 / 0, d = 1 / 0, h = -1 / 0;
                for (const e of this.paths)
                  for (const [l, u, c, y] of e) {
                    const C = a.Util.bezierBoundingBox(...l, ...u, ...c, ...y);
                    n = Math.min(n, C[0]), d = Math.min(d, C[1]), o = Math.max(o, C[2]), h = Math.max(h, C[3]);
                  }
                return [n, d, o, h];
              }
              #_() {
                return this.#l ? Math.ceil(this.thickness * this.parentScale) : 0;
              }
              #I() {
                let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                if (this.isEmpty())
                  return;
                if (!this.#l) {
                  this.#y();
                  return;
                }
                const o = this.#D(), d = this.#_();
                this.#e = Math.max(f.AnnotationEditor.MIN_SIZE, o[2] - o[0]), this.#t = Math.max(f.AnnotationEditor.MIN_SIZE, o[3] - o[1]);
                const h = Math.ceil(d + this.#e * this.scaleFactor), e = Math.ceil(d + this.#t * this.scaleFactor), [l, u] = this.parentDimensions;
                this.width = h / l, this.height = e / u, this.setAspectRatio(h, e);
                const c = this.translationX, y = this.translationY;
                this.translationX = -o[0], this.translationY = -o[1], this.#P(), this.#y(), this.#u = h, this.#f = e, this.setDims(h, e);
                const C = n ? d / this.scaleFactor / 2 : 0;
                this.translate(c - this.translationX - C, y - this.translationY - C);
              }
              static deserialize(n, o, d) {
                if (n instanceof S.InkAnnotationElement)
                  return null;
                const h = super.deserialize(n, o, d);
                h.thickness = n.thickness, h.color = a.Util.makeHexColor(...n.color), h.opacity = n.opacity;
                const [e, l] = h.pageDimensions, u = h.width * e, c = h.height * l, y = h.parentScale, C = n.thickness / 2;
                h.#l = !0, h.#u = Math.round(u), h.#f = Math.round(c);
                const {
                  paths: R,
                  rect: s,
                  rotation: m
                } = n;
                for (let {
                  bezier: B
                } of R) {
                  B = T.#U(B, s, m);
                  const k = [];
                  h.paths.push(k);
                  let V = y * (B[0] - C), z = y * (B[1] - C);
                  for (let J = 2, $ = B.length; J < $; J += 6) {
                    const j = y * (B[J] - C), G = y * (B[J + 1] - C), M = y * (B[J + 2] - C), x = y * (B[J + 3] - C), A = y * (B[J + 4] - C), g = y * (B[J + 5] - C);
                    k.push([[V, z], [j, G], [M, x], [A, g]]), V = A, z = g;
                  }
                  const K = this.#N(k);
                  h.bezierPath2D.push(K);
                }
                const F = h.#D();
                return h.#e = Math.max(f.AnnotationEditor.MIN_SIZE, F[2] - F[0]), h.#t = Math.max(f.AnnotationEditor.MIN_SIZE, F[3] - F[1]), h.#C(u, c), h;
              }
              serialize() {
                if (this.isEmpty())
                  return null;
                const n = this.getRect(0, 0), o = f.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                return {
                  annotationType: a.AnnotationEditorType.INK,
                  color: o,
                  thickness: this.thickness,
                  opacity: this.opacity,
                  paths: this.#V(this.scaleFactor / this.parentScale, this.translationX, this.translationY, n),
                  pageIndex: this.pageIndex,
                  rect: n,
                  rotation: this.rotation,
                  structTreeParentId: this._structTreeParentId
                };
              }
            }
            p.InkEditor = T;
          }),
          /* 203 */
          /***/
          ((P, p, t) => {
            Object.defineProperty(p, "__esModule", {
              value: !0
            }), p.StampEditor = void 0, t(149), t(152);
            var a = t(1), f = t(164), S = t(168), E = t(198);
            class v extends f.AnnotationEditor {
              #t = null;
              #e = null;
              #n = null;
              #i = null;
              #o = null;
              #s = null;
              #a = null;
              #l = null;
              #c = !1;
              #r = !1;
              static _type = "stamp";
              constructor(i) {
                super({
                  ...i,
                  name: "stampEditor"
                }), this.#i = i.bitmapUrl, this.#o = i.bitmapFile;
              }
              static initialize(i) {
                f.AnnotationEditor.initialize(i);
              }
              static get supportedTypes() {
                const i = ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"];
                return (0, a.shadow)(this, "supportedTypes", i.map((n) => `image/${n}`));
              }
              static get supportedTypesStr() {
                return (0, a.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
              }
              static isHandlingMimeForPasting(i) {
                return this.supportedTypes.includes(i);
              }
              static paste(i, n) {
                n.pasteEditor(a.AnnotationEditorType.STAMP, {
                  bitmapFile: i.getAsFile()
                });
              }
              #h(i) {
                let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (!i) {
                  this.remove();
                  return;
                }
                this.#t = i.bitmap, n || (this.#e = i.id, this.#c = i.isSvg), this.#p();
              }
              #u() {
                this.#n = null, this._uiManager.enableWaiting(!1), this.#s && this.div.focus();
              }
              #f() {
                if (this.#e) {
                  this._uiManager.enableWaiting(!0), this._uiManager.imageManager.getFromId(this.#e).then((n) => this.#h(n, !0)).finally(() => this.#u());
                  return;
                }
                if (this.#i) {
                  const n = this.#i;
                  this.#i = null, this._uiManager.enableWaiting(!0), this.#n = this._uiManager.imageManager.getFromUrl(n).then((o) => this.#h(o)).finally(() => this.#u());
                  return;
                }
                if (this.#o) {
                  const n = this.#o;
                  this.#o = null, this._uiManager.enableWaiting(!0), this.#n = this._uiManager.imageManager.getFromFile(n).then((o) => this.#h(o)).finally(() => this.#u());
                  return;
                }
                const i = document.createElement("input");
                i.type = "file", i.accept = v.supportedTypesStr, this.#n = new Promise((n) => {
                  i.addEventListener("change", async () => {
                    if (!i.files || i.files.length === 0)
                      this.remove();
                    else {
                      this._uiManager.enableWaiting(!0);
                      const o = await this._uiManager.imageManager.getFromFile(i.files[0]);
                      this.#h(o);
                    }
                    n();
                  }), i.addEventListener("cancel", () => {
                    this.remove(), n();
                  });
                }).finally(() => this.#u()), i.click();
              }
              remove() {
                this.#e && (this.#t = null, this._uiManager.imageManager.deleteId(this.#e), this.#s?.remove(), this.#s = null, this.#a?.disconnect(), this.#a = null), super.remove();
              }
              rebuild() {
                if (!this.parent) {
                  this.#e && this.#f();
                  return;
                }
                super.rebuild(), this.div !== null && (this.#e && this.#f(), this.isAttachedToDOM || this.parent.add(this));
              }
              onceAdded() {
                this._isDraggable = !0, this.div.focus();
              }
              isEmpty() {
                return !(this.#n || this.#t || this.#i || this.#o);
              }
              get isResizable() {
                return !0;
              }
              render() {
                if (this.div)
                  return this.div;
                let i, n;
                if (this.width && (i = this.x, n = this.y), super.render(), this.div.hidden = !0, this.#t ? this.#p() : this.#f(), this.width) {
                  const [o, d] = this.parentDimensions;
                  this.setAt(i * o, n * d, this.width * o, this.height * d);
                }
                return this.div;
              }
              #p() {
                const {
                  div: i
                } = this;
                let {
                  width: n,
                  height: o
                } = this.#t;
                const [d, h] = this.pageDimensions, e = 0.75;
                if (this.width)
                  n = this.width * d, o = this.height * h;
                else if (n > e * d || o > e * h) {
                  const y = Math.min(e * d / n, e * h / o);
                  n *= y, o *= y;
                }
                const [l, u] = this.parentDimensions;
                this.setDims(n * l / d, o * u / h), this._uiManager.enableWaiting(!1);
                const c = this.#s = document.createElement("canvas");
                i.append(c), i.hidden = !1, this.#v(n, o), this.#b(), this.#r || (this.parent.addUndoableEditor(this), this.#r = !0), this._uiManager._eventBus.dispatch("reporttelemetry", {
                  source: this,
                  details: {
                    type: "editing",
                    subtype: this.editorType,
                    data: {
                      action: "inserted_image"
                    }
                  }
                }), this.addAltTextButton();
              }
              #g(i, n) {
                const [o, d] = this.parentDimensions;
                this.width = i / o, this.height = n / d, this.setDims(i, n), this._initialOptions?.isCentered ? this.center() : this.fixAndSetPosition(), this._initialOptions = null, this.#l !== null && clearTimeout(this.#l);
                const h = 200;
                this.#l = setTimeout(() => {
                  this.#l = null, this.#v(i, n);
                }, h);
              }
              #m(i, n) {
                const {
                  width: o,
                  height: d
                } = this.#t;
                let h = o, e = d, l = this.#t;
                for (; h > 2 * i || e > 2 * n; ) {
                  const u = h, c = e;
                  h > 2 * i && (h = h >= 16384 ? Math.floor(h / 2) - 1 : Math.ceil(h / 2)), e > 2 * n && (e = e >= 16384 ? Math.floor(e / 2) - 1 : Math.ceil(e / 2));
                  const y = new OffscreenCanvas(h, e);
                  y.getContext("2d").drawImage(l, 0, 0, u, c, 0, 0, h, e), l = y.transferToImageBitmap();
                }
                return l;
              }
              #v(i, n) {
                i = Math.ceil(i), n = Math.ceil(n);
                const o = this.#s;
                if (!o || o.width === i && o.height === n)
                  return;
                o.width = i, o.height = n;
                const d = this.#c ? this.#t : this.#m(i, n), h = o.getContext("2d");
                h.filter = this._uiManager.hcmFilter, h.drawImage(d, 0, 0, d.width, d.height, 0, 0, i, n);
              }
              #d(i) {
                if (i) {
                  if (this.#c) {
                    const d = this._uiManager.imageManager.getSvgUrl(this.#e);
                    if (d)
                      return d;
                  }
                  const n = document.createElement("canvas");
                  return {
                    width: n.width,
                    height: n.height
                  } = this.#t, n.getContext("2d").drawImage(this.#t, 0, 0), n.toDataURL();
                }
                if (this.#c) {
                  const [n, o] = this.pageDimensions, d = Math.round(this.width * n * S.PixelsPerInch.PDF_TO_CSS_UNITS), h = Math.round(this.height * o * S.PixelsPerInch.PDF_TO_CSS_UNITS), e = new OffscreenCanvas(d, h);
                  return e.getContext("2d").drawImage(this.#t, 0, 0, this.#t.width, this.#t.height, 0, 0, d, h), e.transferToImageBitmap();
                }
                return structuredClone(this.#t);
              }
              #b() {
                this.#a = new ResizeObserver((i) => {
                  const n = i[0].contentRect;
                  n.width && n.height && this.#g(n.width, n.height);
                }), this.#a.observe(this.div);
              }
              static deserialize(i, n, o) {
                if (i instanceof E.StampAnnotationElement)
                  return null;
                const d = super.deserialize(i, n, o), {
                  rect: h,
                  bitmapUrl: e,
                  bitmapId: l,
                  isSvg: u,
                  accessibilityData: c
                } = i;
                l && o.imageManager.isValidId(l) ? d.#e = l : d.#i = e, d.#c = u;
                const [y, C] = d.pageDimensions;
                return d.width = (h[2] - h[0]) / y, d.height = (h[3] - h[1]) / C, c && (d.altTextData = c), d;
              }
              serialize() {
                let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this.isEmpty())
                  return null;
                const o = {
                  annotationType: a.AnnotationEditorType.STAMP,
                  bitmapId: this.#e,
                  pageIndex: this.pageIndex,
                  rect: this.getRect(0, 0),
                  rotation: this.rotation,
                  isSvg: this.#c,
                  structTreeParentId: this._structTreeParentId
                };
                if (i)
                  return o.bitmapUrl = this.#d(!0), o.accessibilityData = this.altTextData, o;
                const {
                  decorative: d,
                  altText: h
                } = this.altTextData;
                if (!d && h && (o.accessibilityData = {
                  type: "Figure",
                  alt: h
                }), n === null)
                  return o;
                n.stamps ||= /* @__PURE__ */ new Map();
                const e = this.#c ? (o.rect[2] - o.rect[0]) * (o.rect[3] - o.rect[1]) : null;
                if (!n.stamps.has(this.#e))
                  n.stamps.set(this.#e, {
                    area: e,
                    serialized: o
                  }), o.bitmap = this.#d(!1);
                else if (this.#c) {
                  const l = n.stamps.get(this.#e);
                  e > l.area && (l.area = e, l.serialized.bitmap.close(), l.serialized.bitmap = this.#d(!1));
                }
                return o;
              }
            }
            p.StampEditor = v;
          })
          /******/
        ], __webpack_module_cache__ = {};
        function __w_pdfjs_require__(P) {
          var p = __webpack_module_cache__[P];
          if (p !== void 0)
            return p.exports;
          var t = __webpack_module_cache__[P] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return __webpack_modules__[P].call(t.exports, t, t.exports, __w_pdfjs_require__), t.exports;
        }
        var __webpack_exports__ = {};
        return (() => {
          var P = __webpack_exports__;
          Object.defineProperty(P, "__esModule", {
            value: !0
          }), Object.defineProperty(P, "AbortException", {
            enumerable: !0,
            get: function() {
              return p.AbortException;
            }
          }), Object.defineProperty(P, "AnnotationEditorLayer", {
            enumerable: !0,
            get: function() {
              return S.AnnotationEditorLayer;
            }
          }), Object.defineProperty(P, "AnnotationEditorParamsType", {
            enumerable: !0,
            get: function() {
              return p.AnnotationEditorParamsType;
            }
          }), Object.defineProperty(P, "AnnotationEditorType", {
            enumerable: !0,
            get: function() {
              return p.AnnotationEditorType;
            }
          }), Object.defineProperty(P, "AnnotationEditorUIManager", {
            enumerable: !0,
            get: function() {
              return E.AnnotationEditorUIManager;
            }
          }), Object.defineProperty(P, "AnnotationLayer", {
            enumerable: !0,
            get: function() {
              return v.AnnotationLayer;
            }
          }), Object.defineProperty(P, "AnnotationMode", {
            enumerable: !0,
            get: function() {
              return p.AnnotationMode;
            }
          }), Object.defineProperty(P, "CMapCompressionType", {
            enumerable: !0,
            get: function() {
              return p.CMapCompressionType;
            }
          }), Object.defineProperty(P, "DOMSVGFactory", {
            enumerable: !0,
            get: function() {
              return a.DOMSVGFactory;
            }
          }), Object.defineProperty(P, "FeatureTest", {
            enumerable: !0,
            get: function() {
              return p.FeatureTest;
            }
          }), Object.defineProperty(P, "GlobalWorkerOptions", {
            enumerable: !0,
            get: function() {
              return T.GlobalWorkerOptions;
            }
          }), Object.defineProperty(P, "ImageKind", {
            enumerable: !0,
            get: function() {
              return p.ImageKind;
            }
          }), Object.defineProperty(P, "InvalidPDFException", {
            enumerable: !0,
            get: function() {
              return p.InvalidPDFException;
            }
          }), Object.defineProperty(P, "MissingPDFException", {
            enumerable: !0,
            get: function() {
              return p.MissingPDFException;
            }
          }), Object.defineProperty(P, "OPS", {
            enumerable: !0,
            get: function() {
              return p.OPS;
            }
          }), Object.defineProperty(P, "PDFDataRangeTransport", {
            enumerable: !0,
            get: function() {
              return t.PDFDataRangeTransport;
            }
          }), Object.defineProperty(P, "PDFDateString", {
            enumerable: !0,
            get: function() {
              return a.PDFDateString;
            }
          }), Object.defineProperty(P, "PDFWorker", {
            enumerable: !0,
            get: function() {
              return t.PDFWorker;
            }
          }), Object.defineProperty(P, "PasswordResponses", {
            enumerable: !0,
            get: function() {
              return p.PasswordResponses;
            }
          }), Object.defineProperty(P, "PermissionFlag", {
            enumerable: !0,
            get: function() {
              return p.PermissionFlag;
            }
          }), Object.defineProperty(P, "PixelsPerInch", {
            enumerable: !0,
            get: function() {
              return a.PixelsPerInch;
            }
          }), Object.defineProperty(P, "PromiseCapability", {
            enumerable: !0,
            get: function() {
              return p.PromiseCapability;
            }
          }), Object.defineProperty(P, "RenderingCancelledException", {
            enumerable: !0,
            get: function() {
              return a.RenderingCancelledException;
            }
          }), Object.defineProperty(P, "SVGGraphics", {
            enumerable: !0,
            get: function() {
              return t.SVGGraphics;
            }
          }), Object.defineProperty(P, "UnexpectedResponseException", {
            enumerable: !0,
            get: function() {
              return p.UnexpectedResponseException;
            }
          }), Object.defineProperty(P, "Util", {
            enumerable: !0,
            get: function() {
              return p.Util;
            }
          }), Object.defineProperty(P, "VerbosityLevel", {
            enumerable: !0,
            get: function() {
              return p.VerbosityLevel;
            }
          }), Object.defineProperty(P, "XfaLayer", {
            enumerable: !0,
            get: function() {
              return i.XfaLayer;
            }
          }), Object.defineProperty(P, "build", {
            enumerable: !0,
            get: function() {
              return t.build;
            }
          }), Object.defineProperty(P, "createValidAbsoluteUrl", {
            enumerable: !0,
            get: function() {
              return p.createValidAbsoluteUrl;
            }
          }), Object.defineProperty(P, "getDocument", {
            enumerable: !0,
            get: function() {
              return t.getDocument;
            }
          }), Object.defineProperty(P, "getFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return a.getFilenameFromUrl;
            }
          }), Object.defineProperty(P, "getPdfFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return a.getPdfFilenameFromUrl;
            }
          }), Object.defineProperty(P, "getXfaPageViewport", {
            enumerable: !0,
            get: function() {
              return a.getXfaPageViewport;
            }
          }), Object.defineProperty(P, "isDataScheme", {
            enumerable: !0,
            get: function() {
              return a.isDataScheme;
            }
          }), Object.defineProperty(P, "isPdfFile", {
            enumerable: !0,
            get: function() {
              return a.isPdfFile;
            }
          }), Object.defineProperty(P, "loadScript", {
            enumerable: !0,
            get: function() {
              return a.loadScript;
            }
          }), Object.defineProperty(P, "noContextMenu", {
            enumerable: !0,
            get: function() {
              return a.noContextMenu;
            }
          }), Object.defineProperty(P, "normalizeUnicode", {
            enumerable: !0,
            get: function() {
              return p.normalizeUnicode;
            }
          }), Object.defineProperty(P, "renderTextLayer", {
            enumerable: !0,
            get: function() {
              return f.renderTextLayer;
            }
          }), Object.defineProperty(P, "setLayerDimensions", {
            enumerable: !0,
            get: function() {
              return a.setLayerDimensions;
            }
          }), Object.defineProperty(P, "shadow", {
            enumerable: !0,
            get: function() {
              return p.shadow;
            }
          }), Object.defineProperty(P, "updateTextLayer", {
            enumerable: !0,
            get: function() {
              return f.updateTextLayer;
            }
          }), Object.defineProperty(P, "version", {
            enumerable: !0,
            get: function() {
              return t.version;
            }
          });
          var p = __w_pdfjs_require__(1), t = __w_pdfjs_require__(124), a = __w_pdfjs_require__(168), f = __w_pdfjs_require__(195), S = __w_pdfjs_require__(196), E = __w_pdfjs_require__(165), v = __w_pdfjs_require__(198), T = __w_pdfjs_require__(176), i = __w_pdfjs_require__(201);
        })(), __webpack_exports__;
      })()
    ));
  })(pdf)), pdf.exports;
}
var pdfExports = requirePdf();
const pdfjsLib = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null
}, [pdfExports]);
var pdf_viewer = { exports: {} }, hasRequiredPdf_viewer;
function requirePdf_viewer() {
  return hasRequiredPdf_viewer || (hasRequiredPdf_viewer = 1, (function(P, p) {
    (function(a, f) {
      P.exports = a.pdfjsViewer = f();
    })(globalThis, () => (
      /******/
      (() => {
        var t = [
          ,
          /* 1 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.PDFFindController = v.FindState = void 0;
            var i = T(2), n = T(3), o = T(4);
            const d = {
              FOUND: 0,
              NOT_FOUND: 1,
              WRAPPED: 2,
              PENDING: 3
            };
            v.FindState = d;
            const h = 250, e = -50, l = -400, u = {
              "‐": "-",
              "‘": "'",
              "’": "'",
              "‚": "'",
              "‛": "'",
              "“": '"',
              "”": '"',
              "„": '"',
              "‟": '"',
              "¼": "1/4",
              "½": "1/2",
              "¾": "3/4"
            }, c = /* @__PURE__ */ new Set([12441, 12442, 2381, 2509, 2637, 2765, 2893, 3021, 3149, 3277, 3387, 3388, 3405, 3530, 3642, 3770, 3972, 4153, 4154, 5908, 5940, 6098, 6752, 6980, 7082, 7083, 7154, 7155, 11647, 43014, 43052, 43204, 43347, 43456, 43766, 44013, 3158, 3953, 3954, 3962, 3963, 3964, 3965, 3968, 3956]);
            let y;
            const C = new RegExp("\\p{M}+", "gu"), R = new RegExp("([.*+?^${}()|[\\]\\\\])|(\\p{P})|(\\s+)|(\\p{M})|(\\p{L})", "gu"), s = new RegExp("([^\\p{M}])\\p{M}*$", "u"), m = new RegExp("^\\p{M}*([^\\p{M}])", "u"), F = /[\uAC00-\uD7AF\uFA6C\uFACF-\uFAD1\uFAD5-\uFAD7]+/g, B = /* @__PURE__ */ new Map(), k = "[\\u1100-\\u1112\\ud7a4-\\ud7af\\ud84a\\ud84c\\ud850\\ud854\\ud857\\ud85f]", V = /* @__PURE__ */ new Map();
            let z = null, K = null;
            function J(G) {
              const M = [];
              let x;
              for (; (x = F.exec(G)) !== null; ) {
                let {
                  index: D
                } = x;
                for (const L of x[0]) {
                  let W = B.get(L);
                  W || (W = L.normalize("NFD").length, B.set(L, W)), M.push([W, D++]);
                }
              }
              let A;
              if (M.length === 0 && z)
                A = z;
              else if (M.length > 0 && K)
                A = K;
              else {
                const D = Object.keys(u).join(""), L = (0, n.getNormalizeWithNFKC)(), q = `([${D}])|([${L}])|((?:゙|゚)\\n)|(\\p{M}+(?:-\\n)?)|(\\S-\\n)|((?:\\p{Ideographic}|[぀-ヿ])\\n)|(\\n)`;
                M.length === 0 ? A = z = new RegExp(q + "|(\\u0000)", "gum") : A = K = new RegExp(q + `|(${k})`, "gum");
              }
              const g = [];
              for (; (x = C.exec(G)) !== null; )
                g.push([x[0].length, x.index]);
              let I = G.normalize("NFD");
              const U = [[0, 0]];
              let _ = 0, H = 0, N = 0, b = 0, w = 0, O = !1;
              return I = I.replace(A, (D, L, W, X, q, ct, nt, Y, Q, et) => {
                if (et -= b, L) {
                  const Z = u[L], at = Z.length;
                  for (let lt = 1; lt < at; lt++)
                    U.push([et - N + lt, N - lt]);
                  return N -= at - 1, Z;
                }
                if (W) {
                  let Z = V.get(W);
                  Z || (Z = W.normalize("NFKC"), V.set(W, Z));
                  const at = Z.length;
                  for (let lt = 1; lt < at; lt++)
                    U.push([et - N + lt, N - lt]);
                  return N -= at - 1, Z;
                }
                if (X)
                  return O = !0, et + w === g[_]?.[1] ? ++_ : (U.push([et - 1 - N + 1, N - 1]), N -= 1, b += 1), U.push([et - N + 1, N]), b += 1, w += 1, X.charAt(0);
                if (q) {
                  const Z = q.endsWith(`
`), at = Z ? q.length - 2 : q.length;
                  O = !0;
                  let lt = at;
                  et + w === g[_]?.[1] && (lt -= g[_][0], ++_);
                  for (let ft = 1; ft <= lt; ft++)
                    U.push([et - 1 - N + ft, N - ft]);
                  return N -= lt, b += lt, Z ? (et += at - 1, U.push([et - N + 1, 1 + N]), N += 1, b += 1, w += 1, q.slice(0, at)) : q;
                }
                if (ct) {
                  const Z = ct.length - 2;
                  return U.push([et - N + Z, 1 + N]), N += 1, b += 1, w += 1, ct.slice(0, -2);
                }
                if (nt) {
                  const Z = nt.length - 1;
                  return U.push([et - N + Z, N]), b += 1, w += 1, nt.slice(0, -1);
                }
                if (Y)
                  return U.push([et - N + 1, N - 1]), N -= 1, b += 1, w += 1, " ";
                if (et + w === M[H]?.[1]) {
                  const Z = M[H][0] - 1;
                  ++H;
                  for (let at = 1; at <= Z; at++)
                    U.push([et - (N - at), N - at]);
                  N -= Z, b += Z;
                }
                return Q;
              }), U.push([I.length, N]), [I, U, O];
            }
            function $(G, M, x) {
              if (!G)
                return [M, x];
              const A = M, g = M + x - 1;
              let I = (0, i.binarySearchFirstItem)(G, (b) => b[0] >= A);
              G[I][0] > A && --I;
              let U = (0, i.binarySearchFirstItem)(G, (b) => b[0] >= g, I);
              G[U][0] > g && --U;
              const _ = A + G[I][1], N = g + G[U][1] + 1 - _;
              return [_, N];
            }
            class j {
              #t = null;
              #e = !0;
              #n = 0;
              constructor({
                linkService: M,
                eventBus: x,
                updateMatchesCountOnProgress: A = !0
              }) {
                this._linkService = M, this._eventBus = x, this.#e = A, this.onIsPageVisible = null, this.#o(), x._on("find", this.#i.bind(this)), x._on("findbarclose", this.#x.bind(this));
              }
              get highlightMatches() {
                return this._highlightMatches;
              }
              get pageMatches() {
                return this._pageMatches;
              }
              get pageMatchesLength() {
                return this._pageMatchesLength;
              }
              get selected() {
                return this._selected;
              }
              get state() {
                return this.#t;
              }
              setDocument(M) {
                this._pdfDocument && this.#o(), M && (this._pdfDocument = M, this._firstPageCapability.resolve());
              }
              #i(M) {
                if (!M)
                  return;
                M.phraseSearch === !1 && (console.error("The `phraseSearch`-parameter was removed, please provide an Array of strings in the `query`-parameter instead."), typeof M.query == "string" && (M.query = M.query.match(/\S+/g)));
                const x = this._pdfDocument, {
                  type: A
                } = M;
                (this.#t === null || this.#a(M)) && (this._dirtyMatch = !0), this.#t = M, A !== "highlightallchange" && this.#E(d.PENDING), this._firstPageCapability.promise.then(() => {
                  if (!this._pdfDocument || x && this._pdfDocument !== x)
                    return;
                  this.#u();
                  const g = !this._highlightMatches, I = !!this._findTimeout;
                  this._findTimeout && (clearTimeout(this._findTimeout), this._findTimeout = null), A ? this._dirtyMatch ? this.#g() : A === "again" ? (this.#g(), g && this.#t.highlightAll && this.#p()) : A === "highlightallchange" ? (I ? this.#g() : this._highlightMatches = !0, this.#p()) : this.#g() : this._findTimeout = setTimeout(() => {
                    this.#g(), this._findTimeout = null;
                  }, h);
                });
              }
              scrollMatchIntoView({
                element: M = null,
                selectedLeft: x = 0,
                pageIndex: A = -1,
                matchIndex: g = -1
              }) {
                if (!this._scrollMatches || !M)
                  return;
                if (g === -1 || g !== this._selected.matchIdx)
                  return;
                if (A === -1 || A !== this._selected.pageIdx)
                  return;
                this._scrollMatches = !1;
                const I = {
                  top: e,
                  left: x + l
                };
                (0, i.scrollIntoView)(M, I, !0);
              }
              #o() {
                this._highlightMatches = !1, this._scrollMatches = !1, this._pdfDocument = null, this._pageMatches = [], this._pageMatchesLength = [], this.#n = 0, this.#t = null, this._selected = {
                  pageIdx: -1,
                  matchIdx: -1
                }, this._offset = {
                  pageIdx: null,
                  matchIdx: null,
                  wrapped: !1
                }, this._extractTextPromises = [], this._pageContents = [], this._pageDiffs = [], this._hasDiacritics = [], this._matchesCountTotal = 0, this._pagesToSearch = null, this._pendingFindMatches = /* @__PURE__ */ new Set(), this._resumePageIdx = null, this._dirtyMatch = !1, clearTimeout(this._findTimeout), this._findTimeout = null, this._firstPageCapability = new o.PromiseCapability();
              }
              get #s() {
                const {
                  query: M
                } = this.#t;
                return typeof M == "string" ? (M !== this._rawQuery && (this._rawQuery = M, [this._normalizedQuery] = J(M)), this._normalizedQuery) : (M || []).filter((x) => !!x).map((x) => J(x)[0]);
              }
              #a(M) {
                const x = M.query, A = this.#t.query, g = typeof x;
                if (g !== typeof A)
                  return !0;
                if (g === "string") {
                  if (x !== A)
                    return !0;
                } else if (JSON.stringify(x) !== JSON.stringify(A))
                  return !0;
                switch (M.type) {
                  case "again":
                    const U = this._selected.pageIdx + 1, _ = this._linkService;
                    return U >= 1 && U <= _.pagesCount && U !== _.page && !(this.onIsPageVisible?.(U) ?? !0);
                  case "highlightallchange":
                    return !1;
                }
                return !0;
              }
              #l(M, x, A) {
                let g = M.slice(0, x).match(s);
                if (g) {
                  const I = M.charCodeAt(x), U = g[1].charCodeAt(0);
                  if ((0, n.getCharacterType)(I) === (0, n.getCharacterType)(U))
                    return !1;
                }
                if (g = M.slice(x + A).match(m), g) {
                  const I = M.charCodeAt(x + A - 1), U = g[1].charCodeAt(0);
                  if ((0, n.getCharacterType)(I) === (0, n.getCharacterType)(U))
                    return !1;
                }
                return !0;
              }
              #c(M, x, A, g) {
                const I = this._pageMatches[A] = [], U = this._pageMatchesLength[A] = [];
                if (!M)
                  return;
                const _ = this._pageDiffs[A];
                let H;
                for (; (H = M.exec(g)) !== null; ) {
                  if (x && !this.#l(g, H.index, H[0].length))
                    continue;
                  const [N, b] = $(_, H.index, H[0].length);
                  b && (I.push(N), U.push(b));
                }
              }
              #r(M, x) {
                const {
                  matchDiacritics: A
                } = this.#t;
                let g = !1;
                M = M.replaceAll(R, (U, _, H, N, b, w) => _ ? `[ ]*\\${_}[ ]*` : H ? `[ ]*${H}[ ]*` : N ? "[ ]+" : A ? b || w : b ? c.has(b.charCodeAt(0)) ? b : "" : x ? (g = !0, `${w}\\p{M}*`) : w);
                const I = "[ ]*";
                return M.endsWith(I) && (M = M.slice(0, M.length - I.length)), A && x && (y ||= String.fromCharCode(...c), g = !0, M = `${M}(?=[${y}]|[^\\p{M}]|$)`), [g, M];
              }
              #h(M) {
                let x = this.#s;
                if (x.length === 0)
                  return;
                const {
                  caseSensitive: A,
                  entireWord: g
                } = this.#t, I = this._pageContents[M], U = this._hasDiacritics[M];
                let _ = !1;
                typeof x == "string" ? [_, x] = this.#r(x, U) : x = x.sort().reverse().map((b) => {
                  const [w, O] = this.#r(b, U);
                  return _ ||= w, `(${O})`;
                }).join("|");
                const H = `g${_ ? "u" : ""}${A ? "" : "i"}`;
                x = x ? new RegExp(x, H) : null, this.#c(x, g, M, I), this.#t.highlightAll && this.#f(M), this._resumePageIdx === M && (this._resumePageIdx = null, this.#v());
                const N = this._pageMatches[M].length;
                this._matchesCountTotal += N, this.#e ? N > 0 && this.#S() : ++this.#n === this._linkService.pagesCount && this.#S();
              }
              #u() {
                if (this._extractTextPromises.length > 0)
                  return;
                let M = Promise.resolve();
                const x = {
                  disableNormalization: !0
                };
                for (let A = 0, g = this._linkService.pagesCount; A < g; A++) {
                  const I = new o.PromiseCapability();
                  this._extractTextPromises[A] = I.promise, M = M.then(() => this._pdfDocument.getPage(A + 1).then((U) => U.getTextContent(x)).then((U) => {
                    const _ = [];
                    for (const H of U.items)
                      _.push(H.str), H.hasEOL && _.push(`
`);
                    [this._pageContents[A], this._pageDiffs[A], this._hasDiacritics[A]] = J(_.join("")), I.resolve();
                  }, (U) => {
                    console.error(`Unable to get text content for page ${A + 1}`, U), this._pageContents[A] = "", this._pageDiffs[A] = null, this._hasDiacritics[A] = !1, I.resolve();
                  }));
                }
              }
              #f(M) {
                this._scrollMatches && this._selected.pageIdx === M && (this._linkService.page = M + 1), this._eventBus.dispatch("updatetextlayermatches", {
                  source: this,
                  pageIndex: M
                });
              }
              #p() {
                this._eventBus.dispatch("updatetextlayermatches", {
                  source: this,
                  pageIndex: -1
                });
              }
              #g() {
                const M = this.#t.findPrevious, x = this._linkService.page - 1, A = this._linkService.pagesCount;
                if (this._highlightMatches = !0, this._dirtyMatch) {
                  this._dirtyMatch = !1, this._selected.pageIdx = this._selected.matchIdx = -1, this._offset.pageIdx = x, this._offset.matchIdx = null, this._offset.wrapped = !1, this._resumePageIdx = null, this._pageMatches.length = 0, this._pageMatchesLength.length = 0, this.#n = 0, this._matchesCountTotal = 0, this.#p();
                  for (let U = 0; U < A; U++)
                    this._pendingFindMatches.has(U) || (this._pendingFindMatches.add(U), this._extractTextPromises[U].then(() => {
                      this._pendingFindMatches.delete(U), this.#h(U);
                    }));
                }
                if (this.#s.length === 0) {
                  this.#E(d.FOUND);
                  return;
                }
                if (this._resumePageIdx)
                  return;
                const I = this._offset;
                if (this._pagesToSearch = A, I.matchIdx !== null) {
                  const U = this._pageMatches[I.pageIdx].length;
                  if (!M && I.matchIdx + 1 < U || M && I.matchIdx > 0) {
                    I.matchIdx = M ? I.matchIdx - 1 : I.matchIdx + 1, this.#b(!0);
                    return;
                  }
                  this.#d(M);
                }
                this.#v();
              }
              #m(M) {
                const x = this._offset, A = M.length, g = this.#t.findPrevious;
                return A ? (x.matchIdx = g ? A - 1 : 0, this.#b(!0), !0) : (this.#d(g), x.wrapped && (x.matchIdx = null, this._pagesToSearch < 0) ? (this.#b(!1), !0) : !1);
              }
              #v() {
                this._resumePageIdx !== null && console.error("There can only be one pending page.");
                let M = null;
                do {
                  const x = this._offset.pageIdx;
                  if (M = this._pageMatches[x], !M) {
                    this._resumePageIdx = x;
                    break;
                  }
                } while (!this.#m(M));
              }
              #d(M) {
                const x = this._offset, A = this._linkService.pagesCount;
                x.pageIdx = M ? x.pageIdx - 1 : x.pageIdx + 1, x.matchIdx = null, this._pagesToSearch--, (x.pageIdx >= A || x.pageIdx < 0) && (x.pageIdx = M ? A - 1 : 0, x.wrapped = !0);
              }
              #b(M = !1) {
                let x = d.NOT_FOUND;
                const A = this._offset.wrapped;
                if (this._offset.wrapped = !1, M) {
                  const g = this._selected.pageIdx;
                  this._selected.pageIdx = this._offset.pageIdx, this._selected.matchIdx = this._offset.matchIdx, x = A ? d.WRAPPED : d.FOUND, g !== -1 && g !== this._selected.pageIdx && this.#f(g);
                }
                this.#E(x, this.#t.findPrevious), this._selected.pageIdx !== -1 && (this._scrollMatches = !0, this.#f(this._selected.pageIdx));
              }
              #x(M) {
                const x = this._pdfDocument;
                this._firstPageCapability.promise.then(() => {
                  !this._pdfDocument || x && this._pdfDocument !== x || (this._findTimeout && (clearTimeout(this._findTimeout), this._findTimeout = null), this._resumePageIdx && (this._resumePageIdx = null, this._dirtyMatch = !0), this.#E(d.FOUND), this._highlightMatches = !1, this.#p());
                });
              }
              #A() {
                const {
                  pageIdx: M,
                  matchIdx: x
                } = this._selected;
                let A = 0, g = this._matchesCountTotal;
                if (x !== -1) {
                  for (let I = 0; I < M; I++)
                    A += this._pageMatches[I]?.length || 0;
                  A += x + 1;
                }
                return (A < 1 || A > g) && (A = g = 0), {
                  current: A,
                  total: g
                };
              }
              #S() {
                this._eventBus.dispatch("updatefindmatchescount", {
                  source: this,
                  matchesCount: this.#A()
                });
              }
              #E(M, x = !1) {
                !this.#e && (this.#n !== this._linkService.pagesCount || M === d.PENDING) || this._eventBus.dispatch("updatefindcontrolstate", {
                  source: this,
                  state: M,
                  previous: x,
                  matchesCount: this.#A(),
                  rawQuery: this.#t?.query ?? null
                });
              }
            }
            v.PDFFindController = j;
          }),
          /* 2 */
          /***/
          ((E, v) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.animationStarted = v.VERTICAL_PADDING = v.UNKNOWN_SCALE = v.TextLayerMode = v.SpreadMode = v.SidebarView = v.ScrollMode = v.SCROLLBAR_PADDING = v.RenderingStates = v.ProgressBar = v.PresentationModeState = v.OutputScale = v.MIN_SCALE = v.MAX_SCALE = v.MAX_AUTO_SCALE = v.DEFAULT_SCALE_VALUE = v.DEFAULT_SCALE_DELTA = v.DEFAULT_SCALE = v.CursorTool = v.AutoPrintRegExp = void 0, v.apiPageLayoutToViewerModes = X, v.apiPageModeToSidebarView = q, v.approximateFraction = G, v.backtrackBeforeAllVisibleElements = A, v.binarySearchFirstItem = j, v.docStyle = void 0, v.getActiveOrFocusedElement = W, v.getPageSizeInches = x, v.getVisibleElements = g, v.isPortraitOrientation = b, v.isValidRotation = _, v.isValidScrollMode = H, v.isValidSpreadMode = N, v.normalizeWheelEventDelta = U, v.normalizeWheelEventDirection = I, v.parseQueryString = K, v.removeNullCharacters = $, v.roundToDivide = M, v.scrollIntoView = V, v.toggleCheckedBtn = ct, v.toggleExpandedBtn = nt, v.watchScroll = z;
            const T = "auto";
            v.DEFAULT_SCALE_VALUE = T;
            const i = 1;
            v.DEFAULT_SCALE = i;
            const n = 1.1;
            v.DEFAULT_SCALE_DELTA = n;
            const o = 0.1;
            v.MIN_SCALE = o;
            const d = 10;
            v.MAX_SCALE = d;
            const h = 0;
            v.UNKNOWN_SCALE = h;
            const e = 1.25;
            v.MAX_AUTO_SCALE = e;
            const l = 40;
            v.SCROLLBAR_PADDING = l;
            const u = 5;
            v.VERTICAL_PADDING = u;
            const c = {
              INITIAL: 0,
              RUNNING: 1,
              PAUSED: 2,
              FINISHED: 3
            };
            v.RenderingStates = c;
            const y = {
              UNKNOWN: 0,
              NORMAL: 1,
              CHANGING: 2,
              FULLSCREEN: 3
            };
            v.PresentationModeState = y;
            const C = {
              UNKNOWN: -1,
              NONE: 0,
              THUMBS: 1,
              OUTLINE: 2,
              ATTACHMENTS: 3,
              LAYERS: 4
            };
            v.SidebarView = C;
            const R = {
              DISABLE: 0,
              ENABLE: 1,
              ENABLE_PERMISSIONS: 2
            };
            v.TextLayerMode = R;
            const s = {
              UNKNOWN: -1,
              VERTICAL: 0,
              HORIZONTAL: 1,
              WRAPPED: 2,
              PAGE: 3
            };
            v.ScrollMode = s;
            const m = {
              UNKNOWN: -1,
              NONE: 0,
              ODD: 1,
              EVEN: 2
            };
            v.SpreadMode = m;
            const F = {
              SELECT: 0,
              HAND: 1,
              ZOOM: 2
            };
            v.CursorTool = F;
            const B = /\bprint\s*\(/;
            v.AutoPrintRegExp = B;
            class k {
              constructor() {
                const Q = window.devicePixelRatio || 1;
                this.sx = Q, this.sy = Q;
              }
              get scaled() {
                return this.sx !== 1 || this.sy !== 1;
              }
            }
            v.OutputScale = k;
            function V(Y, Q, et = !1) {
              let Z = Y.offsetParent;
              if (!Z) {
                console.error("offsetParent is not set -- cannot scroll");
                return;
              }
              let at = Y.offsetTop + Y.clientTop, lt = Y.offsetLeft + Y.clientLeft;
              for (; Z.clientHeight === Z.scrollHeight && Z.clientWidth === Z.scrollWidth || et && (Z.classList.contains("markedContent") || getComputedStyle(Z).overflow === "hidden"); )
                if (at += Z.offsetTop, lt += Z.offsetLeft, Z = Z.offsetParent, !Z)
                  return;
              Q && (Q.top !== void 0 && (at += Q.top), Q.left !== void 0 && (lt += Q.left, Z.scrollLeft = lt)), Z.scrollTop = at;
            }
            function z(Y, Q) {
              const et = function(lt) {
                at || (at = window.requestAnimationFrame(function() {
                  at = null;
                  const pt = Y.scrollLeft, vt = Z.lastX;
                  pt !== vt && (Z.right = pt > vt), Z.lastX = pt;
                  const yt = Y.scrollTop, xt = Z.lastY;
                  yt !== xt && (Z.down = yt > xt), Z.lastY = yt, Q(Z);
                }));
              }, Z = {
                right: !0,
                down: !0,
                lastX: Y.scrollLeft,
                lastY: Y.scrollTop,
                _eventHandler: et
              };
              let at = null;
              return Y.addEventListener("scroll", et, !0), Z;
            }
            function K(Y) {
              const Q = /* @__PURE__ */ new Map();
              for (const [et, Z] of new URLSearchParams(Y))
                Q.set(et.toLowerCase(), Z);
              return Q;
            }
            const J = /[\x01-\x1F]/g;
            function $(Y, Q = !1) {
              return typeof Y != "string" ? (console.error("The argument must be a string."), Y) : (Q && (Y = Y.replaceAll(J, " ")), Y.replaceAll("\0", ""));
            }
            function j(Y, Q, et = 0) {
              let Z = et, at = Y.length - 1;
              if (at < 0 || !Q(Y[at]))
                return Y.length;
              if (Q(Y[Z]))
                return Z;
              for (; Z < at; ) {
                const lt = Z + at >> 1, ft = Y[lt];
                Q(ft) ? at = lt : Z = lt + 1;
              }
              return Z;
            }
            function G(Y) {
              if (Math.floor(Y) === Y)
                return [Y, 1];
              const Q = 1 / Y, et = 8;
              if (Q > et)
                return [1, et];
              if (Math.floor(Q) === Q)
                return [1, Q];
              const Z = Y > 1 ? Q : Y;
              let at = 0, lt = 1, ft = 1, pt = 1;
              for (; ; ) {
                const yt = at + ft, xt = lt + pt;
                if (xt > et)
                  break;
                Z <= yt / xt ? (ft = yt, pt = xt) : (at = yt, lt = xt);
              }
              let vt;
              return Z - at / lt < ft / pt - Z ? vt = Z === Y ? [at, lt] : [lt, at] : vt = Z === Y ? [ft, pt] : [pt, ft], vt;
            }
            function M(Y, Q) {
              const et = Y % Q;
              return et === 0 ? Y : Math.round(Y - et + Q);
            }
            function x({
              view: Y,
              userUnit: Q,
              rotate: et
            }) {
              const [Z, at, lt, ft] = Y, pt = et % 180 !== 0, vt = (lt - Z) / 72 * Q, yt = (ft - at) / 72 * Q;
              return {
                width: pt ? yt : vt,
                height: pt ? vt : yt
              };
            }
            function A(Y, Q, et) {
              if (Y < 2)
                return Y;
              let Z = Q[Y].div, at = Z.offsetTop + Z.clientTop;
              at >= et && (Z = Q[Y - 1].div, at = Z.offsetTop + Z.clientTop);
              for (let lt = Y - 2; lt >= 0 && (Z = Q[lt].div, !(Z.offsetTop + Z.clientTop + Z.clientHeight <= at)); --lt)
                Y = lt;
              return Y;
            }
            function g({
              scrollEl: Y,
              views: Q,
              sortByVisibility: et = !1,
              horizontal: Z = !1,
              rtl: at = !1
            }) {
              const lt = Y.scrollTop, ft = lt + Y.clientHeight, pt = Y.scrollLeft, vt = pt + Y.clientWidth;
              function yt(Ot) {
                const ot = Ot.div;
                return ot.offsetTop + ot.clientTop + ot.clientHeight > lt;
              }
              function xt(Ot) {
                const ot = Ot.div, it = ot.offsetLeft + ot.clientLeft, tt = it + ot.clientWidth;
                return at ? it < vt : tt > pt;
              }
              const wt = [], _t = /* @__PURE__ */ new Set(), Ct = Q.length;
              let Mt = j(Q, Z ? xt : yt);
              Mt > 0 && Mt < Ct && !Z && (Mt = A(Mt, Q, lt));
              let Rt = Z ? vt : -1;
              for (let Ot = Mt; Ot < Ct; Ot++) {
                const ot = Q[Ot], it = ot.div, tt = it.offsetLeft + it.clientLeft, ut = it.offsetTop + it.clientTop, Et = it.clientWidth, kt = it.clientHeight, rt = tt + Et, dt = ut + kt;
                if (Rt === -1)
                  dt >= ft && (Rt = dt);
                else if ((Z ? tt : ut) > Rt)
                  break;
                if (dt <= lt || ut >= ft || rt <= pt || tt >= vt)
                  continue;
                const bt = Math.max(0, lt - ut) + Math.max(0, dt - ft), gt = Math.max(0, pt - tt) + Math.max(0, rt - vt), mt = (kt - bt) / kt, At = (Et - gt) / Et, ht = mt * At * 100 | 0;
                wt.push({
                  id: ot.id,
                  x: tt,
                  y: ut,
                  view: ot,
                  percent: ht,
                  widthPercent: At * 100 | 0
                }), _t.add(ot.id);
              }
              const Nt = wt[0], Ut = wt.at(-1);
              return et && wt.sort(function(Ot, ot) {
                const it = Ot.percent - ot.percent;
                return Math.abs(it) > 1e-3 ? -it : Ot.id - ot.id;
              }), {
                first: Nt,
                last: Ut,
                views: wt,
                ids: _t
              };
            }
            function I(Y) {
              let Q = Math.hypot(Y.deltaX, Y.deltaY);
              const et = Math.atan2(Y.deltaY, Y.deltaX);
              return -0.25 * Math.PI < et && et < 0.75 * Math.PI && (Q = -Q), Q;
            }
            function U(Y) {
              const Q = Y.deltaMode;
              let et = I(Y);
              const Z = 30, at = 30;
              return Q === WheelEvent.DOM_DELTA_PIXEL ? et /= Z * at : Q === WheelEvent.DOM_DELTA_LINE && (et /= at), et;
            }
            function _(Y) {
              return Number.isInteger(Y) && Y % 90 === 0;
            }
            function H(Y) {
              return Number.isInteger(Y) && Object.values(s).includes(Y) && Y !== s.UNKNOWN;
            }
            function N(Y) {
              return Number.isInteger(Y) && Object.values(m).includes(Y) && Y !== m.UNKNOWN;
            }
            function b(Y) {
              return Y.width <= Y.height;
            }
            const w = new Promise(function(Y) {
              window.requestAnimationFrame(Y);
            });
            v.animationStarted = w;
            const O = document.documentElement.style;
            v.docStyle = O;
            function D(Y, Q, et) {
              return Math.min(Math.max(Y, Q), et);
            }
            class L {
              #t = null;
              #e = null;
              #n = 0;
              #i = null;
              #o = !0;
              constructor(Q) {
                this.#t = Q.classList, this.#i = Q.style;
              }
              get percent() {
                return this.#n;
              }
              set percent(Q) {
                if (this.#n = D(Q, 0, 100), isNaN(Q)) {
                  this.#t.add("indeterminate");
                  return;
                }
                this.#t.remove("indeterminate"), this.#i.setProperty("--progressBar-percent", `${this.#n}%`);
              }
              setWidth(Q) {
                if (!Q)
                  return;
                const Z = Q.parentNode.offsetWidth - Q.offsetWidth;
                Z > 0 && this.#i.setProperty("--progressBar-end-offset", `${Z}px`);
              }
              setDisableAutoFetch(Q = 5e3) {
                isNaN(this.#n) || (this.#e && clearTimeout(this.#e), this.show(), this.#e = setTimeout(() => {
                  this.#e = null, this.hide();
                }, Q));
              }
              hide() {
                this.#o && (this.#o = !1, this.#t.add("hidden"));
              }
              show() {
                this.#o || (this.#o = !0, this.#t.remove("hidden"));
              }
            }
            v.ProgressBar = L;
            function W() {
              let Y = document, Q = Y.activeElement || Y.querySelector(":focus");
              for (; Q?.shadowRoot; )
                Y = Q.shadowRoot, Q = Y.activeElement || Y.querySelector(":focus");
              return Q;
            }
            function X(Y) {
              let Q = s.VERTICAL, et = m.NONE;
              switch (Y) {
                case "SinglePage":
                  Q = s.PAGE;
                  break;
                case "OneColumn":
                  break;
                case "TwoPageLeft":
                  Q = s.PAGE;
                case "TwoColumnLeft":
                  et = m.ODD;
                  break;
                case "TwoPageRight":
                  Q = s.PAGE;
                case "TwoColumnRight":
                  et = m.EVEN;
                  break;
              }
              return {
                scrollMode: Q,
                spreadMode: et
              };
            }
            function q(Y) {
              switch (Y) {
                case "UseNone":
                  return C.NONE;
                case "UseThumbs":
                  return C.THUMBS;
                case "UseOutlines":
                  return C.OUTLINE;
                case "UseAttachments":
                  return C.ATTACHMENTS;
                case "UseOC":
                  return C.LAYERS;
              }
              return C.NONE;
            }
            function ct(Y, Q, et = null) {
              Y.classList.toggle("toggled", Q), Y.setAttribute("aria-checked", Q), et?.classList.toggle("hidden", !Q);
            }
            function nt(Y, Q, et = null) {
              Y.classList.toggle("toggled", Q), Y.setAttribute("aria-expanded", Q), et?.classList.toggle("hidden", !Q);
            }
          }),
          /* 3 */
          /***/
          ((E, v) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.CharacterType = void 0, v.getCharacterType = C, v.getNormalizeWithNFKC = s;
            const T = {
              SPACE: 0,
              ALPHA_LETTER: 1,
              PUNCT: 2,
              HAN_LETTER: 3,
              KATAKANA_LETTER: 4,
              HIRAGANA_LETTER: 5,
              HALFWIDTH_KATAKANA_LETTER: 6,
              THAI_LETTER: 7
            };
            v.CharacterType = T;
            function i(m) {
              return m < 11904;
            }
            function n(m) {
              return (m & 65408) === 0;
            }
            function o(m) {
              return m >= 97 && m <= 122 || m >= 65 && m <= 90;
            }
            function d(m) {
              return m >= 48 && m <= 57;
            }
            function h(m) {
              return m === 32 || m === 9 || m === 13 || m === 10;
            }
            function e(m) {
              return m >= 13312 && m <= 40959 || m >= 63744 && m <= 64255;
            }
            function l(m) {
              return m >= 12448 && m <= 12543;
            }
            function u(m) {
              return m >= 12352 && m <= 12447;
            }
            function c(m) {
              return m >= 65376 && m <= 65439;
            }
            function y(m) {
              return (m & 65408) === 3584;
            }
            function C(m) {
              return i(m) ? n(m) ? h(m) ? T.SPACE : o(m) || d(m) || m === 95 ? T.ALPHA_LETTER : T.PUNCT : y(m) ? T.THAI_LETTER : m === 160 ? T.SPACE : T.ALPHA_LETTER : e(m) ? T.HAN_LETTER : l(m) ? T.KATAKANA_LETTER : u(m) ? T.HIRAGANA_LETTER : c(m) ? T.HALFWIDTH_KATAKANA_LETTER : T.ALPHA_LETTER;
            }
            let R;
            function s() {
              return R ||= " ¨ª¯²-µ¸-º¼-¾Ĳ-ĳĿ-ŀŉſǄ-ǌǱ-ǳʰ-ʸ˘-˝ˠ-ˤʹͺ;΄-΅·ϐ-ϖϰ-ϲϴ-ϵϹևٵ-ٸक़-य़ড়-ঢ়য়ਲ਼ਸ਼ਖ਼-ਜ਼ਫ਼ଡ଼-ଢ଼ำຳໜ-ໝ༌གྷཌྷདྷབྷཛྷཀྵჼᴬ-ᴮᴰ-ᴺᴼ-ᵍᵏ-ᵪᵸᶛ-ᶿẚ-ẛάέήίόύώΆ᾽-῁ΈΉ῍-῏ΐΊ῝-῟ΰΎ῭-`ΌΏ´-῾ - ‑‗․-… ″-‴‶-‷‼‾⁇-⁉⁗ ⁰-ⁱ⁴-₎ₐ-ₜ₨℀-℃℅-ℇ℉-ℓℕ-№ℙ-ℝ℠-™ℤΩℨK-ℭℯ-ℱℳ-ℹ℻-⅀ⅅ-ⅉ⅐-ⅿ↉∬-∭∯-∰〈-〉①-⓪⨌⩴-⩶⫝̸ⱼ-ⱽⵯ⺟⻳⼀-⿕　〶〸-〺゛-゜ゟヿㄱ-ㆎ㆒-㆟㈀-㈞㈠-㉇㉐-㉾㊀-㏿ꚜ-ꚝꝰꟲ-ꟴꟸ-ꟹꭜ-ꭟꭩ豈-嗀塚晴凞-羽蘒諸逸-都飯-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-זּטּ-לּמּנּ-סּףּ-פּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-﷼︐-︙︰-﹄﹇-﹒﹔-﹦﹨-﹫ﹰ-ﹲﹴﹶ-ﻼ！-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ￠-￦", R;
            }
          }),
          /* 4 */
          /***/
          ((E) => {
            E.exports = globalThis.pdfjsLib;
          }),
          /* 5 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.SimpleLinkService = v.PDFLinkService = v.LinkTarget = void 0;
            var i = T(2);
            const n = "noopener noreferrer nofollow", o = {
              NONE: 0,
              SELF: 1,
              BLANK: 2,
              PARENT: 3,
              TOP: 4
            };
            v.LinkTarget = o;
            function d(l, {
              url: u,
              target: c,
              rel: y,
              enabled: C = !0
            } = {}) {
              if (!u || typeof u != "string")
                throw new Error('A valid "url" parameter must provided.');
              C ? l.href = l.title = u : (l.href = "", l.title = `Disabled: ${u}`, l.onclick = () => !1);
              let R = "";
              switch (c) {
                case o.NONE:
                  break;
                case o.SELF:
                  R = "_self";
                  break;
                case o.BLANK:
                  R = "_blank";
                  break;
                case o.PARENT:
                  R = "_parent";
                  break;
                case o.TOP:
                  R = "_top";
                  break;
              }
              l.target = R, l.rel = typeof y == "string" ? y : n;
            }
            class h {
              #t = /* @__PURE__ */ new Map();
              constructor({
                eventBus: u,
                externalLinkTarget: c = null,
                externalLinkRel: y = null,
                ignoreDestinationZoom: C = !1
              } = {}) {
                this.eventBus = u, this.externalLinkTarget = c, this.externalLinkRel = y, this.externalLinkEnabled = !0, this._ignoreDestinationZoom = C, this.baseUrl = null, this.pdfDocument = null, this.pdfViewer = null, this.pdfHistory = null;
              }
              setDocument(u, c = null) {
                this.baseUrl = c, this.pdfDocument = u, this.#t.clear();
              }
              setViewer(u) {
                this.pdfViewer = u;
              }
              setHistory(u) {
                this.pdfHistory = u;
              }
              get pagesCount() {
                return this.pdfDocument ? this.pdfDocument.numPages : 0;
              }
              get page() {
                return this.pdfViewer.currentPageNumber;
              }
              set page(u) {
                this.pdfViewer.currentPageNumber = u;
              }
              get rotation() {
                return this.pdfViewer.pagesRotation;
              }
              set rotation(u) {
                this.pdfViewer.pagesRotation = u;
              }
              get isInPresentationMode() {
                return this.pdfViewer.isInPresentationMode;
              }
              #e(u, c = null, y) {
                const C = y[0];
                let R;
                if (typeof C == "object" && C !== null) {
                  if (R = this._cachedPageNumber(C), !R) {
                    this.pdfDocument.getPageIndex(C).then((s) => {
                      this.cachePageRef(s + 1, C), this.#e(u, c, y);
                    }).catch(() => {
                      console.error(`PDFLinkService.#goToDestinationHelper: "${C}" is not a valid page reference, for dest="${u}".`);
                    });
                    return;
                  }
                } else if (Number.isInteger(C))
                  R = C + 1;
                else {
                  console.error(`PDFLinkService.#goToDestinationHelper: "${C}" is not a valid destination reference, for dest="${u}".`);
                  return;
                }
                if (!R || R < 1 || R > this.pagesCount) {
                  console.error(`PDFLinkService.#goToDestinationHelper: "${R}" is not a valid page number, for dest="${u}".`);
                  return;
                }
                this.pdfHistory && (this.pdfHistory.pushCurrentPosition(), this.pdfHistory.push({
                  namedDest: c,
                  explicitDest: y,
                  pageNumber: R
                })), this.pdfViewer.scrollPageIntoView({
                  pageNumber: R,
                  destArray: y,
                  ignoreDestinationZoom: this._ignoreDestinationZoom
                });
              }
              async goToDestination(u) {
                if (!this.pdfDocument)
                  return;
                let c, y;
                if (typeof u == "string" ? (c = u, y = await this.pdfDocument.getDestination(u)) : (c = null, y = await u), !Array.isArray(y)) {
                  console.error(`PDFLinkService.goToDestination: "${y}" is not a valid destination array, for dest="${u}".`);
                  return;
                }
                this.#e(u, c, y);
              }
              goToPage(u) {
                if (!this.pdfDocument)
                  return;
                const c = typeof u == "string" && this.pdfViewer.pageLabelToPageNumber(u) || u | 0;
                if (!(Number.isInteger(c) && c > 0 && c <= this.pagesCount)) {
                  console.error(`PDFLinkService.goToPage: "${u}" is not a valid page.`);
                  return;
                }
                this.pdfHistory && (this.pdfHistory.pushCurrentPosition(), this.pdfHistory.pushPage(c)), this.pdfViewer.scrollPageIntoView({
                  pageNumber: c
                });
              }
              addLinkAttributes(u, c, y = !1) {
                d(u, {
                  url: c,
                  target: y ? o.BLANK : this.externalLinkTarget,
                  rel: this.externalLinkRel,
                  enabled: this.externalLinkEnabled
                });
              }
              getDestinationHash(u) {
                if (typeof u == "string") {
                  if (u.length > 0)
                    return this.getAnchorUrl("#" + escape(u));
                } else if (Array.isArray(u)) {
                  const c = JSON.stringify(u);
                  if (c.length > 0)
                    return this.getAnchorUrl("#" + escape(c));
                }
                return this.getAnchorUrl("");
              }
              getAnchorUrl(u) {
                return this.baseUrl ? this.baseUrl + u : u;
              }
              setHash(u) {
                if (!this.pdfDocument)
                  return;
                let c, y;
                if (u.includes("=")) {
                  const C = (0, i.parseQueryString)(u);
                  if (C.has("search")) {
                    const R = C.get("search").replaceAll('"', ""), s = C.get("phrase") === "true";
                    this.eventBus.dispatch("findfromurlhash", {
                      source: this,
                      query: s ? R : R.match(/\S+/g)
                    });
                  }
                  if (C.has("page") && (c = C.get("page") | 0 || 1), C.has("zoom")) {
                    const R = C.get("zoom").split(","), s = R[0], m = parseFloat(s);
                    s.includes("Fit") ? s === "Fit" || s === "FitB" ? y = [null, {
                      name: s
                    }] : s === "FitH" || s === "FitBH" || s === "FitV" || s === "FitBV" ? y = [null, {
                      name: s
                    }, R.length > 1 ? R[1] | 0 : null] : s === "FitR" ? R.length !== 5 ? console.error('PDFLinkService.setHash: Not enough parameters for "FitR".') : y = [null, {
                      name: s
                    }, R[1] | 0, R[2] | 0, R[3] | 0, R[4] | 0] : console.error(`PDFLinkService.setHash: "${s}" is not a valid zoom value.`) : y = [null, {
                      name: "XYZ"
                    }, R.length > 1 ? R[1] | 0 : null, R.length > 2 ? R[2] | 0 : null, m ? m / 100 : s];
                  }
                  y ? this.pdfViewer.scrollPageIntoView({
                    pageNumber: c || this.page,
                    destArray: y,
                    allowNegativeOffset: !0
                  }) : c && (this.page = c), C.has("pagemode") && this.eventBus.dispatch("pagemode", {
                    source: this,
                    mode: C.get("pagemode")
                  }), C.has("nameddest") && this.goToDestination(C.get("nameddest"));
                } else {
                  y = unescape(u);
                  try {
                    y = JSON.parse(y), Array.isArray(y) || (y = y.toString());
                  } catch {
                  }
                  if (typeof y == "string" || h.#n(y)) {
                    this.goToDestination(y);
                    return;
                  }
                  console.error(`PDFLinkService.setHash: "${unescape(u)}" is not a valid destination.`);
                }
              }
              executeNamedAction(u) {
                switch (u) {
                  case "GoBack":
                    this.pdfHistory?.back();
                    break;
                  case "GoForward":
                    this.pdfHistory?.forward();
                    break;
                  case "NextPage":
                    this.pdfViewer.nextPage();
                    break;
                  case "PrevPage":
                    this.pdfViewer.previousPage();
                    break;
                  case "LastPage":
                    this.page = this.pagesCount;
                    break;
                  case "FirstPage":
                    this.page = 1;
                    break;
                }
                this.eventBus.dispatch("namedaction", {
                  source: this,
                  action: u
                });
              }
              async executeSetOCGState(u) {
                const c = this.pdfDocument, y = await this.pdfViewer.optionalContentConfigPromise;
                if (c !== this.pdfDocument)
                  return;
                let C;
                for (const R of u.state) {
                  switch (R) {
                    case "ON":
                    case "OFF":
                    case "Toggle":
                      C = R;
                      continue;
                  }
                  switch (C) {
                    case "ON":
                      y.setVisibility(R, !0);
                      break;
                    case "OFF":
                      y.setVisibility(R, !1);
                      break;
                    case "Toggle":
                      const s = y.getGroup(R);
                      s && y.setVisibility(R, !s.visible);
                      break;
                  }
                }
                this.pdfViewer.optionalContentConfigPromise = Promise.resolve(y);
              }
              cachePageRef(u, c) {
                if (!c)
                  return;
                const y = c.gen === 0 ? `${c.num}R` : `${c.num}R${c.gen}`;
                this.#t.set(y, u);
              }
              _cachedPageNumber(u) {
                if (!u)
                  return null;
                const c = u.gen === 0 ? `${u.num}R` : `${u.num}R${u.gen}`;
                return this.#t.get(c) || null;
              }
              static #n(u) {
                if (!Array.isArray(u))
                  return !1;
                const c = u.length;
                if (c < 2)
                  return !1;
                const y = u[0];
                if (!(typeof y == "object" && Number.isInteger(y.num) && Number.isInteger(y.gen)) && !(Number.isInteger(y) && y >= 0))
                  return !1;
                const C = u[1];
                if (!(typeof C == "object" && typeof C.name == "string"))
                  return !1;
                let R = !0;
                switch (C.name) {
                  case "XYZ":
                    if (c !== 5)
                      return !1;
                    break;
                  case "Fit":
                  case "FitB":
                    return c === 2;
                  case "FitH":
                  case "FitBH":
                  case "FitV":
                  case "FitBV":
                    if (c !== 3)
                      return !1;
                    break;
                  case "FitR":
                    if (c !== 6)
                      return !1;
                    R = !1;
                    break;
                  default:
                    return !1;
                }
                for (let s = 2; s < c; s++) {
                  const m = u[s];
                  if (!(typeof m == "number" || R && m === null))
                    return !1;
                }
                return !0;
              }
            }
            v.PDFLinkService = h;
            class e {
              constructor() {
                this.externalLinkEnabled = !0;
              }
              get pagesCount() {
                return 0;
              }
              get page() {
                return 0;
              }
              set page(u) {
              }
              get rotation() {
                return 0;
              }
              set rotation(u) {
              }
              get isInPresentationMode() {
                return !1;
              }
              async goToDestination(u) {
              }
              goToPage(u) {
              }
              addLinkAttributes(u, c, y = !1) {
                d(u, {
                  url: c,
                  enabled: this.externalLinkEnabled
                });
              }
              getDestinationHash(u) {
                return "#";
              }
              getAnchorUrl(u) {
                return "#";
              }
              setHash(u) {
              }
              executeNamedAction(u) {
              }
              executeSetOCGState(u) {
              }
              cachePageRef(u, c) {
              }
            }
            v.SimpleLinkService = e;
          }),
          /* 6 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.AnnotationLayerBuilder = void 0;
            var i = T(4), n = T(7), o = T(2);
            class d {
              #t = null;
              constructor({
                pageDiv: e,
                pdfPage: l,
                linkService: u,
                downloadManager: c,
                annotationStorage: y = null,
                imageResourcesPath: C = "",
                renderForms: R = !0,
                l10n: s = n.NullL10n,
                enableScripting: m = !1,
                hasJSActionsPromise: F = null,
                fieldObjectsPromise: B = null,
                annotationCanvasMap: k = null,
                accessibilityManager: V = null
              }) {
                this.pageDiv = e, this.pdfPage = l, this.linkService = u, this.downloadManager = c, this.imageResourcesPath = C, this.renderForms = R, this.l10n = s, this.annotationStorage = y, this.enableScripting = m, this._hasJSActionsPromise = F || Promise.resolve(!1), this._fieldObjectsPromise = B || Promise.resolve(null), this._annotationCanvasMap = k, this._accessibilityManager = V, this.annotationLayer = null, this.div = null, this._cancelled = !1, this._eventBus = u.eventBus;
              }
              async render(e, l = "display") {
                if (this.div) {
                  if (this._cancelled || !this.annotationLayer)
                    return;
                  this.annotationLayer.update({
                    viewport: e.clone({
                      dontFlip: !0
                    })
                  });
                  return;
                }
                const [u, c, y] = await Promise.all([this.pdfPage.getAnnotations({
                  intent: l
                }), this._hasJSActionsPromise, this._fieldObjectsPromise]);
                if (this._cancelled)
                  return;
                const C = this.div = document.createElement("div");
                if (C.className = "annotationLayer", this.pageDiv.append(C), u.length === 0) {
                  this.hide();
                  return;
                }
                this.annotationLayer = new i.AnnotationLayer({
                  div: C,
                  accessibilityManager: this._accessibilityManager,
                  annotationCanvasMap: this._annotationCanvasMap,
                  l10n: this.l10n,
                  page: this.pdfPage,
                  viewport: e.clone({
                    dontFlip: !0
                  })
                }), await this.annotationLayer.render({
                  annotations: u,
                  imageResourcesPath: this.imageResourcesPath,
                  renderForms: this.renderForms,
                  linkService: this.linkService,
                  downloadManager: this.downloadManager,
                  annotationStorage: this.annotationStorage,
                  enableScripting: this.enableScripting,
                  hasJSActions: c,
                  fieldObjects: y
                }), this.linkService.isInPresentationMode && this.#e(o.PresentationModeState.FULLSCREEN), this.#t || (this.#t = (R) => {
                  this.#e(R.state);
                }, this._eventBus?._on("presentationmodechanged", this.#t));
              }
              cancel() {
                this._cancelled = !0, this.#t && (this._eventBus?._off("presentationmodechanged", this.#t), this.#t = null);
              }
              hide() {
                this.div && (this.div.hidden = !0);
              }
              #e(e) {
                if (!this.div)
                  return;
                let l = !1;
                switch (e) {
                  case o.PresentationModeState.FULLSCREEN:
                    l = !0;
                    break;
                  case o.PresentationModeState.NORMAL:
                    break;
                  default:
                    return;
                }
                for (const u of this.div.childNodes)
                  u.hasAttribute("data-internal-link") || (u.inert = l);
              }
            }
            v.AnnotationLayerBuilder = d;
          }),
          /* 7 */
          /***/
          ((E, v) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.NullL10n = void 0, v.getL10nFallback = i;
            const T = {
              of_pages: "of {{pagesCount}}",
              page_of_pages: "({{pageNumber}} of {{pagesCount}})",
              document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
              document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
              document_properties_date_string: "{{date}}, {{time}}",
              document_properties_page_size_unit_inches: "in",
              document_properties_page_size_unit_millimeters: "mm",
              document_properties_page_size_orientation_portrait: "portrait",
              document_properties_page_size_orientation_landscape: "landscape",
              document_properties_page_size_name_a3: "A3",
              document_properties_page_size_name_a4: "A4",
              document_properties_page_size_name_letter: "Letter",
              document_properties_page_size_name_legal: "Legal",
              document_properties_page_size_dimension_string: "{{width}} × {{height}} {{unit}} ({{orientation}})",
              document_properties_page_size_dimension_name_string: "{{width}} × {{height}} {{unit}} ({{name}}, {{orientation}})",
              document_properties_linearized_yes: "Yes",
              document_properties_linearized_no: "No",
              additional_layers: "Additional Layers",
              page_landmark: "Page {{page}}",
              thumb_page_title: "Page {{page}}",
              thumb_page_canvas: "Thumbnail of Page {{page}}",
              find_reached_top: "Reached top of document, continued from bottom",
              find_reached_bottom: "Reached end of document, continued from top",
              "find_match_count[one]": "{{current}} of {{total}} match",
              "find_match_count[other]": "{{current}} of {{total}} matches",
              "find_match_count_limit[one]": "More than {{limit}} match",
              "find_match_count_limit[other]": "More than {{limit}} matches",
              find_not_found: "Phrase not found",
              page_scale_width: "Page Width",
              page_scale_fit: "Page Fit",
              page_scale_auto: "Automatic Zoom",
              page_scale_actual: "Actual Size",
              page_scale_percent: "{{scale}}%",
              loading_error: "An error occurred while loading the PDF.",
              invalid_file_error: "Invalid or corrupted PDF file.",
              missing_file_error: "Missing PDF file.",
              unexpected_response_error: "Unexpected server response.",
              rendering_error: "An error occurred while rendering the page.",
              annotation_date_string: "{{date}}, {{time}}",
              printing_not_supported: "Warning: Printing is not fully supported by this browser.",
              printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
              web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
              free_text2_default_content: "Start typing…",
              editor_free_text2_aria_label: "Text Editor",
              editor_ink2_aria_label: "Draw Editor",
              editor_ink_canvas_aria_label: "User-created image",
              editor_alt_text_button_label: "Alt text",
              editor_alt_text_edit_button_label: "Edit alt text",
              editor_alt_text_decorative_tooltip: "Marked as decorative"
            };
            T.print_progress_percent = "{{progress}}%";
            function i(d, h) {
              switch (d) {
                case "find_match_count":
                  d = `find_match_count[${h.total === 1 ? "one" : "other"}]`;
                  break;
                case "find_match_count_limit":
                  d = `find_match_count_limit[${h.limit === 1 ? "one" : "other"}]`;
                  break;
              }
              return T[d] || "";
            }
            function n(d, h) {
              return h ? d.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (e, l) => l in h ? h[l] : "{{" + l + "}}") : d;
            }
            const o = {
              async getLanguage() {
                return "en-us";
              },
              async getDirection() {
                return "ltr";
              },
              async get(d, h = null, e = i(d, h)) {
                return n(e, h);
              },
              async translate(d) {
              }
            };
            v.NullL10n = o;
          }),
          /* 8 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.DownloadManager = void 0;
            var i = T(4);
            function n(d, h) {
              const e = document.createElement("a");
              if (!e.click)
                throw new Error('DownloadManager: "a.click()" is not supported.');
              e.href = d, e.target = "_parent", "download" in e && (e.download = h), (document.body || document.documentElement).append(e), e.click(), e.remove();
            }
            class o {
              #t = /* @__PURE__ */ new WeakMap();
              downloadUrl(h, e, l) {
                if (!(0, i.createValidAbsoluteUrl)(h, "http://example.com")) {
                  console.error(`downloadUrl - not a valid URL: ${h}`);
                  return;
                }
                n(h + "#pdfjs.action=download", e);
              }
              downloadData(h, e, l) {
                const u = URL.createObjectURL(new Blob([h], {
                  type: l
                }));
                n(u, e);
              }
              openOrDownloadData(h, e, l) {
                const c = (0, i.isPdfFile)(l) ? "application/pdf" : "";
                return this.downloadData(e, l, c), !1;
              }
              download(h, e, l, u) {
                const c = URL.createObjectURL(h);
                n(c, l);
              }
            }
            v.DownloadManager = o;
          }),
          /* 9 */
          /***/
          ((E, v) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.WaitOnType = v.EventBus = v.AutomationEventBus = void 0, v.waitOnEventOrTimeout = i;
            const T = {
              EVENT: "event",
              TIMEOUT: "timeout"
            };
            v.WaitOnType = T;
            function i({
              target: d,
              name: h,
              delay: e = 0
            }) {
              return new Promise(function(l, u) {
                if (typeof d != "object" || !(h && typeof h == "string") || !(Number.isInteger(e) && e >= 0))
                  throw new Error("waitOnEventOrTimeout - invalid parameters.");
                function c(s) {
                  d instanceof n ? d._off(h, y) : d.removeEventListener(h, y), R && clearTimeout(R), l(s);
                }
                const y = c.bind(null, T.EVENT);
                d instanceof n ? d._on(h, y) : d.addEventListener(h, y);
                const C = c.bind(null, T.TIMEOUT), R = setTimeout(C, e);
              });
            }
            class n {
              #t = /* @__PURE__ */ Object.create(null);
              on(h, e, l = null) {
                this._on(h, e, {
                  external: !0,
                  once: l?.once
                });
              }
              off(h, e, l = null) {
                this._off(h, e, {
                  external: !0,
                  once: l?.once
                });
              }
              dispatch(h, e) {
                const l = this.#t[h];
                if (!l || l.length === 0)
                  return;
                let u;
                for (const {
                  listener: c,
                  external: y,
                  once: C
                } of l.slice(0)) {
                  if (C && this._off(h, c), y) {
                    (u ||= []).push(c);
                    continue;
                  }
                  c(e);
                }
                if (u) {
                  for (const c of u)
                    c(e);
                  u = null;
                }
              }
              _on(h, e, l = null) {
                (this.#t[h] ||= []).push({
                  listener: e,
                  external: l?.external === !0,
                  once: l?.once === !0
                });
              }
              _off(h, e, l = null) {
                const u = this.#t[h];
                if (u) {
                  for (let c = 0, y = u.length; c < y; c++)
                    if (u[c].listener === e) {
                      u.splice(c, 1);
                      return;
                    }
                }
              }
            }
            v.EventBus = n;
            class o extends n {
              dispatch(h, e) {
                throw new Error("Not implemented: AutomationEventBus.dispatch");
              }
            }
            v.AutomationEventBus = o;
          }),
          /* 10 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.GenericL10n = void 0, T(11);
            var i = T(7);
            const n = {
              en: "en-US",
              es: "es-ES",
              fy: "fy-NL",
              ga: "ga-IE",
              gu: "gu-IN",
              hi: "hi-IN",
              hy: "hy-AM",
              nb: "nb-NO",
              ne: "ne-NP",
              nn: "nn-NO",
              pa: "pa-IN",
              pt: "pt-PT",
              sv: "sv-SE",
              zh: "zh-CN"
            };
            function o(h) {
              return n[h?.toLowerCase()] || h;
            }
            class d {
              constructor(e) {
                const {
                  webL10n: l
                } = document;
                this._lang = e, this._ready = new Promise((u, c) => {
                  l.setLanguage(o(e), () => {
                    u(l);
                  });
                });
              }
              async getLanguage() {
                return (await this._ready).getLanguage();
              }
              async getDirection() {
                return (await this._ready).getDirection();
              }
              async get(e, l = null, u = (0, i.getL10nFallback)(e, l)) {
                return (await this._ready).get(e, l, u);
              }
              async translate(e) {
                return (await this._ready).translate(e);
              }
            }
            v.GenericL10n = d;
          }),
          /* 11 */
          /***/
          (() => {
            document.webL10n = (function(E, v) {
              var T = {}, i = "", n = "textContent", o = "", d = {}, h = "loading", e = !0;
              function l() {
                return v.querySelectorAll('link[type="application/l10n"]');
              }
              function u() {
                var $ = v.querySelector('script[type="application/l10n"]');
                return $ ? JSON.parse($.innerHTML) : null;
              }
              function c($) {
                return $ ? $.querySelectorAll("*[data-l10n-id]") : [];
              }
              function y($) {
                if (!$) return {};
                var j = $.getAttribute("data-l10n-id"), G = $.getAttribute("data-l10n-args"), M = {};
                if (G)
                  try {
                    M = JSON.parse(G);
                  } catch {
                    console.warn("could not parse arguments for #" + j);
                  }
                return {
                  id: j,
                  args: M
                };
              }
              function C($, j, G) {
                j = j || function(A) {
                }, G = G || function() {
                };
                var M = new XMLHttpRequest();
                M.open("GET", $, e), M.overrideMimeType && M.overrideMimeType("text/plain; charset=utf-8"), M.onreadystatechange = function() {
                  M.readyState == 4 && (M.status == 200 || M.status === 0 ? j(M.responseText) : G());
                }, M.onerror = G, M.ontimeout = G;
                try {
                  M.send(null);
                } catch {
                  G();
                }
              }
              function R($, j, G, M) {
                var x = $.replace(/[^\/]*$/, "") || "./";
                function A(I) {
                  return I.lastIndexOf("\\") < 0 ? I : I.replace(/\\\\/g, "\\").replace(/\\n/g, `
`).replace(/\\r/g, "\r").replace(/\\t/g, "	").replace(/\\b/g, "\b").replace(/\\f/g, "\f").replace(/\\{/g, "{").replace(/\\}/g, "}").replace(/\\"/g, '"').replace(/\\'/g, "'");
                }
                function g(I, U) {
                  var _ = {}, H = /^\s*|\s*$/, N = /^\s*#|^\s*$/, b = /^\s*\[(.*)\]\s*$/, w = /^\s*@import\s+url\((.*)\)\s*$/i, O = /^([^=\s]*)\s*=\s*(.+)$/;
                  function D(W, X, q) {
                    var ct = W.replace(H, "").split(/[\r\n]+/), nt = "*", Y = j.split("-", 1)[0], Q = !1, et = "";
                    function Z() {
                      for (; ; ) {
                        if (!ct.length) {
                          q();
                          return;
                        }
                        var at = ct.shift();
                        if (!N.test(at)) {
                          if (X) {
                            if (et = b.exec(at), et) {
                              nt = et[1].toLowerCase(), Q = nt !== "*" && nt !== j && nt !== Y;
                              continue;
                            } else if (Q)
                              continue;
                            if (et = w.exec(at), et) {
                              L(x + et[1], Z);
                              return;
                            }
                          }
                          var lt = at.match(O);
                          lt && lt.length == 3 && (_[lt[1]] = A(lt[2]));
                        }
                      }
                    }
                    Z();
                  }
                  function L(W, X) {
                    C(W, function(q) {
                      D(q, !1, X);
                    }, function() {
                      console.warn(W + " not found."), X();
                    });
                  }
                  D(I, !0, function() {
                    U(_);
                  });
                }
                C($, function(I) {
                  i += I, g(I, function(U) {
                    for (var _ in U) {
                      var H, N, b = _.lastIndexOf(".");
                      b > 0 ? (H = _.substring(0, b), N = _.substring(b + 1)) : (H = _, N = n), T[H] || (T[H] = {}), T[H][N] = U[_];
                    }
                    G && G();
                  });
                }, M);
              }
              function s($, j) {
                $ && ($ = $.toLowerCase()), j = j || function() {
                }, m(), o = $;
                var G = l(), M = G.length;
                if (M === 0) {
                  var x = u();
                  if (x && x.locales && x.default_locale) {
                    if (console.log("using the embedded JSON directory, early way out"), T = x.locales[$], !T) {
                      var A = x.default_locale.toLowerCase();
                      for (var g in x.locales)
                        if (g = g.toLowerCase(), g === $) {
                          T = x.locales[$];
                          break;
                        } else g === A && (T = x.locales[A]);
                    }
                    j();
                  } else
                    console.log("no resource to load, early way out");
                  h = "complete";
                  return;
                }
                var I = null, U = 0;
                I = function() {
                  U++, U >= M && (j(), h = "complete");
                };
                function _(b) {
                  var w = b.href;
                  this.load = function(O, D) {
                    R(w, O, D, function() {
                      console.warn(w + " not found."), console.warn('"' + O + '" resource not found'), o = "", D();
                    });
                  };
                }
                for (var H = 0; H < M; H++) {
                  var N = new _(G[H]);
                  N.load($, I);
                }
              }
              function m() {
                T = {}, i = "", o = "";
              }
              function F($) {
                var j = {
                  af: 3,
                  ak: 4,
                  am: 4,
                  ar: 1,
                  asa: 3,
                  az: 0,
                  be: 11,
                  bem: 3,
                  bez: 3,
                  bg: 3,
                  bh: 4,
                  bm: 0,
                  bn: 3,
                  bo: 0,
                  br: 20,
                  brx: 3,
                  bs: 11,
                  ca: 3,
                  cgg: 3,
                  chr: 3,
                  cs: 12,
                  cy: 17,
                  da: 3,
                  de: 3,
                  dv: 3,
                  dz: 0,
                  ee: 3,
                  el: 3,
                  en: 3,
                  eo: 3,
                  es: 3,
                  et: 3,
                  eu: 3,
                  fa: 0,
                  ff: 5,
                  fi: 3,
                  fil: 4,
                  fo: 3,
                  fr: 5,
                  fur: 3,
                  fy: 3,
                  ga: 8,
                  gd: 24,
                  gl: 3,
                  gsw: 3,
                  gu: 3,
                  guw: 4,
                  gv: 23,
                  ha: 3,
                  haw: 3,
                  he: 2,
                  hi: 4,
                  hr: 11,
                  hu: 0,
                  id: 0,
                  ig: 0,
                  ii: 0,
                  is: 3,
                  it: 3,
                  iu: 7,
                  ja: 0,
                  jmc: 3,
                  jv: 0,
                  ka: 0,
                  kab: 5,
                  kaj: 3,
                  kcg: 3,
                  kde: 0,
                  kea: 0,
                  kk: 3,
                  kl: 3,
                  km: 0,
                  kn: 0,
                  ko: 0,
                  ksb: 3,
                  ksh: 21,
                  ku: 3,
                  kw: 7,
                  lag: 18,
                  lb: 3,
                  lg: 3,
                  ln: 4,
                  lo: 0,
                  lt: 10,
                  lv: 6,
                  mas: 3,
                  mg: 4,
                  mk: 16,
                  ml: 3,
                  mn: 3,
                  mo: 9,
                  mr: 3,
                  ms: 0,
                  mt: 15,
                  my: 0,
                  nah: 3,
                  naq: 7,
                  nb: 3,
                  nd: 3,
                  ne: 3,
                  nl: 3,
                  nn: 3,
                  no: 3,
                  nr: 3,
                  nso: 4,
                  ny: 3,
                  nyn: 3,
                  om: 3,
                  or: 3,
                  pa: 3,
                  pap: 3,
                  pl: 13,
                  ps: 3,
                  pt: 3,
                  rm: 3,
                  ro: 9,
                  rof: 3,
                  ru: 11,
                  rwk: 3,
                  sah: 0,
                  saq: 3,
                  se: 7,
                  seh: 3,
                  ses: 0,
                  sg: 0,
                  sh: 11,
                  shi: 19,
                  sk: 12,
                  sl: 14,
                  sma: 7,
                  smi: 7,
                  smj: 7,
                  smn: 7,
                  sms: 7,
                  sn: 3,
                  so: 3,
                  sq: 3,
                  sr: 11,
                  ss: 3,
                  ssy: 3,
                  st: 3,
                  sv: 3,
                  sw: 3,
                  syr: 3,
                  ta: 3,
                  te: 3,
                  teo: 3,
                  th: 0,
                  ti: 4,
                  tig: 3,
                  tk: 3,
                  tl: 4,
                  tn: 3,
                  to: 0,
                  tr: 0,
                  ts: 3,
                  tzm: 22,
                  uk: 11,
                  ur: 3,
                  ve: 3,
                  vi: 0,
                  vun: 3,
                  wa: 4,
                  wae: 3,
                  wo: 0,
                  xh: 3,
                  xog: 3,
                  yo: 0,
                  zh: 0,
                  zu: 3
                };
                function G(g, I) {
                  return I.indexOf(g) !== -1;
                }
                function M(g, I, U) {
                  return I <= g && g <= U;
                }
                var x = {
                  0: function(g) {
                    return "other";
                  },
                  1: function(g) {
                    return M(g % 100, 3, 10) ? "few" : g === 0 ? "zero" : M(g % 100, 11, 99) ? "many" : g == 2 ? "two" : g == 1 ? "one" : "other";
                  },
                  2: function(g) {
                    return g !== 0 && g % 10 === 0 ? "many" : g == 2 ? "two" : g == 1 ? "one" : "other";
                  },
                  3: function(g) {
                    return g == 1 ? "one" : "other";
                  },
                  4: function(g) {
                    return M(g, 0, 1) ? "one" : "other";
                  },
                  5: function(g) {
                    return M(g, 0, 2) && g != 2 ? "one" : "other";
                  },
                  6: function(g) {
                    return g === 0 ? "zero" : g % 10 == 1 && g % 100 != 11 ? "one" : "other";
                  },
                  7: function(g) {
                    return g == 2 ? "two" : g == 1 ? "one" : "other";
                  },
                  8: function(g) {
                    return M(g, 3, 6) ? "few" : M(g, 7, 10) ? "many" : g == 2 ? "two" : g == 1 ? "one" : "other";
                  },
                  9: function(g) {
                    return g === 0 || g != 1 && M(g % 100, 1, 19) ? "few" : g == 1 ? "one" : "other";
                  },
                  10: function(g) {
                    return M(g % 10, 2, 9) && !M(g % 100, 11, 19) ? "few" : g % 10 == 1 && !M(g % 100, 11, 19) ? "one" : "other";
                  },
                  11: function(g) {
                    return M(g % 10, 2, 4) && !M(g % 100, 12, 14) ? "few" : g % 10 === 0 || M(g % 10, 5, 9) || M(g % 100, 11, 14) ? "many" : g % 10 == 1 && g % 100 != 11 ? "one" : "other";
                  },
                  12: function(g) {
                    return M(g, 2, 4) ? "few" : g == 1 ? "one" : "other";
                  },
                  13: function(g) {
                    return M(g % 10, 2, 4) && !M(g % 100, 12, 14) ? "few" : g != 1 && M(g % 10, 0, 1) || M(g % 10, 5, 9) || M(g % 100, 12, 14) ? "many" : g == 1 ? "one" : "other";
                  },
                  14: function(g) {
                    return M(g % 100, 3, 4) ? "few" : g % 100 == 2 ? "two" : g % 100 == 1 ? "one" : "other";
                  },
                  15: function(g) {
                    return g === 0 || M(g % 100, 2, 10) ? "few" : M(g % 100, 11, 19) ? "many" : g == 1 ? "one" : "other";
                  },
                  16: function(g) {
                    return g % 10 == 1 && g != 11 ? "one" : "other";
                  },
                  17: function(g) {
                    return g == 3 ? "few" : g === 0 ? "zero" : g == 6 ? "many" : g == 2 ? "two" : g == 1 ? "one" : "other";
                  },
                  18: function(g) {
                    return g === 0 ? "zero" : M(g, 0, 2) && g !== 0 && g != 2 ? "one" : "other";
                  },
                  19: function(g) {
                    return M(g, 2, 10) ? "few" : M(g, 0, 1) ? "one" : "other";
                  },
                  20: function(g) {
                    return (M(g % 10, 3, 4) || g % 10 == 9) && !(M(g % 100, 10, 19) || M(g % 100, 70, 79) || M(g % 100, 90, 99)) ? "few" : g % 1e6 === 0 && g !== 0 ? "many" : g % 10 == 2 && !G(g % 100, [12, 72, 92]) ? "two" : g % 10 == 1 && !G(g % 100, [11, 71, 91]) ? "one" : "other";
                  },
                  21: function(g) {
                    return g === 0 ? "zero" : g == 1 ? "one" : "other";
                  },
                  22: function(g) {
                    return M(g, 0, 1) || M(g, 11, 99) ? "one" : "other";
                  },
                  23: function(g) {
                    return M(g % 10, 1, 2) || g % 20 === 0 ? "one" : "other";
                  },
                  24: function(g) {
                    return M(g, 3, 10) || M(g, 13, 19) ? "few" : G(g, [2, 12]) ? "two" : G(g, [1, 11]) ? "one" : "other";
                  }
                }, A = j[$.replace(/-.*$/, "")];
                return A in x ? x[A] : (console.warn("plural form unknown for [" + $ + "]"), function() {
                  return "other";
                });
              }
              d.plural = function($, j, G, M) {
                var x = parseFloat(j);
                if (isNaN(x) || M != n) return $;
                d._pluralRules || (d._pluralRules = F(o));
                var A = "[" + d._pluralRules(x) + "]";
                return x === 0 && G + "[zero]" in T ? $ = T[G + "[zero]"][M] : x == 1 && G + "[one]" in T ? $ = T[G + "[one]"][M] : x == 2 && G + "[two]" in T ? $ = T[G + "[two]"][M] : G + A in T ? $ = T[G + A][M] : G + "[other]" in T && ($ = T[G + "[other]"][M]), $;
              };
              function B($, j, G) {
                var M = T[$];
                if (!M) {
                  if (console.warn("#" + $ + " is undefined."), !G)
                    return null;
                  M = G;
                }
                var x = {};
                for (var A in M) {
                  var g = M[A];
                  g = k(g, j, $, A), g = V(g, j, $), x[A] = g;
                }
                return x;
              }
              function k($, j, G, M) {
                var x = /\{\[\s*([a-zA-Z]+)\(([a-zA-Z]+)\)\s*\]\}/, A = x.exec($);
                if (!A || !A.length) return $;
                var g = A[1], I = A[2], U;
                if (j && I in j ? U = j[I] : I in T && (U = T[I]), g in d) {
                  var _ = d[g];
                  $ = _($, U, G, M);
                }
                return $;
              }
              function V($, j, G) {
                var M = /\{\{\s*(.+?)\s*\}\}/g;
                return $.replace(M, function(x, A) {
                  return j && A in j ? j[A] : A in T ? T[A] : (console.log("argument {{" + A + "}} for #" + G + " is undefined."), x);
                });
              }
              function z($) {
                var j = y($);
                if (j.id) {
                  var G = B(j.id, j.args);
                  if (!G) {
                    console.warn("#" + j.id + " is undefined.");
                    return;
                  }
                  if (G[n]) {
                    if (K($) === 0)
                      $[n] = G[n];
                    else {
                      for (var M = $.childNodes, x = !1, A = 0, g = M.length; A < g; A++)
                        M[A].nodeType === 3 && /\S/.test(M[A].nodeValue) && (x ? M[A].nodeValue = "" : (M[A].nodeValue = G[n], x = !0));
                      if (!x) {
                        var I = v.createTextNode(G[n]);
                        $.prepend(I);
                      }
                    }
                    delete G[n];
                  }
                  for (var U in G)
                    $[U] = G[U];
                }
              }
              function K($) {
                if ($.children)
                  return $.children.length;
                if (typeof $.childElementCount < "u")
                  return $.childElementCount;
                for (var j = 0, G = 0; G < $.childNodes.length; G++)
                  j += $.nodeType === 1 ? 1 : 0;
                return j;
              }
              function J($) {
                $ = $ || v.documentElement;
                for (var j = c($), G = j.length, M = 0; M < G; M++)
                  z(j[M]);
                z($);
              }
              return {
                get: function($, j, G) {
                  var M = $.lastIndexOf("."), x = n;
                  M > 0 && (x = $.substring(M + 1), $ = $.substring(0, M));
                  var A;
                  G && (A = {}, A[x] = G);
                  var g = B($, j, A);
                  return g && x in g ? g[x] : "{{" + $ + "}}";
                },
                getData: function() {
                  return T;
                },
                getText: function() {
                  return i;
                },
                getLanguage: function() {
                  return o;
                },
                setLanguage: function($, j) {
                  s($, function() {
                    j && j();
                  });
                },
                getDirection: function() {
                  var $ = ["ar", "he", "fa", "ps", "ur"], j = o.split("-", 1)[0];
                  return $.indexOf(j) >= 0 ? "rtl" : "ltr";
                },
                translate: J,
                getReadyState: function() {
                  return h;
                },
                ready: function($) {
                  if ($)
                    h == "complete" || h == "interactive" ? E.setTimeout(function() {
                      $();
                    }) : v.addEventListener && v.addEventListener("localized", function j() {
                      v.removeEventListener("localized", j), $();
                    });
                  else return;
                }
              };
            })(window, document);
          }),
          /* 12 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.PDFHistory = void 0, v.isDestArraysEqual = c, v.isDestHashesEqual = u;
            var i = T(2), n = T(9);
            const o = 1e3, d = 50, h = 1e3;
            function e() {
              return document.location.hash;
            }
            class l {
              constructor({
                linkService: C,
                eventBus: R
              }) {
                this.linkService = C, this.eventBus = R, this._initialized = !1, this._fingerprint = "", this.reset(), this._boundEvents = null, this.eventBus._on("pagesinit", () => {
                  this._isPagesLoaded = !1, this.eventBus._on("pagesloaded", (s) => {
                    this._isPagesLoaded = !!s.pagesCount;
                  }, {
                    once: !0
                  });
                });
              }
              initialize({
                fingerprint: C,
                resetHistory: R = !1,
                updateUrl: s = !1
              }) {
                if (!C || typeof C != "string") {
                  console.error('PDFHistory.initialize: The "fingerprint" must be a non-empty string.');
                  return;
                }
                this._initialized && this.reset();
                const m = this._fingerprint !== "" && this._fingerprint !== C;
                this._fingerprint = C, this._updateUrl = s === !0, this._initialized = !0, this._bindEvents();
                const F = window.history.state;
                if (this._popStateInProgress = !1, this._blockHashChange = 0, this._currentHash = e(), this._numPositionUpdates = 0, this._uid = this._maxUid = 0, this._destination = null, this._position = null, !this._isValidState(F, !0) || R) {
                  const {
                    hash: k,
                    page: V,
                    rotation: z
                  } = this._parseCurrentHash(!0);
                  if (!k || m || R) {
                    this._pushOrReplaceState(null, !0);
                    return;
                  }
                  this._pushOrReplaceState({
                    hash: k,
                    page: V,
                    rotation: z
                  }, !0);
                  return;
                }
                const B = F.destination;
                this._updateInternalState(B, F.uid, !0), B.rotation !== void 0 && (this._initialRotation = B.rotation), B.dest ? (this._initialBookmark = JSON.stringify(B.dest), this._destination.page = null) : B.hash ? this._initialBookmark = B.hash : B.page && (this._initialBookmark = `page=${B.page}`);
              }
              reset() {
                this._initialized && (this._pageHide(), this._initialized = !1, this._unbindEvents()), this._updateViewareaTimeout && (clearTimeout(this._updateViewareaTimeout), this._updateViewareaTimeout = null), this._initialBookmark = null, this._initialRotation = null;
              }
              push({
                namedDest: C = null,
                explicitDest: R,
                pageNumber: s
              }) {
                if (!this._initialized)
                  return;
                if (C && typeof C != "string") {
                  console.error(`PDFHistory.push: "${C}" is not a valid namedDest parameter.`);
                  return;
                } else if (Array.isArray(R)) {
                  if (!this._isValidPage(s) && (s !== null || this._destination)) {
                    console.error(`PDFHistory.push: "${s}" is not a valid pageNumber parameter.`);
                    return;
                  }
                } else {
                  console.error(`PDFHistory.push: "${R}" is not a valid explicitDest parameter.`);
                  return;
                }
                const m = C || JSON.stringify(R);
                if (!m)
                  return;
                let F = !1;
                if (this._destination && (u(this._destination.hash, m) || c(this._destination.dest, R))) {
                  if (this._destination.page)
                    return;
                  F = !0;
                }
                this._popStateInProgress && !F || (this._pushOrReplaceState({
                  dest: R,
                  hash: m,
                  page: s,
                  rotation: this.linkService.rotation
                }, F), this._popStateInProgress || (this._popStateInProgress = !0, Promise.resolve().then(() => {
                  this._popStateInProgress = !1;
                })));
              }
              pushPage(C) {
                if (this._initialized) {
                  if (!this._isValidPage(C)) {
                    console.error(`PDFHistory.pushPage: "${C}" is not a valid page number.`);
                    return;
                  }
                  this._destination?.page !== C && (this._popStateInProgress || (this._pushOrReplaceState({
                    dest: null,
                    hash: `page=${C}`,
                    page: C,
                    rotation: this.linkService.rotation
                  }), this._popStateInProgress || (this._popStateInProgress = !0, Promise.resolve().then(() => {
                    this._popStateInProgress = !1;
                  }))));
                }
              }
              pushCurrentPosition() {
                !this._initialized || this._popStateInProgress || this._tryPushCurrentPosition();
              }
              back() {
                if (!this._initialized || this._popStateInProgress)
                  return;
                const C = window.history.state;
                this._isValidState(C) && C.uid > 0 && window.history.back();
              }
              forward() {
                if (!this._initialized || this._popStateInProgress)
                  return;
                const C = window.history.state;
                this._isValidState(C) && C.uid < this._maxUid && window.history.forward();
              }
              get popStateInProgress() {
                return this._initialized && (this._popStateInProgress || this._blockHashChange > 0);
              }
              get initialBookmark() {
                return this._initialized ? this._initialBookmark : null;
              }
              get initialRotation() {
                return this._initialized ? this._initialRotation : null;
              }
              _pushOrReplaceState(C, R = !1) {
                const s = R || !this._destination, m = {
                  fingerprint: this._fingerprint,
                  uid: s ? this._uid : this._uid + 1,
                  destination: C
                };
                this._updateInternalState(C, m.uid);
                let F;
                if (this._updateUrl && C?.hash) {
                  const B = document.location.href.split("#")[0];
                  B.startsWith("file://") || (F = `${B}#${C.hash}`);
                }
                s ? window.history.replaceState(m, "", F) : window.history.pushState(m, "", F);
              }
              _tryPushCurrentPosition(C = !1) {
                if (!this._position)
                  return;
                let R = this._position;
                if (C && (R = Object.assign(/* @__PURE__ */ Object.create(null), this._position), R.temporary = !0), !this._destination) {
                  this._pushOrReplaceState(R);
                  return;
                }
                if (this._destination.temporary) {
                  this._pushOrReplaceState(R, !0);
                  return;
                }
                if (this._destination.hash === R.hash || !this._destination.page && this._numPositionUpdates <= d)
                  return;
                let s = !1;
                if (this._destination.page >= R.first && this._destination.page <= R.page) {
                  if (this._destination.dest !== void 0 || !this._destination.first)
                    return;
                  s = !0;
                }
                this._pushOrReplaceState(R, s);
              }
              _isValidPage(C) {
                return Number.isInteger(C) && C > 0 && C <= this.linkService.pagesCount;
              }
              _isValidState(C, R = !1) {
                if (!C)
                  return !1;
                if (C.fingerprint !== this._fingerprint)
                  if (R) {
                    if (typeof C.fingerprint != "string" || C.fingerprint.length !== this._fingerprint.length)
                      return !1;
                    const [s] = performance.getEntriesByType("navigation");
                    if (s?.type !== "reload")
                      return !1;
                  } else
                    return !1;
                return !(!Number.isInteger(C.uid) || C.uid < 0 || C.destination === null || typeof C.destination != "object");
              }
              _updateInternalState(C, R, s = !1) {
                this._updateViewareaTimeout && (clearTimeout(this._updateViewareaTimeout), this._updateViewareaTimeout = null), s && C?.temporary && delete C.temporary, this._destination = C, this._uid = R, this._maxUid = Math.max(this._maxUid, R), this._numPositionUpdates = 0;
              }
              _parseCurrentHash(C = !1) {
                const R = unescape(e()).substring(1), s = (0, i.parseQueryString)(R), m = s.get("nameddest") || "";
                let F = s.get("page") | 0;
                return (!this._isValidPage(F) || C && m.length > 0) && (F = null), {
                  hash: R,
                  page: F,
                  rotation: this.linkService.rotation
                };
              }
              _updateViewarea({
                location: C
              }) {
                this._updateViewareaTimeout && (clearTimeout(this._updateViewareaTimeout), this._updateViewareaTimeout = null), this._position = {
                  hash: C.pdfOpenParams.substring(1),
                  page: this.linkService.page,
                  first: C.pageNumber,
                  rotation: C.rotation
                }, !this._popStateInProgress && (this._isPagesLoaded && this._destination && !this._destination.page && this._numPositionUpdates++, this._updateViewareaTimeout = setTimeout(() => {
                  this._popStateInProgress || this._tryPushCurrentPosition(!0), this._updateViewareaTimeout = null;
                }, h));
              }
              _popState({
                state: C
              }) {
                const R = e(), s = this._currentHash !== R;
                if (this._currentHash = R, !C) {
                  this._uid++;
                  const {
                    hash: F,
                    page: B,
                    rotation: k
                  } = this._parseCurrentHash();
                  this._pushOrReplaceState({
                    hash: F,
                    page: B,
                    rotation: k
                  }, !0);
                  return;
                }
                if (!this._isValidState(C))
                  return;
                this._popStateInProgress = !0, s && (this._blockHashChange++, (0, n.waitOnEventOrTimeout)({
                  target: window,
                  name: "hashchange",
                  delay: o
                }).then(() => {
                  this._blockHashChange--;
                }));
                const m = C.destination;
                this._updateInternalState(m, C.uid, !0), (0, i.isValidRotation)(m.rotation) && (this.linkService.rotation = m.rotation), m.dest ? this.linkService.goToDestination(m.dest) : m.hash ? this.linkService.setHash(m.hash) : m.page && (this.linkService.page = m.page), Promise.resolve().then(() => {
                  this._popStateInProgress = !1;
                });
              }
              _pageHide() {
                (!this._destination || this._destination.temporary) && this._tryPushCurrentPosition();
              }
              _bindEvents() {
                this._boundEvents || (this._boundEvents = {
                  updateViewarea: this._updateViewarea.bind(this),
                  popState: this._popState.bind(this),
                  pageHide: this._pageHide.bind(this)
                }, this.eventBus._on("updateviewarea", this._boundEvents.updateViewarea), window.addEventListener("popstate", this._boundEvents.popState), window.addEventListener("pagehide", this._boundEvents.pageHide));
              }
              _unbindEvents() {
                this._boundEvents && (this.eventBus._off("updateviewarea", this._boundEvents.updateViewarea), window.removeEventListener("popstate", this._boundEvents.popState), window.removeEventListener("pagehide", this._boundEvents.pageHide), this._boundEvents = null);
              }
            }
            v.PDFHistory = l;
            function u(y, C) {
              return typeof y != "string" || typeof C != "string" ? !1 : y === C || (0, i.parseQueryString)(y).get("nameddest") === C;
            }
            function c(y, C) {
              function R(s, m) {
                if (typeof s != typeof m || Array.isArray(s) || Array.isArray(m))
                  return !1;
                if (s !== null && typeof s == "object" && m !== null) {
                  if (Object.keys(s).length !== Object.keys(m).length)
                    return !1;
                  for (const F in s)
                    if (!R(s[F], m[F]))
                      return !1;
                  return !0;
                }
                return s === m || Number.isNaN(s) && Number.isNaN(m);
              }
              if (!(Array.isArray(y) && Array.isArray(C)) || y.length !== C.length)
                return !1;
              for (let s = 0, m = y.length; s < m; s++)
                if (!R(y[s], C[s]))
                  return !1;
              return !0;
            }
          }),
          /* 13 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.PDFPageView = void 0;
            var i = T(4), n = T(2), o = T(14), d = T(6), h = T(15), e = T(7), l = T(5), u = T(16), c = T(17), y = T(18), C = T(19), R = T(20);
            const s = h.compatibilityParams.maxCanvasPixels || 16777216, m = () => ({
              annotationEditorUIManager: null,
              annotationStorage: null,
              downloadManager: null,
              enableScripting: !1,
              fieldObjectsPromise: null,
              findController: null,
              hasJSActionsPromise: null,
              get linkService() {
                return new l.SimpleLinkService();
              }
            });
            class F {
              #t = i.AnnotationMode.ENABLE_FORMS;
              #e = !1;
              #n = null;
              #i = null;
              #o = null;
              #s = null;
              #a = n.RenderingStates.INITIAL;
              #l = n.TextLayerMode.ENABLE;
              #c = {
                directDrawing: !0,
                initialOptionalContent: !0,
                regularAnnotations: !0
              };
              #r = /* @__PURE__ */ new WeakMap();
              constructor(k) {
                const V = k.container, z = k.defaultViewport;
                this.id = k.id, this.renderingId = "page" + this.id, this.#n = k.layerProperties || m, this.pdfPage = null, this.pageLabel = null, this.rotation = 0, this.scale = k.scale || n.DEFAULT_SCALE, this.viewport = z, this.pdfPageRotate = z.rotation, this._optionalContentConfigPromise = k.optionalContentConfigPromise || null, this.#l = k.textLayerMode ?? n.TextLayerMode.ENABLE, this.#t = k.annotationMode ?? i.AnnotationMode.ENABLE_FORMS, this.imageResourcesPath = k.imageResourcesPath || "", this.isOffscreenCanvasSupported = k.isOffscreenCanvasSupported ?? !0, this.maxCanvasPixels = k.maxCanvasPixels ?? s, this.pageColors = k.pageColors || null, this.eventBus = k.eventBus, this.renderingQueue = k.renderingQueue, this.l10n = k.l10n || e.NullL10n, this.renderTask = null, this.resume = null, this._isStandalone = !this.renderingQueue?.hasViewer(), this._container = V, k.useOnlyCssZoom && (console.error("useOnlyCssZoom was removed, please use `maxCanvasPixels = 0` instead."), this.maxCanvasPixels = 0), this._annotationCanvasMap = null, this.annotationLayer = null, this.annotationEditorLayer = null, this.textLayer = null, this.zoomLayer = null, this.xfaLayer = null, this.structTreeLayer = null;
                const K = document.createElement("div");
                if (K.className = "page", K.setAttribute("data-page-number", this.id), K.setAttribute("role", "region"), this.l10n.get("page_landmark", {
                  page: this.id
                }).then((J) => {
                  K.setAttribute("aria-label", J);
                }), this.div = K, this.#h(), V?.append(K), this._isStandalone) {
                  V?.style.setProperty("--scale-factor", this.scale * i.PixelsPerInch.PDF_TO_CSS_UNITS);
                  const {
                    optionalContentConfigPromise: J
                  } = k;
                  J && J.then(($) => {
                    J === this._optionalContentConfigPromise && (this.#c.initialOptionalContent = $.hasInitialVisibility);
                  });
                }
              }
              get renderingState() {
                return this.#a;
              }
              set renderingState(k) {
                if (k !== this.#a)
                  switch (this.#a = k, this.#i && (clearTimeout(this.#i), this.#i = null), k) {
                    case n.RenderingStates.PAUSED:
                      this.div.classList.remove("loading");
                      break;
                    case n.RenderingStates.RUNNING:
                      this.div.classList.add("loadingIcon"), this.#i = setTimeout(() => {
                        this.div.classList.add("loading"), this.#i = null;
                      }, 0);
                      break;
                    case n.RenderingStates.INITIAL:
                    case n.RenderingStates.FINISHED:
                      this.div.classList.remove("loadingIcon", "loading");
                      break;
                  }
              }
              #h() {
                const {
                  viewport: k
                } = this;
                if (this.pdfPage) {
                  if (this.#o === k.rotation)
                    return;
                  this.#o = k.rotation;
                }
                (0, i.setLayerDimensions)(this.div, k, !0, !1);
              }
              setPdfPage(k) {
                this._isStandalone && (this.pageColors?.foreground === "CanvasText" || this.pageColors?.background === "Canvas") && this._container?.style.setProperty("--hcm-highligh-filter", k.filterFactory.addHighlightHCMFilter("CanvasText", "Canvas", "HighlightText", "Highlight")), this.pdfPage = k, this.pdfPageRotate = k.rotate;
                const V = (this.rotation + this.pdfPageRotate) % 360;
                this.viewport = k.getViewport({
                  scale: this.scale * i.PixelsPerInch.PDF_TO_CSS_UNITS,
                  rotation: V
                }), this.#h(), this.reset();
              }
              destroy() {
                this.reset(), this.pdfPage?.cleanup();
              }
              get _textHighlighter() {
                return (0, i.shadow)(this, "_textHighlighter", new y.TextHighlighter({
                  pageIndex: this.id - 1,
                  eventBus: this.eventBus,
                  findController: this.#n().findController
                }));
              }
              async #u() {
                let k = null;
                try {
                  await this.annotationLayer.render(this.viewport, "display");
                } catch (V) {
                  console.error(`#renderAnnotationLayer: "${V}".`), k = V;
                } finally {
                  this.eventBus.dispatch("annotationlayerrendered", {
                    source: this,
                    pageNumber: this.id,
                    error: k
                  });
                }
              }
              async #f() {
                let k = null;
                try {
                  await this.annotationEditorLayer.render(this.viewport, "display");
                } catch (V) {
                  console.error(`#renderAnnotationEditorLayer: "${V}".`), k = V;
                } finally {
                  this.eventBus.dispatch("annotationeditorlayerrendered", {
                    source: this,
                    pageNumber: this.id,
                    error: k
                  });
                }
              }
              async #p() {
                let k = null;
                try {
                  const V = await this.xfaLayer.render(this.viewport, "display");
                  V?.textDivs && this._textHighlighter && this.#v(V.textDivs);
                } catch (V) {
                  console.error(`#renderXfaLayer: "${V}".`), k = V;
                } finally {
                  this.eventBus.dispatch("xfalayerrendered", {
                    source: this,
                    pageNumber: this.id,
                    error: k
                  });
                }
              }
              async #g() {
                const {
                  pdfPage: k,
                  textLayer: V,
                  viewport: z
                } = this;
                if (!V)
                  return;
                let K = null;
                try {
                  if (!V.renderingDone) {
                    const J = k.streamTextContent({
                      includeMarkedContent: !0,
                      disableNormalization: !0
                    });
                    V.setTextContentSource(J);
                  }
                  await V.render(z);
                } catch (J) {
                  if (J instanceof i.AbortException)
                    return;
                  console.error(`#renderTextLayer: "${J}".`), K = J;
                }
                this.eventBus.dispatch("textlayerrendered", {
                  source: this,
                  pageNumber: this.id,
                  numTextDivs: V.numTextDivs,
                  error: K
                }), this.#m();
              }
              async #m() {
                if (!this.textLayer)
                  return;
                this.structTreeLayer ||= new u.StructTreeLayerBuilder();
                const k = await (this.structTreeLayer.renderingDone ? null : this.pdfPage.getStructTree()), V = this.structTreeLayer?.render(k);
                V && this.canvas?.append(V), this.structTreeLayer?.show();
              }
              async #v(k) {
                const V = await this.pdfPage.getTextContent(), z = [];
                for (const K of V.items)
                  z.push(K.str);
                this._textHighlighter.setTextMapping(k, z), this._textHighlighter.enable();
              }
              _resetZoomLayer(k = !1) {
                if (!this.zoomLayer)
                  return;
                const V = this.zoomLayer.firstChild;
                this.#r.delete(V), V.width = 0, V.height = 0, k && this.zoomLayer.remove(), this.zoomLayer = null;
              }
              reset({
                keepZoomLayer: k = !1,
                keepAnnotationLayer: V = !1,
                keepAnnotationEditorLayer: z = !1,
                keepXfaLayer: K = !1,
                keepTextLayer: J = !1
              } = {}) {
                this.cancelRendering({
                  keepAnnotationLayer: V,
                  keepAnnotationEditorLayer: z,
                  keepXfaLayer: K,
                  keepTextLayer: J
                }), this.renderingState = n.RenderingStates.INITIAL;
                const $ = this.div, j = $.childNodes, G = k && this.zoomLayer || null, M = V && this.annotationLayer?.div || null, x = z && this.annotationEditorLayer?.div || null, A = K && this.xfaLayer?.div || null, g = J && this.textLayer?.div || null;
                for (let I = j.length - 1; I >= 0; I--) {
                  const U = j[I];
                  switch (U) {
                    case G:
                    case M:
                    case x:
                    case A:
                    case g:
                      continue;
                  }
                  U.remove();
                }
                $.removeAttribute("data-loaded"), M && this.annotationLayer.hide(), x && this.annotationEditorLayer.hide(), A && this.xfaLayer.hide(), g && this.textLayer.hide(), this.structTreeLayer?.hide(), G || (this.canvas && (this.#r.delete(this.canvas), this.canvas.width = 0, this.canvas.height = 0, delete this.canvas), this._resetZoomLayer());
              }
              update({
                scale: k = 0,
                rotation: V = null,
                optionalContentConfigPromise: z = null,
                drawingDelay: K = -1
              }) {
                this.scale = k || this.scale, typeof V == "number" && (this.rotation = V), z instanceof Promise && (this._optionalContentConfigPromise = z, z.then(($) => {
                  z === this._optionalContentConfigPromise && (this.#c.initialOptionalContent = $.hasInitialVisibility);
                })), this.#c.directDrawing = !0;
                const J = (this.rotation + this.pdfPageRotate) % 360;
                if (this.viewport = this.viewport.clone({
                  scale: this.scale * i.PixelsPerInch.PDF_TO_CSS_UNITS,
                  rotation: J
                }), this.#h(), this._isStandalone && this._container?.style.setProperty("--scale-factor", this.viewport.scale), this.canvas) {
                  let $ = !1;
                  if (this.#e) {
                    if (this.maxCanvasPixels === 0)
                      $ = !0;
                    else if (this.maxCanvasPixels > 0) {
                      const {
                        width: G,
                        height: M
                      } = this.viewport, {
                        sx: x,
                        sy: A
                      } = this.outputScale;
                      $ = (Math.floor(G) * x | 0) * (Math.floor(M) * A | 0) > this.maxCanvasPixels;
                    }
                  }
                  const j = !$ && K >= 0 && K < 1e3;
                  if (j || $) {
                    if (j && this.renderingState !== n.RenderingStates.FINISHED && (this.cancelRendering({
                      keepZoomLayer: !0,
                      keepAnnotationLayer: !0,
                      keepAnnotationEditorLayer: !0,
                      keepXfaLayer: !0,
                      keepTextLayer: !0,
                      cancelExtraDelay: K
                    }), this.renderingState = n.RenderingStates.FINISHED, this.#c.directDrawing = !1), this.cssTransform({
                      target: this.canvas,
                      redrawAnnotationLayer: !0,
                      redrawAnnotationEditorLayer: !0,
                      redrawXfaLayer: !0,
                      redrawTextLayer: !j,
                      hideTextLayer: j
                    }), j)
                      return;
                    this.eventBus.dispatch("pagerendered", {
                      source: this,
                      pageNumber: this.id,
                      cssTransform: !0,
                      timestamp: performance.now(),
                      error: this.#s
                    });
                    return;
                  }
                  !this.zoomLayer && !this.canvas.hidden && (this.zoomLayer = this.canvas.parentNode, this.zoomLayer.style.position = "absolute");
                }
                this.zoomLayer && this.cssTransform({
                  target: this.zoomLayer.firstChild
                }), this.reset({
                  keepZoomLayer: !0,
                  keepAnnotationLayer: !0,
                  keepAnnotationEditorLayer: !0,
                  keepXfaLayer: !0,
                  keepTextLayer: !0
                });
              }
              cancelRendering({
                keepAnnotationLayer: k = !1,
                keepAnnotationEditorLayer: V = !1,
                keepXfaLayer: z = !1,
                keepTextLayer: K = !1,
                cancelExtraDelay: J = 0
              } = {}) {
                this.renderTask && (this.renderTask.cancel(J), this.renderTask = null), this.resume = null, this.textLayer && (!K || !this.textLayer.div) && (this.textLayer.cancel(), this.textLayer = null), this.structTreeLayer && !this.textLayer && (this.structTreeLayer = null), this.annotationLayer && (!k || !this.annotationLayer.div) && (this.annotationLayer.cancel(), this.annotationLayer = null, this._annotationCanvasMap = null), this.annotationEditorLayer && (!V || !this.annotationEditorLayer.div) && (this.annotationEditorLayer.cancel(), this.annotationEditorLayer = null), this.xfaLayer && (!z || !this.xfaLayer.div) && (this.xfaLayer.cancel(), this.xfaLayer = null, this._textHighlighter?.disable());
              }
              cssTransform({
                target: k,
                redrawAnnotationLayer: V = !1,
                redrawAnnotationEditorLayer: z = !1,
                redrawXfaLayer: K = !1,
                redrawTextLayer: J = !1,
                hideTextLayer: $ = !1
              }) {
                if (!k.hasAttribute("zooming")) {
                  k.setAttribute("zooming", !0);
                  const {
                    style: G
                  } = k;
                  G.width = G.height = "";
                }
                const j = this.#r.get(k);
                if (this.viewport !== j) {
                  const G = this.viewport.rotation - j.rotation, M = Math.abs(G);
                  let x = 1, A = 1;
                  if (M === 90 || M === 270) {
                    const {
                      width: g,
                      height: I
                    } = this.viewport;
                    x = I / g, A = g / I;
                  }
                  k.style.transform = `rotate(${G}deg) scale(${x}, ${A})`;
                }
                V && this.annotationLayer && this.#u(), z && this.annotationEditorLayer && this.#f(), K && this.xfaLayer && this.#p(), this.textLayer && ($ ? (this.textLayer.hide(), this.structTreeLayer?.hide()) : J && this.#g());
              }
              get width() {
                return this.viewport.width;
              }
              get height() {
                return this.viewport.height;
              }
              getPagePoint(k, V) {
                return this.viewport.convertToPdfPoint(k, V);
              }
              async #d(k, V = null) {
                if (k === this.renderTask && (this.renderTask = null), V instanceof i.RenderingCancelledException) {
                  this.#s = null;
                  return;
                }
                if (this.#s = V, this.renderingState = n.RenderingStates.FINISHED, this._resetZoomLayer(!0), this.#c.regularAnnotations = !k.separateAnnots, this.eventBus.dispatch("pagerendered", {
                  source: this,
                  pageNumber: this.id,
                  cssTransform: !1,
                  timestamp: performance.now(),
                  error: this.#s
                }), V)
                  throw V;
              }
              async draw() {
                this.renderingState !== n.RenderingStates.INITIAL && (console.error("Must be in new state before drawing"), this.reset());
                const {
                  div: k,
                  l10n: V,
                  pageColors: z,
                  pdfPage: K,
                  viewport: J
                } = this;
                if (!K)
                  throw this.renderingState = n.RenderingStates.FINISHED, new Error("pdfPage is not loaded");
                this.renderingState = n.RenderingStates.RUNNING;
                const $ = document.createElement("div");
                if ($.classList.add("canvasWrapper"), k.append($), !this.textLayer && this.#l !== n.TextLayerMode.DISABLE && !K.isPureXfa && (this._accessibilityManager ||= new c.TextAccessibilityManager(), this.textLayer = new C.TextLayerBuilder({
                  highlighter: this._textHighlighter,
                  accessibilityManager: this._accessibilityManager,
                  isOffscreenCanvasSupported: this.isOffscreenCanvasSupported,
                  enablePermissions: this.#l === n.TextLayerMode.ENABLE_PERMISSIONS
                }), k.append(this.textLayer.div)), !this.annotationLayer && this.#t !== i.AnnotationMode.DISABLE) {
                  const {
                    annotationStorage: L,
                    downloadManager: W,
                    enableScripting: X,
                    fieldObjectsPromise: q,
                    hasJSActionsPromise: ct,
                    linkService: nt
                  } = this.#n();
                  this._annotationCanvasMap ||= /* @__PURE__ */ new Map(), this.annotationLayer = new d.AnnotationLayerBuilder({
                    pageDiv: k,
                    pdfPage: K,
                    annotationStorage: L,
                    imageResourcesPath: this.imageResourcesPath,
                    renderForms: this.#t === i.AnnotationMode.ENABLE_FORMS,
                    linkService: nt,
                    downloadManager: W,
                    l10n: V,
                    enableScripting: X,
                    hasJSActionsPromise: ct,
                    fieldObjectsPromise: q,
                    annotationCanvasMap: this._annotationCanvasMap,
                    accessibilityManager: this._accessibilityManager
                  });
                }
                const j = (L) => {
                  if (g?.(!1), this.renderingQueue && !this.renderingQueue.isHighestPriority(this)) {
                    this.renderingState = n.RenderingStates.PAUSED, this.resume = () => {
                      this.renderingState = n.RenderingStates.RUNNING, L();
                    };
                    return;
                  }
                  L();
                }, {
                  width: G,
                  height: M
                } = J, x = document.createElement("canvas");
                x.setAttribute("role", "presentation"), x.hidden = !0;
                const A = !!(z?.background && z?.foreground);
                let g = (L) => {
                  (!A || L) && (x.hidden = !1, g = null);
                };
                $.append(x), this.canvas = x;
                const I = x.getContext("2d", {
                  alpha: !1
                }), U = this.outputScale = new n.OutputScale();
                if (this.maxCanvasPixels === 0) {
                  const L = 1 / this.scale;
                  U.sx *= L, U.sy *= L, this.#e = !0;
                } else if (this.maxCanvasPixels > 0) {
                  const L = G * M, W = Math.sqrt(this.maxCanvasPixels / L);
                  U.sx > W || U.sy > W ? (U.sx = W, U.sy = W, this.#e = !0) : this.#e = !1;
                }
                const _ = (0, n.approximateFraction)(U.sx), H = (0, n.approximateFraction)(U.sy);
                x.width = (0, n.roundToDivide)(G * U.sx, _[0]), x.height = (0, n.roundToDivide)(M * U.sy, H[0]);
                const {
                  style: N
                } = x;
                N.width = (0, n.roundToDivide)(G, _[1]) + "px", N.height = (0, n.roundToDivide)(M, H[1]) + "px", this.#r.set(x, J);
                const b = U.scaled ? [U.sx, 0, 0, U.sy, 0, 0] : null, w = {
                  canvasContext: I,
                  transform: b,
                  viewport: J,
                  annotationMode: this.#t,
                  optionalContentConfigPromise: this._optionalContentConfigPromise,
                  annotationCanvasMap: this._annotationCanvasMap,
                  pageColors: z
                }, O = this.renderTask = this.pdfPage.render(w);
                O.onContinue = j;
                const D = O.promise.then(async () => {
                  if (g?.(!0), await this.#d(O), this.#g(), this.annotationLayer && await this.#u(), !this.annotationEditorLayer) {
                    const {
                      annotationEditorUIManager: L
                    } = this.#n();
                    if (!L)
                      return;
                    this.annotationEditorLayer = new o.AnnotationEditorLayerBuilder({
                      uiManager: L,
                      pageDiv: k,
                      pdfPage: K,
                      l10n: V,
                      accessibilityManager: this._accessibilityManager,
                      annotationLayer: this.annotationLayer?.annotationLayer
                    });
                  }
                  this.#f();
                }, (L) => (L instanceof i.RenderingCancelledException || g?.(!0), this.#d(O, L)));
                if (K.isPureXfa) {
                  if (this.xfaLayer)
                    this.xfaLayer.div && k.append(this.xfaLayer.div);
                  else {
                    const {
                      annotationStorage: L,
                      linkService: W
                    } = this.#n();
                    this.xfaLayer = new R.XfaLayerBuilder({
                      pageDiv: k,
                      pdfPage: K,
                      annotationStorage: L,
                      linkService: W
                    });
                  }
                  this.#p();
                }
                return k.setAttribute("data-loaded", !0), this.eventBus.dispatch("pagerender", {
                  source: this,
                  pageNumber: this.id
                }), D;
              }
              setPageLabel(k) {
                this.pageLabel = typeof k == "string" ? k : null, this.pageLabel !== null ? this.div.setAttribute("data-page-label", this.pageLabel) : this.div.removeAttribute("data-page-label");
              }
              get thumbnailCanvas() {
                const {
                  directDrawing: k,
                  initialOptionalContent: V,
                  regularAnnotations: z
                } = this.#c;
                return k && V && z ? this.canvas : null;
              }
            }
            v.PDFPageView = F;
          }),
          /* 14 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.AnnotationEditorLayerBuilder = void 0;
            var i = T(4), n = T(7);
            class o {
              #t = null;
              #e;
              constructor(h) {
                this.pageDiv = h.pageDiv, this.pdfPage = h.pdfPage, this.accessibilityManager = h.accessibilityManager, this.l10n = h.l10n || n.NullL10n, this.annotationEditorLayer = null, this.div = null, this._cancelled = !1, this.#e = h.uiManager, this.#t = h.annotationLayer || null;
              }
              async render(h, e = "display") {
                if (e !== "display" || this._cancelled)
                  return;
                const l = h.clone({
                  dontFlip: !0
                });
                if (this.div) {
                  this.annotationEditorLayer.update({
                    viewport: l
                  }), this.show();
                  return;
                }
                const u = this.div = document.createElement("div");
                u.className = "annotationEditorLayer", u.tabIndex = 0, u.hidden = !0, u.dir = this.#e.direction, this.pageDiv.append(u), this.annotationEditorLayer = new i.AnnotationEditorLayer({
                  uiManager: this.#e,
                  div: u,
                  accessibilityManager: this.accessibilityManager,
                  pageIndex: this.pdfPage.pageNumber - 1,
                  l10n: this.l10n,
                  viewport: l,
                  annotationLayer: this.#t
                });
                const c = {
                  viewport: l,
                  div: u,
                  annotations: null,
                  intent: e
                };
                this.annotationEditorLayer.render(c), this.show();
              }
              cancel() {
                this._cancelled = !0, this.div && (this.pageDiv = null, this.annotationEditorLayer.destroy(), this.div.remove());
              }
              hide() {
                this.div && (this.div.hidden = !0);
              }
              show() {
                !this.div || this.annotationEditorLayer.isEmpty || (this.div.hidden = !1);
              }
            }
            v.AnnotationEditorLayerBuilder = o;
          }),
          /* 15 */
          /***/
          ((E, v) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.compatibilityParams = v.OptionKind = v.AppOptions = void 0;
            const T = /* @__PURE__ */ Object.create(null);
            v.compatibilityParams = T;
            {
              const h = navigator.userAgent || "", e = navigator.platform || "", l = navigator.maxTouchPoints || 1, u = /Android/.test(h), c = /\b(iPad|iPhone|iPod)(?=;)/.test(h) || e === "MacIntel" && l > 1;
              (function() {
                (c || u) && (T.maxCanvasPixels = 5242880);
              })();
            }
            const i = {
              VIEWER: 2,
              API: 4,
              WORKER: 8,
              PREFERENCE: 128
            };
            v.OptionKind = i;
            const n = {
              annotationEditorMode: {
                value: 0,
                kind: i.VIEWER + i.PREFERENCE
              },
              annotationMode: {
                value: 2,
                kind: i.VIEWER + i.PREFERENCE
              },
              cursorToolOnLoad: {
                value: 0,
                kind: i.VIEWER + i.PREFERENCE
              },
              defaultZoomDelay: {
                value: 400,
                kind: i.VIEWER + i.PREFERENCE
              },
              defaultZoomValue: {
                value: "",
                kind: i.VIEWER + i.PREFERENCE
              },
              disableHistory: {
                value: !1,
                kind: i.VIEWER
              },
              disablePageLabels: {
                value: !1,
                kind: i.VIEWER + i.PREFERENCE
              },
              enablePermissions: {
                value: !1,
                kind: i.VIEWER + i.PREFERENCE
              },
              enablePrintAutoRotate: {
                value: !0,
                kind: i.VIEWER + i.PREFERENCE
              },
              enableScripting: {
                value: !0,
                kind: i.VIEWER + i.PREFERENCE
              },
              enableStampEditor: {
                value: !0,
                kind: i.VIEWER + i.PREFERENCE
              },
              externalLinkRel: {
                value: "noopener noreferrer nofollow",
                kind: i.VIEWER
              },
              externalLinkTarget: {
                value: 0,
                kind: i.VIEWER + i.PREFERENCE
              },
              historyUpdateUrl: {
                value: !1,
                kind: i.VIEWER + i.PREFERENCE
              },
              ignoreDestinationZoom: {
                value: !1,
                kind: i.VIEWER + i.PREFERENCE
              },
              imageResourcesPath: {
                value: "./images/",
                kind: i.VIEWER
              },
              maxCanvasPixels: {
                value: 16777216,
                kind: i.VIEWER
              },
              forcePageColors: {
                value: !1,
                kind: i.VIEWER + i.PREFERENCE
              },
              pageColorsBackground: {
                value: "Canvas",
                kind: i.VIEWER + i.PREFERENCE
              },
              pageColorsForeground: {
                value: "CanvasText",
                kind: i.VIEWER + i.PREFERENCE
              },
              pdfBugEnabled: {
                value: !1,
                kind: i.VIEWER + i.PREFERENCE
              },
              printResolution: {
                value: 150,
                kind: i.VIEWER
              },
              sidebarViewOnLoad: {
                value: -1,
                kind: i.VIEWER + i.PREFERENCE
              },
              scrollModeOnLoad: {
                value: -1,
                kind: i.VIEWER + i.PREFERENCE
              },
              spreadModeOnLoad: {
                value: -1,
                kind: i.VIEWER + i.PREFERENCE
              },
              textLayerMode: {
                value: 1,
                kind: i.VIEWER + i.PREFERENCE
              },
              viewerCssTheme: {
                value: 0,
                kind: i.VIEWER + i.PREFERENCE
              },
              viewOnLoad: {
                value: 0,
                kind: i.VIEWER + i.PREFERENCE
              },
              cMapPacked: {
                value: !0,
                kind: i.API
              },
              cMapUrl: {
                value: "../web/cmaps/",
                kind: i.API
              },
              disableAutoFetch: {
                value: !1,
                kind: i.API + i.PREFERENCE
              },
              disableFontFace: {
                value: !1,
                kind: i.API + i.PREFERENCE
              },
              disableRange: {
                value: !1,
                kind: i.API + i.PREFERENCE
              },
              disableStream: {
                value: !1,
                kind: i.API + i.PREFERENCE
              },
              docBaseUrl: {
                value: "",
                kind: i.API
              },
              enableXfa: {
                value: !0,
                kind: i.API + i.PREFERENCE
              },
              fontExtraProperties: {
                value: !1,
                kind: i.API
              },
              isEvalSupported: {
                value: !0,
                kind: i.API
              },
              isOffscreenCanvasSupported: {
                value: !0,
                kind: i.API
              },
              maxImageSize: {
                value: -1,
                kind: i.API
              },
              pdfBug: {
                value: !1,
                kind: i.API
              },
              standardFontDataUrl: {
                value: "../web/standard_fonts/",
                kind: i.API
              },
              verbosity: {
                value: 1,
                kind: i.API
              },
              workerPort: {
                value: null,
                kind: i.WORKER
              },
              workerSrc: {
                value: "../build/pdf.worker.js",
                kind: i.WORKER
              }
            };
            n.defaultUrl = {
              value: "compressed.tracemonkey-pldi-09.pdf",
              kind: i.VIEWER
            }, n.disablePreferences = {
              value: !1,
              kind: i.VIEWER
            }, n.locale = {
              value: navigator.language || "en-US",
              kind: i.VIEWER
            }, n.sandboxBundleSrc = {
              value: "../build/pdf.sandbox.js",
              kind: i.VIEWER
            };
            const o = /* @__PURE__ */ Object.create(null);
            class d {
              constructor() {
                throw new Error("Cannot initialize AppOptions.");
              }
              static get(e) {
                const l = o[e];
                if (l !== void 0)
                  return l;
                const u = n[e];
                if (u !== void 0)
                  return T[e] ?? u.value;
              }
              static getAll(e = null) {
                const l = /* @__PURE__ */ Object.create(null);
                for (const u in n) {
                  const c = n[u];
                  if (e) {
                    if ((e & c.kind) === 0)
                      continue;
                    if (e === i.PREFERENCE) {
                      const C = c.value, R = typeof C;
                      if (R === "boolean" || R === "string" || R === "number" && Number.isInteger(C)) {
                        l[u] = C;
                        continue;
                      }
                      throw new Error(`Invalid type for preference: ${u}`);
                    }
                  }
                  const y = o[u];
                  l[u] = y !== void 0 ? y : T[u] ?? c.value;
                }
                return l;
              }
              static set(e, l) {
                o[e] = l;
              }
              static setAll(e) {
                for (const l in e)
                  o[l] = e[l];
              }
              static remove(e) {
                delete o[e];
              }
            }
            v.AppOptions = d, d._hasUserOptions = function() {
              return Object.keys(o).length > 0;
            };
          }),
          /* 16 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.StructTreeLayerBuilder = void 0;
            var i = T(2);
            const n = {
              Document: null,
              DocumentFragment: null,
              Part: "group",
              Sect: "group",
              Div: "group",
              Aside: "note",
              NonStruct: "none",
              P: null,
              H: "heading",
              Title: null,
              FENote: "note",
              Sub: "group",
              Lbl: null,
              Span: null,
              Em: null,
              Strong: null,
              Link: "link",
              Annot: "note",
              Form: "form",
              Ruby: null,
              RB: null,
              RT: null,
              RP: null,
              Warichu: null,
              WT: null,
              WP: null,
              L: "list",
              LI: "listitem",
              LBody: null,
              Table: "table",
              TR: "row",
              TH: "columnheader",
              TD: "cell",
              THead: "columnheader",
              TBody: null,
              TFoot: null,
              Caption: null,
              Figure: "figure",
              Formula: null,
              Artifact: null
            }, o = /^H(\d+)$/;
            class d {
              #t = void 0;
              get renderingDone() {
                return this.#t !== void 0;
              }
              render(e) {
                if (this.#t !== void 0)
                  return this.#t;
                const l = this.#n(e);
                return l?.classList.add("structTree"), this.#t = l;
              }
              hide() {
                this.#t && !this.#t.hidden && (this.#t.hidden = !0);
              }
              show() {
                this.#t?.hidden && (this.#t.hidden = !1);
              }
              #e(e, l) {
                const {
                  alt: u,
                  id: c,
                  lang: y
                } = e;
                u !== void 0 && l.setAttribute("aria-label", (0, i.removeNullCharacters)(u)), c !== void 0 && l.setAttribute("aria-owns", c), y !== void 0 && l.setAttribute("lang", (0, i.removeNullCharacters)(y, !0));
              }
              #n(e) {
                if (!e)
                  return null;
                const l = document.createElement("span");
                if ("role" in e) {
                  const {
                    role: u
                  } = e, c = u.match(o);
                  c ? (l.setAttribute("role", "heading"), l.setAttribute("aria-level", c[1])) : n[u] && l.setAttribute("role", n[u]);
                }
                if (this.#e(e, l), e.children)
                  if (e.children.length === 1 && "id" in e.children[0])
                    this.#e(e.children[0], l);
                  else
                    for (const u of e.children)
                      l.append(this.#n(u));
                return l;
              }
            }
            v.StructTreeLayerBuilder = d;
          }),
          /* 17 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.TextAccessibilityManager = void 0;
            var i = T(2);
            class n {
              #t = !1;
              #e = null;
              #n = /* @__PURE__ */ new Map();
              #i = /* @__PURE__ */ new Map();
              setTextMapping(d) {
                this.#e = d;
              }
              static #o(d, h) {
                const e = d.getBoundingClientRect(), l = h.getBoundingClientRect();
                if (e.width === 0 && e.height === 0)
                  return 1;
                if (l.width === 0 && l.height === 0)
                  return -1;
                const u = e.y, c = e.y + e.height, y = e.y + e.height / 2, C = l.y, R = l.y + l.height, s = l.y + l.height / 2;
                if (y <= C && s >= c)
                  return -1;
                if (s <= u && y >= R)
                  return 1;
                const m = e.x + e.width / 2, F = l.x + l.width / 2;
                return m - F;
              }
              enable() {
                if (this.#t)
                  throw new Error("TextAccessibilityManager is already enabled.");
                if (!this.#e)
                  throw new Error("Text divs and strings have not been set.");
                if (this.#t = !0, this.#e = this.#e.slice(), this.#e.sort(n.#o), this.#n.size > 0) {
                  const d = this.#e;
                  for (const [h, e] of this.#n) {
                    if (!document.getElementById(h)) {
                      this.#n.delete(h);
                      continue;
                    }
                    this.#s(h, d[e]);
                  }
                }
                for (const [d, h] of this.#i)
                  this.addPointerInTextLayer(d, h);
                this.#i.clear();
              }
              disable() {
                this.#t && (this.#i.clear(), this.#e = null, this.#t = !1);
              }
              removePointerInTextLayer(d) {
                if (!this.#t) {
                  this.#i.delete(d);
                  return;
                }
                const h = this.#e;
                if (!h || h.length === 0)
                  return;
                const {
                  id: e
                } = d, l = this.#n.get(e);
                if (l === void 0)
                  return;
                const u = h[l];
                this.#n.delete(e);
                let c = u.getAttribute("aria-owns");
                c?.includes(e) && (c = c.split(" ").filter((y) => y !== e).join(" "), c ? u.setAttribute("aria-owns", c) : (u.removeAttribute("aria-owns"), u.setAttribute("role", "presentation")));
              }
              #s(d, h) {
                const e = h.getAttribute("aria-owns");
                e?.includes(d) || h.setAttribute("aria-owns", e ? `${e} ${d}` : d), h.removeAttribute("role");
              }
              addPointerInTextLayer(d, h) {
                const {
                  id: e
                } = d;
                if (!e)
                  return null;
                if (!this.#t)
                  return this.#i.set(d, h), null;
                h && this.removePointerInTextLayer(d);
                const l = this.#e;
                if (!l || l.length === 0)
                  return null;
                const u = (0, i.binarySearchFirstItem)(l, (R) => n.#o(d, R) < 0), c = Math.max(0, u - 1), y = l[c];
                this.#s(e, y), this.#n.set(e, c);
                const C = y.parentNode;
                return C?.classList.contains("markedContent") ? C.id : null;
              }
              moveElementInDOM(d, h, e, l) {
                const u = this.addPointerInTextLayer(e, l);
                if (!d.hasChildNodes())
                  return d.append(h), u;
                const c = Array.from(d.childNodes).filter((R) => R !== h);
                if (c.length === 0)
                  return u;
                const y = e || h, C = (0, i.binarySearchFirstItem)(c, (R) => n.#o(y, R) < 0);
                return C === 0 ? c[0].before(h) : c[C - 1].after(h), u;
              }
            }
            v.TextAccessibilityManager = n;
          }),
          /* 18 */
          /***/
          ((E, v) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.TextHighlighter = void 0;
            class T {
              constructor({
                findController: n,
                eventBus: o,
                pageIndex: d
              }) {
                this.findController = n, this.matches = [], this.eventBus = o, this.pageIdx = d, this._onUpdateTextLayerMatches = null, this.textDivs = null, this.textContentItemsStr = null, this.enabled = !1;
              }
              setTextMapping(n, o) {
                this.textDivs = n, this.textContentItemsStr = o;
              }
              enable() {
                if (!this.textDivs || !this.textContentItemsStr)
                  throw new Error("Text divs and strings have not been set.");
                if (this.enabled)
                  throw new Error("TextHighlighter is already enabled.");
                this.enabled = !0, this._onUpdateTextLayerMatches || (this._onUpdateTextLayerMatches = (n) => {
                  (n.pageIndex === this.pageIdx || n.pageIndex === -1) && this._updateMatches();
                }, this.eventBus._on("updatetextlayermatches", this._onUpdateTextLayerMatches)), this._updateMatches();
              }
              disable() {
                this.enabled && (this.enabled = !1, this._onUpdateTextLayerMatches && (this.eventBus._off("updatetextlayermatches", this._onUpdateTextLayerMatches), this._onUpdateTextLayerMatches = null), this._updateMatches(!0));
              }
              _convertMatches(n, o) {
                if (!n)
                  return [];
                const {
                  textContentItemsStr: d
                } = this;
                let h = 0, e = 0;
                const l = d.length - 1, u = [];
                for (let c = 0, y = n.length; c < y; c++) {
                  let C = n[c];
                  for (; h !== l && C >= e + d[h].length; )
                    e += d[h].length, h++;
                  h === d.length && console.error("Could not find a matching mapping");
                  const R = {
                    begin: {
                      divIdx: h,
                      offset: C - e
                    }
                  };
                  for (C += o[c]; h !== l && C > e + d[h].length; )
                    e += d[h].length, h++;
                  R.end = {
                    divIdx: h,
                    offset: C - e
                  }, u.push(R);
                }
                return u;
              }
              _renderMatches(n) {
                if (n.length === 0)
                  return;
                const {
                  findController: o,
                  pageIdx: d
                } = this, {
                  textContentItemsStr: h,
                  textDivs: e
                } = this, l = d === o.selected.pageIdx, u = o.selected.matchIdx, c = o.state.highlightAll;
                let y = null;
                const C = {
                  offset: void 0
                };
                function R(V, z) {
                  const K = V.divIdx;
                  return e[K].textContent = "", s(K, 0, V.offset, z);
                }
                function s(V, z, K, J) {
                  let $ = e[V];
                  if ($.nodeType === Node.TEXT_NODE) {
                    const M = document.createElement("span");
                    $.before(M), M.append($), e[V] = M, $ = M;
                  }
                  const j = h[V].substring(z, K), G = document.createTextNode(j);
                  if (J) {
                    const M = document.createElement("span");
                    return M.className = `${J} appended`, M.append(G), $.append(M), J.includes("selected") ? M.offsetLeft : 0;
                  }
                  return $.append(G), 0;
                }
                let m = u, F = m + 1;
                if (c)
                  m = 0, F = n.length;
                else if (!l)
                  return;
                let B = -1, k = -1;
                for (let V = m; V < F; V++) {
                  const z = n[V], K = z.begin;
                  if (K.divIdx === B && K.offset === k)
                    continue;
                  B = K.divIdx, k = K.offset;
                  const J = z.end, $ = l && V === u, j = $ ? " selected" : "";
                  let G = 0;
                  if (!y || K.divIdx !== y.divIdx ? (y !== null && s(y.divIdx, y.offset, C.offset), R(K)) : s(y.divIdx, y.offset, K.offset), K.divIdx === J.divIdx)
                    G = s(K.divIdx, K.offset, J.offset, "highlight" + j);
                  else {
                    G = s(K.divIdx, K.offset, C.offset, "highlight begin" + j);
                    for (let M = K.divIdx + 1, x = J.divIdx; M < x; M++)
                      e[M].className = "highlight middle" + j;
                    R(J, "highlight end" + j);
                  }
                  y = J, $ && o.scrollMatchIntoView({
                    element: e[K.divIdx],
                    selectedLeft: G,
                    pageIndex: d,
                    matchIndex: u
                  });
                }
                y && s(y.divIdx, y.offset, C.offset);
              }
              _updateMatches(n = !1) {
                if (!this.enabled && !n)
                  return;
                const {
                  findController: o,
                  matches: d,
                  pageIdx: h
                } = this, {
                  textContentItemsStr: e,
                  textDivs: l
                } = this;
                let u = -1;
                for (const C of d) {
                  const R = Math.max(u, C.begin.divIdx);
                  for (let s = R, m = C.end.divIdx; s <= m; s++) {
                    const F = l[s];
                    F.textContent = e[s], F.className = "";
                  }
                  u = C.end.divIdx + 1;
                }
                if (!o?.highlightMatches || n)
                  return;
                const c = o.pageMatches[h] || null, y = o.pageMatchesLength[h] || null;
                this.matches = this._convertMatches(c, y), this._renderMatches(this.matches);
              }
            }
            v.TextHighlighter = T;
          }),
          /* 19 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.TextLayerBuilder = void 0;
            var i = T(4), n = T(2);
            class o {
              #t = !1;
              #e = 0;
              #n = 0;
              #i = null;
              constructor({
                highlighter: h = null,
                accessibilityManager: e = null,
                isOffscreenCanvasSupported: l = !0,
                enablePermissions: u = !1
              }) {
                this.textContentItemsStr = [], this.renderingDone = !1, this.textDivs = [], this.textDivProperties = /* @__PURE__ */ new WeakMap(), this.textLayerRenderTask = null, this.highlighter = h, this.accessibilityManager = e, this.isOffscreenCanvasSupported = l, this.#t = u === !0, this.div = document.createElement("div"), this.div.className = "textLayer", this.hide();
              }
              #o() {
                this.renderingDone = !0;
                const h = document.createElement("div");
                h.className = "endOfContent", this.div.append(h), this.#s();
              }
              get numTextDivs() {
                return this.textDivs.length;
              }
              async render(h) {
                if (!this.#i)
                  throw new Error('No "textContentSource" parameter specified.');
                const e = h.scale * (globalThis.devicePixelRatio || 1), {
                  rotation: l
                } = h;
                if (this.renderingDone) {
                  const u = l !== this.#e, c = e !== this.#n;
                  (u || c) && (this.hide(), (0, i.updateTextLayer)({
                    container: this.div,
                    viewport: h,
                    textDivs: this.textDivs,
                    textDivProperties: this.textDivProperties,
                    isOffscreenCanvasSupported: this.isOffscreenCanvasSupported,
                    mustRescale: c,
                    mustRotate: u
                  }), this.#n = e, this.#e = l), this.show();
                  return;
                }
                this.cancel(), this.highlighter?.setTextMapping(this.textDivs, this.textContentItemsStr), this.accessibilityManager?.setTextMapping(this.textDivs), this.textLayerRenderTask = (0, i.renderTextLayer)({
                  textContentSource: this.#i,
                  container: this.div,
                  viewport: h,
                  textDivs: this.textDivs,
                  textDivProperties: this.textDivProperties,
                  textContentItemsStr: this.textContentItemsStr,
                  isOffscreenCanvasSupported: this.isOffscreenCanvasSupported
                }), await this.textLayerRenderTask.promise, this.#o(), this.#n = e, this.#e = l, this.show(), this.accessibilityManager?.enable();
              }
              hide() {
                this.div.hidden || (this.highlighter?.disable(), this.div.hidden = !0);
              }
              show() {
                this.div.hidden && this.renderingDone && (this.div.hidden = !1, this.highlighter?.enable());
              }
              cancel() {
                this.textLayerRenderTask && (this.textLayerRenderTask.cancel(), this.textLayerRenderTask = null), this.highlighter?.disable(), this.accessibilityManager?.disable(), this.textContentItemsStr.length = 0, this.textDivs.length = 0, this.textDivProperties = /* @__PURE__ */ new WeakMap();
              }
              setTextContentSource(h) {
                this.cancel(), this.#i = h;
              }
              #s() {
                const {
                  div: h
                } = this;
                h.addEventListener("mousedown", (e) => {
                  const l = h.querySelector(".endOfContent");
                  if (!l)
                    return;
                  let u = e.target !== h;
                  if (u &&= getComputedStyle(l).getPropertyValue("-moz-user-select") !== "none", u) {
                    const c = h.getBoundingClientRect(), y = Math.max(0, (e.pageY - c.top) / c.height);
                    l.style.top = (y * 100).toFixed(2) + "%";
                  }
                  l.classList.add("active");
                }), h.addEventListener("mouseup", () => {
                  const e = h.querySelector(".endOfContent");
                  e && (e.style.top = "", e.classList.remove("active"));
                }), h.addEventListener("copy", (e) => {
                  if (!this.#t) {
                    const l = document.getSelection();
                    e.clipboardData.setData("text/plain", (0, n.removeNullCharacters)((0, i.normalizeUnicode)(l.toString())));
                  }
                  e.preventDefault(), e.stopPropagation();
                });
              }
            }
            v.TextLayerBuilder = o;
          }),
          /* 20 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.XfaLayerBuilder = void 0;
            var i = T(4);
            class n {
              constructor({
                pageDiv: d,
                pdfPage: h,
                annotationStorage: e = null,
                linkService: l,
                xfaHtml: u = null
              }) {
                this.pageDiv = d, this.pdfPage = h, this.annotationStorage = e, this.linkService = l, this.xfaHtml = u, this.div = null, this._cancelled = !1;
              }
              async render(d, h = "display") {
                if (h === "print") {
                  const u = {
                    viewport: d.clone({
                      dontFlip: !0
                    }),
                    div: this.div,
                    xfaHtml: this.xfaHtml,
                    annotationStorage: this.annotationStorage,
                    linkService: this.linkService,
                    intent: h
                  }, c = document.createElement("div");
                  return this.pageDiv.append(c), u.div = c, i.XfaLayer.render(u);
                }
                const e = await this.pdfPage.getXfa();
                if (this._cancelled || !e)
                  return {
                    textDivs: []
                  };
                const l = {
                  viewport: d.clone({
                    dontFlip: !0
                  }),
                  div: this.div,
                  xfaHtml: e,
                  annotationStorage: this.annotationStorage,
                  linkService: this.linkService,
                  intent: h
                };
                return this.div ? i.XfaLayer.update(l) : (this.div = document.createElement("div"), this.pageDiv.append(this.div), l.div = this.div, i.XfaLayer.render(l));
              }
              cancel() {
                this._cancelled = !0;
              }
              hide() {
                this.div && (this.div.hidden = !0);
              }
            }
            v.XfaLayerBuilder = n;
          }),
          /* 21 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.PDFScriptingManager = void 0;
            var i = T(22), n = T(23);
            class o extends n.PDFScriptingManager {
              constructor(h) {
                h.externalServices || window.addEventListener("updatefromsandbox", (e) => {
                  h.eventBus.dispatch("updatefromsandbox", {
                    source: window,
                    detail: e.detail
                  });
                }), h.externalServices ||= {
                  createScripting: ({
                    sandboxBundleSrc: e
                  }) => new i.GenericScripting(e)
                }, h.docProperties ||= (e) => (0, i.docProperties)(e), super(h);
              }
            }
            v.PDFScriptingManager = o;
          }),
          /* 22 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.GenericScripting = void 0, v.docProperties = n;
            var i = T(4);
            async function n(d) {
              const e = "".split("#")[0];
              let {
                info: l,
                metadata: u,
                contentDispositionFilename: c,
                contentLength: y
              } = await d.getMetadata();
              if (!y) {
                const {
                  length: C
                } = await d.getDownloadInfo();
                y = C;
              }
              return {
                ...l,
                baseURL: e,
                filesize: y,
                filename: c || (0, i.getPdfFilenameFromUrl)(""),
                metadata: u?.getRaw(),
                authors: u?.get("dc:creator"),
                numPages: d.numPages,
                URL: ""
              };
            }
            class o {
              constructor(h) {
                this._ready = (0, i.loadScript)(h, !0).then(() => window.pdfjsSandbox.QuickJSSandbox());
              }
              async createSandbox(h) {
                (await this._ready).create(h);
              }
              async dispatchEventInSandbox(h) {
                const e = await this._ready;
                setTimeout(() => e.dispatchEvent(h), 0);
              }
              async destroySandbox() {
                (await this._ready).nukeSandbox();
              }
            }
            v.GenericScripting = o;
          }),
          /* 23 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.PDFScriptingManager = void 0;
            var i = T(2), n = T(4);
            class o {
              #t = null;
              #e = null;
              #n = null;
              #i = null;
              #o = null;
              #s = null;
              #a = null;
              #l = !1;
              #c = null;
              #r = null;
              #h = null;
              constructor({
                eventBus: h,
                sandboxBundleSrc: e = null,
                externalServices: l = null,
                docProperties: u = null
              }) {
                this.#i = h, this.#c = e, this.#o = l, this.#n = u;
              }
              setViewer(h) {
                this.#a = h;
              }
              async setDocument(h) {
                if (this.#s && await this.#m(), this.#s = h, !h)
                  return;
                const [e, l, u] = await Promise.all([h.getFieldObjects(), h.getCalculationOrderIds(), h.getJSActions()]);
                if (!e && !u) {
                  await this.#m();
                  return;
                }
                if (h === this.#s) {
                  try {
                    this.#r = this.#g();
                  } catch (c) {
                    console.error(`setDocument: "${c.message}".`), await this.#m();
                    return;
                  }
                  this._internalEvents.set("updatefromsandbox", (c) => {
                    c?.source === window && this.#u(c.detail);
                  }), this._internalEvents.set("dispatcheventinsandbox", (c) => {
                    this.#r?.dispatchEventInSandbox(c.detail);
                  }), this._internalEvents.set("pagechanging", ({
                    pageNumber: c,
                    previous: y
                  }) => {
                    c !== y && (this.#p(y), this.#f(c));
                  }), this._internalEvents.set("pagerendered", ({
                    pageNumber: c
                  }) => {
                    this._pageOpenPending.has(c) && c === this.#a.currentPageNumber && this.#f(c);
                  }), this._internalEvents.set("pagesdestroy", async () => {
                    await this.#p(this.#a.currentPageNumber), await this.#r?.dispatchEventInSandbox({
                      id: "doc",
                      name: "WillClose"
                    }), this.#t?.resolve();
                  });
                  for (const [c, y] of this._internalEvents)
                    this.#i._on(c, y);
                  try {
                    const c = await this.#n(h);
                    if (h !== this.#s)
                      return;
                    await this.#r.createSandbox({
                      objects: e,
                      calculationOrder: l,
                      appInfo: {
                        platform: navigator.platform,
                        language: navigator.language
                      },
                      docInfo: {
                        ...c,
                        actions: u
                      }
                    }), this.#i.dispatch("sandboxcreated", {
                      source: this
                    });
                  } catch (c) {
                    console.error(`setDocument: "${c.message}".`), await this.#m();
                    return;
                  }
                  await this.#r?.dispatchEventInSandbox({
                    id: "doc",
                    name: "Open"
                  }), await this.#f(this.#a.currentPageNumber, !0), Promise.resolve().then(() => {
                    h === this.#s && (this.#l = !0);
                  });
                }
              }
              async dispatchWillSave() {
                return this.#r?.dispatchEventInSandbox({
                  id: "doc",
                  name: "WillSave"
                });
              }
              async dispatchDidSave() {
                return this.#r?.dispatchEventInSandbox({
                  id: "doc",
                  name: "DidSave"
                });
              }
              async dispatchWillPrint() {
                if (this.#r) {
                  await this.#h?.promise, this.#h = new n.PromiseCapability();
                  try {
                    await this.#r.dispatchEventInSandbox({
                      id: "doc",
                      name: "WillPrint"
                    });
                  } catch (h) {
                    throw this.#h.resolve(), this.#h = null, h;
                  }
                  await this.#h.promise;
                }
              }
              async dispatchDidPrint() {
                return this.#r?.dispatchEventInSandbox({
                  id: "doc",
                  name: "DidPrint"
                });
              }
              get destroyPromise() {
                return this.#e?.promise || null;
              }
              get ready() {
                return this.#l;
              }
              get _internalEvents() {
                return (0, n.shadow)(this, "_internalEvents", /* @__PURE__ */ new Map());
              }
              get _pageOpenPending() {
                return (0, n.shadow)(this, "_pageOpenPending", /* @__PURE__ */ new Set());
              }
              get _visitedPages() {
                return (0, n.shadow)(this, "_visitedPages", /* @__PURE__ */ new Map());
              }
              async #u(h) {
                const e = this.#a, l = e.isInPresentationMode || e.isChangingPresentationMode, {
                  id: u,
                  siblings: c,
                  command: y,
                  value: C
                } = h;
                if (!u) {
                  switch (y) {
                    case "clear":
                      console.clear();
                      break;
                    case "error":
                      console.error(C);
                      break;
                    case "layout":
                      if (!l) {
                        const s = (0, i.apiPageLayoutToViewerModes)(C);
                        e.spreadMode = s.spreadMode;
                      }
                      break;
                    case "page-num":
                      e.currentPageNumber = C + 1;
                      break;
                    case "print":
                      await e.pagesPromise, this.#i.dispatch("print", {
                        source: this
                      });
                      break;
                    case "println":
                      console.log(C);
                      break;
                    case "zoom":
                      l || (e.currentScaleValue = C);
                      break;
                    case "SaveAs":
                      this.#i.dispatch("download", {
                        source: this
                      });
                      break;
                    case "FirstPage":
                      e.currentPageNumber = 1;
                      break;
                    case "LastPage":
                      e.currentPageNumber = e.pagesCount;
                      break;
                    case "NextPage":
                      e.nextPage();
                      break;
                    case "PrevPage":
                      e.previousPage();
                      break;
                    case "ZoomViewIn":
                      l || e.increaseScale();
                      break;
                    case "ZoomViewOut":
                      l || e.decreaseScale();
                      break;
                    case "WillPrintFinished":
                      this.#h?.resolve(), this.#h = null;
                      break;
                  }
                  return;
                }
                if (l && h.focus)
                  return;
                delete h.id, delete h.siblings;
                const R = c ? [u, ...c] : [u];
                for (const s of R) {
                  const m = document.querySelector(`[data-element-id="${s}"]`);
                  m ? m.dispatchEvent(new CustomEvent("updatefromsandbox", {
                    detail: h
                  })) : this.#s?.annotationStorage.setValue(s, h);
                }
              }
              async #f(h, e = !1) {
                const l = this.#s, u = this._visitedPages;
                if (e && (this.#t = new n.PromiseCapability()), !this.#t)
                  return;
                const c = this.#a.getPageView(h - 1);
                if (c?.renderingState !== i.RenderingStates.FINISHED) {
                  this._pageOpenPending.add(h);
                  return;
                }
                this._pageOpenPending.delete(h);
                const y = (async () => {
                  const C = await (u.has(h) ? null : c.pdfPage?.getJSActions());
                  l === this.#s && await this.#r?.dispatchEventInSandbox({
                    id: "page",
                    name: "PageOpen",
                    pageNumber: h,
                    actions: C
                  });
                })();
                u.set(h, y);
              }
              async #p(h) {
                const e = this.#s, l = this._visitedPages;
                if (!this.#t || this._pageOpenPending.has(h))
                  return;
                const u = l.get(h);
                u && (l.set(h, null), await u, e === this.#s && await this.#r?.dispatchEventInSandbox({
                  id: "page",
                  name: "PageClose",
                  pageNumber: h
                }));
              }
              #g() {
                if (this.#e = new n.PromiseCapability(), this.#r)
                  throw new Error("#initScripting: Scripting already exists.");
                return this.#o.createScripting({
                  sandboxBundleSrc: this.#c
                });
              }
              async #m() {
                if (!this.#r) {
                  this.#s = null, this.#e?.resolve();
                  return;
                }
                this.#t && (await Promise.race([this.#t.promise, new Promise((h) => {
                  setTimeout(h, 1e3);
                })]).catch(() => {
                }), this.#t = null), this.#s = null;
                try {
                  await this.#r.destroySandbox();
                } catch {
                }
                this.#h?.reject(new Error("Scripting destroyed.")), this.#h = null;
                for (const [h, e] of this._internalEvents)
                  this.#i._off(h, e);
                this._internalEvents.clear(), this._pageOpenPending.clear(), this._visitedPages.clear(), this.#r = null, this.#l = !1, this.#e?.resolve();
              }
            }
            v.PDFScriptingManager = o;
          }),
          /* 24 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.PDFSinglePageViewer = void 0;
            var i = T(2), n = T(25);
            class o extends n.PDFViewer {
              _resetView() {
                super._resetView(), this._scrollMode = i.ScrollMode.PAGE, this._spreadMode = i.SpreadMode.NONE;
              }
              set scrollMode(h) {
              }
              _updateScrollMode() {
              }
              set spreadMode(h) {
              }
              _updateSpreadMode() {
              }
            }
            v.PDFSinglePageViewer = o;
          }),
          /* 25 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.PagesCountLimit = v.PDFViewer = v.PDFPageViewBuffer = void 0;
            var i = T(4), n = T(2), o = T(7), d = T(13), h = T(26), e = T(5);
            const l = 10, u = {
              FORCE_SCROLL_MODE_PAGE: 15e3,
              FORCE_LAZY_PAGE_INIT: 7500,
              PAUSE_EAGER_PAGE_INIT: 250
            };
            v.PagesCountLimit = u;
            function c(R) {
              return Object.values(i.AnnotationEditorType).includes(R) && R !== i.AnnotationEditorType.DISABLE;
            }
            class y {
              #t = /* @__PURE__ */ new Set();
              #e = 0;
              constructor(s) {
                this.#e = s;
              }
              push(s) {
                const m = this.#t;
                m.has(s) && m.delete(s), m.add(s), m.size > this.#e && this.#n();
              }
              resize(s, m = null) {
                this.#e = s;
                const F = this.#t;
                if (m) {
                  const B = F.size;
                  let k = 1;
                  for (const V of F)
                    if (m.has(V.id) && (F.delete(V), F.add(V)), ++k > B)
                      break;
                }
                for (; F.size > this.#e; )
                  this.#n();
              }
              has(s) {
                return this.#t.has(s);
              }
              [Symbol.iterator]() {
                return this.#t.keys();
              }
              #n() {
                const s = this.#t.keys().next().value;
                s?.destroy(), this.#t.delete(s);
              }
            }
            v.PDFPageViewBuffer = y;
            class C {
              #t = null;
              #e = null;
              #n = i.AnnotationEditorType.NONE;
              #i = null;
              #o = i.AnnotationMode.ENABLE_FORMS;
              #s = null;
              #a = null;
              #l = !1;
              #c = !1;
              #r = null;
              #h = !1;
              #u = 0;
              #f = new ResizeObserver(this.#C.bind(this));
              #p = null;
              #g = null;
              #m = null;
              #v = n.TextLayerMode.ENABLE;
              constructor(s) {
                const m = "3.11.174";
                if (i.version !== m)
                  throw new Error(`The API version "${i.version}" does not match the Viewer version "${m}".`);
                if (this.container = s.container, this.viewer = s.viewer || s.container.firstElementChild, this.container?.tagName !== "DIV" || this.viewer?.tagName !== "DIV")
                  throw new Error("Invalid `container` and/or `viewer` option.");
                if (this.container.offsetParent && getComputedStyle(this.container).position !== "absolute")
                  throw new Error("The `container` must be absolutely positioned.");
                this.#f.observe(this.container), this.eventBus = s.eventBus, this.linkService = s.linkService || new e.SimpleLinkService(), this.downloadManager = s.downloadManager || null, this.findController = s.findController || null, this.#e = s.altTextManager || null, this.findController && (this.findController.onIsPageVisible = (F) => this._getVisiblePages().ids.has(F)), this._scriptingManager = s.scriptingManager || null, this.#v = s.textLayerMode ?? n.TextLayerMode.ENABLE, this.#o = s.annotationMode ?? i.AnnotationMode.ENABLE_FORMS, this.#n = s.annotationEditorMode ?? i.AnnotationEditorType.NONE, this.imageResourcesPath = s.imageResourcesPath || "", this.enablePrintAutoRotate = s.enablePrintAutoRotate || !1, this.removePageBorders = s.removePageBorders || !1, s.useOnlyCssZoom && (console.error("useOnlyCssZoom was removed, please use `maxCanvasPixels = 0` instead."), s.maxCanvasPixels = 0), this.isOffscreenCanvasSupported = s.isOffscreenCanvasSupported ?? !0, this.maxCanvasPixels = s.maxCanvasPixels, this.l10n = s.l10n || o.NullL10n, this.#l = s.enablePermissions || !1, this.pageColors = s.pageColors || null, this.defaultRenderingQueue = !s.renderingQueue, this.defaultRenderingQueue ? (this.renderingQueue = new h.PDFRenderingQueue(), this.renderingQueue.setViewer(this)) : this.renderingQueue = s.renderingQueue, this.scroll = (0, n.watchScroll)(this.container, this._scrollUpdate.bind(this)), this.presentationModeState = n.PresentationModeState.UNKNOWN, this._onBeforeDraw = this._onAfterDraw = null, this._resetView(), this.removePageBorders && this.viewer.classList.add("removePageBorders"), this.#P(), this.eventBus._on("thumbnailrendered", ({
                  pageNumber: F,
                  pdfPage: B
                }) => {
                  const k = this._pages[F - 1];
                  this.#t.has(k) || B?.cleanup();
                });
              }
              get pagesCount() {
                return this._pages.length;
              }
              getPageView(s) {
                return this._pages[s];
              }
              getCachedPageViews() {
                return new Set(this.#t);
              }
              get pageViewsReady() {
                return this._pagesCapability.settled && this._pages.every((s) => s?.pdfPage);
              }
              get renderForms() {
                return this.#o === i.AnnotationMode.ENABLE_FORMS;
              }
              get enableScripting() {
                return !!this._scriptingManager;
              }
              get currentPageNumber() {
                return this._currentPageNumber;
              }
              set currentPageNumber(s) {
                if (!Number.isInteger(s))
                  throw new Error("Invalid page number.");
                this.pdfDocument && (this._setCurrentPageNumber(s, !0) || console.error(`currentPageNumber: "${s}" is not a valid page.`));
              }
              _setCurrentPageNumber(s, m = !1) {
                if (this._currentPageNumber === s)
                  return m && this.#w(), !0;
                if (!(0 < s && s <= this.pagesCount))
                  return !1;
                const F = this._currentPageNumber;
                return this._currentPageNumber = s, this.eventBus.dispatch("pagechanging", {
                  source: this,
                  pageNumber: s,
                  pageLabel: this._pageLabels?.[s - 1] ?? null,
                  previous: F
                }), m && this.#w(), !0;
              }
              get currentPageLabel() {
                return this._pageLabels?.[this._currentPageNumber - 1] ?? null;
              }
              set currentPageLabel(s) {
                if (!this.pdfDocument)
                  return;
                let m = s | 0;
                if (this._pageLabels) {
                  const F = this._pageLabels.indexOf(s);
                  F >= 0 && (m = F + 1);
                }
                this._setCurrentPageNumber(m, !0) || console.error(`currentPageLabel: "${s}" is not a valid page.`);
              }
              get currentScale() {
                return this._currentScale !== n.UNKNOWN_SCALE ? this._currentScale : n.DEFAULT_SCALE;
              }
              set currentScale(s) {
                if (isNaN(s))
                  throw new Error("Invalid numeric scale.");
                this.pdfDocument && this.#y(s, {
                  noScroll: !1
                });
              }
              get currentScaleValue() {
                return this._currentScaleValue;
              }
              set currentScaleValue(s) {
                this.pdfDocument && this.#y(s, {
                  noScroll: !1
                });
              }
              get pagesRotation() {
                return this._pagesRotation;
              }
              set pagesRotation(s) {
                if (!(0, n.isValidRotation)(s))
                  throw new Error("Invalid pages rotation angle.");
                if (!this.pdfDocument || (s %= 360, s < 0 && (s += 360), this._pagesRotation === s))
                  return;
                this._pagesRotation = s;
                const m = this._currentPageNumber;
                this.refresh(!0, {
                  rotation: s
                }), this._currentScaleValue && this.#y(this._currentScaleValue, {
                  noScroll: !0
                }), this.eventBus.dispatch("rotationchanging", {
                  source: this,
                  pagesRotation: s,
                  pageNumber: m
                }), this.defaultRenderingQueue && this.update();
              }
              get firstPagePromise() {
                return this.pdfDocument ? this._firstPageCapability.promise : null;
              }
              get onePageRendered() {
                return this.pdfDocument ? this._onePageRenderedCapability.promise : null;
              }
              get pagesPromise() {
                return this.pdfDocument ? this._pagesCapability.promise : null;
              }
              #d() {
                const s = this;
                return {
                  get annotationEditorUIManager() {
                    return s.#i;
                  },
                  get annotationStorage() {
                    return s.pdfDocument?.annotationStorage;
                  },
                  get downloadManager() {
                    return s.downloadManager;
                  },
                  get enableScripting() {
                    return !!s._scriptingManager;
                  },
                  get fieldObjectsPromise() {
                    return s.pdfDocument?.getFieldObjects();
                  },
                  get findController() {
                    return s.findController;
                  },
                  get hasJSActionsPromise() {
                    return s.pdfDocument?.hasJSActions();
                  },
                  get linkService() {
                    return s.linkService;
                  }
                };
              }
              #b(s) {
                const m = {
                  annotationEditorMode: this.#n,
                  annotationMode: this.#o,
                  textLayerMode: this.#v
                };
                return s && (!s.includes(i.PermissionFlag.COPY) && this.#v === n.TextLayerMode.ENABLE && (m.textLayerMode = n.TextLayerMode.ENABLE_PERMISSIONS), s.includes(i.PermissionFlag.MODIFY_CONTENTS) || (m.annotationEditorMode = i.AnnotationEditorType.DISABLE), !s.includes(i.PermissionFlag.MODIFY_ANNOTATIONS) && !s.includes(i.PermissionFlag.FILL_INTERACTIVE_FORMS) && this.#o === i.AnnotationMode.ENABLE_FORMS && (m.annotationMode = i.AnnotationMode.ENABLE)), m;
              }
              #x() {
                if (document.visibilityState === "hidden" || !this.container.offsetParent || this._getVisiblePages().views.length === 0)
                  return Promise.resolve();
                const s = new Promise((m) => {
                  this.#g = () => {
                    document.visibilityState === "hidden" && (m(), document.removeEventListener("visibilitychange", this.#g), this.#g = null);
                  }, document.addEventListener("visibilitychange", this.#g);
                });
                return Promise.race([this._onePageRenderedCapability.promise, s]);
              }
              async getAllText() {
                const s = [], m = [];
                for (let F = 1, B = this.pdfDocument.numPages; F <= B; ++F) {
                  if (this.#h)
                    return null;
                  m.length = 0;
                  const k = await this.pdfDocument.getPage(F), {
                    items: V
                  } = await k.getTextContent();
                  for (const z of V)
                    z.str && m.push(z.str), z.hasEOL && m.push(`
`);
                  s.push((0, n.removeNullCharacters)(m.join("")));
                }
                return s.join(`
`);
              }
              #A(s, m) {
                const F = document.getSelection(), {
                  focusNode: B,
                  anchorNode: k
                } = F;
                if (k && B && F.containsNode(this.#r)) {
                  if (this.#c || s === n.TextLayerMode.ENABLE_PERMISSIONS) {
                    m.preventDefault(), m.stopPropagation();
                    return;
                  }
                  this.#c = !0;
                  const V = this.container.style.cursor;
                  this.container.style.cursor = "wait";
                  const z = (K) => this.#h = K.key === "Escape";
                  window.addEventListener("keydown", z), this.getAllText().then(async (K) => {
                    K !== null && await navigator.clipboard.writeText(K);
                  }).catch((K) => {
                    console.warn(`Something goes wrong when extracting the text: ${K.message}`);
                  }).finally(() => {
                    this.#c = !1, this.#h = !1, window.removeEventListener("keydown", z), this.container.style.cursor = V;
                  }), m.preventDefault(), m.stopPropagation();
                }
              }
              setDocument(s) {
                if (this.pdfDocument && (this.eventBus.dispatch("pagesdestroy", {
                  source: this
                }), this._cancelRendering(), this._resetView(), this.findController?.setDocument(null), this._scriptingManager?.setDocument(null), this.#i && (this.#i.destroy(), this.#i = null)), this.pdfDocument = s, !s)
                  return;
                const m = s.numPages, F = s.getPage(1), B = s.getOptionalContentConfig(), k = this.#l ? s.getPermissions() : Promise.resolve();
                if (m > u.FORCE_SCROLL_MODE_PAGE) {
                  console.warn("Forcing PAGE-scrolling for performance reasons, given the length of the document.");
                  const V = this._scrollMode = n.ScrollMode.PAGE;
                  this.eventBus.dispatch("scrollmodechanged", {
                    source: this,
                    mode: V
                  });
                }
                this._pagesCapability.promise.then(() => {
                  this.eventBus.dispatch("pagesloaded", {
                    source: this,
                    pagesCount: m
                  });
                }, () => {
                }), this._onBeforeDraw = (V) => {
                  const z = this._pages[V.pageNumber - 1];
                  z && this.#t.push(z);
                }, this.eventBus._on("pagerender", this._onBeforeDraw), this._onAfterDraw = (V) => {
                  V.cssTransform || this._onePageRenderedCapability.settled || (this._onePageRenderedCapability.resolve({
                    timestamp: V.timestamp
                  }), this.eventBus._off("pagerendered", this._onAfterDraw), this._onAfterDraw = null, this.#g && (document.removeEventListener("visibilitychange", this.#g), this.#g = null));
                }, this.eventBus._on("pagerendered", this._onAfterDraw), Promise.all([F, k]).then(([V, z]) => {
                  if (s !== this.pdfDocument)
                    return;
                  this._firstPageCapability.resolve(V), this._optionalContentConfigPromise = B;
                  const {
                    annotationEditorMode: K,
                    annotationMode: J,
                    textLayerMode: $
                  } = this.#b(z);
                  if ($ !== n.TextLayerMode.DISABLE) {
                    const g = this.#r = document.createElement("div");
                    g.id = "hiddenCopyElement", this.viewer.before(g);
                  }
                  if (K !== i.AnnotationEditorType.DISABLE) {
                    const g = K;
                    s.isPureXfa ? console.warn("Warning: XFA-editing is not implemented.") : c(g) ? (this.#i = new i.AnnotationEditorUIManager(this.container, this.viewer, this.#e, this.eventBus, s, this.pageColors), g !== i.AnnotationEditorType.NONE && this.#i.updateMode(g)) : console.error(`Invalid AnnotationEditor mode: ${g}`);
                  }
                  const j = this.#d.bind(this), G = this._scrollMode === n.ScrollMode.PAGE ? null : this.viewer, M = this.currentScale, x = V.getViewport({
                    scale: M * i.PixelsPerInch.PDF_TO_CSS_UNITS
                  });
                  this.viewer.style.setProperty("--scale-factor", x.scale), (this.pageColors?.foreground === "CanvasText" || this.pageColors?.background === "Canvas") && this.viewer.style.setProperty("--hcm-highligh-filter", s.filterFactory.addHighlightHCMFilter("CanvasText", "Canvas", "HighlightText", "Highlight"));
                  for (let g = 1; g <= m; ++g) {
                    const I = new d.PDFPageView({
                      container: G,
                      eventBus: this.eventBus,
                      id: g,
                      scale: M,
                      defaultViewport: x.clone(),
                      optionalContentConfigPromise: B,
                      renderingQueue: this.renderingQueue,
                      textLayerMode: $,
                      annotationMode: J,
                      imageResourcesPath: this.imageResourcesPath,
                      isOffscreenCanvasSupported: this.isOffscreenCanvasSupported,
                      maxCanvasPixels: this.maxCanvasPixels,
                      pageColors: this.pageColors,
                      l10n: this.l10n,
                      layerProperties: j
                    });
                    this._pages.push(I);
                  }
                  const A = this._pages[0];
                  A && (A.setPdfPage(V), this.linkService.cachePageRef(1, V.ref)), this._scrollMode === n.ScrollMode.PAGE ? this.#S() : this._spreadMode !== n.SpreadMode.NONE && this._updateSpreadMode(), this.#x().then(async () => {
                    if (this.findController?.setDocument(s), this._scriptingManager?.setDocument(s), this.#r && (this.#a = this.#A.bind(this, $), document.addEventListener("copy", this.#a)), this.#i && this.eventBus.dispatch("annotationeditormodechanged", {
                      source: this,
                      mode: this.#n
                    }), s.loadingParams.disableAutoFetch || m > u.FORCE_LAZY_PAGE_INIT) {
                      this._pagesCapability.resolve();
                      return;
                    }
                    let g = m - 1;
                    if (g <= 0) {
                      this._pagesCapability.resolve();
                      return;
                    }
                    for (let I = 2; I <= m; ++I) {
                      const U = s.getPage(I).then((_) => {
                        const H = this._pages[I - 1];
                        H.pdfPage || H.setPdfPage(_), this.linkService.cachePageRef(I, _.ref), --g === 0 && this._pagesCapability.resolve();
                      }, (_) => {
                        console.error(`Unable to get page ${I} to initialize viewer`, _), --g === 0 && this._pagesCapability.resolve();
                      });
                      I % u.PAUSE_EAGER_PAGE_INIT === 0 && await U;
                    }
                  }), this.eventBus.dispatch("pagesinit", {
                    source: this
                  }), s.getMetadata().then(({
                    info: g
                  }) => {
                    s === this.pdfDocument && g.Language && (this.viewer.lang = g.Language);
                  }), this.defaultRenderingQueue && this.update();
                }).catch((V) => {
                  console.error("Unable to initialize viewer", V), this._pagesCapability.reject(V);
                });
              }
              setPageLabels(s) {
                if (this.pdfDocument) {
                  s ? Array.isArray(s) && this.pdfDocument.numPages === s.length ? this._pageLabels = s : (this._pageLabels = null, console.error("setPageLabels: Invalid page labels.")) : this._pageLabels = null;
                  for (let m = 0, F = this._pages.length; m < F; m++)
                    this._pages[m].setPageLabel(this._pageLabels?.[m] ?? null);
                }
              }
              _resetView() {
                this._pages = [], this._currentPageNumber = 1, this._currentScale = n.UNKNOWN_SCALE, this._currentScaleValue = null, this._pageLabels = null, this.#t = new y(l), this._location = null, this._pagesRotation = 0, this._optionalContentConfigPromise = null, this._firstPageCapability = new i.PromiseCapability(), this._onePageRenderedCapability = new i.PromiseCapability(), this._pagesCapability = new i.PromiseCapability(), this._scrollMode = n.ScrollMode.VERTICAL, this._previousScrollMode = n.ScrollMode.UNKNOWN, this._spreadMode = n.SpreadMode.NONE, this.#p = {
                  previousPageNumber: 1,
                  scrollDown: !0,
                  pages: []
                }, this._onBeforeDraw && (this.eventBus._off("pagerender", this._onBeforeDraw), this._onBeforeDraw = null), this._onAfterDraw && (this.eventBus._off("pagerendered", this._onAfterDraw), this._onAfterDraw = null), this.#g && (document.removeEventListener("visibilitychange", this.#g), this.#g = null), this.viewer.textContent = "", this._updateScrollMode(), this.viewer.removeAttribute("lang"), this.#r && (document.removeEventListener("copy", this.#a), this.#a = null, this.#r.remove(), this.#r = null);
              }
              #S() {
                if (this._scrollMode !== n.ScrollMode.PAGE)
                  throw new Error("#ensurePageViewVisible: Invalid scrollMode value.");
                const s = this._currentPageNumber, m = this.#p, F = this.viewer;
                if (F.textContent = "", m.pages.length = 0, this._spreadMode === n.SpreadMode.NONE && !this.isInPresentationMode) {
                  const B = this._pages[s - 1];
                  F.append(B.div), m.pages.push(B);
                } else {
                  const B = /* @__PURE__ */ new Set(), k = this._spreadMode - 1;
                  k === -1 ? B.add(s - 1) : s % 2 !== k ? (B.add(s - 1), B.add(s)) : (B.add(s - 2), B.add(s - 1));
                  const V = document.createElement("div");
                  if (V.className = "spread", this.isInPresentationMode) {
                    const z = document.createElement("div");
                    z.className = "dummyPage", V.append(z);
                  }
                  for (const z of B) {
                    const K = this._pages[z];
                    K && (V.append(K.div), m.pages.push(K));
                  }
                  F.append(V);
                }
                m.scrollDown = s >= m.previousPageNumber, m.previousPageNumber = s;
              }
              _scrollUpdate() {
                this.pagesCount !== 0 && this.update();
              }
              #E(s, m = null) {
                const {
                  div: F,
                  id: B
                } = s;
                if (this._currentPageNumber !== B && this._setCurrentPageNumber(B), this._scrollMode === n.ScrollMode.PAGE && (this.#S(), this.update()), !m && !this.isInPresentationMode) {
                  const k = F.offsetLeft + F.clientLeft, V = k + F.clientWidth, {
                    scrollLeft: z,
                    clientWidth: K
                  } = this.container;
                  (this._scrollMode === n.ScrollMode.HORIZONTAL || k < z || V > z + K) && (m = {
                    left: 0,
                    top: 0
                  });
                }
                (0, n.scrollIntoView)(F, m), !this._currentScaleValue && this._location && (this._location = null);
              }
              #O(s) {
                return s === this._currentScale || Math.abs(s - this._currentScale) < 1e-15;
              }
              #L(s, m, {
                noScroll: F = !1,
                preset: B = !1,
                drawingDelay: k = -1
              }) {
                if (this._currentScaleValue = m.toString(), this.#O(s)) {
                  B && this.eventBus.dispatch("scalechanging", {
                    source: this,
                    scale: s,
                    presetValue: m
                  });
                  return;
                }
                this.viewer.style.setProperty("--scale-factor", s * i.PixelsPerInch.PDF_TO_CSS_UNITS);
                const V = k >= 0 && k < 1e3;
                if (this.refresh(!0, {
                  scale: s,
                  drawingDelay: V ? k : -1
                }), V && (this.#m = setTimeout(() => {
                  this.#m = null, this.refresh();
                }, k)), this._currentScale = s, !F) {
                  let z = this._currentPageNumber, K;
                  this._location && !(this.isInPresentationMode || this.isChangingPresentationMode) && (z = this._location.pageNumber, K = [null, {
                    name: "XYZ"
                  }, this._location.left, this._location.top, null]), this.scrollPageIntoView({
                    pageNumber: z,
                    destArray: K,
                    allowNegativeOffset: !0
                  });
                }
                this.eventBus.dispatch("scalechanging", {
                  source: this,
                  scale: s,
                  presetValue: B ? m : void 0
                }), this.defaultRenderingQueue && this.update();
              }
              get #F() {
                return this._spreadMode !== n.SpreadMode.NONE && this._scrollMode !== n.ScrollMode.HORIZONTAL ? 2 : 1;
              }
              #y(s, m) {
                let F = parseFloat(s);
                if (F > 0)
                  m.preset = !1, this.#L(F, s, m);
                else {
                  const B = this._pages[this._currentPageNumber - 1];
                  if (!B)
                    return;
                  let k = n.SCROLLBAR_PADDING, V = n.VERTICAL_PADDING;
                  this.isInPresentationMode ? (k = V = 4, this._spreadMode !== n.SpreadMode.NONE && (k *= 2)) : this.removePageBorders ? k = V = 0 : this._scrollMode === n.ScrollMode.HORIZONTAL && ([k, V] = [V, k]);
                  const z = (this.container.clientWidth - k) / B.width * B.scale / this.#F, K = (this.container.clientHeight - V) / B.height * B.scale;
                  switch (s) {
                    case "page-actual":
                      F = 1;
                      break;
                    case "page-width":
                      F = z;
                      break;
                    case "page-height":
                      F = K;
                      break;
                    case "page-fit":
                      F = Math.min(z, K);
                      break;
                    case "auto":
                      const J = (0, n.isPortraitOrientation)(B) ? z : Math.min(K, z);
                      F = Math.min(n.MAX_AUTO_SCALE, J);
                      break;
                    default:
                      console.error(`#setScale: "${s}" is an unknown zoom value.`);
                      return;
                  }
                  m.preset = !0, this.#L(F, s, m);
                }
              }
              #w() {
                const s = this._pages[this._currentPageNumber - 1];
                this.isInPresentationMode && this.#y(this._currentScaleValue, {
                  noScroll: !0
                }), this.#E(s);
              }
              pageLabelToPageNumber(s) {
                if (!this._pageLabels)
                  return null;
                const m = this._pageLabels.indexOf(s);
                return m < 0 ? null : m + 1;
              }
              scrollPageIntoView({
                pageNumber: s,
                destArray: m = null,
                allowNegativeOffset: F = !1,
                ignoreDestinationZoom: B = !1
              }) {
                if (!this.pdfDocument)
                  return;
                const k = Number.isInteger(s) && this._pages[s - 1];
                if (!k) {
                  console.error(`scrollPageIntoView: "${s}" is not a valid pageNumber parameter.`);
                  return;
                }
                if (this.isInPresentationMode || !m) {
                  this._setCurrentPageNumber(s, !0);
                  return;
                }
                let V = 0, z = 0, K = 0, J = 0, $, j;
                const G = k.rotation % 180 !== 0, M = (G ? k.height : k.width) / k.scale / i.PixelsPerInch.PDF_TO_CSS_UNITS, x = (G ? k.width : k.height) / k.scale / i.PixelsPerInch.PDF_TO_CSS_UNITS;
                let A = 0;
                switch (m[1].name) {
                  case "XYZ":
                    V = m[2], z = m[3], A = m[4], V = V !== null ? V : 0, z = z !== null ? z : x;
                    break;
                  case "Fit":
                  case "FitB":
                    A = "page-fit";
                    break;
                  case "FitH":
                  case "FitBH":
                    z = m[2], A = "page-width", z === null && this._location ? (V = this._location.left, z = this._location.top) : (typeof z != "number" || z < 0) && (z = x);
                    break;
                  case "FitV":
                  case "FitBV":
                    V = m[2], K = M, J = x, A = "page-height";
                    break;
                  case "FitR":
                    V = m[2], z = m[3], K = m[4] - V, J = m[5] - z;
                    let _ = n.SCROLLBAR_PADDING, H = n.VERTICAL_PADDING;
                    this.removePageBorders && (_ = H = 0), $ = (this.container.clientWidth - _) / K / i.PixelsPerInch.PDF_TO_CSS_UNITS, j = (this.container.clientHeight - H) / J / i.PixelsPerInch.PDF_TO_CSS_UNITS, A = Math.min(Math.abs($), Math.abs(j));
                    break;
                  default:
                    console.error(`scrollPageIntoView: "${m[1].name}" is not a valid destination type.`);
                    return;
                }
                if (B || (A && A !== this._currentScale ? this.currentScaleValue = A : this._currentScale === n.UNKNOWN_SCALE && (this.currentScaleValue = n.DEFAULT_SCALE_VALUE)), A === "page-fit" && !m[4]) {
                  this.#E(k);
                  return;
                }
                const g = [k.viewport.convertToViewportPoint(V, z), k.viewport.convertToViewportPoint(V + K, z + J)];
                let I = Math.min(g[0][0], g[1][0]), U = Math.min(g[0][1], g[1][1]);
                F || (I = Math.max(I, 0), U = Math.max(U, 0)), this.#E(k, {
                  left: I,
                  top: U
                });
              }
              _updateLocation(s) {
                const m = this._currentScale, F = this._currentScaleValue, B = parseFloat(F) === m ? Math.round(m * 1e4) / 100 : F, k = s.id, V = this._pages[k - 1], z = this.container, K = V.getPagePoint(z.scrollLeft - s.x, z.scrollTop - s.y), J = Math.round(K[0]), $ = Math.round(K[1]);
                let j = `#page=${k}`;
                this.isInPresentationMode || (j += `&zoom=${B},${J},${$}`), this._location = {
                  pageNumber: k,
                  scale: B,
                  top: $,
                  left: J,
                  rotation: this._pagesRotation,
                  pdfOpenParams: j
                };
              }
              update() {
                const s = this._getVisiblePages(), m = s.views, F = m.length;
                if (F === 0)
                  return;
                const B = Math.max(l, 2 * F + 1);
                this.#t.resize(B, s.ids), this.renderingQueue.renderHighestPriority(s);
                const k = this._spreadMode === n.SpreadMode.NONE && (this._scrollMode === n.ScrollMode.PAGE || this._scrollMode === n.ScrollMode.VERTICAL), V = this._currentPageNumber;
                let z = !1;
                for (const K of m) {
                  if (K.percent < 100)
                    break;
                  if (K.id === V && k) {
                    z = !0;
                    break;
                  }
                }
                this._setCurrentPageNumber(z ? V : m[0].id), this._updateLocation(s.first), this.eventBus.dispatch("updateviewarea", {
                  source: this,
                  location: this._location
                });
              }
              containsElement(s) {
                return this.container.contains(s);
              }
              focus() {
                this.container.focus();
              }
              get _isContainerRtl() {
                return getComputedStyle(this.container).direction === "rtl";
              }
              get isInPresentationMode() {
                return this.presentationModeState === n.PresentationModeState.FULLSCREEN;
              }
              get isChangingPresentationMode() {
                return this.presentationModeState === n.PresentationModeState.CHANGING;
              }
              get isHorizontalScrollbarEnabled() {
                return this.isInPresentationMode ? !1 : this.container.scrollWidth > this.container.clientWidth;
              }
              get isVerticalScrollbarEnabled() {
                return this.isInPresentationMode ? !1 : this.container.scrollHeight > this.container.clientHeight;
              }
              _getVisiblePages() {
                const s = this._scrollMode === n.ScrollMode.PAGE ? this.#p.pages : this._pages, m = this._scrollMode === n.ScrollMode.HORIZONTAL, F = m && this._isContainerRtl;
                return (0, n.getVisibleElements)({
                  scrollEl: this.container,
                  views: s,
                  sortByVisibility: !0,
                  horizontal: m,
                  rtl: F
                });
              }
              cleanup() {
                for (const s of this._pages)
                  s.renderingState !== n.RenderingStates.FINISHED && s.reset();
              }
              _cancelRendering() {
                for (const s of this._pages)
                  s.cancelRendering();
              }
              async #R(s) {
                if (s.pdfPage)
                  return s.pdfPage;
                try {
                  const m = await this.pdfDocument.getPage(s.id);
                  return s.pdfPage || s.setPdfPage(m), this.linkService._cachedPageNumber?.(m.ref) || this.linkService.cachePageRef(s.id, m.ref), m;
                } catch (m) {
                  return console.error("Unable to get page for page view", m), null;
                }
              }
              #k(s) {
                if (s.first?.id === 1)
                  return !0;
                if (s.last?.id === this.pagesCount)
                  return !1;
                switch (this._scrollMode) {
                  case n.ScrollMode.PAGE:
                    return this.#p.scrollDown;
                  case n.ScrollMode.HORIZONTAL:
                    return this.scroll.right;
                }
                return this.scroll.down;
              }
              forceRendering(s) {
                const m = s || this._getVisiblePages(), F = this.#k(m), B = this._spreadMode !== n.SpreadMode.NONE && this._scrollMode !== n.ScrollMode.HORIZONTAL, k = this.renderingQueue.getHighestPriority(m, this._pages, F, B);
                return k ? (this.#R(k).then(() => {
                  this.renderingQueue.renderView(k);
                }), !0) : !1;
              }
              get hasEqualPageSizes() {
                const s = this._pages[0];
                for (let m = 1, F = this._pages.length; m < F; ++m) {
                  const B = this._pages[m];
                  if (B.width !== s.width || B.height !== s.height)
                    return !1;
                }
                return !0;
              }
              getPagesOverview() {
                let s;
                return this._pages.map((m) => {
                  const F = m.pdfPage.getViewport({
                    scale: 1
                  }), B = (0, n.isPortraitOrientation)(F);
                  if (s === void 0)
                    s = B;
                  else if (this.enablePrintAutoRotate && B !== s)
                    return {
                      width: F.height,
                      height: F.width,
                      rotation: (F.rotation - 90) % 360
                    };
                  return {
                    width: F.width,
                    height: F.height,
                    rotation: F.rotation
                  };
                });
              }
              get optionalContentConfigPromise() {
                return this.pdfDocument ? this._optionalContentConfigPromise ? this._optionalContentConfigPromise : (console.error("optionalContentConfigPromise: Not initialized yet."), this.pdfDocument.getOptionalContentConfig()) : Promise.resolve(null);
              }
              set optionalContentConfigPromise(s) {
                if (!(s instanceof Promise))
                  throw new Error(`Invalid optionalContentConfigPromise: ${s}`);
                this.pdfDocument && this._optionalContentConfigPromise && (this._optionalContentConfigPromise = s, this.refresh(!1, {
                  optionalContentConfigPromise: s
                }), this.eventBus.dispatch("optionalcontentconfigchanged", {
                  source: this,
                  promise: s
                }));
              }
              get scrollMode() {
                return this._scrollMode;
              }
              set scrollMode(s) {
                if (this._scrollMode !== s) {
                  if (!(0, n.isValidScrollMode)(s))
                    throw new Error(`Invalid scroll mode: ${s}`);
                  this.pagesCount > u.FORCE_SCROLL_MODE_PAGE || (this._previousScrollMode = this._scrollMode, this._scrollMode = s, this.eventBus.dispatch("scrollmodechanged", {
                    source: this,
                    mode: s
                  }), this._updateScrollMode(this._currentPageNumber));
                }
              }
              _updateScrollMode(s = null) {
                const m = this._scrollMode, F = this.viewer;
                F.classList.toggle("scrollHorizontal", m === n.ScrollMode.HORIZONTAL), F.classList.toggle("scrollWrapped", m === n.ScrollMode.WRAPPED), !(!this.pdfDocument || !s) && (m === n.ScrollMode.PAGE ? this.#S() : this._previousScrollMode === n.ScrollMode.PAGE && this._updateSpreadMode(), this._currentScaleValue && isNaN(this._currentScaleValue) && this.#y(this._currentScaleValue, {
                  noScroll: !0
                }), this._setCurrentPageNumber(s, !0), this.update());
              }
              get spreadMode() {
                return this._spreadMode;
              }
              set spreadMode(s) {
                if (this._spreadMode !== s) {
                  if (!(0, n.isValidSpreadMode)(s))
                    throw new Error(`Invalid spread mode: ${s}`);
                  this._spreadMode = s, this.eventBus.dispatch("spreadmodechanged", {
                    source: this,
                    mode: s
                  }), this._updateSpreadMode(this._currentPageNumber);
                }
              }
              _updateSpreadMode(s = null) {
                if (!this.pdfDocument)
                  return;
                const m = this.viewer, F = this._pages;
                if (this._scrollMode === n.ScrollMode.PAGE)
                  this.#S();
                else if (m.textContent = "", this._spreadMode === n.SpreadMode.NONE)
                  for (const B of this._pages)
                    m.append(B.div);
                else {
                  const B = this._spreadMode - 1;
                  let k = null;
                  for (let V = 0, z = F.length; V < z; ++V)
                    k === null ? (k = document.createElement("div"), k.className = "spread", m.append(k)) : V % 2 === B && (k = k.cloneNode(!1), m.append(k)), k.append(F[V].div);
                }
                s && (this._currentScaleValue && isNaN(this._currentScaleValue) && this.#y(this._currentScaleValue, {
                  noScroll: !0
                }), this._setCurrentPageNumber(s, !0), this.update());
              }
              _getPageAdvance(s, m = !1) {
                switch (this._scrollMode) {
                  case n.ScrollMode.WRAPPED: {
                    const {
                      views: F
                    } = this._getVisiblePages(), B = /* @__PURE__ */ new Map();
                    for (const {
                      id: k,
                      y: V,
                      percent: z,
                      widthPercent: K
                    } of F) {
                      if (z === 0 || K < 100)
                        continue;
                      let J = B.get(V);
                      J || B.set(V, J ||= []), J.push(k);
                    }
                    for (const k of B.values()) {
                      const V = k.indexOf(s);
                      if (V === -1)
                        continue;
                      const z = k.length;
                      if (z === 1)
                        break;
                      if (m)
                        for (let K = V - 1, J = 0; K >= J; K--) {
                          const $ = k[K], j = k[K + 1] - 1;
                          if ($ < j)
                            return s - j;
                        }
                      else
                        for (let K = V + 1, J = z; K < J; K++) {
                          const $ = k[K], j = k[K - 1] + 1;
                          if ($ > j)
                            return j - s;
                        }
                      if (m) {
                        const K = k[0];
                        if (K < s)
                          return s - K + 1;
                      } else {
                        const K = k[z - 1];
                        if (K > s)
                          return K - s + 1;
                      }
                      break;
                    }
                    break;
                  }
                  case n.ScrollMode.HORIZONTAL:
                    break;
                  case n.ScrollMode.PAGE:
                  case n.ScrollMode.VERTICAL: {
                    if (this._spreadMode === n.SpreadMode.NONE)
                      break;
                    const F = this._spreadMode - 1;
                    if (m && s % 2 !== F)
                      break;
                    if (!m && s % 2 === F)
                      break;
                    const {
                      views: B
                    } = this._getVisiblePages(), k = m ? s - 1 : s + 1;
                    for (const {
                      id: V,
                      percent: z,
                      widthPercent: K
                    } of B)
                      if (V === k) {
                        if (z > 0 && K === 100)
                          return 2;
                        break;
                      }
                    break;
                  }
                }
                return 1;
              }
              nextPage() {
                const s = this._currentPageNumber, m = this.pagesCount;
                if (s >= m)
                  return !1;
                const F = this._getPageAdvance(s, !1) || 1;
                return this.currentPageNumber = Math.min(s + F, m), !0;
              }
              previousPage() {
                const s = this._currentPageNumber;
                if (s <= 1)
                  return !1;
                const m = this._getPageAdvance(s, !0) || 1;
                return this.currentPageNumber = Math.max(s - m, 1), !0;
              }
              increaseScale({
                drawingDelay: s,
                scaleFactor: m,
                steps: F
              } = {}) {
                if (!this.pdfDocument)
                  return;
                let B = this._currentScale;
                if (m > 1)
                  B = Math.round(B * m * 100) / 100;
                else {
                  F ??= 1;
                  do
                    B = Math.ceil((B * n.DEFAULT_SCALE_DELTA).toFixed(2) * 10) / 10;
                  while (--F > 0 && B < n.MAX_SCALE);
                }
                this.#y(Math.min(n.MAX_SCALE, B), {
                  noScroll: !1,
                  drawingDelay: s
                });
              }
              decreaseScale({
                drawingDelay: s,
                scaleFactor: m,
                steps: F
              } = {}) {
                if (!this.pdfDocument)
                  return;
                let B = this._currentScale;
                if (m > 0 && m < 1)
                  B = Math.round(B * m * 100) / 100;
                else {
                  F ??= 1;
                  do
                    B = Math.floor((B / n.DEFAULT_SCALE_DELTA).toFixed(2) * 10) / 10;
                  while (--F > 0 && B > n.MIN_SCALE);
                }
                this.#y(Math.max(n.MIN_SCALE, B), {
                  noScroll: !1,
                  drawingDelay: s
                });
              }
              #P(s = this.container.clientHeight) {
                s !== this.#u && (this.#u = s, n.docStyle.setProperty("--viewer-container-height", `${s}px`));
              }
              #C(s) {
                for (const m of s)
                  if (m.target === this.container) {
                    this.#P(Math.floor(m.borderBoxSize[0].blockSize)), this.#s = null;
                    break;
                  }
              }
              get containerTopLeft() {
                return this.#s ||= [this.container.offsetTop, this.container.offsetLeft];
              }
              get annotationEditorMode() {
                return this.#i ? this.#n : i.AnnotationEditorType.DISABLE;
              }
              set annotationEditorMode({
                mode: s,
                editId: m = null
              }) {
                if (!this.#i)
                  throw new Error("The AnnotationEditor is not enabled.");
                if (this.#n !== s) {
                  if (!c(s))
                    throw new Error(`Invalid AnnotationEditor mode: ${s}`);
                  this.pdfDocument && (this.#n = s, this.eventBus.dispatch("annotationeditormodechanged", {
                    source: this,
                    mode: s
                  }), this.#i.updateMode(s, m));
                }
              }
              set annotationEditorParams({
                type: s,
                value: m
              }) {
                if (!this.#i)
                  throw new Error("The AnnotationEditor is not enabled.");
                this.#i.updateParams(s, m);
              }
              refresh(s = !1, m = /* @__PURE__ */ Object.create(null)) {
                if (this.pdfDocument) {
                  for (const F of this._pages)
                    F.update(m);
                  this.#m !== null && (clearTimeout(this.#m), this.#m = null), s || this.update();
                }
              }
            }
            v.PDFViewer = C;
          }),
          /* 26 */
          /***/
          ((E, v, T) => {
            Object.defineProperty(v, "__esModule", {
              value: !0
            }), v.PDFRenderingQueue = void 0;
            var i = T(4), n = T(2);
            const o = 3e4;
            class d {
              constructor() {
                this.pdfViewer = null, this.pdfThumbnailViewer = null, this.onIdle = null, this.highestPriorityPage = null, this.idleTimeout = null, this.printing = !1, this.isThumbnailViewEnabled = !1, Object.defineProperty(this, "hasViewer", {
                  value: () => !!this.pdfViewer
                });
              }
              setViewer(e) {
                this.pdfViewer = e;
              }
              setThumbnailViewer(e) {
                this.pdfThumbnailViewer = e;
              }
              isHighestPriority(e) {
                return this.highestPriorityPage === e.renderingId;
              }
              renderHighestPriority(e) {
                this.idleTimeout && (clearTimeout(this.idleTimeout), this.idleTimeout = null), !this.pdfViewer.forceRendering(e) && (this.isThumbnailViewEnabled && this.pdfThumbnailViewer?.forceRendering() || this.printing || this.onIdle && (this.idleTimeout = setTimeout(this.onIdle.bind(this), o)));
              }
              getHighestPriority(e, l, u, c = !1) {
                const y = e.views, C = y.length;
                if (C === 0)
                  return null;
                for (let B = 0; B < C; B++) {
                  const k = y[B].view;
                  if (!this.isViewFinished(k))
                    return k;
                }
                const R = e.first.id, s = e.last.id;
                if (s - R + 1 > C) {
                  const B = e.ids;
                  for (let k = 1, V = s - R; k < V; k++) {
                    const z = u ? R + k : s - k;
                    if (B.has(z))
                      continue;
                    const K = l[z - 1];
                    if (!this.isViewFinished(K))
                      return K;
                  }
                }
                let m = u ? s : R - 2, F = l[m];
                return F && !this.isViewFinished(F) || c && (m += u ? 1 : -1, F = l[m], F && !this.isViewFinished(F)) ? F : null;
              }
              isViewFinished(e) {
                return e.renderingState === n.RenderingStates.FINISHED;
              }
              renderView(e) {
                switch (e.renderingState) {
                  case n.RenderingStates.FINISHED:
                    return !1;
                  case n.RenderingStates.PAUSED:
                    this.highestPriorityPage = e.renderingId, e.resume();
                    break;
                  case n.RenderingStates.RUNNING:
                    this.highestPriorityPage = e.renderingId;
                    break;
                  case n.RenderingStates.INITIAL:
                    this.highestPriorityPage = e.renderingId, e.draw().finally(() => {
                      this.renderHighestPriority();
                    }).catch((l) => {
                      l instanceof i.RenderingCancelledException || console.error(`renderView: "${l}"`);
                    });
                    break;
                }
                return !0;
              }
            }
            v.PDFRenderingQueue = d;
          })
          /******/
        ], a = {};
        function f(E) {
          var v = a[E];
          if (v !== void 0)
            return v.exports;
          var T = a[E] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return t[E](T, T.exports, f), T.exports;
        }
        var S = {};
        return (() => {
          var E = S;
          Object.defineProperty(E, "__esModule", {
            value: !0
          }), Object.defineProperty(E, "AnnotationLayerBuilder", {
            enumerable: !0,
            get: function() {
              return n.AnnotationLayerBuilder;
            }
          }), Object.defineProperty(E, "DownloadManager", {
            enumerable: !0,
            get: function() {
              return o.DownloadManager;
            }
          }), Object.defineProperty(E, "EventBus", {
            enumerable: !0,
            get: function() {
              return d.EventBus;
            }
          }), Object.defineProperty(E, "FindState", {
            enumerable: !0,
            get: function() {
              return v.FindState;
            }
          }), Object.defineProperty(E, "GenericL10n", {
            enumerable: !0,
            get: function() {
              return h.GenericL10n;
            }
          }), Object.defineProperty(E, "LinkTarget", {
            enumerable: !0,
            get: function() {
              return T.LinkTarget;
            }
          }), Object.defineProperty(E, "NullL10n", {
            enumerable: !0,
            get: function() {
              return e.NullL10n;
            }
          }), Object.defineProperty(E, "PDFFindController", {
            enumerable: !0,
            get: function() {
              return v.PDFFindController;
            }
          }), Object.defineProperty(E, "PDFHistory", {
            enumerable: !0,
            get: function() {
              return l.PDFHistory;
            }
          }), Object.defineProperty(E, "PDFLinkService", {
            enumerable: !0,
            get: function() {
              return T.PDFLinkService;
            }
          }), Object.defineProperty(E, "PDFPageView", {
            enumerable: !0,
            get: function() {
              return u.PDFPageView;
            }
          }), Object.defineProperty(E, "PDFScriptingManager", {
            enumerable: !0,
            get: function() {
              return c.PDFScriptingManager;
            }
          }), Object.defineProperty(E, "PDFSinglePageViewer", {
            enumerable: !0,
            get: function() {
              return y.PDFSinglePageViewer;
            }
          }), Object.defineProperty(E, "PDFViewer", {
            enumerable: !0,
            get: function() {
              return C.PDFViewer;
            }
          }), Object.defineProperty(E, "ProgressBar", {
            enumerable: !0,
            get: function() {
              return i.ProgressBar;
            }
          }), Object.defineProperty(E, "RenderingStates", {
            enumerable: !0,
            get: function() {
              return i.RenderingStates;
            }
          }), Object.defineProperty(E, "ScrollMode", {
            enumerable: !0,
            get: function() {
              return i.ScrollMode;
            }
          }), Object.defineProperty(E, "SimpleLinkService", {
            enumerable: !0,
            get: function() {
              return T.SimpleLinkService;
            }
          }), Object.defineProperty(E, "SpreadMode", {
            enumerable: !0,
            get: function() {
              return i.SpreadMode;
            }
          }), Object.defineProperty(E, "StructTreeLayerBuilder", {
            enumerable: !0,
            get: function() {
              return R.StructTreeLayerBuilder;
            }
          }), Object.defineProperty(E, "TextLayerBuilder", {
            enumerable: !0,
            get: function() {
              return s.TextLayerBuilder;
            }
          }), Object.defineProperty(E, "XfaLayerBuilder", {
            enumerable: !0,
            get: function() {
              return m.XfaLayerBuilder;
            }
          }), Object.defineProperty(E, "parseQueryString", {
            enumerable: !0,
            get: function() {
              return i.parseQueryString;
            }
          });
          var v = f(1), T = f(5), i = f(2), n = f(6), o = f(8), d = f(9), h = f(10), e = f(7), l = f(12), u = f(13), c = f(21), y = f(24), C = f(25), R = f(16), s = f(19), m = f(20);
        })(), S;
      })()
    ));
  })(pdf_viewer)), pdf_viewer.exports;
}
var pdf_viewerExports = requirePdf_viewer();
function parsePageInput(P, p) {
  const t = parseInt(P, 10);
  return !isNaN(t) && t >= 1 && t <= p ? t : null;
}
function getKeyboardAction(P, p, t) {
  return [
    "ArrowRight",
    "ArrowDown",
    " ",
    "PageDown"
  ].includes(P) ? p < t ? "next" : P === " " || P === "PageDown" ? "prevent" : null : [
    "ArrowLeft",
    "ArrowUp",
    "PageUp"
  ].includes(P) ? p > 1 ? "prev" : P === "PageUp" ? "prevent" : null : null;
}
function calcPdfScale(P, p, t, a) {
  return Math.min(P / t, p / a);
}
function getPdfWorkerSrc(P, p, t) {
  return `${P ? p : t}/pdf.worker.min.js`;
}
function isPageCompleted(P, p) {
  return p === 1 || P === p;
}
const loader_wrap = "_loader_wrap_uz20e_1", error = "_error_uz20e_2", wrap = "_wrap_uz20e_11", canvas_container = "_canvas_container_uz20e_25", pdf_page = "_pdf_page_uz20e_38", fullscreen = "_fullscreen_uz20e_76", fullscreen_button = "_fullscreen_button_uz20e_104", panel = "_panel_uz20e_114", page_input_field = "_page_input_field_uz20e_136", file_name = "_file_name_uz20e_156", file_name_span = "_file_name_span_uz20e_163", actions = "_actions_uz20e_169", pages_counter = "_pages_counter_uz20e_176", all = "_all_uz20e_187", another_actions = "_another_actions_uz20e_192", another_actions_mobile = "_another_actions_mobile_uz20e_193", additional_btn = "_additional_btn_uz20e_209", hide = "_hide_uz20e_252", st$1 = {
  loader_wrap,
  error,
  wrap,
  canvas_container,
  pdf_page,
  fullscreen,
  fullscreen_button,
  panel,
  page_input_field,
  file_name,
  file_name_span,
  actions,
  pages_counter,
  all,
  another_actions,
  another_actions_mobile,
  additional_btn,
  hide
}, { getDocument, GlobalWorkerOptions } = pdfjsLib;
GlobalWorkerOptions.workerSrc = getPdfWorkerSrc(
  !!IS_WEBCOM,
  String(WEBCOM_ASSETS_BASE),
  String(BASE_URL)
);
const AdditionalActions = ({
  onClickPrint: P,
  onClickDownload: p,
  isNeedDownload: t = !0
}) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(
    Button,
    {
      "aria-label": "Печать",
      className: st$1.additional_btn,
      variant: ButtonVariant.Ghost,
      onClick: P,
      children: /* @__PURE__ */ jsx(PrinterIcon, {})
    }
  ),
  t && /* @__PURE__ */ jsx(
    Button,
    {
      "aria-label": "Скачать",
      className: st$1.additional_btn,
      variant: ButtonVariant.Ghost,
      onClick: p,
      children: /* @__PURE__ */ jsx(ArrowDownAndBracketTrailingIcon, {})
    }
  )
] }), CanvasPdfPlayer = ({
  fileUrl: P,
  nextButtonRender: p,
  prevButtonRender: t,
  fileName: a,
  className: f,
  analyticsDownloadCallback: S,
  analyticsCompletedCallback: E,
  snackbarErrorCallback: v,
  isNeedDownload: T = !0
}) => {
  const i = useRef(null), n = useRef(null), o = useRef(null), d = useRef(null), h = useRef(null), [e, l] = useState(null), [u, c] = useState(1), [y, C] = useState(0), [R, s] = useState(!0), [m, F] = useState(!1), [B, k] = useState(u.toString()), V = useRef(null), { isFullscreen: z, toggle: K } = useFullscreen(o, {
    preferCssFallback: !0
  }), J = async () => {
    if (P)
      try {
        const _ = await fetch(P, {
          credentials: "include"
        });
        if (!_.ok) throw new Error("Ошибка загрузки PDF");
        const H = await _.arrayBuffer(), N = new Blob([H], {
          type: "application/pdf"
        }), b = URL.createObjectURL(N), w = window.open(b, "_blank");
        if (!w)
          throw new Error("Не удалось открыть окно печати");
        w.onload = () => {
          w.focus(), w.print();
        };
      } catch (_) {
        console.error("Ошибка при печати PDF:", _);
      }
  }, $ = async () => {
    if (P)
      try {
        const _ = await fetch(P, {
          credentials: "include"
        });
        if (!_.ok)
          throw new Error("Ошибка загрузки PDF-файла");
        const H = await _.arrayBuffer(), N = new Blob([H], {
          type: "application/pdf"
        }), b = URL.createObjectURL(N), w = document.createElement("a"), D = P.replace(/[?#].*$/, "").split(".").pop(), L = D && D.length <= 5 ? D.toLowerCase() : "pdf", W = a || "PDF file", X = W.toLowerCase().endsWith(`.${L}`) ? W : `${W}.${L}`;
        w.href = b, w.download = X, document.body.appendChild(w), w.click(), S?.(), document.body.removeChild(w), URL.revokeObjectURL(b);
      } catch (_) {
        v?.(`Не удалось скачать PDF ${a}. Попробуйте еще раз`), console.error("Не удалось скачать PDF:", _);
      }
  };
  useEffect(() => {
    if (!P) return;
    (async () => {
      try {
        F(!1), s(!0);
        const N = await getDocument({ url: P, isEvalSupported: !1 }).promise;
        l(N), C(N.numPages);
      } catch (H) {
        F(!0), console.error("Ошибка загрузки PDF:", H);
      } finally {
        s(!1);
      }
    })();
  }, [P]);
  const j = useCallback(() => {
    c((_) => {
      const H = Math.min(_ + 1, y);
      return H === y && _ < y && E?.(), H;
    });
  }, [y, E]), G = useCallback(() => {
    c((_) => Math.max(_ - 1, 1));
  }, []), M = useCallback((_) => {
    if (R || m || !e) return;
    const H = getKeyboardAction(
      _.key,
      u,
      y
    );
    H === "next" ? (_.preventDefault(), j()) : H === "prev" ? (_.preventDefault(), G()) : H === "prevent" && _.preventDefault();
  }, [
    R,
    m,
    e,
    u,
    y,
    j,
    G
  ]);
  useEffect(() => {
    const _ = o.current;
    if (_)
      return _.addEventListener("keydown", M), () => {
        _.removeEventListener("keydown", M);
      };
  }, [M]);
  const x = async () => {
    if (!e || !i.current || !n.current || !d.current)
      return;
    const { clientWidth: _, clientHeight: H } = n.current;
    if (!(_ === 0 || H === 0)) {
      h.current && (h.current.cancel(), h.current = null);
      try {
        const N = await e.getPage(u), b = i.current, w = d.current, O = b.getContext("2d");
        if (!O) return;
        const D = window.devicePixelRatio || 1, L = N.getViewport({ scale: 1 }), W = calcPdfScale(
          _,
          H,
          L.width,
          L.height
        ), X = N.getViewport({ scale: W * D });
        b.width = X.width, b.height = X.height, b.style.width = `${X.width / D}px`, b.style.height = `${X.height / D}px`;
        const q = {
          canvasContext: O,
          viewport: X
        };
        h.current = N.render(q), await h.current.promise, h.current = null, w.innerHTML = "", w.style.width = `${X.width / D}px`, w.style.height = `${X.height / D}px`, w.style.setProperty("--scale-factor", String(W));
        const ct = new pdf_viewerExports.EventBus(), nt = new pdf_viewerExports.PDFLinkService({ eventBus: ct });
        nt.setDocument(e), nt.setViewer({
          scrollPageIntoView: ({ pageNumber: Q }) => {
            c(Q);
          }
        }), new pdf_viewerExports.AnnotationLayerBuilder({
          pageDiv: w,
          pdfPage: N,
          linkService: nt,
          downloadManager: null,
          l10n: null,
          renderForms: !1
        }).render(
          N.getViewport({ scale: W }).clone({ dontFlip: !0 }),
          "display"
        );
      } catch (N) {
        N?.name !== "RenderingCancelledException" && console.error("Ошибка рендеринга страницы:", N);
      }
    }
  }, A = (_) => {
    k(_.target.value);
  }, g = () => {
    U();
  }, I = (_) => {
    _.key === "Enter" && U(), _.key === "Escape" && k(u.toString());
  }, U = () => {
    const _ = parsePageInput(B, y);
    _ !== null ? c(_) : k(u.toString());
  };
  return useEffect(() => {
    if (!e) return;
    const _ = new ResizeObserver((H) => {
      window.requestAnimationFrame(() => {
        for (const N of H)
          N.contentRect.width > 0 && N.contentRect.height > 0 && x();
      });
    });
    return n.current && _.observe(n.current), () => {
      _.disconnect(), h.current && (h.current.cancel(), h.current = null);
    };
  }, [e, u]), useEffect(() => {
    isPageCompleted(u, y) && E?.();
  }, [
    u,
    y,
    E
  ]), useEffect(() => {
    k(u.toString());
  }, [u]), /* @__PURE__ */ jsxs(
    "div",
    {
      ref: o,
      className: clsx(
        st$1.wrap,
        f,
        z && st$1.fullscreen,
        "edt_radius_s"
      ),
      id: "edt-pdf-player",
      tabIndex: 0,
      children: [
        m && /* @__PURE__ */ jsx("div", { className: st$1.error, children: "Ошибка загрузки PDF файла" }),
        R && /* @__PURE__ */ jsx("div", { className: st$1.loader_wrap, children: /* @__PURE__ */ jsx(Loader, {}) }),
        !R && !m && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            FullscreenButton,
            {
              className: st$1.fullscreen_button,
              isFullscreen: z,
              onClick: K
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              ref: n,
              className: st$1.canvas_container,
              children: /* @__PURE__ */ jsxs("div", { className: st$1.pdf_page, children: [
                /* @__PURE__ */ jsx("canvas", { ref: i }),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    ref: d,
                    className: "annotationLayer"
                  }
                )
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: st$1.panel, children: [
          /* @__PURE__ */ jsxs("div", { className: clsx(st$1.file_name, z && st$1.hide), children: [
            /* @__PURE__ */ jsx("span", { className: st$1.file_name_span, children: a }),
            /* @__PURE__ */ jsx(
              "div",
              {
                "aria-hidden": "true",
                className: st$1.another_actions_mobile,
                children: /* @__PURE__ */ jsx(
                  AdditionalActions,
                  {
                    isNeedDownload: T,
                    onClickDownload: $,
                    onClickPrint: J
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: st$1.actions, children: [
            t(G, R || m || u <= 1),
            /* @__PURE__ */ jsxs("div", { className: st$1.pages_counter, children: [
              /* @__PURE__ */ jsx(
                "input",
                {
                  ref: V,
                  "aria-label": "Номер страницы",
                  className: st$1.page_input_field,
                  type: "number",
                  value: B,
                  onBlur: g,
                  onChange: A,
                  onKeyDown: I
                }
              ),
              /* @__PURE__ */ jsxs(
                "span",
                {
                  "aria-label": `Общее количество страниц ${y}`,
                  className: st$1.all,
                  children: [
                    "/ ",
                    y
                  ]
                }
              )
            ] }),
            p(j, R || m || u >= y)
          ] }),
          /* @__PURE__ */ jsx("div", { className: st$1.another_actions, children: /* @__PURE__ */ jsx(
            AdditionalActions,
            {
              isNeedDownload: T,
              onClickDownload: $,
              onClickPrint: J
            }
          ) })
        ] })
      ]
    }
  );
}, button = "_button_svp21_1", arrow_icon = "_arrow_icon_svp21_5", arrow_icon_left = "_arrow_icon_left_svp21_8", st = {
  button,
  arrow_icon,
  arrow_icon_left
}, EdtechPdfPlayer = ({
  filePath: P,
  title: p,
  analyticsDownloadCallback: t,
  analyticsCompletedCallback: a,
  className: f,
  theme: S,
  isNeedDownload: E = !0
}) => (useThemeSwitcher({ initialTheme: S }), /* @__PURE__ */ jsx(EdtechProvider, { name: "pdf-player", children: /* @__PURE__ */ jsx(
  CanvasPdfPlayer,
  {
    analyticsCompletedCallback: a,
    analyticsDownloadCallback: t,
    className: f,
    fileName: p || "Файл pdf",
    fileUrl: P,
    isNeedDownload: E,
    nextButtonRender: (v, T) => /* @__PURE__ */ jsx(
      Button,
      {
        className: st.button,
        disabled: T,
        variant: ButtonVariant.Ghost,
        onClick: v,
        children: /* @__PURE__ */ jsx(ArrowLeftCircleIcon, { className: st.arrow_icon_left })
      }
    ),
    prevButtonRender: (v, T) => /* @__PURE__ */ jsx(
      Button,
      {
        className: st.button,
        disabled: T,
        variant: ButtonVariant.Ghost,
        onClick: v,
        children: /* @__PURE__ */ jsx(ArrowLeftCircleIcon, { className: st.arrow_icon })
      }
    )
  }
) }));
export {
  EdtechPdfPlayer
};
